export const QUESTIONS = [
    {
       "id":5267,
       "practice_test_id":6,
       "topic_id":1,
       "question":"An investor buys 100M US Treasury bonds on Tuesday April 10th. The investor will be an owner of record on:",
       "choice_a":"Friday April 13th",
       "choice_b":"Wednesday April 11th",
       "choice_c":"Thursday April 12th",
       "choice_d":"Tuesday April 17th",
       "correct_answer":"B",
       "explanation":"Treasury securities settle on the next business day"
    },
    {
       "id":24639,
       "practice_test_id":1,
       "topic_id":1,
       "question":"Which of the following must appear on an order ticket? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Solicited / unsolicited  </li><li>Time of the order </li><li>Name of the market maker  </li><li>Settlement Date</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"III and IV",
       "correct_answer":"A",
       "explanation":"An order ticket must be marked solicited or unsolicited and the order must be time stamped when it is received. The settlement date appears on the confirmation, not on the order ticket. The name of the market maker is not required on the order ticket."
    },
    {
       "id":24640,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following must a registered representative take to his principal for review?",
       "choice_a":"A customer refuses to provide an email address",
       "choice_b":"A customer opens multiple accounts with different investment objectives",
       "choice_c":"A customer sends in a check with his business address instead of his home address",
       "choice_d":"A customer redeems a mutual fund portfolio at a significant loss",
       "correct_answer":"B",
       "explanation":"All customer accounts must be taken to a principal of the firm for review, regardless of how many accounts a customer opens. A customer could have an account for themselves, and IRA and a custodial account all with different investment objectives. A customer check will most likely go to the cashier department. A customer is not required to provide an email address and a customer redeeming a mutual fund at a loss will be reviewed by the principal after the trade is entered. The trade will not require prior review from a principal."
    },
    {
       "id":24657,
       "practice_test_id":2,
       "topic_id":1,
       "question":"A research analyst for ABC brokerage wants to open an account with his firm. The analyst sits down with a registered representative of ABC to open the account. The analyst provides the registered representative with his address, home and work phone but does not want to provide the details of his investment experience or his previous employment in the securities industry. Which of the following is correct?",
       "choice_a":"The account should not be opened by the firm without these details",
       "choice_b":"The account must be designated as a house account as the analyst works for the firm",
       "choice_c":"The account should be opened for the analyst since the firm is in possession of all of the details of the analysts employment and holdings",
       "choice_d":"The account may be opened but the registered representative may only recommend securities that the analyst covers since no information was provided as to the level of investment experience",
       "correct_answer":"C",
       "explanation":"The RR should open the account as both the analyst and the RR are employed by the same firm, the firm is in possession of all of the analyst\u0027s holdings. Additionally, the firm has the employment history of the analyst listed on the analyst\u0027s U4."
    },
    {
       "id":24660,
       "practice_test_id":3,
       "topic_id":1,
       "question":"An investor is considering purchasing shares of ABC Utilities, Inc. ABC pays a regular quarterly dividend on its shares. The investor is considering purchasing the shares in December, but does not want to add to his taxable income for the year. ABC declared a dividend for payment on Tuesday, December 5th to shareholders of record Wednesday, December 20th. The dividend is to be paid on Thursday, December 28th. If the investor wishes to purchase the shares this month, which of the following dates would be the earliest he should purchase the shares? ",
       "choice_a":"December 6th",
       "choice_b":"December 19th",
       "choice_c":"December 29th",
       "choice_d":"December 27th",
       "correct_answer":"B",
       "explanation":"The record date for the dividend is December 20th. The stock therefore goes ex dividend on December 19th. Investors who purchase a stock on or after the ex date will not receive the dividend. Of the choices listed the earliest day when a person could purchase the stock and not receive the dividend is December 19th. "
    },
    {
       "id":24661,
       "practice_test_id":4,
       "topic_id":1,
       "question":"An investor is considering purchasing shares of ABC Utilities, Inc. ABC pays a regular quarterly dividend on its shares. The investor is considering purchasing the shares in December, and wants to receive the dividend this year. ABC declared a dividend for payment on Tuesday, December 5th to shareholders of record Wednesday, December 20th. The dividend is to be paid on Thursday, December 28th. If the investor wishes to purchase the shares this month, which of the following dates would be the latest he should purchase the shares?",
       "choice_a":"December 4th",
       "choice_b":"December 15th",
       "choice_c":"December 26th",
       "choice_d":"December 18th",
       "correct_answer":"D",
       "explanation":"The record date for the dividend is December 20th. The stock therefore goes ex dividend on December 19th. Investors who purchase a stock on or after the ex date will not receive the dividend. Of the choices listed the last day when a person could purchase the stock and receive the dividend is December 18th."
    },
    {
       "id":24666,
       "practice_test_id":5,
       "topic_id":1,
       "question":"Mr. Jones, an investor in a high tax bracket, has just placed an order for $25,000 worth of municipal bonds with his registered representative. All of the following will appear on the confirmation, except:",
       "choice_a":"Trade date",
       "choice_b":"Settlement date",
       "choice_c":"Call provisions",
       "choice_d":"Paying agent",
       "correct_answer":"D",
       "explanation":"All of the choices listed would appear on the confirmation for a municipal bond purchase except the paying agent. The paying agent is a bank, trust company or broker dealer who is responsible for distributing the interest payments to bondholders on behalf of the issuer. "
    },
    {
       "id":24673,
       "practice_test_id":6,
       "topic_id":1,
       "question":"A woman opens an account with a registered representative and notifies the RR that she would like her investment adviser to receive duplicate notifications for all activity in the account. Which of the following is true? ",
       "choice_a":"Disclosing information to a third party is prohibited",
       "choice_b":"Each time there is a transaction in the account the RR should make a photocopy and fax or email it to the investment adviser",
       "choice_c":"Notification would be sent on a trade by trade basis and would appear on the customer\u0027s confirm",
       "choice_d":"Each time there is a transaction in the account the RR should contact the purchase and sales department and have a copy sent to the investment advisers as per the customer\u0027s instructions",
       "correct_answer":"C",
       "explanation":"When a third party such as an accountant or an investment adviser is notified, the third party will receive notification of all trades and notation on the confirm will indicate that a third party has been notified. "
    },
    {
       "id":24687,
       "practice_test_id":"",
       "topic_id":1,
       "question":"An investor with a new cash account purchases 40 shares of JKL at $100 per share. Three business days later the customer sends in a payment for 30 of the shares. No more payments are received by the customer over the next three business days. Which of the following is correct? ",
       "choice_a":"The broker dealer will sell out all of the shares and freeze the account for 90 days",
       "choice_b":"The broker dealer will waive the call and bill the customer for the 10 shares",
       "choice_c":"The broker dealer will sell out 10 shares and freeze the account for 90 days",
       "choice_d":"The broker dealer will journal the stock to a margin account and waive the call",
       "correct_answer":"C",
       "explanation":"The investor has failed to pay for a portion of a trade executed in a cash account. Because this is a cash account, a call for $1,000 cannot be waived. The broker dealer will be required to sell the shares that the customer did not pay for, in this case 10 shares will be sold. The investor\u0027s account will be frozen for 90 day as a result of the sell out."
    },
    {
       "id":20911,
       "practice_test_id":6,
       "topic_id":1,
       "question":"A client calls his representative wishing to place an order to sell 500 ERT at the market. The representative reviews the client\u0027s account and does not see the shares of ERT in the client\u0027s account. The client instructs the representative to mark the ticket as selling long. Which of the following must the representative do? ",
       "choice_a":"Get the prior approval of the principal",
       "choice_b":"Check to see if the shares of ERT appear on the easy to borrow list",
       "choice_c":"Identify where the shares of ERT are held and if the shares can be delivered",
       "choice_d":"Execute the order and deliver shares of ERT held in street name by the broker dealer",
       "correct_answer":"C",
       "explanation":"The ticket can be marked as selling long only if the representative can determine if the customer has possession of the shares and can deliver the stock certificate promptly. The broker dealer may not deliver other shares on behalf of the client when the sell order is marked as selling long. "
    },
    {
       "id":20916,
       "practice_test_id":2,
       "topic_id":1,
       "question":"XYZ manufacturing has mailed out proxies for its upcoming annual shareholders meeting. A customer of Rock Solid Brokerage has 1,000 shares held in street name. Rock Solid has forwarded the proxy to the customer in line with regulations. The customer signs and returns the proxy to Rock Solid without casting his vote. Under the rules Rock Sold:",
       "choice_a":"Must contact the customer and ask how he wants to vote",
       "choice_b":"Must void the proxy",
       "choice_c":"Must vote the shares anyway it sees fit as the shares are held in street name",
       "choice_d":"Must vote the shares in line with the recommendation of XYZ\u0027s management",
       "correct_answer":"D",
       "explanation":"If a customer signs and returns a blank proxy to a brokerage firm for shares held in street name, the brokerage firm is required to vote those shares in line with the recommendation of the company\u0027s management, in this case as XYZ recommends. "
    },
    {
       "id":20937,
       "practice_test_id":3,
       "topic_id":1,
       "question":"An investor who is fully invested and with no free cash or SMA in his account sells $25,000 worth of TRY and later uses the proceeds to purchase $32,000 worth of XYA. The customer fails to send in any additional funds by the expiration of the fourth business day. Which of the following actions should the broker dealer take? ",
       "choice_a":"Request and extension for the $7,000",
       "choice_b":"Sell out the $32,000 worth of XYA and freeze the account for 90 days",
       "choice_c":"Break the trade and restore the original position",
       "choice_d":"Sell out $7,000 worth of XYA and freeze the account for 90 days",
       "correct_answer":"D",
       "explanation":"An extension may not be granted after the expiration of the fourth business day. Since the customer only failed to pay for $7,000 of the new purchase that is the amount that must be sold out. Even though most of the purchase was paid for, the account must still be frozen for 90 days. During the 90 day freeze no orders may be executed prior to the cash being in the account. "
    },
    {
       "id":19347,
       "practice_test_id":4,
       "topic_id":1,
       "question":"A long term growth oriented investors is long 400 shares of EXT at $19. The stock over the last three years has appreciated to $74 and the company declares a 3:2 stock split. The investor\u0027s account will receive how many additional shares of EXT on the payable date?",
       "choice_a":300,
       "choice_b":200,
       "choice_c":400,
       "choice_d":600,
       "correct_answer":"B",
       "explanation":"To determine the number of shares the investor will own after the split multiply the number of shares owned by the split. In this case 400 X 3/2 = 1200 / 2 = 600 shares. As the investor is long 400 the investor will receive an additional 200 shares of EXT on the payable date."
    },
    {
       "id":19376,
       "practice_test_id":5,
       "topic_id":1,
       "question":"When a registered representative terminates his employment with a broker dealer, the broker dealer files what form with FINRA?",
       "choice_a":"U4",
       "choice_b":"U5",
       "choice_c":"Termination notice form",
       "choice_d":"Registration removal form",
       "correct_answer":"B",
       "explanation":"When an agent joins a firm the agent fills out and the firm files form U4. When an agent is terminated or leaves the firm the firm must submit form U5 within 30 days of the agent leaving or being terminated."
    },
    {
       "id":19378,
       "practice_test_id":6,
       "topic_id":1,
       "question":"Firm x has declared a stock dividend that pays one share of stock for every 7 shares owned. An investor who owns 1400 shares would receive how many new shares?",
       "choice_a":200,
       "choice_b":140,
       "choice_c":70,
       "choice_d":210,
       "correct_answer":"A",
       "explanation":"The company is paying a stock dividend in the amount of 1 share for every 7 shares owned. Therefore an investor who own 1,400 shares would receive 200 additional shares. 1,400 shares / 7 = 200 shares."
    },
    {
       "id":19390,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Your customer purchased $10,000 worth of NY State Bridge 5% revenue bonds. The purpose of the bonds is to maintain a bridge that charges tolls to drivers who use the facility. The facility is insured against damage caused by any foreseeable events. If the facility is damaged the bonds will be called in and the insurance will pay off the bonds. Which of the following is true?",
       "choice_a":"The bonds must be identified as callable on the customer\u0027s confirm",
       "choice_b":"The bonds must be identified as callable pursuant to a catastrophe on the customer\u0027s confirm",
       "choice_c":"The customer\u0027s confirm need not state that the bonds are callable",
       "choice_d":"The customer\u0027s confirm must state the amount and type of insurance that will be in place to call the bonds",
       "correct_answer":"C",
       "explanation":"Catastrophe calls are standard for bonds that finance municipal facilities. The bonds are not otherwise callable and do not need to be identified as callable on the customer\u0027s confirm. "
    },
    {
       "id":19391,
       "practice_test_id":"",
       "topic_id":1,
       "question":"An investor holds 200 shares of SIAC. SIAC declares a 5:4 stock split. The investor will receive how many additional shares of SIAC? ",
       "choice_a":25,
       "choice_b":50,
       "choice_c":20,
       "choice_d":40,
       "correct_answer":"B",
       "explanation":"To determine how many shares the investor will own after the split multiply the number of shares owned by the split. In this case 200 X 5/4 = 1000/4 = 250. Therefore the investor will receive 50 new shares of SIAC."
    },
    {
       "id":20952,
       "practice_test_id":6,
       "topic_id":1,
       "question":"An investor has purchased a municipal bond that has been pre refunded to call. Which of the following must appear on the customer\u0027s confirmation under MSRB rules? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Call provisions  </li><li>Pre refunded  </li><li>Yield to call  </li><li>Extended principal</li></ol>",
       "choice_a":"III and IV",
       "choice_b":"II and III",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"If an investor purchases a municipal bond that has been pre refunded to call all of the choices listed must appear on the confirmation. Because the bond has been pre refunded, the call provisions, a note that the bonds have been pre refunded and the yield to call must appear on the confirm. The extended principal must always appear on the confirm and details the amount of principal value based on the number of bonds purchased."
    },
    {
       "id":20955,
       "practice_test_id":2,
       "topic_id":1,
       "question":"Which of the following would not change the yield information shown on a customer\u0027s confirmation under MSRB rules? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The bonds have been pre refunded  </li><li>An in whole call </li><li>A catastrophe call </li><li>An in part call</li></ol>",
       "choice_a":"I and III",
       "choice_b":"III and IV",
       "choice_c":"I, II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"Bonds that have been called in part may or may not be included in the bonds that have actually been called, so this will not change the yield shown on the customer\u0027s confirmation. A catastrophe call will only be exercised if the facility has been destroyed and all bonds are being paid off with the insurance proceeds. Bonds that have been pre refunded or called in whole will have the yield shown to the call"
    },
    {
       "id":20956,
       "practice_test_id":3,
       "topic_id":1,
       "question":"Investors who purchase which of the following would be required to receive a prospectus? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Unit investment trust  </li><li>Variable annuity  </li><li>Investment company shares  </li><li>A new issue of AAA rate corporate bonds</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"An investor who purchases any of the choices listed must receive a prospectus. a UIT is a type of investment company investors must receive a prospectus when purchasing a UIT."
    },
    {
       "id":20957,
       "practice_test_id":4,
       "topic_id":1,
       "question":"An investor who has had an account at your firm for 6 months is speaking to you about a biotech stock you have been recommending as a speculative opportunity. The stock trades on the OTCBB at $3.10 per share. the customer decides to purchase 1,000 shares. All of the following must appear on the risk disclosure statement except: ",
       "choice_a":"The definition of a penny stock",
       "choice_b":"The investor\u0027s legal rights",
       "choice_c":"The broker dealer\u0027s obligations to the investor",
       "choice_d":"52 week high and low pricing information for the stock",
       "correct_answer":"D",
       "explanation":"Non established customers must be given a risk disclosure document that details the investors rights, the obligation of the broker dealer to the investor, the legal rights of the investor and the risks of investing in penny stocks. The 52 week high and low pricing information is not detailed in the document. "
    },
    {
       "id":21451,
       "practice_test_id":5,
       "topic_id":1,
       "question":"A principal of a member firm is not required to review and approve which of the following?",
       "choice_a":"order tickets",
       "choice_b":"new account applications",
       "choice_c":"annuity account applications",
       "choice_d":"confirmations",
       "correct_answer":"D",
       "explanation":"A principal of a member firm is required to review and approve all new account applications. This includes annuity account applications which must be approved or denied within 7 days. A principal is required to review and approve all orders promptly by T+1. Confirmations are not required to be reviewed or approved by a principal. "
    },
    {
       "id":39570,
       "practice_test_id":6,
       "topic_id":1,
       "question":"Your firm, an introducing broker-dealer, utilizes the services of a carrying member firm. A customer contacts your firm after receiving a monthly statement that indicates securities positions were transferred from her account to an account she does not recognize. It is quickly determined that even though a letter of authorization (LOA) to complete the transfer was received, it was fraudulent. When customer accounts are to be carried on a fully disclosed basis, FINRA rules ultimately allocate the responsibility for safeguarding customer funds and securities to the:",
       "choice_a":"introducing firm.",
       "choice_b":"carrying firm.",
       "choice_c":"principal who initially approved the account.",
       "choice_d":"registered representative assigned the account.",
       "correct_answer":"B",
       "explanation":"The requirement that firms have supervisory procedures for reviewing and monitoring transfers of customer assets applies to both clearing and introducing firms. While the FINRA rule permits firms to allocate responsibility for the performance of certain functions between the carrying and introducing firms, it expressly requires that the carrying firm be allocated the responsibility for safeguarding customer funds and securities."
    },
    {
       "id":39596,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A member firm after receiving transfer instructions regarding a client\u0027s account via form ACATS has deemed one of the positions as being non transferable because it is a proprietary product of the carrying firm. In notifying the customer the carrying firm should include in the notification:",
       "choice_a":"any monetary penalty in the form of a fee levied on the account for attempting to transfer proprietary products away from the carrying firm.",
       "choice_b":"alternative methods of disposition for the non transferable assets which could not include direct and physical transfer to the customer in the customer\u0027s name.",
       "choice_c":"alternative methods of disposition for the non transferable assets which could not include keeping the securities with the carrying firm.",
       "choice_d":"alternative methods of disposition for the non transferable assets which could include liquidation",
       "correct_answer":"D",
       "explanation":"Regarding products that are non transferable because they are proprietary to the carrying firm, the carrying firm when notifying the customer of the non transferable status of the securities must include in the notification alternative methods of disposition for the non transferable assets. Alternative methods of disposition would include liquidation, retention by the carrying member or the option to transfer physically direct to the customer (not another member) in the customer\u0027s name."
    },
    {
       "id":39597,
       "practice_test_id":6,
       "topic_id":1,
       "question":"A carrying member may not take exception to a transfer instruction received via ACATS for which of the following?",
       "choice_a":"When the account title on the transfer instruction does not match that on the carrying member\u0027s records.",
       "choice_b":"When there is a dispute over the money balance in the account to be transferred.",
       "choice_c":"When additional documentation is required such as a death or marriage certificate.",
       "choice_d":"When the account is deemed to be flat meaning it contains no transferable assets.",
       "correct_answer":"B",
       "explanation":"There are a number of valid reasons a carrying firm can take exception to transfer instructions received via form ACATS and deny validation. Among the reasons would include the lack of documentation, a mismatched account title or the account having no transferable assets. However, a dispute over the money balance contained in the account is not one of them. In the event of such a dispute the carrying member must validate the transfer instructions and transfer the money balance reflected on its books for the account."
    },
    {
       "id":20256,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following is true of the ACAT process when a customer requests to have his securities transferred to another broker dealer?",
       "choice_a":"The carrying firm has 1 business day to validate the positions and an additional 3 business days to complete the transfer",
       "choice_b":"The carrying firm has 3 business days to validate the positions and an additional 3 business days to complete the transfer",
       "choice_c":"The carrying firm has 3 business days to validate the positions and an additional 4 business days to complete the transfer",
       "choice_d":"The carrying firm has 1 business day to validate the positions and an additional 4 business days to complete the transfer",
       "correct_answer":"A",
       "explanation":"The ACAT process allows the carrying firm one business day to either validate or take exception to the customer\u0027s positions. The firm then has an additional 3 business days to complete the transfer of those securities to the new broker dealer."
    },
    {
       "id":20257,
       "practice_test_id":"",
       "topic_id":2,
       "question":"When opening a new margin account at a broker dealer which of the following is not required?",
       "choice_a":"A signed margin agreement",
       "choice_b":"A signed credit agreement",
       "choice_c":"A signed loan consent",
       "choice_d":"A signed hypothecation agreement",
       "correct_answer":"C",
       "explanation":"The margin agreement details the terms of the margin at the broker dealer, the credit agreement states how interest is charged on the margin loan and the hypothecation agreement states that the customer agrees to allow the broker dealer to pledge his securities to the bank as collateral for the loan. All of these must be signed by the customer. The loan consent allows the broker dealer to loan out the customer\u0027s securities for short sales and is not required to open a margin account."
    },
    {
       "id":20293,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following are true when a customer takes a withdrawal from a 529 college savings plan and uses the money to pay for educational expenses?",
       "choice_a":"The principal will be taxed, but the growth will be federally tax free",
       "choice_b":"The growth will be taxed, but the principal is federally tax free",
       "choice_c":"Both the principal and the growth are federally taxable",
       "choice_d":"Both the interest and the growth are federally tax free",
       "correct_answer":"D",
       "explanation":"When a customer makes a contribution to a 529 plan he does so with after tax dollars, so the tax has already been paid. When he withdraws money to use for educational expenses, the growth is federally tax free and may be state tax free depending on where the customer resides."
    },
    {
       "id":20294,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following regarding 529 plans is a true statement?",
       "choice_a":"Only college savings plans have income limits for the donors",
       "choice_b":"Contribution limits vary from state to state",
       "choice_c":"Contributions are made pre-tax",
       "choice_d":"The account becomes the property of the beneficial owner upon the date of the first withdrawal",
       "correct_answer":"B",
       "explanation":"There are no income limitations on donors to 529 plans though the contribution limits may vary by state. The donor makes contributions to the account with after tax money and will always remain the owner of the account. Ownership of a 529 plan does not revert to the beneficial owner at any point."
    },
    {
       "id":20305,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Variable annuities are considered retirement vehicles and as such are required to follow many of the same rules as traditional IRAs. All of the following apply to both variable annuities and traditional IRAs except:",
       "choice_a":"Withdrawals before the age of 59\u00BD are subject to a 10% penalty",
       "choice_b":"Excess contributions are subject to a 6% penalty",
       "choice_c":"Withdrawals due to death are not subject to a 10% penalty",
       "choice_d":"Withdrawals due to disability are not subject to a 10% penalty",
       "correct_answer":"B",
       "explanation":"Both variable annuities and IRAs are subject to a premature withdrawal penalty that will be negated in the event of death or disability. Only the IRA has contribution limits, the variable annuity does not."
    },
    {
       "id":20309,
       "practice_test_id":"",
       "topic_id":2,
       "question":" Which of the following statements are true when a customer opens a new option account at a broker dealer? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> The customer must sign the option agreement </li><li>The broker dealer will furnish the customer with a copy of the risk disclosure document  </li><li>The account must be approved by the ROSFP prior to the first trade  </li><li>The account must be approved by a branch manager prior to the first trade</li></ol>",
       "choice_a":"I  and  II",
       "choice_b":"III  and  IV",
       "choice_c":"I, II  and  IV",
       "choice_d":"I, III  and  IV",
       "correct_answer":"C",
       "explanation":"When opening a new option account a customer will sign the option agreement and be given a copy of the risk disclosure document. A branch manager may initially approve the account as long as it is subsequently approved by the ROSFP within a reasonable period of time."
    },
    {
       "id":21455,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Mr. Jones has just completed a review of your firm\u0027s services and decides to open an account with your firm after meeting with his new representative. Your firm must provide Mr. Jones with a copy of the new account information:",
       "choice_a":"within 30 days",
       "choice_b":"within 45 days",
       "choice_c":"with the first statement",
       "choice_d":"by the completion of the first transaction",
       "correct_answer":"A",
       "explanation":"A firm opening a customer account must provide a copy of the information contained on the new account within 30 days. This is done to ensure that the information on file relating to the customer is accurate. "
    },
    {
       "id":37006,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following would be deemed to be a fiduciary when operating an account at a broker-dealer?",
       "choice_a":"The custodian on a ugma account",
       "choice_b":"The custodian on a utma account",
       "choice_c":"The owner of an account established as transfer on death for a named beneficiary",
       "choice_d":"The conservator on a guardian account",
       "correct_answer":"D",
       "explanation":"The only person who would be deemed to be a fiduciary when operating any of the above accounts would be the conservator who is appointed by a court to manage the affairs of someone who has been deemed incompetent."
    },
    {
       "id":37005,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An Investor who maintains both a cash and margin account with your firm executes an order in a non discretionary account. The investor tells the representative to buy 500 shares ABC whenever the representative feels the price is right. Which of the following statements is correct?",
       "choice_a":"The order may not be accepted as this is a non discretionary account",
       "choice_b":"The order may be accepted if the agent receives discretionary authority in writing prior to executing the order",
       "choice_c":"The order must be approved both before and after the execution by a principal of the firm",
       "choice_d":"The order must be approved by a principal once the transaction has been completed",
       "correct_answer":"D",
       "explanation":"An investor may provide a registered representative with price and time discretion, allowing the representative to choose the price for the security. This order would only require principal approval after the transaction has been completed."
    },
    {
       "id":37101,
       "practice_test_id":"",
       "topic_id":2,
       "question":"The U.S.A PATRIOT Act, stipulates that:",
       "choice_a":"financial institutions should be encouraged to share information regarding suspected money laundering or terrorist activity",
       "choice_b":"information regarding suspected money laundering or terrorist activity may never be shared among financial institutions",
       "choice_c":"sharing information among financial institutions regarding suspected terrorist acts is encouraged, but not information regarding money laundering activities",
       "choice_d":"sharing information regarding suspected money laundering activities is encouraged but not information regarding terrorist acts activity",
       "correct_answer":"A",
       "explanation":"Under the U.S.A PATRIOT Act, all financial institutions, regulatory bodies and law enforcement entities, are encouraged to share all information regarding suspected money laundering or terrorist activity."
    },
    {
       "id":37004,
       "practice_test_id":"",
       "topic_id":2,
       "question":"As it relates to the operation of an able account, for a disabled individual, which of the following is correct?",
       "choice_a":"the maximum dollar limit in an able account is $100,000 ",
       "choice_b":"any money remaining in the account upon the death of the beneficiary will first go to repay the state where the individual resides",
       "choice_c":"the individual who funds the able account is deemed to be the owner of the account",
       "choice_d":"able accounts qualify for pre-tax contributions so long as the individual had a qualifying disability prior to reaching the age of 26",
       "correct_answer":"B",
       "explanation":"The only correct choice is that any money remaining in the account at the time of the person\u0027s death will go to repay the state for any supplemental insurance benefits paid to the individual during their lifetime. contributions to an able account are made with after-tax dollars and the disabled individual is deemed to be both the owner and beneficiary of the account."
    },
    {
       "id":37100,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Regarding a discretionary account which of the following statements is true?",
       "choice_a":"It must be approved by a principal of the firm and it must be reviewed frequently by a principal",
       "choice_b":"It must be approved by a principal of the firm and orders must have principal approval before entry",
       "choice_c":"It must be approved by the SEC and it must be reviewed frequently by a principal",
       "choice_d":"It must be approved by the SEC and orders must have principal approval before entry",
       "correct_answer":"A",
       "explanation":"The opening of a discretionary account must first be approved by a principal of the firm. While orders must be approved by a principal no later than the end of day on the day of the transaction, it is not required that they be approved before entry. Finally, these accounts must be reviewed frequently by a principal to ensure suitability standards are being met."
    },
    {
       "id":37010,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A registered representative sits down with a potential new customer. The potential customer is a foreign national here on a Visa. The potential customer tells a registered representative that they do a large amount of international business and as a result will be sending and receiving multiple wires from overseas. Which of the following actions should the rep and the broker-dealer take?",
       "choice_a":"The registered rep should open the account and the broker-dealer should approve the account without restriction as the customer is a foreign business person",
       "choice_b":"The registered rep should refuse to open the account as multiple International wires are red flags for money laundering",
       "choice_c":"The registered rep should open the account, the broker-dealer should approve the account and the account will be subject to heightened supervision as part of the broker dealer\u0027s anti money laundering program",
       "choice_d":"Prior to opening the account the account would have to be approved by the broker dealer\u0027s AML officer",
       "correct_answer":"C",
       "explanation":"The registered rep should open the account and present the account to a principal for approval. The principal should approve the account and the account will be subject to heightened supervisory requirements due to the frequent International wire transfers"
    },
    {
       "id":37103,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A customer of a member firm, one party to an account designated as joint tenants in common (JTIC), has died. Once informed of this event the firm should:",
       "choice_a":"freeze the account preventing any transactions to occur",
       "choice_b":"transfer all of the assets to the surviving party\u0027s individual account",
       "choice_c":"allow the surviving parties to the account to continue trading",
       "choice_d":"immediately set up an estate account for the party who has died",
       "correct_answer":"A",
       "explanation":"In a joint tenant in common (JTIC) account, the assets of a deceased party will go to that party\u0027s individual estate. A member firm first freezes the account and then awaits the proper court documents to facilitate the transfer of assets. Freezing the account prevents trading by surviving parties to the account. However, If the account was set up as joint tenants with rights of survivorship (JTWROS) account, trading by the surviving tenants could continue."
    },
    {
       "id":37102,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Your customer wants to open a cash account as guardian for her nephew. In order to open the account designated this way, in addition to a new account form, the member firm would need which of the following?",
       "choice_a":"A copy of the court order appointing guardianship to the aunt",
       "choice_b":"A limited power of attorney given by the nephew to his aunt",
       "choice_c":"A full power of attorney given by the nephew to his aunt",
       "choice_d":"A hypothecation agreement between the aunt and the member firm",
       "correct_answer":"A",
       "explanation":"Guardianship can be granted for a number of reasons. The appointment of a person as guardian of another is made by court order. Therefore, in addition to any new account forms required, a copy of that court order would be needed to open an account designated this way. Remember that hypothecation agreements are only applicable for margin (not cash) accounts."
    },
    {
       "id":37104,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A registered representative has made written notice to, and received approval from a member firm to be listed as a beneficiary for the estate of one of the registered representative\u0027s customers. For purposes of record retention which of the following applies?",
       "choice_a":"Both the written notice and approval must be preserved for at least three years after the date that the beneficiary status has terminated or the registered person\u0027s association with the member has terminated.",
       "choice_b":"The approval only needs to be preserved for at least three years after the date that the beneficiary status has terminated or the registered person\u0027s association with the member has terminated.",
       "choice_c":"The approval only needs to be preserved for the lifetime of the member firm.",
       "choice_d":"The written notice must be preserved for at least three years after the date that the beneficiary status has terminated or the registered person\u0027s association with the member has terminated but the approval must be preserved for the lifetime of the member firm.",
       "correct_answer":"A",
       "explanation":"Whether being named a customer\u0027s beneficiary or someone who holds a position of trust for a customer, written notice must be made to the member firm and approval must have been obtained prior to being named. Both the written notice and approval must be preserved for at least three years after the date that the beneficiary status has terminated or the registered person\u0027s association with the member firm has terminated."
    },
    {
       "id":37105,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A member firm reserves the right to disclose nonpublic private information about their customers to unaffiliated third parties. In order to do so the member firm must:",
       "choice_a":"provide notice to customers at the time the account is opened and provide reasonable means for customers to opt out of such disclosures",
       "choice_b":"provide notice to customers at the time the account is opened and provide notice to customers each time a transaction occurs within the account",
       "choice_c":"provide notice to customers each time a transaction occurs within the account and provide reasonable means for customers to opt out of such disclosures",
       "choice_d":"provide reasonable means for customers to opt out by sending a written request with signature witnessed by a notary",
       "correct_answer":"A",
       "explanation":"When a broker-dealer reserves the right to disclose nonpublic personal information about their account holders to third nonaffiliated parties, it must notify the customer at the time the account is opened and annually thereafter. A means to opt out that is reasonable and easy for the customer to abide by must also be provided."
    },
    {
       "id":37106,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Each of the following scenarios should be identified as a red flag in accordance with policies and procedures regarding account instructions received from customers by email except for one. Which is it?",
       "choice_a":"Your customer requests in an email that all securities in a joint account with his brother be sold and a check made payable to the named parties to the account be forwarded as soon as able",
       "choice_b":"Your customer requests by email to have specific securities in the account sold with the sales proceeds transferred to a third party not named on the account",
       "choice_c":"Emailed account instructions are received that cannot be verified by the member firm as having come from the account holder",
       "choice_d":"An emailed request is received instructing that funds in the account be sent to an overseas bank account not previously known to be associated with the client",
       "correct_answer":"A",
       "explanation":"All member firms are required to have in place written supervisory policies and procedures for reviewing and monitoring the movement of funds and a method of verifying that instructions received by email came from the customer named to the account and not an unknown third party. All parties to a joint account are authorized to do transactions or withdraw funds or securities from the account as long as the distributions are made payable to all parties in the account. This alone would not be viewed as unusual. Scenarios that might be viewed as unusual and should raise a red flag for example are those where account instructions received are noted as urgent or those instructing movement of funds overseas or made payable to third parties."
    },
    {
       "id":37107,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A longtime customer of a broker-dealer mentioned that if ABC common stock, a stock well known and included in a major market index, drops five points, he would most likely want to purchase it. The stock falls by more than the five points mentioned by the customer but his registered representative cannot reach him. Given the customer has long traded these types of stocks in his account which is non discretionary, the registered representative purchases the stock. Given the circumstances, the registered representative has:",
       "choice_a":"engaged in a prohibited practice; unauthorized discretionary trading",
       "choice_b":"acted ethically; carrying out the customers intended actions even though the customer could not be reached",
       "choice_c":"engaged in a prohibited practice; making unsuitable recommendations",
       "choice_d":"engaged in a prohibited practice; front running",
       "correct_answer":"A",
       "explanation":"In the absence of discretionary power, the trading authorization given for a discretionary account, trades placed in the customer\u0027s account without the customer\u0027s specific consent constitute the prohibited practice of unauthorized use of discretion. Though the transaction does not appear unsuitable, given the customer\u0027s history of trading, a discretionary account would be needed for the registered representative to enter the order without instructions to do so. Front running refers to the prohibited practice of placing proprietary firm orders or orders for oneself ahead of customer orders."
    },
    {
       "id":37024,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Mr. Thompson, a 70 year old client of a large financial services firm, sent a letter via email to his investment professional requesting that the firm transfer $100,000 to the account of LMN Manufacturing. Which of the following would be the greatest concern to the firm?",
       "choice_a":"Mr. Thompson maybe the victim of identity theft",
       "choice_b":"Mr. Thompson Maybe the victim of elder abuse",
       "choice_c":"Mr. Thompson may be engaging in money laundering",
       "choice_d":"Mr. Thompson  was not the sender of the email",
       "correct_answer":"C",
       "explanation":"While all of the choices listed would be concerns for the firm, the request to transfer money to another seemingly unrelated account is a serious red flag for money laundering and would be the biggest concern for the firm."
    },
    {
       "id":37025,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A client of your broker-dealer is a foreign national who engages in international business transactions. The products that his company makes are traditionally sold for several hundred dollars each. The firm notices that the client has recently received a wire transfer into his account in the amount of $4,200. The wire was received from a little-known bank based in a country known to sponsor terrorism. Which of the following actions should the firm take?",
       "choice_a":"The firm should submit a suspicious activity report",
       "choice_b":"The firm should submit a currency transaction report",
       "choice_c":"The firm should maintain a record of the wire transfer",
       "choice_d":"The firm should inform FinCen of the wire transfer",
       "correct_answer":"C",
       "explanation":"Financial services firms are required to maintain a record of any International wire greater than $3,000. The customer is known to export products overseas and the dollar value does not exceed the $5,000 threshold requiring the filing of a suspicious activity report."
    },
    {
       "id":37026,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Sue is a retired schoolteacher who has maintained an account with your firm for more than 20 years. The account has been primarily invested to generate income to help Sue meet her monthly expenses. Sue enjoys the check writing privileges afforded to her through your firm\u0027s money market account and generally spends about $3,000 per month. One day Sue calls in and requests that a check be sent to a third party in the amount of $50,000. Which of the following would not be an appropriate action based on this request?",
       "choice_a":"Withhold sending the check for 15 days",
       "choice_b":"Call the trusted contact and inquire about the validity of the request",
       "choice_c":"Investigate the recipient of the payment",
       "choice_d":"Forward the check as requested by the client",
       "correct_answer":"D",
       "explanation":"The request is significantly outside the normal course of business for the retired account owner. The large sum being sent to a third party is a substantial red flag for elder abuse. The registered rep and the firm should do all they can to ensure that the request is indeed valid. All of the choices listed would be appropriate actions for the firm to take with the exception of Simply forwarding the check as requested by the client."
    },
    {
       "id":37027,
       "practice_test_id":"",
       "topic_id":2,
       "question":"As a relates the automated client account transfer system which of the following is incorrect?",
       "choice_a":"Any disputes between broker-dealers must be resolved within 3 days",
       "choice_b":"A registered representative changing broker-dealers may not use a bulk account transfer request to move a large client base",
       "choice_c":"If a broker-dealer is changing clearing firms, if approved by FINRA, the broker-dealer may use a negative consent letter",
       "choice_d":"All account transfers between broker-dealers must adhere  to the requirements of Regulation SP",
       "correct_answer":"A",
       "explanation":"All the choices listed are correct except that disputes between broker-dealers must be resolved in 5 days, not in 3 days as listed in the question."
    },
    {
       "id":37108,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Your customer is a non-registered employee of another broker-dealer. When the account was opened or to maintain the account at your broker-dealer which of the following would not be required?",
       "choice_a":"The customer\u0027s employer must approve each transaction prior to order entry",
       "choice_b":"If requested by the employer, they must receive duplicate copies of all transaction confirmations",
       "choice_c":"The employer would have to have been notified in writing by the employee intending to open the account prior to doing so",
       "choice_d":"The employer would have to have granted written approval before the account could be opened",
       "correct_answer":"A",
       "explanation":"There is no requirement for the employer to approve orders prior to or at the time of entry. The rules do require that the employing broker-dealer be notified in writing and that they give prior written consent before the account can be opened by their employee at another broker-dealer. Duplicate copies for both account statements and trade confirmations must be sent to the employer only if they had requested them."
    },
    {
       "id":37109,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Of the following individuals employed by financial institutions, who would be able to open an account at another FINRA member broker-dealer without abiding by the rules that require notifying or receiving permission from their employer?",
       "choice_a":"An agent with an insurance license allowing for the sale of fixed annuities only",
       "choice_b":"A registered person employed by a member firm to trade US government securities",
       "choice_c":"A non-registered person employed by a broker-dealer in the purchases and sales department",
       "choice_d":"An agent with an insurance company licensed to sell both fixed and variable annuities",
       "correct_answer":"A",
       "explanation":"Employees of member financial institutions who want to open a securities account with another member firm must give prior written notice to the employing member, and receive prior written consent from the employing member before the account can be opened. It should be recognized that a person selling fixed annuities only (not a security like a variable annuity) need not be registered to sell securities and therefore wouldn\u0027t have to be an employee of a member firm to do so."
    },
    {
       "id":37110,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A member firm holding an account in the name of a general partnership receives notification that one of the partners has died. The correct procedure to follow would include which of the following?",
       "choice_a":"The member firm must await to receive written authorization from the remaining partners before the execution of any further orders may occur",
       "choice_b":"The member firm must immediately exercise any option position that is currently in-the-money or may reasonably be by the end of the business day",
       "choice_c":"The member firm must await a court order or ruling showing that the remaining partners now have all authority over the account including directing that orders be entered",
       "choice_d":"Because the partnership does not dissolve as a result of the death of one of its partners the member firm must permit trading to continue as before with no further required documentation",
       "correct_answer":"A",
       "explanation":"For partnership accounts, if one partner dies, the member firm needs written authorization from the remaining partners before executing any further orders. This written authorization generally takes the form of an amended partnership agreement as the original partnership having one partner deceased, no longer exists."
    },
    {
       "id":37111,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Your broker-dealer is opening a new cash account for a small corporation. Which of the following documents is not required to be filed by the corporation to do so?",
       "choice_a":"a hypothecation agreement",
       "choice_b":"a new account form",
       "choice_c":"a copy of the corporate charter",
       "choice_d":"a copy of the corporate resolution",
       "correct_answer":"A",
       "explanation":"A hypothecation agreement is only needed to open a margin account, not a cash account. For corporate accounts to be opened, a new account form must be on file, the corporation\u0027s charter must be provided as proof that the corporation exists, and a corporate resolution is required to designate by name, those authorized to enter orders."
    },
    {
       "id":37112,
       "practice_test_id":"",
       "topic_id":2,
       "question":"As required by the Uniform Practice Code, the transfer of customer accounts by a carrying firm must be handled in which of the following ways?",
       "choice_a":"Upon receipt of the signed ACAT Form, the carrying firm has 1 business day to validate the positions and then must complete the transfer within 3 business days of validation",
       "choice_b":"Upon receipt of the signed ACAT Form, the carrying firm has 2 business days to validate the positions and then must complete the transfer within 3 business days of validation",
       "choice_c":"Upon receipt of the signed ACAT Form, the carrying firm has 3 business days to validate the positions and then must complete the transfer within 1 business day of having received the ACAT form",
       "choice_d":"Upon receipt of the signed ACAT Form, the carrying firm has 3 business days to validate the positions and then must complete the transfer within 15 calendar days of having received the ACAT form",
       "correct_answer":"A",
       "explanation":"Upon receipt of the signed account transfer (ACAT) form, the carrying firm has 1 business day to validate the positions in the account. Once validated, the carrying firm has 3 business days to transfer the positions to the receiving firm."
    },
    {
       "id":37113,
       "practice_test_id":6,
       "topic_id":2,
       "question":"If opening an account for a registered person associated with another member firm, which of the following must occur?",
       "choice_a":"Written consent from the employing member firm must be obtained by the registered person prior to opening the account",
       "choice_b":"The member firm opening the account must send duplicate account statements automatically to the registered person\u0027s employing firm at least quarterly",
       "choice_c":"The registered person is required to notify their employer immediately in writing once the account is opened at another member firm",
       "choice_d":"There are no notification or consent requirements if the account to be opened is a joint account with a non-registered person",
       "correct_answer":"A",
       "explanation":"A registered person must obtain the written consent of the employing member prior to opening an account at another member firm. These rules apply to both individual accounts and accounts opened jointly. Duplicate account statements or trade confirmations need only be sent if the employing member requests that it be done."
    },
    {
       "id":37114,
       "practice_test_id":1,
       "topic_id":2,
       "question":"Aligning with the requirement to verify the identity of any person opening an account with a financial institution including broker-dealers, which of the following is not accurate?",
       "choice_a":"No transactions are allowed in the account until the customer identification is verified",
       "choice_b":"The individual to be named account owner must provide a valid government picture ID",
       "choice_c":"Determination must be made as to whether the applicant is on a list of known or suspected terrorist individuals and / or groups",
       "choice_d":"Even if not received yet, applicants who have applied for a social security number may still open an account",
       "correct_answer":"A",
       "explanation":"No industry or Federal law prevents a transaction from being done in a new account while still awaiting to verify a customer\u0027s identification. However, it should also be noted that member firms and financial institutions at large are not prevented from having such a rule in-house."
    },
    {
       "id":37115,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Of the following accounts identify the only one that allows the registered owner of the account to pass all or a portion of the account to a named beneficiary, thus avoiding probate, should the owner of the account die?",
       "choice_a":"Transfer on death (TOD)",
       "choice_b":"Fiduciary",
       "choice_c":"Joint tenants in common (JTIC)",
       "choice_d":"Partnership",
       "correct_answer":"A",
       "explanation":"An account opened Transfer on Death (TOD) allows the registered owner of the account to pass all or a portion of the account upon death to a named beneficiary. Because the estate is bypassed, probate is avoided."
    },
    {
       "id":37116,
       "practice_test_id":2,
       "topic_id":2,
       "question":"A new customer is opening an account with your firm. In order to do so, all of the following information must be obtained except the customer\u0027s:",
       "choice_a":"educational background",
       "choice_b":"primary residence address",
       "choice_c":"social security number",
       "choice_d":"date of birth",
       "correct_answer":"A",
       "explanation":"A customer\u0027s level of education or background is not required to open a new account. A physical address (not a PO box), SSN, and DOB are all required."
    },
    {
       "id":37117,
       "practice_test_id":3,
       "topic_id":2,
       "question":"A registered representative, new to a member firm, was previously appointed to a position of trust (trustee, POA, executor) for a customer of the member firm prior to her association with the member firm. Within how many days of becoming associated with the member does the registered representative have to provide notice to, and receive approval from the member?",
       "choice_a":"Within 30 calendar days",
       "choice_b":"Within 45 calendar days",
       "choice_c":"Within 10 business days",
       "choice_d":"No later than the end of the first business day of the association",
       "correct_answer":"A",
       "explanation":"When a position of trust exists between a registered representative and a customer of a member firm prior to the registered persons association with that member, notice to and approval from the member firm must occur within 30 calendar days of the registered persons association with the member."
    },
    {
       "id":37118,
       "practice_test_id":4,
       "topic_id":2,
       "question":"A registered representative is asked by a customer\u0027s attorney to act as trustee for the customer\u0027s trust account. In order for the registered representative to be appointed to this position of trust, the registered representative must:",
       "choice_a":"make written notice to the member firm of the proposed appointment and receive the member\u0027s written approval prior to the appointment.",
       "choice_b":"make written notice to the member firm that the appointment has been requested by the customer\u0027s attorney thus allowing the appointment to be made.",
       "choice_c":"make written notice of the appointment to the member firm presenting all of the supporting documents prepared by the customer\u0027s attorney and finalizing the appointment.",
       "choice_d":"accept the appointed position of trust in writing to the customer\u0027s attorney and supply a copy of the acceptance to the member firm.",
       "correct_answer":"A",
       "explanation":"Whenever a position of trust is proposed, written notice to, and written approval from the member firm must be made prior to the appointment."
    },
    {
       "id":37119,
       "practice_test_id":5,
       "topic_id":2,
       "question":"A new client is transferring his brokerage account to your firm. Transfer instructions have been given to the carrying firm. Regarding the transfer procedures, which one of the following statements is correct?",
       "choice_a":"The carrying firm has one business day to either validate or take exception to the instructions received",
       "choice_b":"The carrying firm has two business days to either validate or take exception to the instructions received",
       "choice_c":"The carrying firm may only take exception if there is a dispute over the value of the assets in the account",
       "choice_d":"Account transfers must be completed by carrying firms within ten business days of receiving the instructions. Validation or exception occurs later at the new or receiving broker-dealer",
       "correct_answer":"A",
       "explanation":"Validation or exception to the transfer instructions by the carrying firm must take place within one business day of the request. Completion of the transfer cannot occur unless the instructions have been validated. Dispute over the value of the assets in the account is not an allowable reason for taking exception to the transfer."
    },
    {
       "id":37120,
       "practice_test_id":6,
       "topic_id":2,
       "question":"Regarding account transfers, FINRA rules require the carrying member to transfer positions in the account to the receiving member within how many business days of validation?",
       "choice_a":2,
       "choice_b":1,
       "choice_c":3,
       "choice_d":5,
       "correct_answer":"C",
       "explanation":"Once the carrying firm validates the positions, they must transfer the positions within 3 business days."
    },
    {
       "id":37121,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An account is opened at a broker-dealer by a new customer. How many days does the member firm have to provide the customer with a copy of the new account record?",
       "choice_a":"30 calendar days",
       "choice_b":"5 business days",
       "choice_c":"15 business days",
       "choice_d":"60 calendar days",
       "correct_answer":"A",
       "explanation":"When a new account is opened a member firm must provide the new customer with a copy of the account record (new account form) within 30 calendar days of opening the account."
    },
    {
       "id":37122,
       "practice_test_id":6,
       "topic_id":2,
       "question":"After establishing an UTMA account for his niece, naming himself as the custodian, an uncle places 1,000 shares of ABC stock currently selling at $18 per share into the account. Within days, fueled by takeover rumors, the stock is trading at $30 per share. The uncle requests to replace the stock he placed in the account with US government treasury bonds having a face value of $25,000. Under the provisions of the Uniform Transfer to Minors Act: ",
       "choice_a":"the gift given cannot be taken back, reclaimed or replaced by the donor of the gift",
       "choice_b":"the replacement would not be permitted because it exceeds the maximum amount that may be given to the minor by an adult who names himself custodian.",
       "choice_c":"this is allowable because the replacement securities have a value equal to or exceeding the amount of the original gift.",
       "choice_d":"This would be permitted if the donor of the gift was someone other than the custodian",
       "correct_answer":"A",
       "explanation":"Gifts under UTMA are irrevocable. They may neither be reclaimed, replaced or substituted. Gifts in any amount can be given by any adult donor including the custodian, but gifts in excess of a certain dollar amount determined by the IRS and subject to change each year, might require the donor to pay a gift tax."
    },
    {
       "id":37123,
       "practice_test_id":2,
       "topic_id":2,
       "question":"Three individuals, none of whom are related, want to open a joint account with your firm. Each wants equal trading authority in the account and they specify that each wants their portion of ownership to revert to their individual estate in the event one of them dies. A registered representative recognizes that the account should be opened as a:",
       "choice_a":"joint tenants in common account",
       "choice_b":"joint tenants with right of survivorship account",
       "choice_c":"trust account",
       "choice_d":"community property account",
       "correct_answer":"A",
       "explanation":"This account should be opened as; joint tenants in common. These types of accounts revert a tenant\u0027s ownership in the account to that party\u0027s estate should that party die."
    },
    {
       "id":37124,
       "practice_test_id":3,
       "topic_id":2,
       "question":"A customer is opening a new cash account with your member firm. Which of the following transactions can occur in the account? Of the activities listed only the purchase of securities could occur in a cash account. Borrowing money or securities from a member, the short sale of securities or writing uncovered calls, are all activities requiring that a margin account be in place.",
       "choice_a":"Writing uncovered calls",
       "choice_b":"Selling short both listed and unlisted common and preferred shares",
       "choice_c":"The purchase of initial public offering (IPO) shares of common stock",
       "choice_d":"Borrowing money from the member firm for the purchase of exchange listed securities",
       "correct_answer":"C",
       "explanation":"Of the activities listed only the purchase of securities could occur in a cash account. Borrowing money or securities from a member, the short sale of securities or writing uncovered calls, are all activities requiring that a margin account be in place."
    },
    {
       "id":37125,
       "practice_test_id":4,
       "topic_id":2,
       "question":"In order to assist financial institutions in determining if any customers or potential customers have been identified as posing terroristic threats or are involved in money laundering activities, the Office of Foreign Asset Control (OFAC) publishes and maintains:",
       "choice_a":"the customer identification program (CIP)",
       "choice_b":"the \u0022Specially Designated Nationals\u0022 list",
       "choice_c":"the national do-not-call list",
       "choice_d":"regional do-not-call lists on a state, by state basis",
       "correct_answer":"B",
       "explanation":"The Office of Foreign Asset Control (OFAC) publishes and maintains the \u0022Specially Designated Nationals\u0022 list. The list is available to all financial institutions with the intent of assisting them in identifying those who pose terroristic threats or are involved in money laundering activities."
    },
    {
       "id":37126,
       "practice_test_id":5,
       "topic_id":2,
       "question":"A new customer is opening an account with your broker-dealer. The federal legislation mandating that your broker-dealer verify the identity of the new account holder is the:",
       "choice_a":"USA PATRIOT Act",
       "choice_b":"Securities Exchange Act of 1934",
       "choice_c":"Uniform Securities Act of 1956",
       "choice_d":"Insider Trading Act",
       "correct_answer":"A",
       "explanation":"The USA PATRIOT Act (Uniting and Strengthening America by Providing Appropriate Tools Required to Intercept and Obstruct Terrorism) through the customer identification program (CIP) mandates that all financial institutions including broker-dealers obtain identifying information on each new customer."
    },
    {
       "id":37127,
       "practice_test_id":6,
       "topic_id":2,
       "question":"Your customer asks you how a durable power of attorney differs from other power of attorneys. You correctly explain that a key feature that differentiates it from other POAs is that it will:",
       "choice_a":"no longer exist once the party who has granted the durable POA dies",
       "choice_b":"continue to exist if the grantor is later deemed mentally incompetent",
       "choice_c":"no longer exist if the person who was given the durable POA dies",
       "choice_d":"revert from a full POA to a limited POA in the event the grantor of the POA dies",
       "correct_answer":"B",
       "explanation":"The durable POA will survive even if the party who granted it is later declared mentally incompetent. This is a key difference when compared to other forms of POAs. A POA can be either limited or full, and in all cases will cease to exist if either party, grantor or designee dies, whether they are durable POAs or not."
    },
    {
       "id":37128,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A financial institution is required to give a disclosure to new customers regarding its policies and procedures for maintaining customer privacy. How often must existing customers receive an updated notice or the same information?",
       "choice_a":"annually",
       "choice_b":"monthly",
       "choice_c":"quarterly",
       "choice_d":"only when an account statement is required to be sent",
       "correct_answer":"A",
       "explanation":"Financial institutions are required to give a clear disclosure to new customers regarding its policies and procedures for customer privacy at the time an account is opened. In addition, customers must receive the same or updated information no less than annually thereafter."
    },
    {
       "id":37129,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Your firm opens an account for a registered representative of another member firm. The registered representative\u0027s employer must be sent written notification of the new account opening:",
       "choice_a":"only if the registered representative opening the account has authorized your firm to do so",
       "choice_b":"before an order execution can occur",
       "choice_c":"either by the representative or by your firm immediately",
       "choice_d":"within 5 business days of the account opening",
       "correct_answer":"B",
       "explanation":"In this scenario it is the firm opening the account who is responsible for notifying in writing the registered representative\u0027s employer. The written notification must be made before the execution of any order can occur."
    },
    {
       "id":37130,
       "practice_test_id":6,
       "topic_id":2,
       "question":"SEC rules regarding the accuracy of information on customer accounts aligns with which of the following statements?",
       "choice_a":"Broker-dealers must furnish a customer who reports a change in employment, an updated account record within 30 calendar days of receiving notice of the change and update the account record no less frequently than once every 36 months",
       "choice_b":"Broker-dealers must furnish a customer who reports a change in employment, an updated account record within 30 calendar days of receiving notice of the change and update the account record no less frequently than once every other year",
       "choice_c":"Broker-dealers must furnish a customer who reports a change in employment, an updated account record within 10 business days of receiving notice of the change and update the account record no less frequently than once every year",
       "choice_d":"Broker-dealers must furnish a customer who reports a change in employment, an updated account record within 10 business days of receiving notice of the change and update the account record no less frequently than once every 36 months",
       "correct_answer":"A",
       "explanation":"The Securities Exchange Commission mandates that the information obtained from each new customer is accurate. In accordance with this, SEC rules require broker-dealers to furnish each new customer a copy of the account record within 30 calendar days of account opening. The same is required any time the record has been updated which must occur whenever significant account information changes such as a change in employment. Finally, account records must be updated no less than once each 36 months even when no changes have been reported."
    },
    {
       "id":37131,
       "practice_test_id":2,
       "topic_id":2,
       "question":"A registered representative working for a FINRA member firm would not be permitted to open a joint account for:",
       "choice_a":"Bradley Smith and his 12-year-old daughter Amanda",
       "choice_b":"Jenna Smith and Megan Jones, friends for over 30 years",
       "choice_c":"George Smith and Bill Jones, adult college roommates",
       "choice_d":"Kelly Jones, age 36 and her brother Ronald, age 29",
       "correct_answer":"A",
       "explanation":"Joint account owners must be legally recognized as adults. There may be two or more persons who share ownership of the joint account and all parties to the account have the right to exercise control over the account. A minor however may not legally exercise control over an account and therefore may not be an owner of record of an account. However, a minor, rather than being an owner of record may be notated as the beneficial owner of an account. This would require that the account be a custodial account (UGMA or UTMA), not a joint account."
    },
    {
       "id":37132,
       "practice_test_id":3,
       "topic_id":2,
       "question":"While monitoring the activity in an account an electronic transfer of cash in the amount of $34,000 is red flagged. In this scenario a member firm would need to file a currency transaction report (CTR) with the:",
       "choice_a":"Department of the Treasury",
       "choice_b":"Securities Exchange Commission (SEC)",
       "choice_c":"Federal Bureau of Investigation (FBI)",
       "choice_d":"Office of Foreign Assets Control (OFAC)",
       "correct_answer":"A",
       "explanation":"Currency transactions over $10,000 must be reported on a CTR via the Financial Crimes Enforcement Network (FinCEN) with the Department of the Treasury."
    },
    {
       "id":37133,
       "practice_test_id":4,
       "topic_id":2,
       "question":"The Bank Secrecy Act requires that currency transaction reports (CTRs) be filed for cash transactions that exceed:",
       "choice_a":"$5,000",
       "choice_b":"$10,000",
       "choice_c":"$25,000",
       "choice_d":"$50,000",
       "correct_answer":"B",
       "explanation":"As required by the Bank Secrecy Act, financial institutions must file a currency transaction report (CTR) for each cash transaction that exceeds $10,000. Note; not $10,000 or more, but exceeds $10,000."
    },
    {
       "id":37134,
       "practice_test_id":5,
       "topic_id":2,
       "question":"The filing of a currency transaction report (CTR) is best described as being required for cash transactions used in an account to:",
       "choice_a":"purchase stocks, bonds, mutual funds, and other investments, or payoff loans, and includes the electronic transfer of funds to do so",
       "choice_b":"purchase stocks, bonds, or mutual funds but not debt instruments such as certificates of deposit",
       "choice_c":"purchase debt instruments only such as corporate bonds, CDs, or Treasury securities, but does not include the electronic transfer of funds to do so",
       "choice_d":"purchase tangible investments only, such as real estate, collectibles and art, but does not include the electronic transfer of funds to do so",
       "correct_answer":"A",
       "explanation":"The filing of a CTR is required for cash transactions to purchase any security or investment such as real estate, art or collectibles and includes those transactions used to pay off loans as well as the electronic transfer of funds to do any of the aforementioned."
    },
    {
       "id":37135,
       "practice_test_id":6,
       "topic_id":2,
       "question":"A new customer to your firm has opened a cash account giving his brother trading authorization. He makes it clear that his brother should not have the authorization to add to, or withdraw assets from the account. In order to accommodate the customer which two documents would have been needed by your firm to open the account?",
       "choice_a":"A new account form and a full POA",
       "choice_b":"A margin agreement and a limited POA",
       "choice_c":"A new account form and a limited POA",
       "choice_d":"A margin agreement and a full POA",
       "correct_answer":"C",
       "explanation":"A new account form is required to open the new cash account. For a cash account no margin agreement is needed. A limited power of attorney is also needed to accommodate the customer\u0027s request to give his brother trading authorization only, with no authorization to withdraw assets from the account. The latter would require a full power of attorney."
    },
    {
       "id":37136,
       "practice_test_id":"",
       "topic_id":2,
       "question":"One of your customers designates you, her registered representative, as having limited power of attorney for her account. Which of the following is true?",
       "choice_a":"The limited POA requires that you must have principal approval for any transaction prior to order entry",
       "choice_b":"The customer must renew the power of attorney in writing no less frequently than annually",
       "choice_c":"The limited POA requires that you receive written permission from the customer for each transaction prior to order entry",
       "choice_d":"In order for the limited POA to be granted to the RR it must be in writing and have the customer\u0027s authorizing signature",
       "correct_answer":"D",
       "explanation":"For the limited POA to exist, a registered representative must have prior written authorization from the customer (by signature) and written approval from a principal of the firm before exercising any discretionary authority in the account. The limited POA allows the RR to enter orders without customer approval prior to order entry. While a principal of the firm must review and approve all trades on a daily basis, prior approval of discretionary orders is not required."
    },
    {
       "id":37137,
       "practice_test_id":6,
       "topic_id":2,
       "question":"A customer, completely unsolicited, calls his registered representative and places an order to purchase a security that does not align with the customer\u0027s investment objectives and might be deemed unsuitable for the client. Under FINRA rules, the registered representative:",
       "choice_a":"must obtain approval of a member principal prior to order entry",
       "choice_b":"can enter the order and should mark the order ticket unsolicited",
       "choice_c":"must request that the order be placed in writing prior to order entry",
       "choice_d":"cannot enter the order under any circumstances",
       "correct_answer":"B",
       "explanation":"FINRA rules do not prohibit the representative from entering the order at the customer\u0027s request. However, the trade ticket should be marked unsolicited."
    },
    {
       "id":37138,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Account identification and verification procedures in accordance with the U.S.A PATRIOT Act, should be applied to which of the following accounts?",
       "choice_a":"New individual and new business accounts",
       "choice_b":"New individual and existing business accounts",
       "choice_c":"Existing individual and new business accounts",
       "choice_d":"Existing individual and existing business accounts",
       "correct_answer":"A",
       "explanation":"Under the U.S.A PATRIOT Act, procedures for the verification and identification of customers are to be applied to all new accounts whether those accounts are to be held by individuals or businesses. In the case of accounts already existing, the identification and verification procedures should have been applied at the time of the account opening (new account)."
    },
    {
       "id":37139,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Certain account types can only be opened as cash accounts. Included among them are:",
       "choice_a":"custodial accounts",
       "choice_b":"joint investment accounts for married couples",
       "choice_c":"corporate investment accounts",
       "choice_d":"joint investment accounts for unmarried parties",
       "correct_answer":"A",
       "explanation":"Types of accounts that must be opened as cash accounts include personal retirement accounts such as IRAs, and tax-sheltered annuities, corporate retirement accounts, and custodial accounts as specified in the Uniform Gift to Minors Act (UGMA) and the Uniform Transfers to Minors Act (UTMA)."
    },
    {
       "id":37140,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A young unmarried couple wants to open a new account together. They ask to have the account designation be joint tenants with rights of survivorship (JTWROS). Given these circumstances which of the following should a registered representative do?",
       "choice_a":"First discuss the resulting consequences regarding an account set up as JTWROS should one of them die, and after doing so open the account",
       "choice_b":"Immediately file a report regarding the couple\u0027s request as to how the account is to be set up with FINRA, after which the account can be opened",
       "choice_c":"Immediately file a report regarding the couple\u0027s request as to how the account is to be set up with FINRA, and as per industry rules explain why the account cannot be opened",
       "choice_d":"First discuss the resulting consequences regarding an account set up as JTWROS should one of them die, and then as per industry rules explain that in order to open the account signatures must be verified by a notary",
       "correct_answer":"A",
       "explanation":"No industry rule prohibits unmarried couples from opening an account registered as JTWROS. However, the account designation does have consequences that should be explained by the RR prior to account opening. With JTWROS, if one party to the account dies, that party\u0027s ownership interest in the account goes to the remaining party in the account, rather than to the deceased party\u0027s estate. This is an important consideration that should not be overlooked, and therefore discussed prior to opening the account."
    },
    {
       "id":37141,
       "practice_test_id":"",
       "topic_id":2,
       "question":"One specification regarding individual retirement accounts is that they must be designated and opened as:",
       "choice_a":"cash accounts",
       "choice_b":"wrap accounts",
       "choice_c":"margin accounts",
       "choice_d":"fee for service accounts, not brokerage accounts",
       "correct_answer":"A",
       "explanation":"Because all transactions must be paid for in full utilizing the contributions made to the retirement account, the accounts must be designated and opened as cash accounts. Margin is simply not permitted."
    },
    {
       "id":37142,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following is not applicable to property defined as community property?",
       "choice_a":"Property acquired prior to marriage is considered to be jointly owned after marriage",
       "choice_b":"It is considered to be jointly owned by both spouses and therefore divided at the time of divorce or annulment",
       "choice_c":"Not all states designate themselves as community property states",
       "choice_d":"Property that is inherited is considered an exception to the definition of community property",
       "correct_answer":"A",
       "explanation":"When a state recognizes community property (not all states do) any property acquired prior to marriage is considered to be owned separately, not jointly. In states recognizing community property there are exceptions allowed for, such as inherited property, and finally, community property is always divided in the case of a divorce or annulment."
    },
    {
       "id":37143,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An account set up so that one broker-dealer handles the administration of the account and provide services such as custody of securities and clearing transactions, but other broker-dealers handle execution of trades depending on the types of securities being bought or sold, is known as a (n):",
       "choice_a":"prime brokerage account",
       "choice_b":"advisory account",
       "choice_c":"fee-based account",
       "choice_d":"wrap account",
       "correct_answer":"A",
       "explanation":"When a customer selects one member firm to provide custody and other services, while other member firms will be used to execute orders, the account is known as a prime brokerage account. The member firm administering the account is known as the prime broker."
    },
    {
       "id":37144,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Your customer actively trades within her investment account. Because she has a distaste for paying commissions on every transaction individually, which type of account would suit her the best?",
       "choice_a":"Wrap account",
       "choice_b":"Cash account",
       "choice_c":"Margin account",
       "choice_d":"Prime brokerage account",
       "correct_answer":"A",
       "explanation":"Wrap accounts allow for the bundling of services offered by the broker-dealer, including transactions, for a periodic fee."
    },
    {
       "id":37145,
       "practice_test_id":"",
       "topic_id":2,
       "question":"When an account is set up as transfer on death (TOD), the beneficiary\u0027s cost basis regarding any securities in the account if the account owner dies is:",
       "choice_a":"the value of the securities at the time of death",
       "choice_b":"the value of the securities when the estate is settled giving the beneficiary access to the securities",
       "choice_c":"the value of the securities when originally purchased by the account owner",
       "choice_d":"zero",
       "correct_answer":"A",
       "explanation":"When a beneficiary inherits securities via an account set up as transfer on death (TOD), the beneficiary receives a stepped-up cost basis. That is, the basis will be the current market value of the securities at the time of the account holder\u0027s death."
    },
    {
       "id":37146,
       "practice_test_id":"",
       "topic_id":2,
       "question":"For a joint account, determining suitability and the requirement to disclose information allowing the member firm to do so, applies to:",
       "choice_a":"each individual who is a party to the account",
       "choice_b":"the individual with the greatest initial capital contribution to the account",
       "choice_c":"the individual granted trading authority and / or the ability to withdraw assets from the account",
       "choice_d":"the person whose Social Security number is on the account",
       "correct_answer":"A",
       "explanation":"All parties designated in a joint account are subject to the rules regarding disclosure for the purpose of a firm determining suitability."
    },
    {
       "id":37147,
       "practice_test_id":"",
       "topic_id":2,
       "question":"When a customer wants to give a broker-dealer permission to hold their mail while traveling, which of the following applies?",
       "choice_a":"The customer must initiate the process by written request and the firm may abide by the request as a courtesy to the customer if the firm\u0027s in-house rules allow it",
       "choice_b":"The customer must initiate the process by written request and FINRA approval is required and granted on a case-by-case basis",
       "choice_c":"A written request is not required but the broker-dealer need only abide by the request as a courtesy to the customer if the firm\u0027s in-house rules allow it",
       "choice_d":"As per FINRA\u0027s rules, once the request is made by the customer either orally or in writing, the firm is required to abide by it",
       "correct_answer":"A",
       "explanation":"A request to hold mail must be initiated by the customer in writing. As there are no regulatory rules requiring member firms to hold customer mail, broker-dealers are not required to abide by such a request unless the firm\u0027s own in-house rules allow it."
    },
    {
       "id":37148,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Other than exceptions that might be granted for acceptable reasons, such as safety or security concerns, member broker-dealers are generally not permitted to hold customer mail such as statements and confirmations when requested to do so, for longer than:",
       "choice_a":"three months",
       "choice_b":"two months",
       "choice_c":"one year",
       "choice_d":"9 months",
       "correct_answer":"A",
       "explanation":"Member firms are permitted to hold mail for a customer such as statements and confirmations for up to three months. The member broker-dealer must receive a written request from the customer that includes the time period the request is being made for. Requests may be granted for periods longer than three months for an acceptable reason such as safety or security concerns, but will not be granted simply for the sake of convenience."
    },
    {
       "id":37149,
       "practice_test_id":"",
       "topic_id":2,
       "question":"The USA PATRIOT Act requires financial institutions to maintain which of the following in order to prevent the financing of terrorist operations and money laundering?",
       "choice_a":"Customer identification programs (CIPs)",
       "choice_b":"Do-not-call lists",
       "choice_c":"Specially Designated Nationals lists",
       "choice_d":"Privacy notices",
       "correct_answer":"A",
       "explanation":"In order to protect against financing terrorist operations or activities and potential money laundering activities, the USA PATRIOT Act requires financial institutions such as banks and broker-dealers to maintain customer identification programs (CIPs)."
    },
    {
       "id":37150,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Prior to opening an account for a sole proprietor, a registered representative should know that of the following considerations one stands out as being the most important to convey to the customer. Which would it be?",
       "choice_a":"That a sole proprietor\u0027s account is subject to the creditors of the business",
       "choice_b":"That in all scenarios it is treated like any other individual account",
       "choice_c":"That all gains and losses incurred in the account are taxed to the proprietorship, not the individual",
       "choice_d":"That these accounts require very little additional documentation to create or close",
       "correct_answer":"A",
       "explanation":"With a sole proprietorship the business owner is always subject to unlimited liability. Therefore, designating an account this way leaves the account open to all claims of creditors of the business."
    },
    {
       "id":37151,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A customer, in writing, grants discretion over his account to a registered representative. Regarding the account which of the following practices would not be permitted?",
       "choice_a":"Because it is a discretionary account the RR marks all order tickets unsolicited",
       "choice_b":"Because it is a discretionary account the RR buys and sells stocks without notifying the customer prior to order entry",
       "choice_c":"Because it is a discretionary account the RR moves funds among the offered funds of a single fund family based upon the expectations of, or predictions regarding market performance",
       "choice_d":"Because it is a discretionary account the RR chooses to discuss only periodically with the customer details regarding the account\u0027s performance",
       "correct_answer":"A",
       "explanation":"Though the account is a discretionary one, this does not preclude the RR from soliciting orders, as would be the case for those the RR places without the customers preapproval, or accepting unsolicited orders from the customer. Therefore, all orders entered for this account must still be marked solicited if they were, or unsolicited, when they weren\u0027t. None of the other practices shown here are prohibited."
    },
    {
       "id":37152,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A customer has requested that a member firm open a prime brokerage account for them. Given the structure of a prime brokerage account it is most likely that this customer is:",
       "choice_a":"an institutional customer",
       "choice_b":"a retirement account holder",
       "choice_c":"an investment club with at least 10 members",
       "choice_d":"a joint account holder where each party to the account also maintains an individual account as well",
       "correct_answer":"A",
       "explanation":"By definition, a prime brokerage account is one in which a customer selects one member firm to provide custody and other services, but uses other firms to handle all trade executions depending upon their expertise or access to certain products and markets. This somewhat sophisticated arrangement is most often used by institutional customers who engage in many transactions covering numerous product types, traded in different markets, and who therefore find it advantageous to maintain many different industry relationships."
    },
    {
       "id":37153,
       "practice_test_id":"",
       "topic_id":2,
       "question":"While speaking with a customer on the phone, a registered representative is asked to send duplicate confirmations and account statements to an Investment Advisor not associated with the firm. The appropriate course of action would be to:",
       "choice_a":"ask the customer to make the request in writing in order to have the firm abide by the request once received",
       "choice_b":"politely deny the request until a power of attorney can be received from the Investment Advisor",
       "choice_c":"instruct the firm\u0027s processing department in writing of the request so that it can be abided by",
       "choice_d":"refuse the request noting that industry rules prohibit third parties to be privy to such information",
       "correct_answer":"A",
       "explanation":"In order for the instruction to be abided by it must be in writing. Those who hold POA over an account can request statements and confirmations directly. However, no POA is required for a customer to request such an instruction be followed for one\u0027s own account."
    },
    {
       "id":37154,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A municipal securities broker is opening an account for an employee of another firm. Because MSRB rules differ from FINRA rules regarding opening accounts for other members personnel, the municipal dealer must:",
       "choice_a":"automatically send duplicate confirmations to the new account holder\u0027s employer after each trade",
       "choice_b":"automatically notify the MSRB prior to order entry and then again after confirmation of the trade has been received",
       "choice_c":"notify and obtain the employing members approval prior to order entry and notify the MSRB after confirmation of the trade has been received",
       "choice_d":"notify the SEC prior to order entry only",
       "correct_answer":"A",
       "explanation":"Whenever an account has been opened for an employee of another municipal firm, MSRB rules require that duplicate confirmations of each trade be automatically sent to the employer. Remember that this is different from FINRA rules which only require that duplicate confirmations of each trade (and/or account statements) be sent if the employer has requested them to be sent."
    },
    {
       "id":37155,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A customer opens an UTMA account for his daughter and names himself as the custodian. The child\u0027s grandparents, the only donors to the account, place several thousand dollars in the account in the hopes that it will someday help pay for education costs for their granddaughter. The customer who is custodian of the account offers several possible scenarios he foresees. Only one of them would be permitted. Which is it?",
       "choice_a":"Making charges to the account for a custodial fee payable to himself",
       "choice_b":"Making charges to the account to further his own education to better administer the account",
       "choice_c":"Making charges to the account for a sibling\u0027s daycare or education later",
       "choice_d":"Returning some of the funds to the grandparents should they fall short in funding for their retirement needs",
       "correct_answer":"A",
       "explanation":"So long as the custodian is not the donor of the funds in a custodial account, the custodian may charge a reasonable custodial fee. Funds in the account may not be used for the benefit of anyone other than the minor named in the account nor may funds be returned to donors."
    },
    {
       "id":37156,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A new account form for an account opened a few days prior is being reexamined by a principal to assure that it complies with industry rules. It\u0027s noted that one of the items found on the form is actually not required. Of the items listed below, which is it?",
       "choice_a":"customer\u0027s signature",
       "choice_b":"customer\u0027s date of birth",
       "choice_c":"customer\u0027s physical address",
       "choice_d":"principal\u0027s signature",
       "correct_answer":"A",
       "explanation":"Industry rules do not require the customer\u0027s signature on a new account form. The principal approving (accepting) the account however is required to sign it. Customer\u0027s date of birth and a physical address (not PO box) are required."
    },
    {
       "id":37157,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A registered representative is named as a beneficiary to a customer\u0027s estate. This status is permissible without written notice to, and approval from the member firm for each of the following customers except, the registered representative\u0027s:",
       "choice_a":"brother-in-law\u0027s parent",
       "choice_b":"sister-in-law",
       "choice_c":"step daughter",
       "choice_d":"uncle",
       "correct_answer":"A",
       "explanation":"For purposes of being named a beneficiary, trustee, executor or power of attorney the definition of immediate family is broad. It includes; parents, grandparents, mother-in-law or father-in-law, spouse or domestic partner, brother or sister, brother-in-law or sister-in-law, son-in law or daughter-in-law, children, grandchildren, cousin, aunt or uncle, or niece or nephew, and any other person who resides in the same household as the registered person and the registered person financially supports, directly or indirectly, to a material extent. In addition, the term includes step and adoptive relationships. The above appointments are permissible without written notice to, or approval from the member firm."
    },
    {
       "id":37158,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A member firm registered representative is asked to be the named executor of a customer\u0027s estate. Which of the following applies to the situation described?",
       "choice_a":"The registered representative must decline being named as an executor on behalf of the customer unless certain conditions are satisfied.",
       "choice_b":"While there are limitations imposed regarding being named a beneficiary of a customer\u0027s estate, there are none regarding being named an executor.",
       "choice_c":"While there are limitations imposed regarding being named a power of attorney for a customer, there are none regarding being named an executor to a customer\u0027s estate.",
       "choice_d":"There are no limitations imposed regarding being named an executor for, or beneficiary of a customer\u0027s estate, nor being named a power of attorney for a customer.",
       "correct_answer":"A",
       "explanation":"A registered representative must decline being named as an executor on behalf of a customer unless one of two conditions is satisfied; the customer is a member of the registered person\u0027s immediate family, or the registered person provides written notice describing the appointment to the member firm and receives written approval from the member prior to being appointed as, or acting in the capacity of executor."
    },
    {
       "id":37159,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A customer wants to name her registered representative as one of several beneficiaries to her estate. Essentially this is her way of thanking the RR for having done such a good job with the account. These circumstances would first require the registered representative to:",
       "choice_a":"make written notice to the member firm using the form specified by FINRA.",
       "choice_b":"make written notice to the member firm in the way or in such form as specified by the member firm.",
       "choice_c":"acknowledge to the customer in writing, consent to be listed as a beneficiary.",
       "choice_d":"convey orally or in writing to a principal of the member firm that the customer has finalized an estate listing the registered representative as a beneficiary.",
       "correct_answer":"B",
       "explanation":"Upon learning of the proposed beneficiary status, the registered representative must provide written notice describing the proposed status to the member firm. This written notice can be provided in such form as specified by the member as no form is specified by FINRA or any other regulatory body."
    },
    {
       "id":39567,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An options account must be approved by a principal:",
       "choice_a":"prior to the first transaction.",
       "choice_b":"prior to delivery of the OCC options disclosure document.",
       "choice_c":"prior to sending a letter to clients listing the benefits and risks of covered call writing.",
       "choice_d":"prior to sending a letter to clients explaining the limited risk and reward associated with options spreads.",
       "correct_answer":"A",
       "explanation":"An options account must be approved by a principal prior to the first option transaction. OCC\u0027s disclosure document must be delivered to the client at or before the account is approved. No option account approval is required to send clients general information about the risks and rewards of different options positions and strategies, though approval of such correspondence can be required."
    },
    {
       "id":39568,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An employee of a member firm opens an account with your member firm. The new account holder\u0027s employer must be notified:",
       "choice_a":"verbally, either by the employee or by your member firm before the account can be approved.",
       "choice_b":"in writing before the account can be approved.",
       "choice_c":"in writing before execution of the first trade in the account.",
       "choice_d":"verbally, either by the employee or by your member firm before execution of the first trade in the account.",
       "correct_answer":"C",
       "explanation":"While the executing member must notify the employer member in writing before the execution of a transaction can occur, notification prior to account approval is not required."
    },
    {
       "id":39569,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Regarding letters of authorization and other forms of asset transmittal requests, which of the following statements is inaccurate?",
       "choice_a":"Member firms are required by FINRA to permit standing letters of authorization for retail customers.",
       "choice_b":"Member firms should clearly specify whether there are limits on the use of standing letters of authorization.",
       "choice_c":"FINRA does not mandate that standing letters of authorization must have a stated expiration.",
       "choice_d":"Transfers made pursuant to standing letters of authorization should be subject to heightened scrutiny.",
       "correct_answer":"A",
       "explanation":"While FINRA does not require member firms to permit standing letters of authorization they do offer guidance when firms do. FINRA urges firms to review the adequacy of their policies and procedures regularly to verify the validity of asset transfer requests. Included in FINRA\u0027s guidance, member firm policies should address any limits on the use of standing letters of authorization, whether they expire after a specified period of time. FINRA encourages heightened scrutiny of transfers made subject to these letters."
    },
    {
       "id":39572,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A registered representative learns that she has been named to receive a small stipend ($1,000) from a customer\u0027s estate if the customer should die. Which of the following is true?",
       "choice_a":"This is permitted if the customer is a member of the RR\u0027s immediate family.",
       "choice_b":"This is permitted if the customer is a member of the RR\u0027s immediate family or if the RR notifies the member firm of the intended arrangement.",
       "choice_c":"This is permitted as long as the RR notifies the member firm of the intended arrangement.",
       "choice_d":"This is not permitted.",
       "correct_answer":"A",
       "explanation":"This is permitted if the customer is a member of the RR\u0027s immediate family or if the RR provides written notice describing the proposed status to the member firm and receives written approval from the member of such status prior to being named a beneficiary of a customer\u0027s estate or receiving a bequest from a customer\u0027s estate."
    },
    {
       "id":39573,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A registered representative learns that a customer with no family wants to name him as a beneficiary to his estate. The customer has had an account with the firm for 8 years and aside from their professional relationship they\u0027ve been friends since high school, over 35 years. Which of the following is true?",
       "choice_a":"The member firm must approve the RR\u0027s status as a beneficiary and must implement certain limitations or conditions.",
       "choice_b":"The member firm must approve the RR\u0027s status as a beneficiary with no limitations or conditions.",
       "choice_c":"The member firm must approve the RR\u0027s status as a beneficiary given the friendship predates the professional relationship. ",
       "choice_d":"The member firm can disapprove of the RR\u0027s status as a beneficiary if they so choose.",
       "correct_answer":"D",
       "explanation":"Once notified of the RR\u0027s intended status as a beneficiary the member firm can either disapprove or approve it. If the member firm approves it, they may also place limitations or conditions upon the relationship if they so choose, but are not required to."
    },
    {
       "id":39574,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A registered person must decline being named which of the following for a customer of their member firm unless certain conditions are met?",
       "choice_a":"Being named an executor, trustee, holder of power of attorney or beneficiary.",
       "choice_b":"Being named a trustee or holder of power of attorney only.",
       "choice_c":"Being named a beneficiary only.",
       "choice_d":"Being named an executor only.",
       "correct_answer":"A",
       "explanation":"Upon learning of such status, a registered person is required to decline being named a beneficiary of a customer\u0027s estate, a trustee, an executor or holding a power of attorney unless certain conditions are satisfied. The conditions are as follows; Either the customer must be a member of the registered person\u0027s immediate family or upon learning of the named status the RR has notified the member and received written approval for the status."
    },
    {
       "id":39575,
       "practice_test_id":"",
       "topic_id":2,
       "question":"John was named several years ago as POA for a disabled friend. Now, newly registered and employed by a broker-dealer, which of the following is true?",
       "choice_a":"Within 30 calendar days of becoming associated with the member firm, John must provide notice of the position of trust and receive written approval from the member firm.",
       "choice_b":"John need only notify the member firm of the position of trust, upon which it must be approved by the firm due to the pre-existing nature of the position.",
       "choice_c":"Only in the case of being named a beneficiary does John, within 30 calendar days of becoming associated with the member firm, have to notify the member.",
       "choice_d":"There is no requirement for John to notify the member firm given the pre-existing nature of the position.",
       "correct_answer":"A",
       "explanation":"Whether it be a pre-existing beneficiary status or a position of trust, the RR within 30 calendar days of becoming associated with the member firm must provide notice of the position and receive written approval from the member firm to continue in the position or maintain the status."
    },
    {
       "id":39576,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A registered representative is asked by his widowed Aunt, also his client at the member firm he is associated with, to be the executor on her soon to be completed will. Which of the following applies?",
       "choice_a":"The RR must notify his member firm of the position of trust immediately and await written approval.",
       "choice_b":"The RR must notify his member firm of the position of trust within 30 days of his appointment.",
       "choice_c":"The RR must decline the position of trust.",
       "choice_d":"The RR may accept the position of trust.",
       "correct_answer":"D",
       "explanation":"A registered person must decline being named as an executor or trustee or holding a power of attorney on behalf of a customer unless one of two conditions is satisfied. The first condition, the one applicable here, is that the customer is a member of the registered person\u0027s immediate family. Given the condition has been met, the RR may accept the position of trust. If the customer is not a member of the RR\u0027s immediate family, notice must be made to the member firm and written approval must be granted."
    },
    {
       "id":39577,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A customer who has only recently opened an account with your member firm and had all of his investments transferred to his new account does the following; <ol style='margin-left: 25px; list-style-type: disc;'><li>Deposits three separate $2,800 money orders on three consecutive days to be deposited into a money market fund. </li><li>Deposits $1,000 into a variable annuity he has been funding monthly for several years. </li><li>Wires $3,000 from the money market fund to another broker/dealer. </li></ol>Which of these actions, if any, would trigger the filing of a Suspicious Activity Report (SAR)?",
       "choice_a":"Depositing $1,000 into his VA.",
       "choice_b":"Wiring $3,000 to another BD.",
       "choice_c":"The final deposit of $2,800",
       "choice_d":"The second deposit of $2,800.",
       "correct_answer":"D",
       "explanation":"Member firms are required to file a SAR whenever transactions are equal to or exceed $5,000 and appear commercially illogical, serving no apparent purpose. Making money order deposits of equal amounts on consecutive days would constitute financial behavior aligning with the above; illogical, serving no apparent purpose. Therefore, it is the second deposit that would exceed the $5,000 threshold triggering the SAR. Note that a currency transaction report (CTR) would be triggered for transactions totaling $10,000 or more within a single day."
    },
    {
       "id":39580,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A registered representative is completing the customer account form with a new client. They discuss risk tolerance and the customer says she is comfortable with some risk for whatever initial dollars she commits to the account in exchange for what she hopes will be higher returns. The registered representative feels compelled to clarify that the willingness to accept some risk should ideally allow the account to keep pace with inflation but that it also means the account could lose value. Assuming the customer acknowledges that she understands, the RR would best characterize her risk tolerance as:",
       "choice_a":"moderate aggressive.",
       "choice_b":"aggressive.",
       "choice_c":"conservative.",
       "choice_d":"moderate.",
       "correct_answer":"D",
       "explanation":"This investor is willing to accept some risk for the initial dollars invested, and understands that this means there is the possibility of loss. Given she is willing to accept this risk in exchange for the opportunity to earn higher returns, her risk tolerance would be best noted as moderate. Moderate aggressive by comparison means that one is willing to accept a much more appreciable amount of risk to attain one\u0027s investment objectives."
    },
    {
       "id":39582,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An account at your broker-dealer is registered as joint tenants with rights of survivorship (JTWROS). One of the two parties to the account dies. Regarding handling of the account, which of the following is true?",
       "choice_a":"Transfer of ownership to the remaining party (the new owner) cannot occur until a certified copy of the death certificate is presented to the BD.",
       "choice_b":"A certified copy of the death certificate and an inheritance tax waiver is required to transfer ownership of the account.",
       "choice_c":"The deceased party\u0027s interest in the account will go to his estate upon presentation of a certified copy of the death certificate to the BD.",
       "choice_d":"The account is frozen until a certified copy of the death certificate is presented during which time the remaining party to the account cannot enter orders to buy or sell.",
       "correct_answer":"A",
       "explanation":"When one party to an account registered as JTWROS dies, the account cannot be transferred to the name of the remaining party (the new owner) until a certified copy of the death certificate is presented to the BD. However, with JTWROS accounts, the death of one tenant does not preclude the remaining tenant from entering orders prior to the account being transferred. Finally, for JTWROS accounts, other documents such as tax waivers are not required for the account to be transferred."
    },
    {
       "id":39583,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Of the following individuals, who would be permitted to open a securities account at a member firm without notifying or receiving permission from their employer?",
       "choice_a":"An employee of a bank licensed to sell fixed annuities only.",
       "choice_b":"An employee of a member firm trading government securities only.",
       "choice_c":"An employee of a member firm acting as a clerk on a retail order routing desk.",
       "choice_d":"An employee of an insurance company licensed to sell variable annuities.",
       "correct_answer":"A",
       "explanation":"Whenever an employee of a FINRA member firm wants to open a securities account with another member firm or financial institution, the employee must give prior written notice to his employer and receive prior written consent from his employer, before the account can be opened. Someone selling fixed annuities (not a security) only and employed by an insurance company is most likely not associated with a member firm and therefore freely open a securities account."
    },
    {
       "id":39588,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A new client has completed a new account form and informs you that she wants to have her existing securities positions transferred to your broker-dealer. In order to affect the transfer, your request to the client should be for her to:",
       "choice_a":"mark the new account form discretionary so that you can begin and see through the transfer process for her.",
       "choice_b":"notify the holding broker-dealer to cancel any open (unfilled) orders that may be working in the market.",
       "choice_c":"complete and submit a transfer initiation form (TIF) in order to begin the transfer process.",
       "choice_d":"notify the holding broker-dealer to cancel any open (unfilled) orders that may be working in the market.",
       "correct_answer":"C",
       "explanation":"In order to begin the transfer process, the first step is to have the client complete and submit a transfer initiation form (TIF). The data submitted on this form is entered into the ACATS system by the receiving broker-dealer. "
    },
    {
       "id":39589,
       "practice_test_id":"",
       "topic_id":2,
       "question":"New clients, a married couple in their early thirties with one young child and a combined annual income of $75,000 have transferred a small investment portfolio currently valued at $50,000 to your firm. They note that they are finally in a position to put away approximately $50 a week and think that saving for their child\u0027s education is probably the next best step they should take. Given this is all you know about them, of the following choices, which might be the best way for a discussion to begin so that you might broaden your understanding of their financial picture?",
       "choice_a":"Affirming that they are aware that contributions to an education savings account (ESA) are not tax deductible.",
       "choice_b":"Exploring whether either has done anything in the way of retirement planning for themselves.",
       "choice_c":"Establishing their risk tolerance for the new funds to be allocated for their child\u0027s education.",
       "choice_d":"Exploring whether or not they would consider speculative investing such as options, crypto currencies or digital assets for this purpose.",
       "correct_answer":"B",
       "explanation":"Before a discussion about ways to finance higher education for their child should begin, or the tax consequences of different vehicles available, a broader picture is needed. Included in that picture would be knowing whether any retirement planning for themselves has begun yet. If not, that may also be a priority to consider."
    },
    {
       "id":39590,
       "practice_test_id":"",
       "topic_id":2,
       "question":"In getting to know a new client, age 45, he mentions that he makes the maximum contributions to his employer\u0027s 401K plan and to his IRA annually. He now wants to supplement those retirement funds by making a lump sum contribution to a variable annuity. He goes on to note that liquidating $100,000 from an investment account, or refinancing his home would both be feasible ways to fund the VA. Your best follow-up question should be which of the following?",
       "choice_a":"Do you have any readily available cash to fund the VA?",
       "choice_b":"How do your potential heirs feel about you tying funds up in a VA?",
       "choice_c":"Given you\u0027ve maxed out other retirement plan contributions, would you consider more than $100,000 as a contribution to the VA?",
       "choice_d":"Would you object if we look at several different companies offering VAs?",
       "correct_answer":"A",
       "explanation":"The client\u0027s age and current ability to max out contributions to other available retirement plans makes a VA a good option to supplement retirement income for him; therefore suitable. However, liquidating assets or refinancing property are considered unsuitable methods of funding a VA. The best source for VA funding is readily available cash, and knowing if any is available for this purpose would be the next best inquiry."
    },
    {
       "id":39591,
       "practice_test_id":"",
       "topic_id":2,
       "question":"You are conducting a new client interview. When you ask about marital status the client tells you he is divorced. Of the following, which might be the next best exploratory question?",
       "choice_a":"Is the ex-spouse also in need of guidance for investments or brokerage services?",
       "choice_b":"What is the name and social security number of the ex-spouse?",
       "choice_c":"How long has the client been divorced?",
       "choice_d":"Is the client receiving or paying out income as a result of the divorce?",
       "correct_answer":"D",
       "explanation":"Of the possibilities offered, knowing whether the new client is receiving or paying out income as a result of the divorce would be most relevant to completing the client profile. For instance, if receiving income, the purpose for the payments such as alimony or child support would determine the tax liability for the payments received."
    },
    {
       "id":39592,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A client tells you that they are receiving a lump sum payment due to a judgment issued in the form of a qualified domestic relations order (QDRO). Which of the following should be the most important follow-up question?",
       "choice_a":"Are you the ex-spouse of the party making the payment?",
       "choice_b":"What is the amount of the payment?",
       "choice_c":"What is the name and social security number of the party making the payment?",
       "choice_d":"Is the payment taxable income to you?",
       "correct_answer":"A",
       "explanation":"While QDRO\u0027s are most often associated with divorce proceedings, they may be issued in other domestic judgements as well. Therefore, knowing if your client, the payment recipient, is the ex-spouse of the party from whom the payment is coming is most important as it will determine if the lump sum can be rolled over into a qualified plan. For ex-spouses, it can be. For someone other than an ex-spouse it cannot be. If the recipient is an ex-spouse, deferring taxation on the amount received is possible if rolled over to another qualified plan."
    },
    {
       "id":39593,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A new client expresses the importance of his long-term goal which primarily is to secure some financial independence from his family. He tells you that he has substantial dividend income received quarterly from stock he inherited from his father. Aligning with his long-term goal he tells you he wants to set up an IRA for later in life. Regarding his specific request to set up an IRA, what would be the most relevant question to ask the client now?",
       "choice_a":"Does he have any income in addition to the dividend income?",
       "choice_b":"How much is the quarterly amount received from the dividends?",
       "choice_c":"Where is the dividend yielding stock held?",
       "choice_d":"Is he considering a traditional IRA or a ROTH IRA?",
       "correct_answer":"A",
       "explanation":"An IRA contribution can only be made from earned income. Dividends and interest are investment income and therefore not an eligible source of funding for IRA\u0027s. Therefore, the most relevant follow-up question would be to ask if he has any other income sources for the purpose of determining if they might be deemed earned income eligible to fund an IRA."
    },
    {
       "id":39594,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A new customer has agreed to have his securities positions transferred from the broker dealer he intends to sever ties with to your broker dealer. In order to achieve the transfer via ACATS which of the following is the correct process?",
       "choice_a":"The customer must complete and submit a transfer initiation form (TIF) to the receiving BD. The receiving BD will electronically enter specific data from the TIF into ACATS. Then the ACATS system electronically informs the carrying BD of the transfer instructions.",
       "choice_b":"The receiving BD must complete and submit a transfer initiation form (TIF) to ACATS. Then the ACATS system electronically informs the carrying BD of the transfer instructions.",
       "choice_c":"The customer must complete and submit a transfer initiation form (TIF) to the carrying BD. The carrying BD will electronically enter specific data from the TIF into ACATS. Then the ACATS system electronically executes the transfer instructions.",
       "choice_d":"Once informed by the customer to transfer the securities, the carrying BD contacts the receiving BD via form ACATS. Then the ACATS system electronically executes the transfer instructions",
       "correct_answer":"A",
       "explanation":"The correct process when transferring positions to another BD via the ACATS system begins with the customer who must complete and submit a transfer initiation form (TIF) to the receiving BD. The receiving firm electronically enters specified data from the TIF, including the customer\u0027s name, social security number and account number, into ACATS. If the submitted data meets ACATS minimum requirements, then the ACATS system electronically informs the carrying firm of the transfer instruction."
    },
    {
       "id":39595,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A member firm takes exception to transfer instructions received via ACATS in regards to specific securities that are deemed to be non transferable. What must occur next?",
       "choice_a":"The carrying firm must provide the customer with a list of the specific assets and request, in writing, further instructions from the customer with respect to the disposition of those assets.",
       "choice_b":"The carrying member must notify the receiving firm directly and list the securities which are non transferable and await further instructions to come directly from the receiving firm.",
       "choice_c":"The carrying member must notify the receiving firm via ACATS and list the securities which are non transferable and await further instructions via ACATS from the receiving firm.",
       "choice_d":"The carrying firm must liquidate the assets immediately after validation of their existence in order to complete the transfer in cash.",
       "correct_answer":"A",
       "explanation":"If during the course of validation after receiving form ACATS the carrying firm deems certain securities to be non transferable, the carrying firm must provide the customer with a list of those specific assets and request, in writing, further instructions from the customer with respect to the disposition of those assets."
    },
    {
       "id":39598,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Your clients, a married couple holding a joint account with your firm, are proceeding with an amicable divorce. They live in a state that recognizes community property and know that the joint account falls under that designation. They meet with you and make several statements about community property, but you point out immediately that one of them is incorrect. Which of the statements below is it?",
       "choice_a":"Once we married, community property automatically applied to the things each of us owned individually before we were married.",
       "choice_b":"Dissolving our joint account, because it is considered community property, is probably going to have tax implications when the divorce is finalized.",
       "choice_c":"The community property law does not apply to any of the gifts we received individually from our respective families.",
       "choice_d":"The community property law does not apply to the inheritance one of us received from our grandfather.",
       "correct_answer":"A",
       "explanation":"In jurisdictions that recognize community property and in cases of divorce, the designation applies to property obtained during a marriage but does not apply to property owned individually by either spouse before the marriage. Nor does it apply to inheritances or gifts received individually. However, for property falling under this category, such as the joint account, there can be federal tax implications when dissolved and these can differ from jurisdiction to jurisdiction."
    },
    {
       "id":39599,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Your client will soon receive distributions awarded in a qualified domestic relations order (QDRO) during a divorce proceeding. Asked about the tax consequences of these distributions you would correctly state that:",
       "choice_a":"the payments must be reported by your client as if they were the plan participant and that they will be allocated a share of the participants cost basis if the payments are taxable.",
       "choice_b":"the payments must be reported by your client as if they were the plan participant but their cost basis will be zero if the payments are taxable.",
       "choice_c":"the payments only need to be reported if the distributions under the qualified domestic relations order (QDRO) were for alimony, but not reported if for child support.",
       "choice_d":"the payments need not be reported as they were mandated to occur by a court order under a qualified domestic relations order (QDRO).",
       "correct_answer":"A",
       "explanation":"The payments must be reported by your client as if they were the plan participant themselves no matter what the purpose of the distributions; alimony, child support or marital property rights. While the payments must be reported, the tax liability depends on the intended use of the payments; alimony or child support for example. If taxable, under the QDRO your client will be allocated a share of the ex-spouse\u0027s cost basis."
    },
    {
       "id":39600,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A client, age 45 and recently divorced, will be receiving distributions from her spouse\u0027s traditional IRA and her spouse\u0027s employer\u0027s 401K plan, to meet the judgment issued via a qualified domestic relations order (QDRO) during the divorce proceedings. You correctly advise that the distributions from both would be taxable if they are not rolled over and that:",
       "choice_a":"a 10% early distribution penalty (tax) would apply to the IRA only.",
       "choice_b":"a 10% early distribution penalty (tax) would apply to the employer qualified 401K plan only.",
       "choice_c":"a 10% early distribution penalty (tax) would apply to both plans.",
       "choice_d":"a 10% early distribution penalty (tax) wouldn\u0027t apply to either plan due to the QDRO decree.",
       "correct_answer":"A",
       "explanation":"A qualified domestic relations order (QDRO) allows distributions from an employer qualified plan such as a 401K to avoid the 10% early distribution penalty, also referred to as a penalty tax. It does not however apply to IRAs of any kind. The recipient reports the distributions received as if they were the plan participant. If rolled over into another qualified plan the distributions are not taxable. However, if not rolled over, the distributions are taxable but the early 10% distribution penalty (tax) would apply only to the IRA distribution and not the 401K distribution."
    },
    {
       "id":39601,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A qualified domestic relations order (QDRO) issued in the course of divorce proceedings allows for an exemption applicable to distributions from a:",
       "choice_a":"ROTH IRA or a SEP IRA plan.",
       "choice_b":"traditional IRA or a ROTH IRA plan.",
       "choice_c":"qualified employer plan or a traditional IRA.",
       "choice_d":"qualified employer plan.",
       "correct_answer":"D",
       "explanation":"A QDRO is an order or decree, generally issued in the course of divorce proceedings. While premature distributions from retirement plans are subject to a 10% penalty, a QDRO distribution is exempt from the penalty in the case of qualified employer plans only. The exemption from the penalty tax does not apply to IRA\u0027s."
    },
    {
       "id":5454,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which is true regarding Treasury securities?",
       "choice_a":"Treasury bills, notes, and bonds differ in their price and term only.",
       "choice_b":"Treasury bills, notes, and bonds differ in their interest, term and price.",
       "choice_c":"Treasury bills, notes, and bonds differ in their interest and term only.",
       "choice_d":"Treasury bills, notes, and bonds differ in their interest and price but have the same terms.",
       "correct_answer":"B",
       "explanation":"Treasury bills, notes and bonds differ in their interest, term, and price. All of the Treasury securities differ in the terms of maturity. T\u0027 notes and bonds are priced as a percentage of par and pay semi annual interest. T\u0027 bills pay no interest and are priced on a discounted yield basis."
    },
    {
       "id":5455,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following debt securities pays interest?",
       "choice_a":"T\u0027 Bill",
       "choice_b":"Commercial paper",
       "choice_c":"Banker\u0027s acceptance",
       "choice_d":"Industrial revenue bond",
       "correct_answer":"D",
       "explanation":"Of all the choices listed only an industrial revenue bond pays interest. All of the other choices are issued at a discount and appreciate to par. This appreciation represents the investor\u0027s interest. These discounted securities do not \u0022pay\u0022 interest by making regular interest payments. "
    },
    {
       "id":5456,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following are backed by the full faith and credit of the United States government?",
       "choice_a":"Federal National Mortgage Association",
       "choice_b":"Federal Home Loan Mortgage Corporation",
       "choice_c":"United States Trust Certificates",
       "choice_d":"Government National Mortgage Association",
       "correct_answer":"D",
       "explanation":"Only the Government National Mortgage Association is backed by the full faith and credit of the US Government.  If GNMA defaults, the government covers the loss. FNMA and FHLMC have been placed in receivership by the US Government but those are not the direct obligations of the US Government."
    },
    {
       "id":5457,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following could trade in the money market?",
       "choice_a":"Short term equity",
       "choice_b":"Newly issued corporate bond",
       "choice_c":"Newly issued option contract",
       "choice_d":"Treasury note issued 9 years ago",
       "correct_answer":"D",
       "explanation":"A high quality debt instrument with less than one year to maturity regardless of its original maturity may trade in the money market. The Treasury note issued 9 years ago has one year or less remaining until maturity."
    },
    {
       "id":5458,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following does not price on the basis of par value alone?",
       "choice_a":"Corporate bonds",
       "choice_b":"Treasury bills",
       "choice_c":"Treasury notes",
       "choice_d":"Treasury bonds",
       "correct_answer":"B",
       "explanation":"Treasury bills do not pay semi-annual interest and are issued at a discount from par. Treasury bills are priced on a discounted yield basis."
    },
    {
       "id":5459,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following facilitates foreign trade?",
       "choice_a":"World Trade Organization",
       "choice_b":"ADR",
       "choice_c":"Banker\u0027s acceptance",
       "choice_d":"Commercial paper",
       "correct_answer":"C",
       "explanation":"A banker\u0027s acceptance facilitates foreign trade. A banker\u0027s acceptance or \u0022BA\u0022 is a guarantee to pay issued by a bank and backed by a letter of credit. Whoever presents the BA to the bank on the maturity date, not to exceed 270 days will receive the face value."
    },
    {
       "id":5460,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following may always trade in the money market?",
       "choice_a":"T\u0027 bond",
       "choice_b":"T\u0027 note",
       "choice_c":"ADR",
       "choice_d":"Banker\u0027s acceptance",
       "correct_answer":"D",
       "explanation":"Of the answers listed only banker\u0027s acceptances have an original maturity of less than one year. The T note and bond may trade in the money market only after they have one year or less remaining to maturity. An ADR is an equity security and may never trade in the money market."
    },
    {
       "id":5461,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following only relates to the fixed income securities of an issuer?",
       "choice_a":"Systematic risk",
       "choice_b":"Credit risk",
       "choice_c":"Legislative risk",
       "choice_d":"Purchasing power risk",
       "correct_answer":"B",
       "explanation":"Credit risk is the risk of default which only relates to fixed income securities."
    },
    {
       "id":5462,
       "practice_test_id":"",
       "topic_id":3,
       "question":"XVC, a marginally profitable company with a spotty credit history, has promised bondholders to set aside money to repay the principal of the bonds.  This money will be used to pay off the bonds at maturity.  The money will be deposited in:",
       "choice_a":"A separate account",
       "choice_b":"A general account",
       "choice_c":"A sinking fund",
       "choice_d":"A bond repayment fund",
       "correct_answer":"C",
       "explanation":"Money set aside for the exclusive purpose of paying off bondholders is placed in a sinking fund. Once placed in the sinking fund the money may not be used for any other purpose."
    },
    {
       "id":5463,
       "practice_test_id":"",
       "topic_id":3,
       "question":"XYZ 8 percent bonds due 10 1, 2040 are quoted at 95 what is the current yield on the bond?",
       "choice_a":"8.40%",
       "choice_b":"7.5 %",
       "choice_c":"6.40%",
       "choice_d":"7.80%",
       "correct_answer":"A",
       "explanation":"The current yield on the bond is approximately 8.4%. The current yield is c found by dividing the annual income of the bond by its price. In this case an 8 percent bond pays $80. per year and its current market price is 950. 80/950 = 8.4%"
    },
    {
       "id":5464,
       "practice_test_id":"",
       "topic_id":3,
       "question":"XYZ has 8% subordinated debentures trading in the marketplace at 120. They are convertible into XYZ common stock at $ 25 per share. What is the parity price of the common stock?",
       "choice_a":28,
       "choice_b":29,
       "choice_c":30,
       "choice_d":31,
       "correct_answer":"C",
       "explanation":"The parity price is found by determining the number of shares that can be received upon conversion par / conversion price = 1000/25=40 shares, then the parity price equals the current market value of the convertible / # of shares. 1200/40=$30."
    },
    {
       "id":5465,
       "practice_test_id":"",
       "topic_id":3,
       "question":"XYZ has issued subordinated debentures offering 8% to investors and they mature on March 1, 2035. XYZ is now selling subordinated debentures maturing in 2045 offering the investors a 6% interest rate. What has happened to the price of the debentures maturing in 2025?",
       "choice_a":"The price has gone down",
       "choice_b":"The price has gone up",
       "choice_c":"The price has remained unchanged",
       "choice_d":"There is no effect on the price of the older bond",
       "correct_answer":"B",
       "explanation":"The price of the debenture maturing in 2035 has gone up because interest rates have fallen. The outstanding issue had an interest rate of 8%, the new issue maturing in 2045 is paying 6%. Interest rates in the marketplace have fallen by two percentage points since the bonds maturing in 2035 were sold. Therefore, the bonds with the higher interest rate have increased in price. "
    },
    {
       "id":5466,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Your customer is inquiring about a particular bond investment, which of the following would be of most concern to him?",
       "choice_a":"Nominal yield",
       "choice_b":"Current yield",
       "choice_c":"Yield to maturity",
       "choice_d":"Price",
       "correct_answer":"C",
       "explanation":"The yield to maturity or the YTM is the investor\u0027s overall return on a bond and would be the most important. The price and the nominal yield will impact the YTM and the current is an important factor, but the most important factor is the YTM."
    },
    {
       "id":5467,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Your customer wants to invest in a conservative income producing investment and is inquiring about GNMAs.  She wants to know the minimum dollar amount required to purchase a pass through certificate.  You should tell her:",
       "choice_a":"$10,000",
       "choice_b":"$1,000",
       "choice_c":"$2,500",
       "choice_d":"There is no minimum you can invest almost any sum",
       "correct_answer":"B",
       "explanation":"The minimum dollar amount to purchase a GNMA pass through certificate is $1,000."
    },
    {
       "id":5468,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following is not a method of retiring bonds?",
       "choice_a":"Term",
       "choice_b":"Redemption",
       "choice_c":"Refunding",
       "choice_d":"Conversion",
       "correct_answer":"A",
       "explanation":"All of the answers listed are a way of retiring bonds except term. Term is a type of maturity. Bonds are redeemed at maturity, can be refunded by issuing new debt to pay off existing debt, or in the case of a convertible bond the bond may be redeemed by the investor by converting the bond into common shares."
    },
    {
       "id":5469,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following is not a secured corporate debt obligation?",
       "choice_a":"Collateral trust bonds",
       "choice_b":"Debentures",
       "choice_c":"Open end mortgage bonds",
       "choice_d":"Equipment trust certificates",
       "correct_answer":"B",
       "explanation":"Debentures are unsecured corporate debt obligations backed only by the full faith and credit of the issuer."
    },
    {
       "id":5471,
       "practice_test_id":"",
       "topic_id":3,
       "question":"What is the dollar value of a Treasury bond quoted at 101.24?",
       "choice_a":"$1,017.50",
       "choice_b":"$1,012.40",
       "choice_c":"$1,013.75",
       "choice_d":"$1,124.00",
       "correct_answer":"A",
       "explanation":"Treasury bonds are quoted as a percentage of par down to 32nds of 1 percent. A price of 101.24 = 101 24/32 % of $1,000 or $1,017.50"
    },
    {
       "id":5472,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Atlantic Electric announced that it will refund, on March 15, its $200,000,000 principal amount of 30-year 8% debentures. It will redeem them at a price of 108.55  plus accrued interest payable up to the redemption date. It will use the funds obtained from its recent sale of $200,000,000 principal amount of 6 5/8%, 30-year debentures. In March, investors owning the 8% debentures will receive how much per bond (in addition to accrued interest)?",
       "choice_a":"Principal at the rate calculated to yield a current return of $108.55.",
       "choice_b":"An amount equal to an 8% yield less a call premium",
       "choice_c":"Refund of initial investment plus an additional $108.55",
       "choice_d":"Repayment of face value plus premium of $85.50",
       "correct_answer":"D",
       "explanation":"The company is offering to pay 1085.5% for its $1,000 par value bonds. Or in this case $1,085.50 per bond representing a premium of $85.50 per bond. Investors will receive their par value plus a premium of $85.50 per bond"
    },
    {
       "id":5473,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Atlantic Electric announced that it will refund, on March 15, its $200,000,000 principal amount of 30-year 8% debentures. It will redeem them at a price of 108.55  plus accrued interest to the redemption date. It will use the funds obtained from its recent sale of $200,000,000 principal amount of 6 5/8%, 30-year debentures. Why would management do this? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>To improve capitalization. </li><li>To reduce interest expense over the next three decades. </li><li>To expedite payment of debt.</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"I and II",
       "choice_d":"I and III",
       "correct_answer":"B",
       "explanation":"Management would do this to reduce the company\u0027s interest expenses. The capital structure will not change as the total amount of debt outstanding has not been reduced."
    },
    {
       "id":5474,
       "practice_test_id":"",
       "topic_id":3,
       "question":"The SXX Corporation offers to exchange $42 \u00BD million of a $75 \u00BD million, 4 \u00BD% bond of 2029 which is currently quoted at 55, and is convertible into 25 shares of common, for a 4 \u00BD% nonconvertible of 2029, plus some cash. The common stock pays $1.60 per share and is selling at 20.75. The parity price of the stock is:",
       "choice_a":"$20",
       "choice_b":"$22",
       "choice_c":"$40",
       "choice_d":"$50",
       "correct_answer":"B",
       "explanation":"To determine the parity price in this question we must first determine the conversion price. The conversion price is found by the following formula. par/ number of shares that can be received. In this case 1000 / 25 equals = 40 The bond is trading at 55 or 55% of par. Therefore the stock\u0027s parity price must be 55% of the conversion price which is $40. $40 X .55 = 22"
    },
    {
       "id":5475,
       "practice_test_id":"",
       "topic_id":3,
       "question":"The difference in annual income between coupons of 5.10% and 5.30% for a $5,000 bond is:",
       "choice_a":"$1",
       "choice_b":"$2",
       "choice_c":"$10",
       "choice_d":"$20",
       "correct_answer":"C",
       "explanation":"The difference between 5.1% and 5.3% is 20 basis points. The interest earned from a $5,000 bond at a 5.1% coupon is $255. The interest earned from a $5000 bond with a 5.3% coupon is $265. The difference is $10."
    },
    {
       "id":5476,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A 6% bond with 10 years to maturity selling in the market at $1,006 has a yield to maturity of:",
       "choice_a":5.92,
       "choice_b":5.88,
       "choice_c":5.9,
       "choice_d":5.79,
       "correct_answer":"A",
       "explanation":"To determine the approximate yield to maturity for a bond purchased at a premium use the following formula:<br>Annual interest - annualized premium / (par + price paid) / 2 <br>The annualized premium is found by dividing the premium by the number of years remaining until maturity. <br>Using that we take the $60 in annual income minus the annualized premium of of 60 cents get 60 - .60 = 59.40. <br>to determine the average price we do the following 1000+1006=2006 / 2 = 1003,  59.4/1003=5.92%"
    },
    {
       "id":5477,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A 6% bond due in 15 years is selling in market for 80. The current yield on this bond is:",
       "choice_a":"7.50%",
       "choice_b":"8%",
       "choice_c":"8.20%",
       "choice_d":"7.90%",
       "correct_answer":"A",
       "explanation":"This bond pays $60 in interest each year and is selling in the market at $800 The current yield = annual income / current price. In this case 60/800 = 7.5%"
    },
    {
       "id":5478,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following would be found in the capital market?",
       "choice_a":"Treasury bills",
       "choice_b":"Banker\u0027s acceptances",
       "choice_c":"CDs",
       "choice_d":"Federal Home Loan Bonds",
       "correct_answer":"D",
       "explanation":"The capital markets consist of long term financing vehicles. Of the choices listed only the Federal Home Loan bond would be a capital market instrument."
    },
    {
       "id":5479,
       "practice_test_id":"",
       "topic_id":3,
       "question":"ABC convertible bonds are convertible at $40. If the bonds are selling in the market for 80 and the common stock is selling for $32, which of the following statements are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Arbitrage in this situation is a violation. </li><li>The stock is selling on conversion parity.  </li><li>There would be a profitable arbitrage situation. </li><li>The bond can be converted into 25 shares of common stock.</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"A",
       "explanation":"The stock is trading at parity and the bonds are convertible into 25 shares of common stock. To determine the number of shares that can be received use the following formula: par / conversion price. In this case 1000/ 40 = 25 shares. The bonds are trading at a 20 % discount to par value. Therefore, the parity price of the underlying common stock would have to be 20% lower than the conversion price. In this case $40 conversion price x 80% = $32. As the stock and bonds are at parity there is no arbitrage opportunity."
    },
    {
       "id":5480,
       "practice_test_id":"",
       "topic_id":3,
       "question":"The SXX Corporation offers to exchange $42 \u00BD million of a $75 \u00BD million, 4 \u00BD% bond of 2029 which is currently quoted at 55 and is convertible to 25 shares of common, for a 4 \u00BD% nonconvertible of 2029, plus some cash. The common stock pays $1.60 per share and is selling at 20.75.  The current yield on the bond is:",
       "choice_a":"4.25%.",
       "choice_b":"4.3%.",
       "choice_c":"8.18%.",
       "choice_d":"20.5%.",
       "correct_answer":"C",
       "explanation":"The current yield is found using the following formula: annual interest / market price. In this case 45 / 550 = 8.18%"
    },
    {
       "id":5481,
       "practice_test_id":"",
       "topic_id":3,
       "question":"The SXX Corporation offers to exchange $42 \u00BD million of a $75 \u00BD million, 4 \u00BD% bond of 2029 which is currently quoted at 55 and is convertible to 25 shares of common, for a 4 \u00BD% nonconvertible of 2029, plus some cash. The common stock pays $1.60 per share and is selling at 20.75 the nominal yield on the bond is:",
       "choice_a":"4.5%.",
       "choice_b":"4.3%.",
       "choice_c":"7.7%.",
       "choice_d":"20.5%.",
       "correct_answer":"A",
       "explanation":"The nominal yield on the bond is 4.5%. The nominal yield on the bond is stated at the time the bonds are issued and never changes."
    },
    {
       "id":5482,
       "practice_test_id":"",
       "topic_id":3,
       "question":"The SXX Corporation offers to exchange $42 \u00BD million of a $75 \u00BD million, 4 \u00BD% bond of 2029 which is currently quoted at 55 and is convertible to 25 shares of common, for a 4 \u00BD% nonconvertible of 2029, plus some cash. The common stock pays $1.60 per share and is selling at 20.75 these bonds are quoted as a percentage of:",
       "choice_a":"Stated value.",
       "choice_b":"Conversion value.",
       "choice_c":"Par value.",
       "choice_d":"Market value.",
       "correct_answer":"C",
       "explanation":"Corporate bonds are quoted as a percentage of par. The quote of 55 is 55% of $1,000 or $550. These bonds are trading at a deep discount."
    },
    {
       "id":5483,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following is a means of financing foreign trade?",
       "choice_a":"CD\u0027s.",
       "choice_b":"Banker\u0027s acceptances.",
       "choice_c":"ADRs.",
       "choice_d":"Commercial paper.",
       "correct_answer":"B",
       "explanation":"Banker\u0027s acceptances are used to finance foreign trade. BAs are issued by a bank and are backed by letters of credit and are used to facilitate or finance import and export activities."
    },
    {
       "id":5484,
       "practice_test_id":"",
       "topic_id":3,
       "question":"The \u0022money market\u0022 refers to transactions in which of the following instruments?",
       "choice_a":"Short-term debt.",
       "choice_b":"Intermediate debt.",
       "choice_c":"Long-term debt.",
       "choice_d":"Long-term equity.",
       "correct_answer":"A",
       "explanation":"Money market instruments are short term debt instruments with one year or less to maturity. There is no such thing as short term equity,equity is perpetual with no maturity date."
    },
    {
       "id":5485,
       "practice_test_id":"",
       "topic_id":3,
       "question":"If a bond is convertible into 20 shares of stock (at a 20 to 1 conversion ratio) the dollar conversion price is:",
       "choice_a":"$20.00",
       "choice_b":"$50.00",
       "choice_c":"$100.00",
       "choice_d":"$1,000.00",
       "correct_answer":"B",
       "explanation":"If a bondholder can receive 20 shares of stock for each bond simply divide the par value of the bond by the number of shares to be received upon conversion to determine the conversion price. In this case 1000 / 20 = $50."
    },
    {
       "id":5486,
       "practice_test_id":"",
       "topic_id":3,
       "question":"XYZ Corporation has a 13 3/4% convertible bond outstanding which is convertible into 20 shares of common stock. The bond is currently selling in the market at 90  and the common stock is selling at 19.25. The XYZ Corporation is offering its existing bondholders a new straight (nonconvertible) bond paying 13 3/4%, which matures at the same time as the convertible bond. XYZ Corporation pays a 40 cent quarterly dividend ($1.60 per year). The Corporation may be attempting:",
       "choice_a":"An arbitrage.",
       "choice_b":"Refunding.",
       "choice_c":"A hedge.",
       "choice_d":"To save cash.",
       "correct_answer":"B",
       "explanation":"A corporation that issues a bond in exchange for another bond is refunding their debt. There is no arbitration opportunity here and the price of the common stock is significantly under parity so the company cannot force a conversion of the bonds into common stock."
    },
    {
       "id":5487,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Lesser quality issues having the same face value, maturity and coupon exhibit which two of the following, compared to high quality debt issues? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Lower market price. </li><li>Lower yield. </li><li>Higher market price. </li><li>Higher yield.</li></ol>",
       "choice_a":"I and II.",
       "choice_b":"I and IV.",
       "choice_c":"II and III.",
       "choice_d":"III and IV.",
       "correct_answer":"B",
       "explanation":"All things being equal the lower quality issue will have a lower price and a higher yield. Investors who take on more risk by purchasing lower quality bonds must be compensated for that risk with a higher interest rate."
    },
    {
       "id":5488,
       "practice_test_id":"",
       "topic_id":3,
       "question":"When the market price of a bond increases, the yield will:",
       "choice_a":"Decrease.",
       "choice_b":"Increase.",
       "choice_c":"Remain the same.",
       "choice_d":"None of the choices listed.",
       "correct_answer":"A",
       "explanation":"Prices and yields are inversely related. As the price of the bonds  increased the yield has fallen."
    },
    {
       "id":5489,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Two bonds with coupons of 4 \u00BD% and 4 3/4% respectively would have an annual interest payment difference of:",
       "choice_a":"$0.25.",
       "choice_b":"$2.50.",
       "choice_c":"$25.00",
       "choice_d":"$250.00",
       "correct_answer":"B",
       "explanation":"A bond with a 4.5 percent coupon pays $45 per year ($1,000 X .045) . The bond with a 4.75 percent coupon pages $47.50 per year (1,000 X .0475) The difference would be between $45 and $47.50 or $2.50"
    },
    {
       "id":5490,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A CMO is considered a/an",
       "choice_a":"Equity security",
       "choice_b":"Direct mortgage obligation",
       "choice_c":"REIT",
       "choice_d":"Derivative",
       "correct_answer":"D",
       "explanation":"CMOs are a type of securities that is derived from pass through obligations  based on a pool of mortgages. The value of the CMO is derived from the value of the underlying asset."
    },
    {
       "id":5491,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A warrant is issued and attached to a bond issue to provide the issuer with which of the following?",
       "choice_a":"Higher interest rate",
       "choice_b":"Higher ratings",
       "choice_c":"Lower interest rate",
       "choice_d":"Lower risk of default",
       "correct_answer":"C",
       "explanation":"The advantage to attaching warrants to a bond issue is that it generally allows the issuer to offer a lower stated rate of interest on the bonds. Warrants improve the marketability of bonds with low credit ratings as well."
    },
    {
       "id":5492,
       "practice_test_id":"",
       "topic_id":3,
       "question":"What does a warrant attached to a bond entitle the holder to?",
       "choice_a":"To trade the bond for stock at a set market price",
       "choice_b":"To the purchase of preferred stock at a set price over a range of dates",
       "choice_c":"To the purchase of common stock at set price over range of dates",
       "choice_d":"To the purchase of set number shares of stock at set price on a certain date",
       "correct_answer":"C",
       "explanation":"A warrant attached to a bond entitles the holder to purchase a set number of shares of common stock at a set price over a period of time not on a set date."
    },
    {
       "id":5493,
       "practice_test_id":"",
       "topic_id":3,
       "question":"You own a long term corporate bond.  Which of the following risks should you be least concerned about?",
       "choice_a":"Default",
       "choice_b":"Interest rate risk",
       "choice_c":"Market risk",
       "choice_d":"Liquidity risk",
       "correct_answer":"D",
       "explanation":"Of the risks listed the holder of a long term corporate bond would be least concerned about liquidity risk, which is the ability to sell the bond quickly without adversely impacting the bond\u0027s price. The long term bond would be subject to interest rate risk and this would be the biggest concern. If interest rates rise the value of the long term bond will fall the most."
    },
    {
       "id":5494,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A bond has a 6% coupon and is selling in the marketplace at 105. The bond is currently:",
       "choice_a":"Selling at par value",
       "choice_b":"Selling at discount",
       "choice_c":"Selling at premium",
       "choice_d":"Selling with a 6% yield to maturity",
       "correct_answer":"C",
       "explanation":"A bond trading in the marketplace at 105 is selling at a premium to its par value. In this case the bond is trading at 105% of its par value of $1,050."
    },
    {
       "id":5495,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following are US Treasury obligations? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Notes </li><li>Bills </li><li>Savings bonds  </li><li>Revenue bonds</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"I ,II, and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"All of the above securities are obligations of the US Treasury except revenue bonds. Revenue bonds are municipal securities not Treasury securities."
    },
    {
       "id":5496,
       "practice_test_id":"",
       "topic_id":3,
       "question":"The advantages of a zero coupon bond for an investor are:",
       "choice_a":"Tax free interest",
       "choice_b":"Taxation of phantom income",
       "choice_c":"The ability to choose a maturity date and to receive a known amount on that date",
       "choice_d":"Higher interest rates than coupon bonds",
       "correct_answer":"C",
       "explanation":"An advantage of a zero coupon bond is the ability to purchase a bond with a set maturity date and the ability to receive a known amount on that date."
    },
    {
       "id":37364,
       "practice_test_id":"",
       "topic_id":3,
       "question":"<div>Of the following debt instruments which of the following is associated with mortgages and the term \u0022tranche\u0022?</div>",
       "choice_a":"CMO",
       "choice_b":"FNMA",
       "choice_c":"GNMA",
       "choice_d":"Corporate bonds",
       "correct_answer":"A",
       "explanation":"Collateralized mortgage obligations (CMOs) are just one of the securities that are backed by mortgages. However, a CMO is the only type of issue divided into several tranches, or pieces. Each tranche is unique regarding the priority set for payments of principal and interest. Investors choose a tranche that suits them in terms of the risk associated with the payment priority."
    },
    {
       "id":37365,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Debt securities are often associated with a fixed maturity date. Of the following debt securities which would be an exception?",
       "choice_a":"Corporate debenture",
       "choice_b":"General obligation municipal bond",
       "choice_c":"Collateralized mortgage obligation",
       "choice_d":"Treasury bills",
       "correct_answer":"C",
       "explanation":"Remember that CMOs are mortgage-backed securities and that mortgages can be, and often are paid off early or ahead of the scheduled maturity. Therefore, when investing in CMOs, the exact maturity date is uncertain."
    },
    {
       "id":37366,
       "practice_test_id":6,
       "topic_id":3,
       "question":"A client interested in CMOs makes several statements regarding the risk associated with CMOs and their suitability for different investors. But only one of the statements is accurate. Which of those statements below is it?",
       "choice_a":"One of their unique characteristics is that they are suitable for small or unsophisticated investors who want to invest in something backed by mortgages.",
       "choice_b":"Repayment of principal is always guaranteed because they are mortgaged-backed.",
       "choice_c":"Because early prepayment is a possibility, the rate of return may vary.",
       "choice_d":"Though they are divided into tranches, each is the same, having identical risk characteristics.",
       "correct_answer":"C",
       "explanation":"Prepayment risk is so inherent with CMOs, it must be disclosed to prospective investors. To offer investors different degrees and characteristics of risk such as prepayment and extension risk, CMOs are divided into different pieces called tranches. Investors can choose the tranche with risk characteristics they are comfortable with. There is no guarantee of principal repayment, and this coupled with the risks mentioned above, is why they may not be suitable for smaller or unsophisticated investors."
    },
    {
       "id":37367,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following debt instruments pays interest that is taxable at all levels; federal, state and local where applicable?",
       "choice_a":"Collateralized mortgage obligations",
       "choice_b":"Treasury notes",
       "choice_c":"Municipal revenue bonds",
       "choice_d":"Municipal general obligation bonds",
       "correct_answer":"A",
       "explanation":"Remember that the interest on corporate debt securities is taxable at the federal, state, and local levels, and because CMOs are issued by corporations they too are taxable at all levels. Interest on Treasury instruments is taxable at the federal level only. Interest on municipal instruments is exempt from taxation at the federal level and sometimes the state level as well if the investor is a resident of the state of issue."
    },
    {
       "id":37368,
       "practice_test_id":6,
       "topic_id":3,
       "question":"Which of the following account profiles would a CMO Z-tranche be best suited for?",
       "choice_a":"The account for a professionally managed hedge fund specializing in real estate investments and mortgage-backed securities",
       "choice_b":"The IRA account for a middle-aged corporate professional mostly comfortable with mutual fund investments",
       "choice_c":"The custodial account for a pre-teen set up by his parents where funds are being invested for future college expenses",
       "choice_d":"The joint investment account for a medical professional and her retired spouse",
       "correct_answer":"A",
       "explanation":"One of the characteristics of a zero tranche (Z-Tranche) CMO is that it receives no payments until all preceding tranches of the CMO are retired. In this light, they are considered to be among the most volatile and therefore risky. CMO tranches in general are not suitable for smaller or unsophisticated investors which is why customers are required to sign a suitability statement before purchasing any CMO tranche. All of the above considered, of the account profiles shown here, the best suited would be the one that is professionally managed and already specializing in real estate and mortgage-backed investments."
    },
    {
       "id":37369,
       "practice_test_id":1,
       "topic_id":3,
       "question":"Regarding collateralized mortgage obligations (CMOs) which of the following statements accurately conveys one of their characteristics?",
       "choice_a":"CMO returns can be impacted by changes in interest rates.",
       "choice_b":"CMO earnings are tax exempt at the federal level only.",
       "choice_c":"CMOs cannot trade at a premium.",
       "choice_d":"CMOs cannot trade at a discount.",
       "correct_answer":"A",
       "explanation":"Because CMOs are mortgage-backed securities they respond to changes in interest rates. When interest rates decline, certain CMO tranches can trade at a premium and conversely some can trade at a discount when interest rates rise. This characteristic is common to most debt instruments. CMOs are issued by corporations and therefore earnings are taxable at all levels."
    },
    {
       "id":37370,
       "practice_test_id":2,
       "topic_id":3,
       "question":"One of your clients is interested in collateralized mortgage obligations for the purpose of adding some real estate related diversity to her portfolio. While certain risk disclosures should be made, which of the following risks would be of least concern for someone investing in CMOs?",
       "choice_a":"Prepayment risk",
       "choice_b":"Extended maturity risk",
       "choice_c":"Interest rate risk",
       "choice_d":"Liquidity risk",
       "correct_answer":"D",
       "explanation":"Because CMOs are backed by mortgages, investors are always subject to interest rate risk. Interest rate risk impacts both maturity date risk known as extended maturity risk and the risk of prepayment. However, because these corporate debt instruments trade OTC they are considered to be fairly liquid which allows investors to buy or sell them easily at fair market value."
    },
    {
       "id":37371,
       "practice_test_id":3,
       "topic_id":3,
       "question":"When someone is given a yield quote on a collateralized mortgage obligation (CMO) tranche it should be recognized that the yield is based on the:",
       "choice_a":"expected life of that individual tranche",
       "choice_b":"average life of the underlying mortgages backing the entire CMO portfolio",
       "choice_c":"maturity dates of the underlying mortgages backing the entire CMO portfolio",
       "choice_d":"average interest rates of the underlying mortgages encompassed in that individual tranche",
       "correct_answer":"A",
       "explanation":"Yield quotes on collateralized mortgage obligation tranches are based on the tranche\u0027s expected life. Depending on the risk characteristics of the tranche, its expected life can be impacted by both extended and prepayment risk."
    },
    {
       "id":37372,
       "practice_test_id":4,
       "topic_id":3,
       "question":"When interest rates are falling, holders of collateralized mortgage obligations (CMOs) should expect which of the following?",
       "choice_a":"Prepayment risk will decrease and the prices of each tranche will fall.",
       "choice_b":"Prepayment risk will decrease and the prices of each tranche will rise.",
       "choice_c":"Prepayment risk will increase and the prices of each tranche will fall.",
       "choice_d":"Prepayment risk will increase and the prices of each tranche will rise.",
       "correct_answer":"D",
       "explanation":"Remember that CMOs are debt instruments and like all debt instruments their prices are inversely related to interest rates: rates up, prices down or rates down, prices up. Because CMOs are backed by mortgages, prepayment risk exists when rates fall. In a falling rate environment, mortgage holders will refinance; paying off existing high-rate mortgages with lower rate mortgages."
    },
    {
       "id":37373,
       "practice_test_id":5,
       "topic_id":3,
       "question":"If discussing collateralized mortgage obligations (CMOs), one of the statements shown below would be incorrect. Which is it?",
       "choice_a":"These debt securities are considered to be a derivative security.",
       "choice_b":"Principal repayments when received, are applied to earlier tranches first.",
       "choice_c":"Interest payments received on the mortgages backing CMOs are distributed pro rata to each tranche when received.",
       "choice_d":"Interest payments on CMOs are paid semiannually to investors.",
       "correct_answer":"D",
       "explanation":"Investors in CMOs are paid interest monthly. As interest payments are received from the underlying mortgages, it is distributed pro rata to all tranches. However, when principal repayments are received, those are paid to the first tranche until it is retired and subsequently applied to the next tranche and then the next, and so on. CMOs are a derivative security because they are backed by an underlying investment; mortgages. "
    },
    {
       "id":37374,
       "practice_test_id":6,
       "topic_id":3,
       "question":"An investor receives interest payments for a collateralized mortgage obligation he holds in his portfolio. These payments, representing interest only, will be:",
       "choice_a":"taxed as ordinary income.",
       "choice_b":"taxed partly as ordinary income and partly as a tax-free return of principal.",
       "choice_c":"tax exempt.",
       "choice_d":"taxed at the investors capital gains rate.",
       "correct_answer":"A",
       "explanation":"Payments made to CMO investors representing interest only are taxed as ordinary income."
    },
    {
       "id":37375,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A registered representative is recommending a CMO to one of her more sophisticated investor clients. Of the risks shown below, which is likely to be of least or nominal consideration?",
       "choice_a":"Interest rate risk",
       "choice_b":"Credit risk",
       "choice_c":"Extended payment risk",
       "choice_d":"Prepayment risk",
       "correct_answer":"B",
       "explanation":"Most CMOs offered to the public customers are backed by mortgages held by government sponsored corporations such as Fannie Mae, Ginnie Mae and Freddie Mac. In this light, being backed by government sponsored corporations, of the risks listed, credit risk would be the one of least or nominal consideration. The other risks listed are all inherent to mortgage-backed securities."
    },
    {
       "id":37376,
       "practice_test_id":6,
       "topic_id":3,
       "question":"A registered representative is recommending a private label CMO to an institutional customer. In the conversation it would be accurate to convey which of the following characteristics?",
       "choice_a":"They sometimes include government agency securities in their portfolio and if so, the CMO will  carry the guarantee of that agency.",
       "choice_b":"They may not be issued unless they contain government agency securities in their portfolio.",
       "choice_c":"The good faith and credit of their issuer is the only guarantee they carry.",
       "choice_d":"The issues can only originate from, and therefore be issued by, government agencies.",
       "correct_answer":"C",
       "explanation":"Private label CMOs are unique in that they are issued by private entities such as financial institutions, investment banks and at times, home builders. While they sometimes include government agency securities such as GNMAs in their portfolios, they are not mandated to. Even when they do, they do not carry any implied guarantee other than the good faith and credit of their private issuer."
    },
    {
       "id":38138,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A non callable bond would be most valuable in an environment where:",
       "choice_a":"Bond prices are falling",
       "choice_b":"Inflation is falling",
       "choice_c":"Bond prices are rising",
       "choice_d":"Inflation is rising",
       "correct_answer":"C",
       "explanation":"A non-callable bond would be most valuable in an environment where bond prices are rising. Bond prices will generally rise when interest rates fall. A non-callable bond would appreciate more than a callable bond and would be the most valuable in this environment."
    },
    {
       "id":37378,
       "practice_test_id":"",
       "topic_id":3,
       "question":"When a corporation pools loans into a financial instrument such as a CMO to better facilitate marketing them to public investors, the process of pooling the assets is known as:",
       "choice_a":"laddering",
       "choice_b":"structuring",
       "choice_c":"planned amortization",
       "choice_d":"securitization",
       "correct_answer":"D",
       "explanation":"CMOs are asset backed securities representing a pool of mortgage loan assets that were combined into a single financial instrument for the purpose of selling the assets to the investing public. The pooling of assets into a single financial instrument specifically done for this purpose is known as securitization."
    },
    {
       "id":19326,
       "practice_test_id":6,
       "topic_id":3,
       "question":"The written agreement that contains the specific details related to a bond issue is called the bond:",
       "choice_a":"Indenture",
       "choice_b":"Contract",
       "choice_c":"Subscription",
       "choice_d":"Prospectus",
       "correct_answer":"A",
       "explanation":"The written agreement that contains the specific details related to a bond issue is called the bond indenture. The indenture spells out all of the terms and conditions of the bond."
    },
    {
       "id":24644,
       "practice_test_id":2,
       "topic_id":3,
       "question":"A client who is risk averse is speaking to his registered representative about brokered CDs as an option for $200,000 he has in his investment account. Which of the following choices are not features of negotiable CDs sold to clients of broker dealers? ",
       "choice_a":"The CDs are available in a wide maturity range",
       "choice_b":"The CDs trade flat in the secondary market",
       "choice_c":"The CDs will be covered under FDIC Insurance for $250,000",
       "choice_d":"The greater the number of compounding periods the greater the return",
       "correct_answer":"B",
       "explanation":"The question asks which is not a feature of negotiable CDs sold through brokers. All of the choices are true except the CDs do not trade flat. The negotiable CDs trade with accrued interest."
    },
    {
       "id":24648,
       "practice_test_id":3,
       "topic_id":3,
       "question":"Which of the following would not be a short term money market instrument?",
       "choice_a":"Banker\u0027s acceptance",
       "choice_b":"Commercial paper",
       "choice_c":"CDs",
       "choice_d":"A warrant with 7 months remaining to maturity",
       "correct_answer":"D",
       "explanation":"Only short term debt securities may be traded in the money market. A warrant is an equity security and therefore not a money market instrument."
    },
    {
       "id":24654,
       "practice_test_id":4,
       "topic_id":3,
       "question":"An income oriented investor purchased a 7 percent bond at 90 when the issuer was having financial trouble. After a series of corporate initiatives the issuer\u0027s prospects are looking up. The bond is now trading in the marketplace at 120. What is the investor\u0027s current yield?",
       "choice_a":"7.77%",
       "choice_b":"5.83%",
       "choice_c":"6.36%",
       "choice_d":"8.1 %",
       "correct_answer":"A",
       "explanation":"When an investor purchases a bond the investor locks in the current yield at the time of purchase. In this case it is 7.77%. Found using the formula: CY= AI/CMP 70/ 900 = 7.77. The current yield on the bond for new purchasers will be less because the bond has increased in price. However, the current yield for this investor has not changed"
    },
    {
       "id":24655,
       "practice_test_id":5,
       "topic_id":3,
       "question":"Which of the following would not carry currency risk for A U.S. based issuer or investor? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Eurobond </li><li>Yankee bond </li><li>Eurodollar bond </li><li>Eurodollar deposit</li></ol>",
       "choice_a":"III only",
       "choice_b":"II and IV",
       "choice_c":"I and IV",
       "choice_d":"II, III and IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed are denominated and pay interested in US dollars, except a Eurobond. A Yankee bond is a bond issued by an overseas corporation denominated in US dollars. Eurodollar bonds are sold by US corporations to overseas investors and are denominated in US dollars. A Eurodollar deposits is an overseas account denominated in US dollars. "
    },
    {
       "id":24670,
       "practice_test_id":2,
       "topic_id":3,
       "question":"Which of the following investments would subject the investor the the greatest interest rate risk? ",
       "choice_a":"A 20 year floating rate security",
       "choice_b":"A 15 year zero coupon bond",
       "choice_c":"A 20 year zero coupon bond",
       "choice_d":"A 30 year zero coupon bond",
       "correct_answer":"D",
       "explanation":"As interest rates change the bond with the longest time until maturity and trading the furthest away from par will fall the most in price if interest rates rise. In this case the 30-year zero coupon bond is the correct choice. "
    },
    {
       "id":20913,
       "practice_test_id":3,
       "topic_id":3,
       "question":"An investor who is long a variable rate demand obligation is looking to offset his position and liquidate the security. The investor may accomplish this by doing which of the following?",
       "choice_a":"Selling the security in the market",
       "choice_b":"Putting the security to the dealer at any time",
       "choice_c":"Putting  the security to a third party at any time",
       "choice_d":"Putting the security to the dealer on the reset date only",
       "correct_answer":"D",
       "explanation":"An investor may only liquidate the variable rate demand obligation by putting the security to the dealer or to a third party on the reset date."
    },
    {
       "id":19358,
       "practice_test_id":4,
       "topic_id":3,
       "question":"Commercial paper with 270 days to maturity trading in the money market has its interest rate calculated based on:",
       "choice_a":"270 days",
       "choice_b":"360 days",
       "choice_c":"Nine 30 day months",
       "choice_d":"Three 90 day quarters",
       "correct_answer":"B",
       "explanation":"Commercial paper with 270 days to maturity trading in the money market has its interest rate calculated based on a 360 day year."
    },
    {
       "id":19361,
       "practice_test_id":5,
       "topic_id":3,
       "question":"Bond interest starts to accrue on:",
       "choice_a":"The accrual date",
       "choice_b":"The issue date",
       "choice_c":"The dated date",
       "choice_d":"The payment date",
       "correct_answer":"C",
       "explanation":"Bond interest starts to accrue on a new issue of bonds on the dated date. "
    },
    {
       "id":20280,
       "practice_test_id":6,
       "topic_id":3,
       "question":"An investor who is concerned that interest rates will be falling in the near future would be unlikely to buy which of the following?",
       "choice_a":"CMOs",
       "choice_b":"GNMAs",
       "choice_c":"zero coupon bonds",
       "choice_d":"all of the the choices listed",
       "correct_answer":"D",
       "explanation":"Mortgage backed securities like CMOs and GNMAs have refinancing risk, i.e. when interest rates fall homeowners refinance and the holders of these securities will be paid back sooner than anticipated. And zero coupon bonds pay no interest, but are sold at a deep discount making them extremely sensitive to changes in interest rates. If an investor is concerned about falling interest rates none of these would be appropriate investments."
    },
    {
       "id":20282,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following are true of both CMOs and GNMAs? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> They are both mortgage backed securities  </li><li>They are both issued by a US government agency  </li><li>They are both subject to interest rate risk  </li><li>They are both pass through certificates</li></ol>",
       "choice_a":"I only",
       "choice_b":"I,II, IV",
       "choice_c":"II, III, IV",
       "choice_d":"I, III, IV",
       "correct_answer":"D",
       "explanation":"Both CMOs and GNMAs are mortgage backed securities that are classified as pass through certificates, as interest and principal pass through to the investor. As such they are both subject to interest rate risk i.e. if interest rates fall homeowners are more likely to refinance their mortgages resulting in the CMO or GNMA investor being paid off sooner than anticipated. Only GMNAs are issued by a US government agency. CMO\u0027s are issued by investment banks."
    },
    {
       "id":20283,
       "practice_test_id":6,
       "topic_id":3,
       "question":"All of the following are available to investors in a CMO except:",
       "choice_a":"Tendered Amortization Class",
       "choice_b":"Planned Amortization Class",
       "choice_c":"Principal only",
       "choice_d":"Targeted amortization Class",
       "correct_answer":"A",
       "explanation":"When purchasing a CMO an investor may choose between a planned or targeted amortization class and a principal only or interest only option. There are no tendered amortization classes."
    },
    {
       "id":20285,
       "practice_test_id":"",
       "topic_id":3,
       "question":"All of the following are risks to a CMO investor: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Interest rate risk </li><li>Refinancing risk </li><li>Liquidity risk </li><li>Purchasing power risk</li></ol>",
       "choice_a":"I, II",
       "choice_b":"I, IV",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"When purchasing a CMO it is important that the investor understands that fluctuations in interest rates may result in homeowners refinancing their mortgages and the investors having their principal returned early. There are also the risks that when the principal is paid, its value will have eroded due to inflation and that the investor won\u0027t be able to sell the position quickly."
    },
    {
       "id":20286,
       "practice_test_id":6,
       "topic_id":3,
       "question":"CMOs are issued by all of the following except:",
       "choice_a":"Investment banks",
       "choice_b":"FNMA",
       "choice_c":"US government agencies",
       "choice_d":"FHLMC",
       "correct_answer":"C",
       "explanation":"CMOs are issued by investment banks, FNMA and FHLMC. Unlike GNMAs they are not issued by government agencies."
    },
    {
       "id":20945,
       "practice_test_id":6,
       "topic_id":3,
       "question":"A bond issue that is said to trade \u0022flat\u0022 indicates to the investor:",
       "choice_a":"the bond is trading at par value",
       "choice_b":"the bond is in default",
       "choice_c":"the bond price is very stable",
       "choice_d":"the bond does not pay interest",
       "correct_answer":"D",
       "explanation":"A bond that is said to trade flat does not trade with accrued interest. Zero coupon bonds, and other issues that are issued at a discount like T\u0027 bills, commercial paper and banker\u0027s acceptances all trade flat and do not make regular interest payments. These securities are issued at a discount and appreciate up to par."
    },
    {
       "id":20946,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor is considering purchasing a 7 percent corporate bond. The bond is trading in the marketplace at 100 and is callable in 10 years at par. The bond has 16 years left until maturity. Which of the following is true? ",
       "choice_a":"The YTC is lower than the YTM",
       "choice_b":"The YTC is greater than the YTM",
       "choice_c":"The YTC equals the YTM",
       "choice_d":"The investor would be better off purchasing a non callable issue",
       "correct_answer":"C",
       "explanation":"The bond is trading at 100 or par in the market and callable at par in 10 years. Since the price the investor would pay for the bond is equal to par and the bond is callable at par, the YTC will be equal to the YTM. When an investor buys a bond at par the nominal yield, the current yield and the yield to maturity will all be equal. If the bond is callable at par the YTC will also be the same as the nominal yield.  "
    },
    {
       "id":20947,
       "practice_test_id":6,
       "topic_id":3,
       "question":"As it relates to the issuance of Eurodollar bonds issued by a US corporation, which of the following is / are not true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The corporation is subject to currency risk </li><li>The bonds must be registered with the SEC prior to sale  </li><li>The investors will receive payments in their domestic currency  </li><li>The bonds may only be sold to qualified institutional buyers in the US</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"Eurodollar bonds are bonds issued by a US corporation denominated in US dollars and sold to investors who reside outside of the US. Because the bonds are issued in US Dollars the corporation does not have any currency risk. The bonds are issued outside of the US which is beyond the jurisdiction of the SEC. Therefore the bonds do not need to register with the SEC. Eurodollar bonds are not sold to any US investors and investors receive payments in US dollars."
    },
    {
       "id":20953,
       "practice_test_id":2,
       "topic_id":3,
       "question":"As it relates to a variable interest rate municipal security, which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The bond has a fixed coupon rate </li><li>The bond has a stable principal value  </li><li>The bond has a coupon rate that varies  </li><li>The bond has a principal amount that varies</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"III and IV",
       "correct_answer":"C",
       "explanation":"A variable interest rate municipal security has a coupon rate that is regularly adjusted to the prevailing interest rates in the market. As such the principal value of the bond tends to be very stable and always close to par. If rates increase the interest rate paid on the bond is increased., if rates fall the interest rate paid on the bond is reduced."
    },
    {
       "id":21465,
       "practice_test_id":3,
       "topic_id":3,
       "question":"As structured products equity linked notes or ELNs may not be suitable for all investors. Which of the following is a typical characteristic of ELNs that investors should be made aware of:",
       "choice_a":"ELNs convert to cash at maturity",
       "choice_b":"ELNs convert to the underlying equity security",
       "choice_c":"ELNs have a set rate of interest",
       "choice_d":"ELNs make payments to investors annually and at maturity",
       "correct_answer":"A",
       "explanation":"Of the choices listed only the fact that ELNs convert to cash at maturity is correct. ELNs do not make interest payments. At maturity the investor receives the cash value of the note which will include the principal amount plus a percentage of the actual return of the underlying security. "
    },
    {
       "id":37377,
       "practice_test_id":4,
       "topic_id":3,
       "question":"An inverse floater CMO is considered to be:",
       "choice_a":"one that will provide stable principal payments to investors when interest rates are rising.",
       "choice_b":"highly volatile, carrying more extension risk for investors.",
       "choice_c":"relatively safe for unsophisticated investors in all interest rate environments.",
       "choice_d":"the least volatile of all CMO issues because payments are guaranteed in all interest rate environments.",
       "correct_answer":"B",
       "explanation":"Inverse floater CMOs are considered to be highly volatile and only suitable for sophisticated investors who are willing to accept the unique risk they present. Namely, the risk that principal payments will decrease when interest rates are rising. If the principal is not being paid when it is anticipated to be, this extends the maturity date. Therefore, these types of CMOs present high levels of extension risk to investors."
    },
    {
       "id":36987,
       "practice_test_id":5,
       "topic_id":3,
       "question":"SIA \u0026 Co. is considering borrowing funds through the sale of zero coupon bonds. As it relates to the interest payments on the issue, which of the following is true?",
       "choice_a":"Investors will pay taxes at maturity and SIA \u0026 Co. will take the interest tax deduction at maturity",
       "choice_b":"Investors will pay taxes annually and SIA \u0026 Co. will take the interest tax deduction at maturity",
       "choice_c":"Investors, will pay taxes at maturity and SIA \u0026 Co. will take the interest tax deduction annually",
       "choice_d":"Investors, will pay taxes annually and SIA \u0026 Co. will take the interest tax deduction at annually",
       "correct_answer":"B",
       "explanation":"Investors who purchase zero coupon bonds must pay taxes annually on the phantom income produced by the appreciation of the bonds. Issuers of zero coupon bonds, in this case SIA \u0026 Co must take the interest tax deduction at maturity when the interest is actually paid by the issuer."
    },
    {
       "id":36986,
       "practice_test_id":1,
       "topic_id":3,
       "question":"An investor who is risk averse is reviewing an opportunity to purchase a corporate bond issued by ABC Corporation. Which of the following would provide the investor with the greatest understanding of the bond\u0027s risk?",
       "choice_a":"Term",
       "choice_b":"Collateral",
       "choice_c":"Yield",
       "choice_d":"Price",
       "correct_answer":"C",
       "explanation":"The bond\u0027s yield is the best measure of risk. The higher the yield, the greater the risk associated with the bond. Bonds with a significant amount of risk of default or credit risk will have the highest yield to compensate investors for taking on that risk."
    },
    {
       "id":5559,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The Federal Reserve Board tool most used to control money and credit is:",
       "choice_a":"Reserve requirements.",
       "choice_b":"Discount rate.",
       "choice_c":"Margin requirements.",
       "choice_d":"Open-market operations.",
       "correct_answer":"D",
       "explanation":"The tool most used by the FRB to influence the direction of interest rates is open market operations."
    },
    {
       "id":5560,
       "practice_test_id":"",
       "topic_id":4,
       "question":"From a fundamental point of view, which of the following is not significant?",
       "choice_a":"Sales.",
       "choice_b":"Inventories.",
       "choice_c":"Assets.",
       "choice_d":"Trading volume.",
       "correct_answer":"D",
       "explanation":"A fundamental analyst would not be concerned with the trading volume in the stock."
    },
    {
       "id":5561,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Changes in the DJIA will affect:",
       "choice_a":"Railroad stocks.",
       "choice_b":"Utility stocks.",
       "choice_c":"Bank stocks.",
       "choice_d":"Industrial stocks.",
       "correct_answer":"D",
       "explanation":"The DJIA is an index comprised of 30 industrial stocks. therefore a change in the DJIA reflects changes in the price of industrial stocks."
    },
    {
       "id":5562,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following would not be considered a defensive stock?",
       "choice_a":"A utility stock.",
       "choice_b":"A food stock.",
       "choice_c":"A natural gas stock.",
       "choice_d":"A steel stock.",
       "correct_answer":"D",
       "explanation":"A steel stock would be an example of a cyclical stock. A defensive stock is one whose earnings are resistant to inflation."
    },
    {
       "id":5563,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following would best describe the odd-lot theory?",
       "choice_a":"Periodic investment of a fixed dollar amount.",
       "choice_b":"Buying when the market is in a long-term downtrend.",
       "choice_c":"Buying when the market is in a long-term uptrend.",
       "choice_d":"Adopting a bearish attitude when the small investor is bullish and bullish when the small investor is bearish.",
       "correct_answer":"D",
       "explanation":"The odd lot theory believes that the smaller investor buys and sells at the wrong time. If there are a lot of odd lot buy orders the investor would become bearish. If there are a lot of odd lot sell orders the investor would become bullish."
    },
    {
       "id":5564,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A devaluation of the U.S. dollar in comparison to other currencies would have the effect of making: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>U.S. exports more competitive than foreign exports. </li><li>U.S. exports less competitive than foreign exports.  </li><li>Foreign exports less competitive than U.S. exports.  </li><li>Foreign exports more competitive than U.S. exports.</li></ol>",
       "choice_a":"I only.",
       "choice_b":"I and III.",
       "choice_c":"II only.",
       "choice_d":"II and IV.",
       "correct_answer":"B",
       "explanation":"A fall in the value of the US Dollar would make US exports more competitive and foreign goods less competitive."
    },
    {
       "id":5565,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A fundamental analyst evaluating the common stock of a corporation would look at all of the following, except:",
       "choice_a":"The sales of the corporation.",
       "choice_b":"The management of the corporation.",
       "choice_c":"The current amount of earnings paid out as dividends to the shareholders.",
       "choice_d":"The short interest in the company\u0027s stock",
       "correct_answer":"D",
       "explanation":"A fundamental analyst would not be concerned with the short interest in the company\u0027s stock."
    },
    {
       "id":5566,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A technical analysis of the market would be based on all of the following, except:",
       "choice_a":"Advances and declines.",
       "choice_b":"New highs and lows.",
       "choice_c":"The amount of Dow-Jones Industrial Stocks sold short.",
       "choice_d":"An in-depth analysis of the 30 stocks in the Dow-Jones Industrial Average.",
       "correct_answer":"D",
       "explanation":"A technical analyst would not do an in depth analysis of the 30 stocks in the Dow Jones"
    },
    {
       "id":5567,
       "practice_test_id":"",
       "topic_id":4,
       "question":"If the amount on the balance sheet representing shareholders equity declines as a result of a corporate transaction while assets remain unchanged, which must occur?",
       "choice_a":"A decrease in accrued expenses.",
       "choice_b":"A decrease in prepaid expenses.",
       "choice_c":"An increase in total liabilities.",
       "choice_d":"An increase in total net worth accounts.",
       "correct_answer":"C",
       "explanation":"The transaction must have resulted in an increase in total liabilities."
    },
    {
       "id":5568,
       "practice_test_id":"",
       "topic_id":4,
       "question":"All of the following are true of stockholders equity, except:",
       "choice_a":"It consists of capital stock, capital surplus and retained earnings.",
       "choice_b":"It is carried on the asset side of the balance sheet.",
       "choice_c":"It is also known as book value.",
       "choice_d":"It is also known as net worth.",
       "correct_answer":"B",
       "explanation":"Stockholders equity is carried on the right side of the balance sheet consisting of liabilities and stockholders equity."
    },
    {
       "id":5569,
       "practice_test_id":"",
       "topic_id":4,
       "question":"When a corporation redeems its bonds, this will: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Decrease working capital. </li><li>Increase working capital. </li><li>Increase net worth. </li><li>Decrease net worth.</li></ol>",
       "choice_a":"I only.",
       "choice_b":"I and II.",
       "choice_c":"I and III.",
       "choice_d":"I, II and III.",
       "correct_answer":"A",
       "explanation":"If a corporation redeems its bonds for cash this will reduce the amount of cash the company has to operate. The company\u0027s assets (cash) and its liabilities (bonds being redeemed) will be reduced by an equal amount and will not affect the company\u0027s net worth."
    },
    {
       "id":5570,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Of the choices listed , the financial ratio that would be the most stringent measure of the liquidity of a corporation would be the:",
       "choice_a":"Current ratio.",
       "choice_b":"Debt to net worth ratio.",
       "choice_c":"Quick ratio.",
       "choice_d":"Interest coverage ratio.",
       "correct_answer":"C",
       "explanation":"The quick ratio is the most stringent of the tests listed. The quick ratio is sometimes referred to as the acid test ratio. it measures the relationship between cash and marketable securities relative to the company\u0027s current liabilities."
    },
    {
       "id":5571,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The calculation for earnings per share on a \u0027primary\u0027 basis is computed based upon:",
       "choice_a":"The outstanding common shares + the amount of shares that would be outstanding if convertible bonds and convertible preferred stock were converted into common stock.",
       "choice_b":"The number of outstanding common shares only.",
       "choice_c":"The number of outstanding common shares + the retained earnings.",
       "choice_d":"The number of outstanding common shares + the working capital.",
       "correct_answer":"B",
       "explanation":"Primary EPS is calculated based on the total number of outstanding shares only."
    },
    {
       "id":5572,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The ABC Corporation has earnings per share of $1.00. ABC Corporation\u0027s earnings are expected to grow at the rate of 20% per year for the next five years. At the end of five years, the earnings should be:",
       "choice_a":"$1.20.",
       "choice_b":"$2.00.",
       "choice_c":"$2.49.",
       "choice_d":"$2.99.",
       "correct_answer":"C",
       "explanation":"The easiest way to determine the answer is to multiply the current earnings of $1 and multiply it by 1.2 five times."
    },
    {
       "id":5573,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Depreciation is not: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Accumulated to a liability. </li><li>Recovery of the cost of an asset. </li><li>Included as an entry on the income statement. </li><li>Accumulated to an asset.</li></ol>",
       "choice_a":"I only.",
       "choice_b":"II only.",
       "choice_c":"I and II.",
       "choice_d":"I, II and III.",
       "correct_answer":"A",
       "explanation":"Choice I. is the only answer that is not true about depreciation."
    },
    {
       "id":5574,
       "practice_test_id":"",
       "topic_id":4,
       "question":"ZZZ Corporation has a net income of $8,000,000 and 6,000,000 common shares outstanding. ZZZ Corporation pays out $2 million in dividends annually. ZZZ Corporation\u0027s earnings per common share is:",
       "choice_a":"35¢.",
       "choice_b":"95¢.",
       "choice_c":"$1.33.",
       "choice_d":"$3.00.",
       "correct_answer":"C",
       "explanation":"To determine the EPS divide the earnings of $8,000,000 by the number of outstanding common shares.  In this case $8,000,000 / 6,000,000 = 1.33"
    },
    {
       "id":5575,
       "practice_test_id":6,
       "topic_id":4,
       "question":"The payment of a 10% stock dividend would cause: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The outstanding common stock to increase. </li><li>The paid-in surplus to decrease. </li><li>The treasury stock to increase. </li><li>The earned surplus to decrease.</li></ol>",
       "choice_a":"I only.",
       "choice_b":"I and II.",
       "choice_c":"I, II and III.",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"A",
       "explanation":"The payment of a stock dividend has no effect on the corporation\u0027s assets or liabilities. The payment will only cause the number of outstanding shares to increase."
    },
    {
       "id":5576,
       "practice_test_id":1,
       "topic_id":4,
       "question":"XYZ Corporation declares a cash dividend. This will cause the:",
       "choice_a":"Paid-in surplus to decrease.",
       "choice_b":"Par value to decrease.",
       "choice_c":"Treasury stock to decrease.",
       "choice_d":"current liabilities to increase.",
       "correct_answer":"D",
       "explanation":"The declaration of a dividend causes current liabilities increase"
    },
    {
       "id":5577,
       "practice_test_id":"",
       "topic_id":4,
       "question":"If XYZ Corporation split its $1 par common stock 2 for 1, the result would be: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The par value would be reduced to 50¢. </li><li>The par value would be increased to $2 per share. </li><li>The retained earnings would decrease. </li><li>The number of authorized shares would be reduced.</li></ol>",
       "choice_a":"I only.",
       "choice_b":"II only.",
       "choice_c":"II and III.",
       "choice_d":"III only.",
       "correct_answer":"A",
       "explanation":"In the case of a forward stock split only the par value would be reduced from $1 to 50 cents. All of the other choices listed are incorrect."
    },
    {
       "id":5578,
       "practice_test_id":2,
       "topic_id":4,
       "question":"Stockholders would have to approve:",
       "choice_a":"The 10% stock dividend.",
       "choice_b":"The 2 for 1 split.",
       "choice_c":"The payment of a cash dividend.",
       "choice_d":"All of the choices listed",
       "correct_answer":"B",
       "explanation":"Stockholders would have to approve a stock split only because it changes the number of authorized shares the company is allowed to issue and its par value."
    },
    {
       "id":5579,
       "practice_test_id":3,
       "topic_id":4,
       "question":"If a corporation should go bankrupt, whatever assets remained would be distributed in which of the following order of priorities? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Common stockholders. </li><li>Secured bondholders.  </li><li>Internal Revenue Service.  </li><li>Debenture bondholders.</li></ol>",
       "choice_a":"I, II, III and IV.",
       "choice_b":"IV, III, II and I.",
       "choice_c":"III, II, I and IV.",
       "choice_d":"III, II, IV and I.",
       "correct_answer":"D",
       "explanation":"Common stockholders will always be paid last."
    },
    {
       "id":5580,
       "practice_test_id":4,
       "topic_id":4,
       "question":"All of the following can be determined solely from the balance sheet, except the:",
       "choice_a":"Current ratio.",
       "choice_b":"Acid test ratio.",
       "choice_c":"EPS",
       "choice_d":"Book value of the corporation.",
       "correct_answer":"C",
       "explanation":"The corporation EPS can not be determined only from the balance sheet. The earnings available to common holders is found on the income statement."
    },
    {
       "id":5581,
       "practice_test_id":5,
       "topic_id":4,
       "question":"Which of the following information can be derived from the balance sheet of a corporation? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Book value for the common stock. </li><li>Accounts receivable turnover. </li><li>Inventory turnover. </li><li>Working capital.</li></ol>",
       "choice_a":"I and IV.",
       "choice_b":"II and III.",
       "choice_c":"II and IV.",
       "choice_d":"I, III and IV.",
       "correct_answer":"A",
       "explanation":"A company\u0027s book value and working capital may be determined from the balance sheet."
    },
    {
       "id":5582,
       "practice_test_id":6,
       "topic_id":4,
       "question":"The best description of a balance sheet would be:",
       "choice_a":"Assets = Stockholders Equity.",
       "choice_b":"Assets = Liabilities + Profits.",
       "choice_c":"Total Assets = Total Liabilities + Profits.",
       "choice_d":"Total Assets = Total Liabilities + Net Worth.",
       "correct_answer":"D",
       "explanation":"The Balance sheet equation may be expressed two ways. Assets - Liabilities = net worth or assets = liabilities + net worth."
    },
    {
       "id":5583,
       "practice_test_id":"",
       "topic_id":4,
       "question":"In an inverted scale, the nearer maturities have yields to maturity in relation to the longer maturities which are:",
       "choice_a":"Unrelated.",
       "choice_b":"Higher.",
       "choice_c":"Lower.",
       "choice_d":"The same.",
       "correct_answer":"B",
       "explanation":"An inverted yield curve will have higher interest rates for short term maturities than for long term maturities."
    },
    {
       "id":5584,
       "practice_test_id":6,
       "topic_id":4,
       "question":"Stock indexes are often used by investors as a benchmark to determine performance, which of the following indexes are weighted by the capitalization of its members? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Dow Jones Industrial Average </li><li>NASDAQ Composite Average </li><li>Russell 2000 </li><li>Dow Jones Transportation Average</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I and IV",
       "choice_d":"III and IV",
       "correct_answer":"B",
       "explanation":"The NASDAQ Composite and the Russell 2000 are based on the market capitalization of its members. A company\u0027s market capitalization is determined by multiplying the share price in the marketplace by the total number of outstanding shares for that company. A company with a $10 stock price and 1,000,000 shares outstanding would have a $10,000,000 market capitalization. The larger the market capitalization of a company the larger its weighting in the index."
    },
    {
       "id":5585,
       "practice_test_id":2,
       "topic_id":4,
       "question":"Stock indexes are often used by investors as a benchmark to determine performance, which of the following indexes are weighted by the price of its members? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Dow Jones Industrial Average </li><li>NASDAQ Composite Average </li><li>Russell 2000 </li><li>Dow Jones Transportation Average</li></ol>",
       "choice_a":"I only",
       "choice_b":"III only",
       "choice_c":"II and III",
       "choice_d":"I and IV",
       "correct_answer":"D",
       "explanation":"The Dow Jones Industrial and Dow Jones Transportation Averages are based on the share price of its members. The higher the share price of a company the larger its weighting in the index."
    },
    {
       "id":5586,
       "practice_test_id":3,
       "topic_id":4,
       "question":"XYZ index is a market weighted index designed as a benchmark for XYZ brokerage firm\u0027s customers. A move in the price of which of the following participants would have the greatest impact on the XYZ index?",
       "choice_a":"TRY stock with a market price of $77 and 1,000,000 shares outstanding",
       "choice_b":"GET stock with a market price of $7 and 3,000,000 shares outstanding",
       "choice_c":"PLA stock with a market price of $2 and 10,000,000 shares outstanding",
       "choice_d":"HIP stock with a market price of $100 and 100,000 shares outstanding",
       "correct_answer":"A",
       "explanation":"The XYZ index is a market capitalization weighted index. Therefore a move in the price of the stock with the greatest market capitalization would have the largest impact on the index. TRY has a market capitalization of $77,000,000. It has the highest market capitalization of the choices listed and a move in the price of TRY stock would have the greatest impact on the XYZ index."
    },
    {
       "id":5587,
       "practice_test_id":4,
       "topic_id":4,
       "question":"What does a proponent of fundamental analysis use to value common stock? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Trade volume </li><li>Discounted Cash Flow </li><li>P/E ratio </li><li>Moving price average</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"II and III",
       "choice_d":"I and IV",
       "correct_answer":"C",
       "explanation":"The correct answers are II and III. A fundamental analyst would look at the financial makeup of the company and how that financial value of the company is priced in the marketplace. Of the choices listed a fundamental analyst would use a discounted cash flow method which would be used to place a current value on the company\u0027s future earnings and a P/E ratio which would tell the analyst what people are paying in the marketplace for those earnings on a per share basis. Moving averages and trade volume would be used by an investor interested in technical analysis"
    },
    {
       "id":5588,
       "practice_test_id":5,
       "topic_id":4,
       "question":"The yield to maturity will be less than yield to call when:",
       "choice_a":"Interest rates are going up",
       "choice_b":"Interest rates are below the coupon rate",
       "choice_c":"The issuer has had its rating increased by a major rating service",
       "choice_d":"Inflation expectations are going down",
       "correct_answer":"A",
       "explanation":"The yield to maturity for a bond will be lower than the yield to call for the bond when the bond is trading at a discount from par. Of the choices listed a bond would only fall in price and be trading at a discount if interest rates are going up."
    },
    {
       "id":5589,
       "practice_test_id":6,
       "topic_id":4,
       "question":"A high tax bracket investor who is looking for growth would invest in common stock for:",
       "choice_a":"Capital gains",
       "choice_b":"Protection of principal",
       "choice_c":"Avoidance of taxes",
       "choice_d":"A systematic purchase plan with a low beta",
       "correct_answer":"A",
       "explanation":"Any investor who purchases common stock is doing so for capital gains regardless of their tax bracket."
    },
    {
       "id":5590,
       "practice_test_id":"",
       "topic_id":4,
       "question":"An investment strategy you may employ if you believe economic cycles are unpredictable would be:",
       "choice_a":"Buy and hold",
       "choice_b":"Technical analysis",
       "choice_c":"Fundamental analysis",
       "choice_d":"Efficient market allocation",
       "correct_answer":"A",
       "explanation":"An investor who feels that economic cycles are unpredictable and that the changes to the economic cycles are unknowable would use a buy and hold strategy."
    },
    {
       "id":5591,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The CPI is a good measure of:",
       "choice_a":"The present value of money",
       "choice_b":"Inflation on consumer goods",
       "choice_c":"Future risk",
       "choice_d":"Economic growth",
       "correct_answer":"B",
       "explanation":"The consumer price index (CPI) is an index created from the prices of a basket of goods and services consumers use in their daily lives. It is used as a measure of inflation on consumer goods. A rise in the CPI reflects inflationary pressure."
    },
    {
       "id":5592,
       "practice_test_id":6,
       "topic_id":4,
       "question":"In which way is the value of money correlated to the CPI as the CPI goes up?",
       "choice_a":"The value of money goes down",
       "choice_b":"The value of money goes up",
       "choice_c":"There is no correlation",
       "choice_d":"The value of money stays constant",
       "correct_answer":"A",
       "explanation":"As the CPI increases the value of money declines. An increase in the CPI reduces the purchasing power of money. There is a negative correlation between the value of the dollar and the CPI"
    },
    {
       "id":5593,
       "practice_test_id":2,
       "topic_id":4,
       "question":"A company\u0027s P/E ratio is useful in:",
       "choice_a":"Estimating future earnings",
       "choice_b":"Comparing companies in the same industry",
       "choice_c":"Valuing corporate bonds",
       "choice_d":"Assessing support for the company\u0027s stock price",
       "correct_answer":"B",
       "explanation":"A company\u0027s P/E ratio is useful in comparing companies in the same industry. A fundamental analyst may want to compare how the earnings of similar companies are priced in the marketplace. The analyst would then use this information to evaluate which companies stock prices are cheap or expensive relative to their industry."
    },
    {
       "id":5594,
       "practice_test_id":3,
       "topic_id":4,
       "question":"What happens to the yield curve if long term interest rates are expected to rise?",
       "choice_a":"The curve steepens",
       "choice_b":"The curve flattens",
       "choice_c":"The curve does not change",
       "choice_d":"The curve inverts",
       "correct_answer":"A",
       "explanation":"The yield curve would steepen as long term rates rise. Even if long term rates are simply expected to rise, investors would sell long term bonds and this action in itself would cause long term rates to rise."
    },
    {
       "id":5595,
       "practice_test_id":4,
       "topic_id":4,
       "question":"A yield curve that slopes downwards is said to be:",
       "choice_a":"Inverted",
       "choice_b":"Positive",
       "choice_c":"Contango",
       "choice_d":"Backward",
       "correct_answer":"A",
       "explanation":"A downward sloping yield curve is one where short term interest rates are higher than long term rates. The yield curve in this situation is said to be inverted."
    },
    {
       "id":5596,
       "practice_test_id":5,
       "topic_id":4,
       "question":"An investor is looking at the price-book ratio when considering which stocks to purchase. What type of analysis are they employing?",
       "choice_a":"Fundamental analysis",
       "choice_b":"Financial analysis",
       "choice_c":"Technical Analysis",
       "choice_d":"Price Earnings / Growth analysis",
       "correct_answer":"A",
       "explanation":"When an investor is looking at the price to book ratio of various equities they are employing fundamental analysis."
    },
    {
       "id":5597,
       "practice_test_id":6,
       "topic_id":4,
       "question":"Why might it be better for an investor to get a stock dividend rather than a cash dividend?",
       "choice_a":"Stock dividends are generally tax free until you sell the stock",
       "choice_b":"Cash dividends generally can\u0027t be reinvested",
       "choice_c":"Stock dividends generally carry twice the voting rights of ordinary shares",
       "choice_d":"Stock dividends are generally paid in preferred shares rather than ordinary shares",
       "correct_answer":"A",
       "explanation":"Stock dividends are generally not taxable when they are received by the investor."
    },
    {
       "id":5598,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The rate at which the Federal Reserve lends money to other banks is called the:",
       "choice_a":"Federal funds rate",
       "choice_b":"Discount rate",
       "choice_c":"LIBOR",
       "choice_d":"Bank loan rate",
       "correct_answer":"B",
       "explanation":"The Federal Reserve lends money to banks at the discount rate."
    },
    {
       "id":24693,
       "practice_test_id":6,
       "topic_id":4,
       "question":"An investor has a 3 percent interest in a real estate DPP. The financial performance of the partnership allocated to the investor is as follows: <img src='/question_assets/series7/5.png'></img> As a result of the performance the investor will have:",
       "choice_a":"$10,000 in net income",
       "choice_b":"$42,000 in net income",
       "choice_c":"An $8,000 net loss",
       "choice_d":"$24,000 net income",
       "correct_answer":"C",
       "explanation":"To determine what the investor would report for tax purposes you must subtract the expenses and mortgage interest from the revenues. In this case $120,000 - $78,000 - $32,000 = $10,000. From the net income you must subtract the depreciation of $18,000. This results in a net loss of $8,0000."
    },
    {
       "id":24699,
       "practice_test_id":"",
       "topic_id":4,
       "question":"If investors have priced in the expectation for generally increasing prices in the marketplace, the yield curve most likely to reflect that expectation would be:",
       "choice_a":"Flat",
       "choice_b":"Inverted",
       "choice_c":"Ascending",
       "choice_d":"Correlated",
       "correct_answer":"C",
       "explanation":"An ascending or upward sloping yield curve is one which displays higher interest rates for longer term maturities. The increase in interest rates over time reflect investor\u0027s expectations for inflation ( increase in prices )."
    },
    {
       "id":24645,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A corporation has a balance sheet that appears as follows:<img src='/question_assets/series7/2.png'></img> What is the company's working capital ?",
       "choice_a":"$4,800,000",
       "choice_b":"$4,200,000",
       "choice_c":"$5,500,000",
       "choice_d":"$4,000,000",
       "correct_answer":"A",
       "explanation":"The formula for working capital is current assets - current liabilities. Current assets are: cash, inventory and accounts receivable. Current liabilities are: wages payable, accounts payable and current portion of long term debt. In this case, $7,500,000= $2,700,000 = $4,800,000."
    },
    {
       "id":24690,
       "practice_test_id":"",
       "topic_id":4,
       "question":"ASR Technologies is involved in the development of microchips and the prospects for the company\u0027s earnings vary according to the expectations for the pricing of its products in the market. ASR\u0027s stock has a beta coefficient of 1.4. The market has gone into a major advance and the broad market is up 10 percent. What has happened to the price of ASR\u0027s stock? ",
       "choice_a":"It has increased more in price than the broad market",
       "choice_b":"It has increased in price by 6 percent",
       "choice_c":"The price of ASR has moved inline with the expectations for the pricing of its products and could be up or down in price",
       "choice_d":"It has increased by 14 percent",
       "correct_answer":"D",
       "explanation":"The stock has a beta of 1.4 which means that the stock will tend to rise or fall by 1.4 times the change in the underlying index. Therefore, the price of ASR has most likely increased by 1.4 X 10% or 14%."
    },
    {
       "id":24692,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The President and Congress have been working to pass legislation that will increase the marginal tax rate. Which two of the following choices are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The stock market will most likely fall </li><li>There will be a decrease in the rate of disintermediation  </li><li>Yields on municipal bonds will most likely fall  </li><li>The yield curve will become inverted </li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"B",
       "explanation":"If there is an increase in the marginal tax rate, income taxes will increase. As a result of the increase in income taxes investors will be more likely to purchase municipal bonds. The increase in demand for the municipal bonds will cause the yields on municipal bonds to fall. An increase in taxes is bearish for the stock market and stock prices will likely fall."
    },
    {
       "id":20919,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A fixed income investor is looking at the yield curve reflecting the current interest rate environment. The investor notices that long term debt is paying significantly higher interest rates than shorter term debt securities. The chart for this would indicate that the yield curve is:",
       "choice_a":"flat",
       "choice_b":"inverted",
       "choice_c":"stable",
       "choice_d":"positive",
       "correct_answer":"D",
       "explanation":"When the interest rates on long term bonds exceed the interest rates on short term bonds, the yield curve is said to be positive or upward sloping. The chart of the yields will increase from the lower left to the upper right when measured by the term to maturity of the bonds. "
    },
    {
       "id":20932,
       "practice_test_id":"",
       "topic_id":4,
       "question":"If the Federal Reserve undertakes an accommodative monetary policy and begins to reduce interest rates, which of the following is most likely to occur? ",
       "choice_a":"The value of the dollar will rise versus the Euro",
       "choice_b":"The value of the dollar will fall versus the Euro",
       "choice_c":"The value of the dollar will not be impacted versus the Euro",
       "choice_d":"The value of the dollar will be positively impacted versus the Euro",
       "correct_answer":"B",
       "explanation":"If the Federal Reserve reduces interest rates the value of the dollar will fall versus the value of all other currencies. In this case the value of the dollar will fall versus the Euro. It will now take more dollars to purchase 1 Euro. "
    },
    {
       "id":20933,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The manager of a long only fund has been systematically liquidating securities over the past 6 months and has moved the proceeds into money market funds. The manager is now said to be in \u0022cash\u0022. Which of the following would best describe the manager\u0027s outlook?",
       "choice_a":"He is bullish on rates",
       "choice_b":"He is bullish on bonds",
       "choice_c":"He is bearish on stocks",
       "choice_d":"He expects the FRB to reduce rates",
       "correct_answer":"C",
       "explanation":"The manager of a long only fund is not allowed to sell equities short. As a result the only option for this manager when they turn bearish on the stock market is to move to the sidelines and into cash and short term money market funds."
    },
    {
       "id":20938,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Common stockholders have the right to vote on which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The use of retained earnings to repurchase shares for the treasury </li><li>The issuance of convertible bonds  </li><li>The compensation for senior executives  </li><li>The declaration of bankruptcy</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"II only",
       "choice_d":"I and IV",
       "correct_answer":"C",
       "explanation":"Of the choices listed the only item that common stockholders may vote on would be the issuance of convertible debt. Common stockholders are entitled to vote for the issuance of any securities that could result in the dilution of shareholder\u0027s equity."
    },
    {
       "id":20941,
       "practice_test_id":"",
       "topic_id":4,
       "question":"XYZ Construction has just purchased a $5 million piece of equipment, utilizing cash on hand. XYZ plans on depreciating the equipment under an accelerated depreciation method. Which of the following is / are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The cost of the equipment will be recovered more quickly  </li><li>XYZ\u0027s income will be reduced more in the first few years of operation  </li><li>The majority of cost of the equipment will not be recovered until the equipment is decommissioned  </li><li>XYZ\u0027s income will be reduced by a similar amount over the useful life of the equipment</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"III and IV",
       "choice_d":"I and IV",
       "correct_answer":"A",
       "explanation":"Under accelerated depreciation the majority of the cost of the equipment is recovered in the first few years of its useful life. As a result XYZ\u0027s earnings will be reduced more in the first few years. This creates a lower taxable income for the company in the first few years after purchase."
    },
    {
       "id":19327,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following economic indicators would be most useful for figuring out whether the economy is growing quickly or slowly?",
       "choice_a":"Leading",
       "choice_b":"Lagging",
       "choice_c":"Coincident",
       "choice_d":"Fiscal",
       "correct_answer":"C",
       "explanation":"Of the three economic indicators, leading, coincident and lagging, the coincident indicators will be the best measure of how fast or slow the economy is growing . "
    },
    {
       "id":19346,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following prescribe that lower taxes will encourage economic activity and help the economy grow resulting in a higher overall level tax collection?",
       "choice_a":"Supply side policy",
       "choice_b":"Fiscal policy",
       "choice_c":"Monetary policy",
       "choice_d":"Keynesian policy",
       "correct_answer":"A",
       "explanation":"Supply side economic policy beleives that lower taxes will encourage economic activity and help the economy grow resulting in a higher overall level tax collection?"
    },
    {
       "id":19354,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The FOMC has been reducing the size of its balance sheet in line with its mandate. Which of the following will occur? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Interest rates will increase  </li><li>The money supply will decrease </li><li>Interest rates will decrease  </li><li>The money supply will increase </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I only",
       "correct_answer":"A",
       "explanation":"When the FOMC reduces the size of its balance sheet it is selling bonds and removing money from the system thereby reducing the money supply. When the FOMC sells bonds interest rates will increase ."
    },
    {
       "id":19355,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A corporation borrows money on an unsecured intermediate basis at a rate of 4.9%. The corporation then takes the borrowed funds and invests in expanding its operations and generates a return of 9%. The corporation is employing:",
       "choice_a":"Arbitrage",
       "choice_b":"Interest rate spreading",
       "choice_c":"Leverage",
       "choice_d":"Expansionary policy",
       "correct_answer":"C",
       "explanation":"When a corporation borrows money and uses the borrowed funds to generate a return that exceeds the cost of the borrowed money the company is employing leverage."
    },
    {
       "id":19359,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The FOMC has been embarking on a bond buying program in line with its mandate. Which of the following will occur? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Interest rates will increase  </li><li>The money supply will decrease </li><li>Interest rates will decrease </li><li>The money supply will increase</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"B",
       "explanation":"When the FOMC purchases bonds it is injecting money into the system increasing the money supply. When the FOMC buys bonds it will lower interest rates ."
    },
    {
       "id":19369,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following companies would be considered the most highly leveraged?",
       "choice_a":"A small cap company who has received its total capitalization from a recent stock offering",
       "choice_b":"A regulated utility company whose has issued a significant amount of bonds to build a new power plant and has a small float of common stock",
       "choice_c":"A  NASDAQ listed issuer who has an active market and a credit facility available through a syndicate of banks",
       "choice_d":"A large cap company with 300,000,000 shares of common stock outstanding, 30,000,000 shares of preferred stock and  20,000,000 in long term variable rate bonds outstanding",
       "correct_answer":"B",
       "explanation":"A highly leveraged corporation is one that has borrowed a large percentage of its capital usually through the sale of bonds. When a corporation borrows money it is anticipating that it can use the borrowed funds to generate a return on the capital that is greater than the cost of that capital."
    },
    {
       "id":19372,
       "practice_test_id":"",
       "topic_id":4,
       "question":"XYZ mining corporation is considering the purchase of a large piece of mining equipment to modernize its facility. It is anticipated that the new equipment will increase productivity. The purchase of the equipment would make sense if the net present value was:",
       "choice_a":"Depreciated d slower than the amortization of the equipment",
       "choice_b":"Zero",
       "choice_c":"Less than zero",
       "choice_d":"Greater than zero",
       "correct_answer":"D",
       "explanation":"The purchase would only make sense if the net present value was greater than zero. The NPV is the difference in present value of the income generated by the equipment relative to the NPV of the expense to purchase the equipment."
    },
    {
       "id":19373,
       "practice_test_id":"",
       "topic_id":4,
       "question":"An investor purchases an 8 percent corporate bond in the marketplace at par. After holding the bond fully paid for, the investor has a total return of 5 percent. Why is the investor\u0027s total return lower than the coupon rate?",
       "choice_a":"Interest rate have fallen",
       "choice_b":"The bond\u0027s total return takes into account commissions and markups paid to acquire the bond",
       "choice_c":"Interest rates have risen",
       "choice_d":"The investor paid accrued interest when the bond was purchased and the accrued interest lowers the total return",
       "correct_answer":"C",
       "explanation":"An investor\u0027s total return is found by adding the income received from the investment with any appreciation in price. If the investment falls in price the loss in value would be subtracted from the total return. The reason the investor\u0027s total return is lower than the coupon rate is due to the fact that interest rates have increased and this caused the bond to fall in price."
    },
    {
       "id":19377,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The largest component of the money supply (m1) is:",
       "choice_a":"Currency",
       "choice_b":"Checks",
       "choice_c":"Revolving accounts",
       "choice_d":"Debit transactions",
       "correct_answer":"A",
       "explanation":"The largest component of M1 money supply is the amount of physical currency in circulation. "
    },
    {
       "id":19392,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following conditions would be persistent during a period of stagflation? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> High unemployment </li><li>Inflation  </li><li>Deflation </li><li>Falling interest rates</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and II",
       "choice_c":"III and IV",
       "choice_d":"II and IV",
       "correct_answer":"B",
       "explanation":"During a period of stagflation the economy will experience high unemployment and inflation. Interest rates will not decline as rates will remain high to fight inflation. High unemployment and high inflation and interest rates are persistent during a period of stagflation."
    },
    {
       "id":19398,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The expansionary phase of the business cycle is characterized by: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Falling prices </li><li>Falling savings </li><li>Rising prices </li><li>Rising savings</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"II only",
       "choice_d":"IV only",
       "correct_answer":"B",
       "explanation":"The expansionary phase of the business cycle is characterized by rising prices and rising savings. As people earn more they tend to spend more and save more. This will cause prices to rise as more people buy goods. Balances in savings accounts will also increase."
    },
    {
       "id":20943,
       "practice_test_id":"",
       "topic_id":4,
       "question":"As interest rates rise which of the following is true?",
       "choice_a":"The amount of interest paid on outstanding issues will increase",
       "choice_b":"The amount of interest paid on outstanding issues will decrease",
       "choice_c":"The amount of interest paid on outstanding issues will remain constant",
       "choice_d":"The amount of interest paid on outstanding issues will be adjusted to market rates",
       "correct_answer":"C",
       "explanation":"The amount of interest paid on bonds does not change once the bonds have been issued. The nominal yield or the coupon rate will determine the amount of interest that the bond pays over its entire maturity. Prices of bonds do change in the marketplace and that will cause a bond\u0027s current yield and yield to maturity to change based on the change in price. "
    },
    {
       "id":5642,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The PPC company declares a $0.25 dividend to shareholders of record as of Monday December 21st. With the stock closing on Thursday at $18 per share, what price will PPC open at on Friday?",
       "choice_a":"$18.00",
       "choice_b":"$18.25",
       "choice_c":"$17.50",
       "choice_d":"$17.75",
       "correct_answer":"D",
       "explanation":"The value of a stock is reduced on the ex-dividend date by the amount of the dividend to be paid. In this case: $18.00 (the closing price) - $0.25 (the dividend) = $17.75."
    },
    {
       "id":5643,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The subscription price of a warrant is always:",
       "choice_a":"Below the stock price when issued",
       "choice_b":"Equal to the stock price when issued",
       "choice_c":"Above the stock price when issued",
       "choice_d":"Determined on the exercise date",
       "correct_answer":"C",
       "explanation":"The subscription price of a warrant is always above the market value of the stock when it\u0027s originally issued. The value of the warrant is that it is long term up to 10 years."
    },
    {
       "id":5644,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The two methods of voting by common stockholders differ in which way?",
       "choice_a":"The statutory method allows the votes to be distributed evenly among the candidates the investor wishes to vote for, while the cumulative method allows the stockholders to cast all of their votes for one candidate.",
       "choice_b":"The cumulative method allows the votes to be distributed evenly among the candidates the investor wishes to vote for, while the statutory method allows the stockholders to cast all of their votes for one candidate.",
       "choice_c":"The standard method allows the votes to be distributed in any amounts among the candidates as the investor wishes, while the calculated method allows the stockholders to cast all of their votes for several candidates.",
       "choice_d":"The calculated method allows the votes to be distributed in any amounts among the candidates as the investor wishes, while the standard method allows the stockholders to cast all of their votes for several candidates.",
       "correct_answer":"A",
       "explanation":"The statutory method allows the votes to be distributed evenly among the candidates the investor wishes to vote for, while the cumulative method allows the stockholders to cast all of their votes for one candidate. The cumulative method of voting is considered to favor smaller investors as it allows the investor to cast all of their votes to elect one candidate. "
    },
    {
       "id":5645,
       "practice_test_id":"",
       "topic_id":5,
       "question":"To determine the number of shares of common stock which can be obtained on conversion from a bond, use which of the following:",
       "choice_a":"Par value divided by conversion price",
       "choice_b":"Conversion price divided by par value",
       "choice_c":"Par value multiplied by conversion price",
       "choice_d":"Conversion price multiplied by par value",
       "correct_answer":"A",
       "explanation":"The formula to convert bonds to common stock is par value divided by conversion price."
    },
    {
       "id":5646,
       "practice_test_id":"",
       "topic_id":5,
       "question":"What are market makers?",
       "choice_a":"Brokers who are specialists in over the counter market trading.",
       "choice_b":"Brokers who create a market for their own specialty stocks and for the companies whose stocks they sell.",
       "choice_c":"A firm of brokers who display a two-sided market, both buying and selling stock through a network of computers which connects firms throughout the world.",
       "choice_d":"Brokers who make their profit from buying cheaply, creating a demand by promoting the stocks, then selling at a higher price.",
       "correct_answer":"C",
       "explanation":"There are no specialists in OTC trading, and brokers do not create markets or demand; they buy at bid price and sell at the offering price; their profit is the difference."
    },
    {
       "id":5647,
       "practice_test_id":"",
       "topic_id":5,
       "question":"What can happen to a right?",
       "choice_a":"The shareholder can elect to purchase additional shares, or exercise the right.",
       "choice_b":"The shareholder can choose not to purchase the additional shares, and may choose to sell these shares to another investor",
       "choice_c":"The original shareholder or the new investor can allow the 45 days to lapse without purchasing the shares offered",
       "choice_d":"All of the choices listed may happen.",
       "correct_answer":"D",
       "explanation":"All of the choices listed can happen; and a corporation may also retain a brokerage firm to purchase any unsold shares and resell to the public, called standby underwriting."
    },
    {
       "id":5648,
       "practice_test_id":"",
       "topic_id":5,
       "question":"What is not a feature of preferred stock?",
       "choice_a":"Par value for all preferred stock is $250.",
       "choice_b":"Dividends must be paid to preferred stockholders before common stockholders.",
       "choice_c":"Preferred stock is perpetual with no maturity date.",
       "choice_d":"Most preferred stock is non-voting.",
       "correct_answer":"A",
       "explanation":"Par value for all preferred is the same, set at $100;  companies generally express the par value as a percentage of par value for the preferred stock."
    },
    {
       "id":5649,
       "practice_test_id":"",
       "topic_id":5,
       "question":"What is the major risk involved in owning common stock?",
       "choice_a":"A common stockholder is the last person to get paid if the company is liquidated.",
       "choice_b":"A company may decide not to pay dividends.",
       "choice_c":"A company may decide to pay very small dividends, but it must pay some amount to its stockholders.",
       "choice_d":"The stock may fall in value.",
       "correct_answer":"D",
       "explanation":"The greatest risk is that the investor will lose some or all of his money if the stock falls in value or if the company fails."
    },
    {
       "id":5650,
       "practice_test_id":"",
       "topic_id":5,
       "question":"What is the Maximum duration for a warrant?",
       "choice_a":"45 days",
       "choice_b":"10 years",
       "choice_c":"9 months",
       "choice_d":"270 days",
       "correct_answer":"B",
       "explanation":"The Maximum duration of a warrant is 10 years."
    },
    {
       "id":5651,
       "practice_test_id":"",
       "topic_id":5,
       "question":"What is the most common form of dividend?",
       "choice_a":"Cash dividends",
       "choice_b":"Stock dividends",
       "choice_c":"Products sample dividends",
       "choice_d":"Property portion dividends",
       "correct_answer":"A",
       "explanation":"Cash dividends are the most common form of dividends usually sent out in the form of a check directly to the investor or the brokerage firm to the account of the investor."
    },
    {
       "id":5652,
       "practice_test_id":"",
       "topic_id":5,
       "question":"What makes a warrant more valuable than a right?",
       "choice_a":"A warrant allows an investor to purchase preferred stock at a subscription price.",
       "choice_b":"The subscription price is always higher than the market value, indicating a valuable company to invest in.",
       "choice_c":"The holder of a warrant has twenty years during which he may buy the stock at the subscription price.",
       "choice_d":"The long life of a warrant is what makes the warrant  more valuable than the right since the subscription price usually cannot change during the time of the warrant.",
       "correct_answer":"D",
       "explanation":"A warrant guarantees the price remains the same for many years, while a right guarantees the price remains the same for up to 45 days."
    },
    {
       "id":5653,
       "practice_test_id":"",
       "topic_id":5,
       "question":"When dividends are distributed, the name of the first day when purchasers are no longer entitled to receive the dividends is called:",
       "choice_a":"Dividend date",
       "choice_b":"Declaration date",
       "choice_c":"Record date",
       "choice_d":"Ex date",
       "correct_answer":"D",
       "explanation":"The ex-dividend date or the \u0022ex date\u0022 is the first day when purchasers of the security are no longer entitled to receive the dividend that the company has declared for payment."
    },
    {
       "id":5654,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following  allows the owner of the securities full voting rights?",
       "choice_a":"Corporate Bonds",
       "choice_b":"Preferred Stock",
       "choice_c":"Common Stock",
       "choice_d":"All of the choices listed",
       "correct_answer":"C",
       "explanation":"Common Stockholders retain the full voting rights, under normal circumstances. Bankruptcy might be one case where preferred stockholders, and bond holders might gain voting rights."
    },
    {
       "id":5655,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following are characteristics of common stock? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Right to vote </li><li>Ownership </li><li>Unlimited liability </li><li>Residual claim on assets</li></ol>",
       "choice_a":"I and  III",
       "choice_b":"III and IV",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"A common stock has all of the characteristics listed except unlimited liability. A stockholder\u0027s liability is limited to the amount of their investment."
    },
    {
       "id":5656,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is not true about the owner of an ADR?",
       "choice_a":"He has a currency risk",
       "choice_b":"He will be paid in the currency of the foreign country.",
       "choice_c":"His dividends will be converted to US dollars, and if the conversion rate has dropped, he will lose money.",
       "choice_d":"His dividends will be converted to US dollars, and if the conversion rate has risen, he will make money.",
       "correct_answer":"B",
       "explanation":"The investor will be paid in US dollars converted from the foreign currency."
    },
    {
       "id":5657,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is the most junior security?",
       "choice_a":"Preferred stock",
       "choice_b":"Mortgage bond",
       "choice_c":"Subordinated debenture",
       "choice_d":"Common Stock",
       "correct_answer":"D",
       "explanation":"Common stock is always the last to get paid in the event of a bankruptcy and therefore is the most junior security"
    },
    {
       "id":5658,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Common stock must be issued before any other type of stock can be issued. </li><li>Authorized stock is the first kind of common stock which a company offers. </li><li>Outstanding stock is stock which has not been bought by investors. </li><li>Treasury stock is stock which has been sold to investors and then repurchased by the company.</li></ol>",
       "choice_a":"I, II,  and  III",
       "choice_b":"I, II,  and  IV",
       "choice_c":"I, III,  and  IV",
       "choice_d":"II, III, and IV",
       "correct_answer":"B",
       "explanation":"III is false because outstanding stock is the stock which has been sold to the public and which remains in their hands."
    },
    {
       "id":5659,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which type of preferred stock allows the company involved to buy back the stock from the stockholders?",
       "choice_a":"Cumulative preferred",
       "choice_b":"Participating preferred",
       "choice_c":"Convertible preferred",
       "choice_d":"Callable preferred",
       "correct_answer":"D",
       "explanation":"Callable preferred is the only type of stock which benefits the company and not the investor since the company can call in, or buy back at the current market price, the stock outstanding.  Callable stock is call protected for the first few years."
    },
    {
       "id":5660,
       "practice_test_id":"",
       "topic_id":5,
       "question":"XYZ has issued 7% convertible preferred stock that can be exchanged for common shares for $ 50 per share.  The preferred stock is quoted at $ 140.  What is the parity price of the common?",
       "choice_a":"$ 7 per share",
       "choice_b":"$ 28 per share",
       "choice_c":"$ 70 per share",
       "choice_d":"$ 200 per share",
       "correct_answer":"C",
       "explanation":"Parity price = CMV of the preferred / # of shares = 140/ 2= 70"
    },
    {
       "id":5661,
       "practice_test_id":"",
       "topic_id":5,
       "question":"XYZ Incorporated has 15,000,000 shares of common stock authorized, 11,000,000 shares have been issued and there are 4,000,000 shares of treasury stock.  How many shares are outstanding?",
       "choice_a":"15,000,000",
       "choice_b":"7,000,000",
       "choice_c":"11,000,000",
       "choice_d":"8,000,000",
       "correct_answer":"B",
       "explanation":"There are 7,000,000 shares outstanding. Issued stock - treasury stock = outstanding stock."
    },
    {
       "id":5662,
       "practice_test_id":"",
       "topic_id":5,
       "question":"XYZ is going through reorganization and is electing five new members of the board of directors under the cumulative method of voting. An investor owning 500 shares would have:",
       "choice_a":"500 votes to split evenly among 5 candidates",
       "choice_b":"2500 votes to split anyway they choose",
       "choice_c":"500 votes to cast 100 for each director",
       "choice_d":"2500 votes to split 500 for each candidate",
       "correct_answer":"B",
       "explanation":"An investor with 500 shares of stock voting for 5 directors would have a total of 2500 votes to cast in any way he chooses under the cumulative method of voting."
    },
    {
       "id":5663,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following powers does a corporation\u0027s Board of Directors not have?",
       "choice_a":"Determining dividend payout policies",
       "choice_b":"Determining key policies of the corporation",
       "choice_c":"Electing top management and other company officers",
       "choice_d":"Changing the corporate charter",
       "correct_answer":"D",
       "explanation":"A company\u0027s board may do all of the answers listed except change the corporate charter."
    },
    {
       "id":5664,
       "practice_test_id":"",
       "topic_id":5,
       "question":"ABC has issued ten million shares and has reacquired one million shares, what are the remaining nine million issued shares called?",
       "choice_a":"Offered stock",
       "choice_b":"Issued stock",
       "choice_c":"Outstanding stock",
       "choice_d":"Treasury stock",
       "correct_answer":"C",
       "explanation":"The stock that remains in the hands of the public is outstanding stock."
    },
    {
       "id":5665,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following statements is not true of stock rights?",
       "choice_a":"Rights are receipts for common stock",
       "choice_b":"Rights are securities evidencing the privilege to buy securities at a stated price within a specified period of time",
       "choice_c":"Rights are securities evidencing the preemptive privilege",
       "choice_d":"One right is usually issued for each share of outstanding common stock",
       "correct_answer":"A",
       "explanation":"All of the choices listed are true of stock rights except they are not a receipt for stock."
    },
    {
       "id":5666,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is not a right of common stock owners?",
       "choice_a":"Limited access to corporate books",
       "choice_b":"The right to a proportionate share of dividends",
       "choice_c":"The right to recover the par value from the company",
       "choice_d":"The right to a voice in management through voting powers",
       "correct_answer":"C",
       "explanation":"A common stockholder does not have the right to receive the common stock\u0027s par value from the corporation."
    },
    {
       "id":5667,
       "practice_test_id":1,
       "topic_id":5,
       "question":"A customer owns 50 shares of ABC Corporation. ABC Corporation is engaging in a rights offering. The terms of the offering are 10 rights plus $35 is required to buy one new share of stock. If the customer wanted to subscribe to the rights offering, how many additional rights would he need to buy 100 shares of stock?",
       "choice_a":950,
       "choice_b":95,
       "choice_c":100,
       "choice_d":350,
       "correct_answer":"A",
       "explanation":"It will take 1000 rights to purchase 100 additional shares. The investor will receive 50 rights based on the 50 shares they own. Therefore the investor will need an additional 950 rights to purchase 100 shares of stock."
    },
    {
       "id":5668,
       "practice_test_id":2,
       "topic_id":5,
       "question":"XYZ Corporation is engaging in a rights offering. The market price of XYZ Corporation is $29 and the subscription price is $25. Four rights are required to subscribe to one new share of stock. The value of the right prior to the expiration of the rights offering (cum-rights) is:",
       "choice_a":"8 cents",
       "choice_b":"10 cents",
       "choice_c":"80 cents",
       "choice_d":"$1.00",
       "correct_answer":"C",
       "explanation":"To determine the value of one right when the stock is trading cum rights use the following formula: <br>Market price - Subscription price / number of rights required to purchase one share + 1. In this case <br>29-25/5 = .8"
    },
    {
       "id":5669,
       "practice_test_id":3,
       "topic_id":5,
       "question":"A holder of an ADR has the same rights as a regular stockholder, except:",
       "choice_a":"The right to exchange the ADR for the underlying shares",
       "choice_b":"Preemptive rights.",
       "choice_c":"The right to transfer ownership.",
       "choice_d":"The right to receive dividends",
       "correct_answer":"B",
       "explanation":"Holders of ADRs do not have preemptive rights. The holder does have the right to sell the ADR, to convert the ADR and receive the underlying shares and to receive dividends if paid."
    },
    {
       "id":5670,
       "practice_test_id":4,
       "topic_id":5,
       "question":"A corporation has a 5% participating preferred stock outstanding. The stated rate of payment is fixed as to the:",
       "choice_a":"Maximum but not as to the minimum.",
       "choice_b":"Minimum but not as to the maximum.",
       "choice_c":"Maximum.",
       "choice_d":"Minimum.",
       "correct_answer":"B",
       "explanation":"The stated dividend on a participating preferred is stated as a minimum but not as a maximum."
    },
    {
       "id":5671,
       "practice_test_id":5,
       "topic_id":5,
       "question":"A preferred stock that can be redeemed by the issuing corporation is called a:",
       "choice_a":"Cumulative preferred.",
       "choice_b":"Convertible preferred.",
       "choice_c":"Participating preferred.",
       "choice_d":"Callable preferred.",
       "correct_answer":"D",
       "explanation":"A preferred stock that can be redeemed by the issuing corporation is a callable preferred"
    },
    {
       "id":5672,
       "practice_test_id":6,
       "topic_id":5,
       "question":"The dividend rate on participating preferred stock:",
       "choice_a":"Is paid quarterly",
       "choice_b":"Are fixed monthly payments",
       "choice_c":"Is paid semi-annually.",
       "choice_d":"Accumulates if it is not paid.",
       "correct_answer":"C",
       "explanation":"The dividend on a participating preferred stock is paid semi annually."
    },
    {
       "id":5673,
       "practice_test_id":"",
       "topic_id":5,
       "question":"All of the following pay dividends except:",
       "choice_a":"Common stock.",
       "choice_b":"Preferred stock.",
       "choice_c":"ADRs.",
       "choice_d":"Warrants.",
       "correct_answer":"D",
       "explanation":"Warrants do not pay dividends."
    },
    {
       "id":5674,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The holders of shares of common stock have:",
       "choice_a":"Part ownership in a corporation.",
       "choice_b":"No ownership in the corporation.",
       "choice_c":"Status as creditors of the corporation.",
       "choice_d":"Status as debtors of the corporation.",
       "correct_answer":"A",
       "explanation":"Owners of commons stock have part ownership in the company."
    },
    {
       "id":5675,
       "practice_test_id":6,
       "topic_id":5,
       "question":"A corporation would primarily declare a forward stock split to:",
       "choice_a":"Increase its retained earnings.",
       "choice_b":"Decrease its retained earnings.",
       "choice_c":"Increase the price of its stock to make it more marketable.",
       "choice_d":"Decrease the price of its stock to make it more marketable.",
       "correct_answer":"D",
       "explanation":"A corporation would primarily declare a forward stock split to decrease its price to make it more attractive to individual investors."
    },
    {
       "id":5676,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A customer owns 200 shares of XYZ Corporation. XYZ splits 3 for 2. How many additional shares of XYZ stock will the customer receive?",
       "choice_a":33,
       "choice_b":50,
       "choice_c":100,
       "choice_d":150,
       "correct_answer":"C",
       "explanation":"The customer will receive 100 additional shares multiply 200 X 3/2"
    },
    {
       "id":5677,
       "practice_test_id":6,
       "topic_id":5,
       "question":"Which of the following occurs in a reverse split?",
       "choice_a":"The par value decreases and the capital surplus decreases.",
       "choice_b":"The par value increases and the number of outstanding shares decreases.",
       "choice_c":"Retained earnings decrease and capital surplus increases.",
       "choice_d":"Retained earnings increase and the number of outstanding shares increases.",
       "correct_answer":"B",
       "explanation":"With a reverse stock split the par value increases and the number of outstanding shares decreases."
    },
    {
       "id":5679,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following represents an ownership interest in a publicly traded company? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Common stock </li><li>Preferred stock  </li><li>Secured debenture  </li><li>Authorized stock</li></ol>",
       "choice_a":"I Only",
       "choice_b":"I  and  II",
       "choice_c":"I, II  and  III",
       "choice_d":"I, II, III  and  IV",
       "correct_answer":"B",
       "explanation":"Common and preferred stock both represent equity or ownership of a corporation. Authorized stock has not yet been issued."
    },
    {
       "id":5680,
       "practice_test_id":2,
       "topic_id":5,
       "question":"Treasury stock has been issued and repurchased by a corporation for which of the following reasons?",
       "choice_a":"Raise new capital",
       "choice_b":"Add to outstanding shares",
       "choice_c":"Increase earnings per share",
       "choice_d":"Create a sinking fund",
       "correct_answer":"C",
       "explanation":"A corporation can increase its earning per share or EPS without increasing income by repurchasing outstanding shares from the public."
    },
    {
       "id":5681,
       "practice_test_id":3,
       "topic_id":5,
       "question":"Owning common stock provides an investor with",
       "choice_a":"Safety of principal",
       "choice_b":"Guaranteed dividend income",
       "choice_c":"Protection against market risk",
       "choice_d":"Capital growth",
       "correct_answer":"D",
       "explanation":"Capital growth is the primary objective for investors who own common stock. There are no guaranteed dividends or protection against market risk associated with common stock. Safety of principal is a benefit of owning debt, not equity securities"
    },
    {
       "id":5682,
       "practice_test_id":4,
       "topic_id":5,
       "question":"An investor purchases convertible preferred stocks and will receive all of the following except:",
       "choice_a":"Opportunity to benefit from common stock growth",
       "choice_b":"Guaranteed dividend payments",
       "choice_c":"Lower dividend rates",
       "choice_d":"Ownership interest",
       "correct_answer":"B",
       "explanation":"Although preferred stocks pay a stated dividend rate there is no guarantee that the dividends will be paid to investors. Dividend payments are subject to availability of funds after expenses and debt service is paid."
    },
    {
       "id":5683,
       "practice_test_id":5,
       "topic_id":5,
       "question":"Which type of preferred stock is likely to have the lowest stated dividend rate?",
       "choice_a":"Cumulative preferred",
       "choice_b":"Participating preferred",
       "choice_c":"Callable preferred",
       "choice_d":"Straight preferred",
       "correct_answer":"A",
       "explanation":"Cumulative preferred stock has the feature of accruing dividends that are missed and paying them out prior to paying out common stock dividends. This protective feature is a benefit to the shareholder and in exchange the stated dividend rate is relatively lower."
    },
    {
       "id":5684,
       "practice_test_id":6,
       "topic_id":5,
       "question":"Your customer recently purchased common stock shares in Alpha Corp., a clothing manufacturer. When he asks you about how dividends are paid, you explain that he can receive all of the following as a dividend except:",
       "choice_a":"Cash",
       "choice_b":"Stock in Alpha Corp.",
       "choice_c":"Stock split shares",
       "choice_d":"Merchandise",
       "correct_answer":"C",
       "explanation":"Stock splits do not represent a dividend payment. It is merely a capital structure reorganization that adjusts outstanding shares and it does not represent a taxable economic benefit to the investor."
    },
    {
       "id":5685,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The transfer agent for a corporation does which of the following?",
       "choice_a":"Audits amount of outstanding shares",
       "choice_b":"Authorizes stock",
       "choice_c":"Transfer payment of dividends to shareholders",
       "choice_d":"Maintains record of ownership",
       "correct_answer":"D",
       "explanation":"The primary function of the transfer agent is to maintain the issuer\u0027s record of ownership. In addition, the transfer agent also cancels old and issues new certificates, as well as handles problems with lost, stolen or destroyed certificates."
    },
    {
       "id":5686,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Ownership of American Depository Receipts is associated with which of the following risks <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Political risk  </li><li>Market risk </li><li>Interest rate risk </li><li>Foreign currency risk</li></ol>",
       "choice_a":"II only",
       "choice_b":"I  and  II",
       "choice_c":"I, II  and  IV",
       "choice_d":"II, III  and  IV",
       "correct_answer":"C",
       "explanation":"All marketable securities are subject to market risk. In addition, ADRs carry foreign currency and political risk."
    },
    {
       "id":5687,
       "practice_test_id":"",
       "topic_id":5,
       "question":"REITs provide investors with all of the following advantages except",
       "choice_a":"Pass through income",
       "choice_b":"Liquidity",
       "choice_c":"Limited liability",
       "choice_d":"Tax deduction for losses",
       "correct_answer":"D",
       "explanation":"Only income is passed through to investors in a Real Estate Investment Trust. Losses incurred by the REIT cannot be deducted by an investor."
    },
    {
       "id":5688,
       "practice_test_id":6,
       "topic_id":5,
       "question":"An investor owns 1000 shares of the Omega Company, a company listed on the NYSE. Omega Company has  announced a 5% stock dividend to be paid in stock of its subsidiary company Theta Brands. The investor will receive:",
       "choice_a":"50 shares of Omega Company",
       "choice_b":"5 shares of Omega Company",
       "choice_c":"50 shares of Theta Brands",
       "choice_d":"500 shares of Theta Brands",
       "correct_answer":"C",
       "explanation":"A 5% stock dividend on 1000 shares is equal to 50 shares and the dividend is being paid in shares of Theta Brands."
    },
    {
       "id":5689,
       "practice_test_id":"",
       "topic_id":5,
       "question":"When a company holds its annual meeting and is holding elections to fill seats on its board of directors, which of the following is true about cumulative voting rights?",
       "choice_a":"It benefits large investors who have accumulated more shares",
       "choice_b":"It gives an advantage to the company\u0027s remaining board members",
       "choice_c":"It allows investors who own preferred and common stock to combine their voting rights",
       "choice_d":"It benefits the small investors by giving them the ability to cast all of their votes behind one member in  an election",
       "correct_answer":"D",
       "explanation":"The small investor benefits the most from cumulative voting rights by having the ability to cast all votes from each election for a single board member candidate."
    },
    {
       "id":5690,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The biggest benefit of preferred stock for an investor is:",
       "choice_a":"A low unit price and guaranteed return of the face amount of the shares",
       "choice_b":"A low unit price and guaranteed semi annual payment",
       "choice_c":"A low unit price and secured as a general creditor of the issuer in case of bankruptcy",
       "choice_d":"A stated dividend payment",
       "correct_answer":"D",
       "explanation":"The biggest benefit to an investor in preferred stock is the stated dividend. The dividend is promised at a stated rate but is not guaranteed. A low unit price is generally not a benefit for an investor in preferred shares."
    },
    {
       "id":5691,
       "practice_test_id":6,
       "topic_id":5,
       "question":"A company defaults on its dividend due to a challenging economic environment.  This is an example of:",
       "choice_a":"Business Risk",
       "choice_b":"Liquidity Risk",
       "choice_c":"Regulatory Risk",
       "choice_d":"Currency Risk",
       "correct_answer":"A",
       "explanation":"A company performing poorly due to a difficult economic environment is an example of business risk."
    },
    {
       "id":5692,
       "practice_test_id":"",
       "topic_id":5,
       "question":"You own shares in XYZ, a large multinational manufacturer that is the biggest manufacturer in its industry. The company may be ruled a monopoly by the Government. This is an example of:",
       "choice_a":"Market Risk",
       "choice_b":"Liquidity Risk",
       "choice_c":"Regulatory Risk",
       "choice_d":"Business Risk",
       "correct_answer":"C",
       "explanation":"Any action taken by the Government that may affect the prospects of an industry or a specific company would be an example of regulatory risk."
    },
    {
       "id":5693,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Common stock typically has voting rights, these rights entitle the owner to: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Send a proxy </li><li>Dividends </li><li>Nominate board members </li><li>Vote on corporate policy</li></ol>",
       "choice_a":"II and III",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"I, II,  III,  IV",
       "correct_answer":"C",
       "explanation":"While stockholders have the right to receive dividends they do not have the right to vote for them. Stockholders also do not get to vote for general corporate policy. Stockholders are entitled to cast their votes by sending proxies and may nominate a person for the board of directors. Generally only large shareholders will try to nominate a board member."
    },
    {
       "id":37379,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Obtaining written verification of an investor\u0027s net worth is required for investment in a:",
       "choice_a":"real estate investment trust",
       "choice_b":"open-end mutual fund",
       "choice_c":"direct participation program",
       "choice_d":"Collateralized mortgage obligation",
       "correct_answer":"C",
       "explanation":"Because DPPs present unique risks and are not suitable for all investors, written verification of the investor\u0027s net worth is required to be obtained before the investor can become accepted as a limited partner."
    },
    {
       "id":37382,
       "practice_test_id":6,
       "topic_id":5,
       "question":"Your client has invested in a limited partnership generating passive losses. These losses can be used to offset:",
       "choice_a":"passive income from other partnerships and rental income from direct investments in real estate.",
       "choice_b":"passive income from other partnerships and dividends received from listed securities.",
       "choice_c":"rental income from direct investments in real estate and dividends received from listed securities",
       "choice_d":"dividends received from listed securities and capital gains from the sale of listed securities.",
       "correct_answer":"A",
       "explanation":"A passive loss can be taken as a deduction from any passive income received or income from certain direct real estate investments. It cannot be used as a deduction from active or portfolio (investment) income such as dividends received or capital gains gotten from the sale of securities."
    },
    {
       "id":37381,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Some investments allow for the direct pass-through of both losses and income to investors. Of the following, which does not?",
       "choice_a":"REITs",
       "choice_b":"Oil and gas drilling direct participation programs",
       "choice_c":"Existing real estate direct participation programs",
       "choice_d":"New construction real estate direct participation programs",
       "correct_answer":"A",
       "explanation":"Real estate investment trusts (REITs) allow for the direct pass-through of income only, not losses. Direct participation programs are a form of business partnership that allow for pass-through of both income and losses to the partners, a noted tax advantage."
    },
    {
       "id":37383,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Your institutional client is the general partner in an existing real estate direct participation program (DPP). Given the position your client holds, it is understood that all of the following are applicable except:",
       "choice_a":"having limited liability and being protected from legal action against the partnership",
       "choice_b":"being responsible for either managing the properties or appointing another to manage the properties",
       "choice_c":"making any day-to-day decisions required for managing the partnership",
       "choice_d":"having the authority to buy or sell real estate in the partnership\u0027s portfolio",
       "correct_answer":"A",
       "explanation":"The general partner of a direct participation real estate partnership has the authority to buy and sell properties for the partnership\u0027s portfolio. The general partner can either manage properties directly or appoint someone to manage the properties. The general partner however does not have limited liability like limited partners do, and can therefore are not protected from legal actions against the partnership."
    },
    {
       "id":24665,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is an attribute of an investment in an oil and gas partnership program that is not associated with an investment in a real estate partnership program?",
       "choice_a":"Passive loss pass through",
       "choice_b":"Pass through of passive gains",
       "choice_c":"Lack of liquidity",
       "choice_d":"Depletion",
       "correct_answer":"D",
       "explanation":"All DPPs offer the pass through of gains and losses and most lack liquidity. Depletion is an allowance for the reduction in the amount of a natural resource. This takes into consideration the fact that at some point the resource will be completely removed from the ground. Real estate is not a natural resource. The buildings would be depreciated over time to account for the fact that the buildings will not last forever."
    },
    {
       "id":19328,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which one of the following rights is never directly granted to all common shareholders of a publicly-held corporation?",
       "choice_a":"Pre emptive right",
       "choice_b":"Voting right",
       "choice_c":"Right to receive declared dividends",
       "choice_d":"Right to elect the CEO",
       "correct_answer":"D",
       "explanation":"The CEO of a company is appointed by the Board of Directors. Shareholders do not vote directly for the CEO of the company. Shareholders vote for the Board of Directors and the Board determines who should run the day to day operations of the company"
    },
    {
       "id":19351,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following features would benefit a preferred stock investor during a period of inflation? ",
       "choice_a":"Cumulative",
       "choice_b":"Callable",
       "choice_c":"Convertible",
       "choice_d":"Participating",
       "correct_answer":"C",
       "explanation":"During times of inflation the value of fixed payments will become less valuable and the price of the preferred stock may decrease as a result. If the preferred stock is convertible it would lend support to the price of the preferred stock and allow the investor to convert the preferred shares for common shares which tend to do better during times of inflation. "
    },
    {
       "id":19379,
       "practice_test_id":"",
       "topic_id":5,
       "question":"What type of stock receives an equal part of the profits on each share to be distributed after all other obligations of the company have been satisfied?",
       "choice_a":"Common Stock",
       "choice_b":"ETFs",
       "choice_c":"Preferred stock",
       "choice_d":"Open end mutual fund shares",
       "correct_answer":"A",
       "explanation":"Common stock is the most junior security and has the lowest claim on corporate assets and earnings. Dividends paid to common stockholders are paid after interest payments on bonds, preferred dividends and corporate income taxes."
    },
    {
       "id":37393,
       "practice_test_id":2,
       "topic_id":5,
       "question":"A client interested in the potential tax benefits of a DPP expresses that any deductions able to be taken sooner would suit her most. She mentions having heard about intangible drilling costs (IDCs) associated with natural resource programs. You confirm that IDCs can often be taken by limited partners earlier in the program and that any of the following might generate such costs, except for:",
       "choice_a":"land surveys or leases",
       "choice_b":"fuel consumption",
       "choice_c":"employee wages",
       "choice_d":"drilling equipment",
       "correct_answer":"D",
       "explanation":"Intangible costs can be viewed as those incidental to but necessary for the drilling to occur, and would include employee wages, fuel, surveys, and land leases. The IRS allows IDCs to be taken by limited partners as deductions early in the life of the program, sometimes all within the first few years. Conversely, capital equipment costs for the actual wells and support equipment can be depreciated over their expected life and therefore do not generate as much in current deductions."
    },
    {
       "id":37392,
       "practice_test_id":3,
       "topic_id":5,
       "question":"A discussion is overheard addressing the risks of investing in different types of oil and gas limited partnership programs. Several statements are made but one of them is inaccurate. Which is it?",
       "choice_a":"Developmental programs may require the acquisition of expensive leases in order to drill where reserves are already known to be present.",
       "choice_b":"Income programs are less risky than exploratory programs but also have fewer tax benefits than exploratory programs.",
       "choice_c":"It\u0027s possible that a well may not produce enough oil or gas to even realize the return of the cost of drilling.",
       "choice_d":"A developmental program has higher risks associated with it than an exploratory program does.",
       "correct_answer":"D",
       "explanation":"Always remember that exploratory programs, that are drilling to explore the possibility that a natural resource exists there, have the highest risks, the highest rewards, and offer the most potential tax benefits. Developmental wells are drilled to develop a reserve that is already known to be present and therefore might require expensive land leases to drill there, and income programs invest in wells that are already producing and hence considered the least risky offering fewer tax benefits."
    },
    {
       "id":37391,
       "practice_test_id":4,
       "topic_id":5,
       "question":"In order for a direct participation program recommendation to be deemed suitable for an investor, all of the following should be considered investment objectives of the investor except:",
       "choice_a":"short-term capital gains",
       "choice_b":"long-term capital gains",
       "choice_c":"deferment of taxes",
       "choice_d":"current deductions against income",
       "correct_answer":"A",
       "explanation":"One of the advantages offered by investing in a DPP might include the generation of currently deductible expenses. These deductions reduce current taxable income. The investment objectives for those investing in DPPs might include that as well as the deferral of taxable income. That is, foregoing any short-term gains presently taxable in the hopes of realizing those gains at a later date, long-term, when the partnership dissolves."
    },
    {
       "id":37390,
       "practice_test_id":5,
       "topic_id":5,
       "question":"When investing in a direct participation limited partnership program there are certain tax advantages that can be realized by a limited partner. Which of the following represents two items that are examples of possible tax advantages for a limited partner?",
       "choice_a":"Accelerated depreciation and depletion allowances",
       "choice_b":"Accelerated depreciation and the recapture of depreciation",
       "choice_c":"Tangible drilling expenses and the recapture of depreciation",
       "choice_d":"Tangible drilling expenses and depletion allowances",
       "correct_answer":"A",
       "explanation":"Accelerated depreciation of physical assets such as machinery or buildings, and depletion allowances given for natural resources such as oil or gas are considered tax benefits that can be realized by a limited partner. Tangible drilling expenses go to the general partner. Therefore, these are not tax benefits for any of the limited partners (intangible expenses would be). Recapture of depreciation occurs when an asset that has been fully depreciated is actually sold for more than its depreciated value. The excess is recaptured by the IRS who deems that amount taxable as ordinary income."
    },
    {
       "id":37389,
       "practice_test_id":6,
       "topic_id":5,
       "question":"A client of your broker-dealer has invested in an undeveloped (raw) land limited partnership. Given the characteristics of these particular types of real estate partnerships it is most likely that the client\u0027s objective is:",
       "choice_a":"appreciation",
       "choice_b":"depreciation",
       "choice_c":"depletion",
       "choice_d":"deductions for current expenses",
       "correct_answer":"A",
       "explanation":"Those who invest in undeveloped or raw land limited partnerships are investing with the expectation that the land will appreciate in value. Depreciation is associated with physical assets that have a limited life expectancy like equipment or buildings, and depletion is associated with natural resources such as oil and gas. Current expenses that can be used as deductions are most associated with assets that need to be actively managed; not a characteristic of raw land."
    },
    {
       "id":37388,
       "practice_test_id":"",
       "topic_id":5,
       "question":"When a limited partnership interest is sold or the partnership dissolved, the reportable gain or loss for a partner is the difference between the partner\u0027s allocated portion of the sales proceeds and the:",
       "choice_a":"partners adjusted cost basis at that time",
       "choice_b":"partners original cost basis",
       "choice_c":"total of the deductible losses taken by the partner over the life of the partnership",
       "choice_d":"total of all reportable passive gains the partner has for that current tax year",
       "correct_answer":"A",
       "explanation":"The adjusted cost basis is a limited partner\u0027s calculated cost at any point in time. Gain or loss for the partner on the sale or dissolution of the partnership is determined by comparing that portion of the sales proceeds allocated to the partner and the partners adjusted cost basis at that time."
    },
    {
       "id":37387,
       "practice_test_id":"",
       "topic_id":5,
       "question":"One tax advantage offered by certain types of limited partnership programs is that they offer depletion allowances. This would apply to all of the following programs except:",
       "choice_a":"timber",
       "choice_b":"copper mining",
       "choice_c":"oil and gas",
       "choice_d":"real estate",
       "correct_answer":"D",
       "explanation":"Depletion allowances are applicable to partnerships encompassing natural resources. These might include mining or timber. Depletion is not applicable to real estate, but depreciation would be."
    },
    {
       "id":37386,
       "practice_test_id":1,
       "topic_id":5,
       "question":"An investor reports $42,000 of passive income on his tax return. As a limited partner in a direct participation program, he has an adjusted cost basis for the year calculated to be $21,000. He receives his portion of the losses passed through for the year in the amount of $38,000. How much of these losses may he deduct against his passive income?",
       "choice_a":"$21,000 (100% of the calculated cost basis)",
       "choice_b":"$38,000 (100% of the losses passed through)",
       "choice_c":"$19,000 (50% of the losses passed through)",
       "choice_d":"$42,000 (100% of his passive income)",
       "correct_answer":"A",
       "explanation":"Of the $42,000 in passive income received the investor would be able to deduct up to the amount of his calculated adjusted cost basis. Here we are told that the adjusted cost basis for the year is $21,000. Remember that the losses passed through would have already reduced the initial cost basis allowing one to arrive at the calculated adjusted cost basis given."
    },
    {
       "id":37385,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Your client invests $25,000 in a DPP and signs a recourse note for $40,000. In the first year of operation, she receives a cash distribution from the partnership in the amount of $5,000. At the end of the first year for tax purposes her adjusted cost basis is:",
       "choice_a":"$65,000",
       "choice_b":"$45,000",
       "choice_c":"$60,000",
       "choice_d":"$25,000",
       "correct_answer":"C",
       "explanation":"To determine adjusted cost basis for tax purposes, add the original investment ($25,000) to any recourse debt assumed by the investor ($40,000); $65,000 cost basis. The recourse debt adds to basis because a limited partner is liable for this amount; they would not be liable for NON recourse debt). However, the cash distributions received ($5,000) reduce cost basis; $65,000 - $5,000 = $60,000 cost basis at the end of the first year."
    },
    {
       "id":37384,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor profile is as follows; high net worth, high salary, and substantial unearned passive investment income. His investment objective is to shelter a portion of his income as quickly as possible. Which of the following direct participation programs would offer the opportunity to generate the most initial write-offs available to shelter his passive income?",
       "choice_a":"existing housing real estate program",
       "choice_b":"raw land real estate program",
       "choice_c":"oil and gas income program",
       "choice_d":"oil and gas drilling program",
       "correct_answer":"D",
       "explanation":"Of the programs listed, the oil and gas drilling program would offer the best opportunity to satisfy the objective. This is because these programs pass through intangible drilling costs (IDCs), which partners may use as deductions against any passive income received that year."
    },
    {
       "id":37380,
       "practice_test_id":"",
       "topic_id":5,
       "question":"One of the risks associated with a direct participation program is that the IRS may determine that as a tax shelter the partnership is abusive. If this occurs, the IRS may do all of the following except:",
       "choice_a":"sentence all partners in the program to terms in prison",
       "choice_b":"disallow all previously taken tax deductions",
       "choice_c":"charge interest and penalties on any back taxes it determines are due",
       "choice_d":"charge the general partners with intent to defraud",
       "correct_answer":"A",
       "explanation":"If the IRS determines that a partnership is abusive regarding its sheltering of taxes, it can charge the general partners with intent to defraud, disallow all previously taken tax deductions, and charge interest and / or penalties on any taxes it determines should have been paid and weren\u0027t. It does not however have the authority to levy prison sentences."
    },
    {
       "id":5793,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Most mutual funds do not sell their shares directly to investors; this selling is the responsibility of the:",
       "choice_a":"Broker dealer",
       "choice_b":"Investment advisor",
       "choice_c":"The underwriter",
       "choice_d":"The selling agent",
       "correct_answer":"C",
       "explanation":"The underwriter, also known as the sponsor or the distributor, is responsible for selling mutual fund shares."
    },
    {
       "id":5794,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Your customer is investing $10,000 in a mutual fund with a sales charge of 6%; how much will actually be invested in the fund after the sales charge is taken out?",
       "choice_a":"$9,400",
       "choice_b":"$9,500",
       "choice_c":"$9,600",
       "choice_d":"None of the choices listed",
       "correct_answer":"A",
       "explanation":"$10,000 x 6% = $600; $10,000 - $600 = $9,400 is his total investment."
    },
    {
       "id":5795,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An investor knows that he invested in a fund with a NAV of $9.75 and a sales charge of 2.5%; what was his POP?",
       "choice_a":"$5.00",
       "choice_b":"$10.00",
       "choice_c":"$9.50",
       "choice_d":"None of the choices listed",
       "correct_answer":"B",
       "explanation":"to find the POP when you know the NAV and the sales charge percent use the following formula: NAV / (100%-SC%) = 9.75/(100%-2.5%) = 9.75/97.5% = 9.75/.975 = 10.00"
    },
    {
       "id":5796,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Mutual funds, classified as a conduit of investment income, are taxed in the following way:",
       "choice_a":"They are not taxed on their income distributed to investors as long as the fund distributes at least 90% of its net investment income",
       "choice_b":"They are taxed on the first 90% of their net investment income, but they are tax free on the last 10%",
       "choice_c":"They are taxed every month on the net investment income at a rate of 10%",
       "choice_d":"They pay no taxes since they are only a conduit and not earning income for themselves, but rather for their investors",
       "correct_answer":"A",
       "explanation":"A mutual fund is not taxed on its net investment income so long as it sends out at least 90 % to shareholders as dividends."
    },
    {
       "id":5797,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Once registered an investment company may do all of the following except:",
       "choice_a":"Act as a bank or savings and loan",
       "choice_b":"Raise money through the sale of shares",
       "choice_c":"Lend money to earn interest",
       "choice_d":"Borrow money on a limited basis",
       "correct_answer":"A",
       "explanation":"A registered  investment company is prohibited from acting as a bank or a savings and loan."
    },
    {
       "id":5798,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Open end funds and closed end funds differ in sales charge in what way?",
       "choice_a":"Open end funds charge sales charge and closed end funds charge no sales charge",
       "choice_b":"Open end funds charge more sales charge than closed end funds",
       "choice_c":"Investors pay the sales charge for open end funds, while the fund pays the sales charge for closed end funds",
       "choice_d":"Open end funds carry a front end sales charge while closed end funds carry a back end load sales charge",
       "correct_answer":"A",
       "explanation":"Open end funds charge a sales charge, born by the investor, while closed end funds do not charge a sales charge at all."
    },
    {
       "id":5799,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Open end mutual funds are priced:",
       "choice_a":"By supply and demand",
       "choice_b":"As a percentage of NAV",
       "choice_c":"By formula",
       "choice_d":"As a percentage of POP",
       "correct_answer":"C",
       "explanation":"Open end mutual funds are priced by formula"
    },
    {
       "id":5800,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Sales charges in excess of what amount must be returned to an investor who cancels their contractual plan organized under the act of 1940 between 45 days and 18 months?",
       "choice_a":"15%",
       "choice_b":"40 %",
       "choice_c":"30%",
       "choice_d":"9%",
       "correct_answer":"A",
       "explanation":"An investor who cancels their contractual plan between 45 days and 18 months is entitled to a refund of sales charges in excess of 15% of the payments."
    },
    {
       "id":5801,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The 12b-1 fee charged by a mutual fund may be used to pay all of the following except:",
       "choice_a":"Printing of prospectus",
       "choice_b":"Radio advertisement",
       "choice_c":"Investment advisor fees",
       "choice_d":"Sponsoring a tennis match",
       "correct_answer":"C",
       "explanation":"A 12b-1 fee may be used to pay promotional and distribution expenses only."
    },
    {
       "id":5802,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The board of directors does all but the following:",
       "choice_a":"Manage the investment portfolio",
       "choice_b":"Define the investment objectives",
       "choice_c":"Hire the investment advisor, the custodian bank, and the transfer agent",
       "choice_d":"Determine what type of funds to offer",
       "correct_answer":"A",
       "explanation":"The board of directors does not manage the investment portfolio."
    },
    {
       "id":5803,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The contract for an investment advisory must be approved by: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The Board of directors </li><li>The Shareholders </li><li>The outstanding shares </li><li>The FINRA board of governors</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I and III",
       "correct_answer":"D",
       "explanation":"The contract for the mutual fund\u0027s investment advisor must be approved by a majority vote of the Board of Directors and the outstanding shares."
    },
    {
       "id":5804,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The custodian bank of an investment company does which of the following?",
       "choice_a":"Physically holds all of the fund\u0027s cash and securities",
       "choice_b":"Holds all of the fund\u0027s assets for safekeeping",
       "choice_c":"Provides bookkeeping and other clerical functions for the investment company",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The custodian bank of an investment company does All of the choices listed as well as ensuring that only approved persons have access to the account."
    },
    {
       "id":5805,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The different groups which make up an investment company are which of the following?",
       "choice_a":"The board of directors, the investment advisor, the mortgage bank, and the transfer agent",
       "choice_b":"The board of directors, the custodian advisor, the mortgage bank, and the transfer agent",
       "choice_c":"The board of directors, the custodian bank, the mortgage bank, and the transfer agent",
       "choice_d":"The board of directors, the investment advisor, the custodian bank, and the transfer agent",
       "correct_answer":"D",
       "explanation":"The board of directors, investment advisor, custodian bank, and transfer agent make up a management investment company."
    },
    {
       "id":5806,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The entity that is responsible for selling open-end mutual fund shares to investors is?",
       "choice_a":"Broker dealer",
       "choice_b":"Sponsor",
       "choice_c":"Custodian",
       "choice_d":"Transfer agent",
       "correct_answer":"B",
       "explanation":"The sponsor is responsible for selling the mutual fund shares.  They act as the underwriter for the open-end fund."
    },
    {
       "id":5807,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The GGF Fund is a diversified mutual fund with net assets of $1,000,000.  How much must it invest in securities of other issuers?",
       "choice_a":"$250,000",
       "choice_b":"$500,000",
       "choice_c":"$750,000",
       "choice_d":"None of the choices listed",
       "correct_answer":"C",
       "explanation":"This fund must invest 75% of its net assets in securities of other issuers in order to market itself as a diversified mutual fund."
    },
    {
       "id":5808,
       "practice_test_id":1,
       "topic_id":6,
       "question":"The GGC Fund Company, a balanced fund, has a POP of $10 and has paid dividends of $0.55 per share.  Find its current yield.",
       "choice_a":"$5.50",
       "choice_b":"55%",
       "choice_c":"$55",
       "choice_d":"5.50%",
       "correct_answer":"D",
       "explanation":"Current yield equals annual income ($0.55) divided by current price($10) or 5.5%.  CY = AI/CP"
    },
    {
       "id":5809,
       "practice_test_id":2,
       "topic_id":6,
       "question":"All of the following are true relating to the investment adviser of an investment company except which of the following?",
       "choice_a":"Manages the fund\u0027s portfolio and may not borrow from it",
       "choice_b":"Can be a person hired by the board of directors and may not have any security related convictions",
       "choice_c":"Determines the tax consequences of distributions and strategies",
       "choice_d":"Receives the highest paid member of the investment company\u0027s team",
       "correct_answer":"B",
       "explanation":"The investment adviser is always a company, not a single person. All of the other choices are true of the investment adviser for an investment company"
    },
    {
       "id":5810,
       "practice_test_id":3,
       "topic_id":6,
       "question":"The largest expense of a mutual fund is:",
       "choice_a":"Its sales charge",
       "choice_b":"Its management fee",
       "choice_c":"Its custodial fee",
       "choice_d":"Its redemption fee",
       "correct_answer":"B",
       "explanation":"The largest expense of a mutual fund is the management fee paid to the investment advisor."
    },
    {
       "id":5811,
       "practice_test_id":4,
       "topic_id":6,
       "question":"The MMF Fund is a diversified mutual fund with net assets of $1,000,000.  How much may it invest in any one company?",
       "choice_a":"$5,000",
       "choice_b":"$10,000",
       "choice_c":"$50,000",
       "choice_d":"$100,000",
       "correct_answer":"C",
       "explanation":"This fund may invest a maximum of 5% or $50,000 in any one fund in order to be a diversified mutual fund."
    },
    {
       "id":5812,
       "practice_test_id":5,
       "topic_id":6,
       "question":"The MMF Mutual Fund has assets of $1,000,000 and liabilities of $250,000, and 75,000 outstanding shares of stock.  What is the net asset value per share of the outstanding stock?",
       "choice_a":"$16.66",
       "choice_b":"$13.33",
       "choice_c":"$10.00",
       "choice_d":"$7.50",
       "correct_answer":"C",
       "explanation":"$1,000,000 - $250,000 = $750,000 / 75,000 = $10.00."
    },
    {
       "id":5813,
       "practice_test_id":6,
       "topic_id":6,
       "question":"The maximum allowable sales charge on an open mutual fund is:",
       "choice_a":"8.5% of the NAV",
       "choice_b":"9% of the POP",
       "choice_c":"8.5% of the POP",
       "choice_d":"9% of the NAV",
       "correct_answer":"C",
       "explanation":"The maximum allowable sales charge on an open-end fund is 8 \u00BD% of the POP."
    },
    {
       "id":5814,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The maximum amount that a diversified fund may invest in any one target company is:",
       "choice_a":"10%",
       "choice_b":"5%",
       "choice_c":"7 %",
       "choice_d":"8.5 %",
       "correct_answer":"B",
       "explanation":"A diversified mutual fund may invest no more than 5% of its assets in any one company."
    },
    {
       "id":5816,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The maximum sales charge that may be deducted in any one year from a contractual plan organized under the act of 1940 is:",
       "choice_a":"9%",
       "choice_b":"20%",
       "choice_c":"16%",
       "choice_d":"50%",
       "correct_answer":"D",
       "explanation":"Up to 50% of the first years payments may go towards the sales charge for a contractual plan organizer under the act of 1940."
    },
    {
       "id":5817,
       "practice_test_id":6,
       "topic_id":6,
       "question":"The minimum net capital for an investment company is:",
       "choice_a":"$25,000",
       "choice_b":"$50,000",
       "choice_c":"$1,000,000",
       "choice_d":"$100,000",
       "correct_answer":"D",
       "explanation":"The minimum net capital for an investment company is $ 100,000."
    },
    {
       "id":5818,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The PPF Fund is a diversified mutual fund with net assets of $10,000,000.  What is the maximum amount of any company\u0027s outstanding voting stock which this fund may own?",
       "choice_a":"$10,000",
       "choice_b":"$100,000",
       "choice_c":"$1,000,000",
       "choice_d":"None of the choices listed",
       "correct_answer":"D",
       "explanation":"This fund may not own more than 10% of any company\u0027s outstanding stock in order to be a diversified mutual fund."
    },
    {
       "id":5819,
       "practice_test_id":6,
       "topic_id":6,
       "question":"The pricing formula for an open-end mutual fund is:",
       "choice_a":"NAV=assets-liabilities",
       "choice_b":"POP-SC=NAV",
       "choice_c":"NAV+SC=POP",
       "choice_d":"Supply + demand = POP",
       "correct_answer":"C",
       "explanation":"The pricing formula for an opened investment company is always NAV+SC=POP."
    },
    {
       "id":5820,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The purpose of a letter of intent is:",
       "choice_a":"To let the mutual fund know what the person is considering",
       "choice_b":"To allow an investor to reach a breakpoint within 13 months of his first investment",
       "choice_c":"To provide a binding agreement for both the customer and the fund company for investment planning purposes",
       "choice_d":"To allow the fund company to create an escrow fund to protect itself should the investor default",
       "correct_answer":"B",
       "explanation":"A letter of intent simply allows an investor to reach a breakpoint within 13 months of his first investment; it is binding on the fund company, not on the individual."
    },
    {
       "id":5821,
       "practice_test_id":2,
       "topic_id":6,
       "question":"The Securities Act of 1933 requires that all investment company offerings do all of the following except:",
       "choice_a":"Register with the Securities Exchange Commission",
       "choice_b":"Have a net worth a minimum of $250,000",
       "choice_c":"Give all purchasers a prospectus",
       "choice_d":"Follow specific guidelines on its offerings and keep investors informed",
       "correct_answer":"B",
       "explanation":"The Securities Act of 1933 did not require an investment company to have a net worth, but in order to register with the Securities Exchange Commission, a company must have a minimum net worth of $100,000."
    },
    {
       "id":5822,
       "practice_test_id":3,
       "topic_id":6,
       "question":"The transfer agent of an investment company does which of the following?",
       "choice_a":"Handles the issuance, cancellation, and redemption of fund shares",
       "choice_b":"Handles name changes",
       "choice_c":"Receives an agreed upon fee for his services",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The transfer agent does all of the choices listed for an investment company."
    },
    {
       "id":5823,
       "practice_test_id":4,
       "topic_id":6,
       "question":"To determine the value of a fund, use the following formula:",
       "choice_a":"Assets plus liabilities equals net asset value",
       "choice_b":"Net asset value equals liabilities minus assets",
       "choice_c":"Assets minus liabilities equal net asset value",
       "choice_d":"Net asset value equals liabilities plus assets",
       "correct_answer":"C",
       "explanation":"Assets - liabilities = NAV, a most important formula."
    },
    {
       "id":5824,
       "practice_test_id":5,
       "topic_id":6,
       "question":"Unless an investment company meets the strictest of capital and disclosure requirements, it may not do any of the following except:",
       "choice_a":"Sell securities short",
       "choice_b":"Buy securities on margin",
       "choice_c":"Maintain its own account",
       "choice_d":"Distribute its own shares",
       "correct_answer":"C",
       "explanation":"An investment company may only maintain its own  account unless it has met very strict capital and disclosure requirements."
    },
    {
       "id":5825,
       "practice_test_id":6,
       "topic_id":6,
       "question":"What is the mutual fund pricing formula?",
       "choice_a":"NAV – SC = POP",
       "choice_b":"NAV + SC = POP",
       "choice_c":"SC + POP = NAV",
       "choice_d":"None of the choices listed",
       "correct_answer":"B",
       "explanation":"Net asset value (NAV) plus service charge (SC) equals the public offering price (POP)."
    },
    {
       "id":5826,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following are true regarding dollar cost averaging? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is effective in a short period of time </li><li>It is more effective when the dollar amount varies </li><li>It is a long term investment strategy </li><li>It is more effective when the share price varies</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"III and IV",
       "correct_answer":"D",
       "explanation":"Dollar cost averaging is a long term investment strategy that is most effective when the share price varies. The investor invests a fixed amount over a long period of time into a fund with a fluctuating share price."
    },
    {
       "id":5827,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which equity income fund traditionally pays the highest percentage of their earnings to shareholders in the form of dividends?",
       "choice_a":"Utility stocks",
       "choice_b":"Common stock",
       "choice_c":"Preferred stock",
       "choice_d":"Government bonds",
       "correct_answer":"A",
       "explanation":"Utilities traditionally pay out the highest percentage of earnings as dividends."
    },
    {
       "id":5828,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which is not correct about mutual fund investors\u0027 voting right?",
       "choice_a":"All votes are won by a simple majority of outstanding shares",
       "choice_b":"All votes are won by a simple majority of shareholders",
       "choice_c":"Votes are taken on a number of major issues regarding the fund",
       "choice_d":"Votes are taken on financial issues as well as policies and Board of Directors",
       "correct_answer":"B",
       "explanation":"All votes are won by a simple majority of shares, not shareholders; thus if one investor has 100 shares and another has 500, the second has 5 times as many votes."
    },
    {
       "id":5829,
       "practice_test_id":6,
       "topic_id":6,
       "question":"Which is true about the board of directors?",
       "choice_a":"The board is elected by the vote of the shareholders",
       "choice_b":"The board must be made up of at least 60% non-interested or non-affiliated persons",
       "choice_c":"The board may be made up of a maximum of 40% of interested persons, such as a broker, attorney, or immediate family member",
       "choice_d":"The board is elected by a vote of the outstanding shares",
       "correct_answer":"D",
       "explanation":"It is elected by a vote of the outstanding shares, the board must be made up of at least majority of non-interested persons."
    },
    {
       "id":5830,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following are true regarding a breakpoint sales charge reduction. <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It results in a lower POP </li><li>Its based on dollars invested </li><li>The POP does not change </li><li>They are available to corporations</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I, II, and IV",
       "choice_d":"II, III and IV",
       "correct_answer":"C",
       "explanation":"All of the choices listed are true except III"
    },
    {
       "id":5831,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following are types of sales loads: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Front end </li><li>Back end </li><li>Contingent deferred sales charge </li><li>12 b-1 fee</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"I, II , and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed are types of sales loads.  A sales load is anything that reduces the return to an investor and a 12b-1 fee is a type of sales load."
    },
    {
       "id":5832,
       "practice_test_id":6,
       "topic_id":6,
       "question":"Which of the following funds would most likely have the highest management fee?",
       "choice_a":"A long term bond fund",
       "choice_b":"A Long term growth fund",
       "choice_c":"An aggressive growth fund",
       "choice_d":"An option income fund",
       "correct_answer":"C",
       "explanation":"The aggressive growth fund would have the highest fee. The more aggressive the fund\u0027s objective the higher the fee"
    },
    {
       "id":5833,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following investments is the most popular way to try to accumulate mutual fund shares?",
       "choice_a":"UIT",
       "choice_b":"Contractual plan",
       "choice_c":"Lump sum deposit",
       "choice_d":"Dollar cost averaging",
       "correct_answer":"D",
       "explanation":"Dollar cost averaging is much more widely used as a way to accumulate shares in an open-end mutual fund."
    },
    {
       "id":5834,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following is a reason an investor would purchase a mutual fund through a contractual plan?",
       "choice_a":"To obtain the best price possible for the mutual fund shares.",
       "choice_b":"To purchase shares with a lower sales charge",
       "choice_c":"To purchase mutual fund shares at a lower average price",
       "choice_d":"To purchase a mutual fund when they cannot meet the minimum initial investment.",
       "correct_answer":"D",
       "explanation":"An investor would most likely purchase a mutual fund through a contractual plan because they cannot meet the initial minimum investment."
    },
    {
       "id":5835,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following is not a feature of closed-end funds?",
       "choice_a":"Single fixed offering through an IPO",
       "choice_b":"Common and preferred shares and debt securities",
       "choice_c":"Shares purchased from company and redeemed to company",
       "choice_d":"Shares priced by supply and demand",
       "correct_answer":"C",
       "explanation":"Closed-end funds have shares that may be purchased only from the fund company during the IPO; then secondary market transactions take place between investors."
    },
    {
       "id":5836,
       "practice_test_id":6,
       "topic_id":6,
       "question":"Which of the following is not a feature of open-end funds?",
       "choice_a":"Unlimited continuous primary offering",
       "choice_b":"Shares are priced by supply and demand",
       "choice_c":"Full and fractional shares",
       "choice_d":"Common shares only",
       "correct_answer":"B",
       "explanation":"Open-end fund shares are priced by the formula NAV + SC = POP."
    },
    {
       "id":5837,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following is not considered when determining a mutual fund\u0027s net investment income?",
       "choice_a":"Dividends received",
       "choice_b":"Interest payments received",
       "choice_c":"Expenses paid",
       "choice_d":"Large capital gains",
       "correct_answer":"D",
       "explanation":"A mutual fund\u0027s net investment income  only looks at interest and dividends received and expenses paid by the fund."
    },
    {
       "id":5838,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following is not true?",
       "choice_a":"Common stock is the only investment which will meet a growth objective",
       "choice_b":"Growth funds seek capital gains and produce significant dividend income",
       "choice_c":"Growth funds seeking capital appreciation will invest in the common stock of corporations whose business is growing very rapidly",
       "choice_d":"Growth funds will invest in corporations whose business is growing more rapidly than the economy as a whole",
       "correct_answer":"B",
       "explanation":"Growth funds seek capital gains and do not produce significant dividend income."
    },
    {
       "id":5839,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following is true about securities in a  mutual fund portfolio?",
       "choice_a":"The NAV will decrease if the fund distributes dividends or capital gains",
       "choice_b":"The NAV will increase if the fund receives investment income",
       "choice_c":"The NAV will be unchanged by sales charges, portfolio purchases and sales and investor purchases and sales",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are true about the NAV and the securities in a portfolio."
    },
    {
       "id":5840,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following is true regarding the ex dividend date for an open end mutual fund? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is set by FINRA </li><li>It is the day before the record date </li><li>It is set by the board of directors </li><li>It is the day after the record date.</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I and IV",
       "choice_d":"III and IV",
       "correct_answer":"D",
       "explanation":"The ex dividend date for an open end mutual fund is set by the board of directors and is the day after the record date."
    },
    {
       "id":5841,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A mutual fund makes breakpoint sales charge reductions available to investors:",
       "choice_a":"To encourage investors to invest larger sums of money into a mutual fund",
       "choice_b":"To guarantee parents and their adult children greater returns when they invest in separate accounts",
       "choice_c":"To encourage investors to invest in more than one mutual fund",
       "choice_d":"To encourage personal investors only, by excluding corporations and trusts, to invest greater sums for greater returns",
       "correct_answer":"A",
       "explanation":"A mutual fund encourages investors, be they individuals, corporations, trusts, or accounts for minors, to invest larger sums of money in the same mutual fund; this increased investment benefits everyone in the process."
    },
    {
       "id":5842,
       "practice_test_id":"",
       "topic_id":6,
       "question":"You are recommending a fixed UIT to an investor.  The portfolio most likely contains which of the following:",
       "choice_a":"Common stock",
       "choice_b":"Bonds",
       "choice_c":"Preferred stock",
       "choice_d":"Both stocks and bonds",
       "correct_answer":"B",
       "explanation":"A fixed UIT will invest in a large block of bonds and hold them until maturity then distribute the proceeds to investors."
    },
    {
       "id":5843,
       "practice_test_id":2,
       "topic_id":6,
       "question":"You are recommending a mutual fund to your client and have discussed the fund\u0027s holdings and performance. You have presented the prospectus to your client. The prospectus is an advertising prospectus and provides performance data. The prospectus must disclose performance for: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>One year </li><li>Three years </li><li>Five years  </li><li>Ten years </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I, III, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"A mutual fund prospectus that offers performance data must disclose its performance for 1, 5, and 10 years"
    },
    {
       "id":5844,
       "practice_test_id":3,
       "topic_id":6,
       "question":"You have been following a mutual fund in the newspaper.  The XYZ fund has an NAV of $ 11.05 and a POP of $ 10.90.  Which of the following is true?",
       "choice_a":"There was a large drop in the futures market overnight and the market is expected to drop on the open",
       "choice_b":"XYZ is an open end fund that is losing money",
       "choice_c":"XYZ is an open end fund with a back end load",
       "choice_d":"XYZ is a closed end fund",
       "correct_answer":"D",
       "explanation":"XYZ is a closed-end mutual fund whose shares are priced by supply and demand. A closed end fund may trade at, below or above its NAV."
    },
    {
       "id":5845,
       "practice_test_id":4,
       "topic_id":6,
       "question":"You work for the management company, which has been hired by the mutual fund to make appropriate investments based on the fund\u0027s objectives.  You\u0027re paid for your services and receive:",
       "choice_a":"Commissions",
       "choice_b":"A percentage of the profits",
       "choice_c":"A percentage of the NAV",
       "choice_d":"A percentage of the POP",
       "correct_answer":"C",
       "explanation":"The management company always receives a fee based on the NAV of the fund."
    },
    {
       "id":5846,
       "practice_test_id":5,
       "topic_id":6,
       "question":"Your customer has invested $ 7,000 in a mutual fund two months ago. She now wants to invest a significant amount of her savings in this fund. She will need some time to reach the breakpoint for a sales charge reduction and would like to include her original purchase of $ 7,000. Which of the following is true regarding her letter of intent?",
       "choice_a":"The letter of intent may not be backdated to include the original purchase",
       "choice_b":"Your client should make a lump sum investment to gain the maximum appreciation on her portfolio",
       "choice_c":"The letter of intent may be backdated to include the original purchase and there will be a sales charge reduction made for the original investment only",
       "choice_d":"The letter of intent may be backdated to include the original amount  to realize a reduced sales charge",
       "correct_answer":"D",
       "explanation":"The letter of intent can be backdated up to 90 days to include the original purchase."
    },
    {
       "id":5847,
       "practice_test_id":6,
       "topic_id":6,
       "question":"Your customer has just bought $ 10,000 worth of Kashmir Growth fund. The trade will settle on:",
       "choice_a":"The third business day",
       "choice_b":"The second business day",
       "choice_c":"The next business day",
       "choice_d":"The same day",
       "correct_answer":"D",
       "explanation":"The investor has purchased shares of an open-end mutual fund. Every new investor gets a new share and becomes an owner of record on the day the order is received so long as the purchase order was received prior to the calculation of the NAV."
    },
    {
       "id":5848,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Your customer thinks that the telecommunication sector is likely to rebound over the next 24 months.  He wants to liquidate his shares in the XYZ income opportunity fund, which has an NAV of $ 11 and a POP of $ 11.70.  He has 500 shares and wants to move the money into the XYZ telecommunication fund, which has a NAV of $ 10 and a POP of $ 10.50.  XYZ offers conversion privileges.  How many shares can he buy?",
       "choice_a":"550 shares",
       "choice_b":"522.5 shares",
       "choice_c":"585 shares",
       "choice_d":"512 shares",
       "correct_answer":"A",
       "explanation":"The investor will be able to buy 550 shares of the new fund because the fund offers conversion privileges.  The investor sells his shares at the NAV of $11 X 500 = $5,500 and buys the new shares at the NAV of $10  $ 5,500/10=550."
    },
    {
       "id":5849,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An investor in a UIT will receive what as their evidence of ownership in the UIT?",
       "choice_a":"Trust certificates",
       "choice_b":"Shares of beneficial interest",
       "choice_c":"Exchangeable share",
       "choice_d":"Units of ownership",
       "correct_answer":"B",
       "explanation":"Investors who purchase a UIT will receive shares of beneficial ownership."
    },
    {
       "id":5850,
       "practice_test_id":1,
       "topic_id":6,
       "question":"All of the following are characteristics of an index fund except:",
       "choice_a":"Passive management",
       "choice_b":"Low portfolio turnover",
       "choice_c":"Performance designed to track a specific market indicator",
       "choice_d":"Higher expenses",
       "correct_answer":"D",
       "explanation":"An index fund is one that is designed to track the performance of a market index. As a result the portfolio is passively managed and will have a lower turnover rate and lower expenses"
    },
    {
       "id":5851,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The following closed-end funds are listed in the Wall Street Journal: <ol style='margin-left: 25px; list-style-type: disc;'><li>American Fund - Net Asset Value 23.75, Market Price 24.25 </li><li>Bunker Hill Fund - Net Asset Value 21.85, Market Price 21.50  </li></ol>A customer purchasing the Bunker Hill Fund at the current market price would pay:",
       "choice_a":"$21.50 + sales charge",
       "choice_b":"$21.50 + commission",
       "choice_c":"$21.85 + sales charge",
       "choice_d":"$21.85 + commission",
       "correct_answer":"B",
       "explanation":"The Bunker Hill Fund is a closed end fund the investor would play 21.50 plus a commission to the broker for executing the order."
    },
    {
       "id":5852,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A woman invests $200 per month in a front-end load contractual plan. After making two payments within 40 days she decides to cancel the plan. She owns 22 shares that have a net asset value of $10.50 per share. She will receive:",
       "choice_a":"$431",
       "choice_b":"$231",
       "choice_c":"$331",
       "choice_d":"$531",
       "correct_answer":"A",
       "explanation":"The investor has canceled the contract during the free look period and will receive a refund of all sales charges in this case $200 + the Value of the account of $231"
    },
    {
       "id":5853,
       "practice_test_id":"",
       "topic_id":6,
       "question":"If the sales charge is 8% and the bid price is 9.20, what do you divide by to get the asked price?",
       "choice_a":92,
       "choice_b":".92.",
       "choice_c":"9.2.",
       "choice_d":60,
       "correct_answer":"B",
       "explanation":"To find the public offering price divided the NAV 9.20 by the complement of the sales charge or in this case .92"
    },
    {
       "id":5854,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An investment company has an NAV of $8 and is $7 offered. The cost to a customer would be:",
       "choice_a":"$7.00",
       "choice_b":"$7 + commission.",
       "choice_c":"$8.00",
       "choice_d":"$8 + commission.",
       "correct_answer":"B",
       "explanation":"This fund has to be a closed end fund because the offer is lower than the NAV. The investor would pay $7 plus commission."
    },
    {
       "id":5855,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following statements is true about closed-end investment companies?",
       "choice_a":"The amount of outstanding shares is constantly increasing.",
       "choice_b":"They are sold at the current ask price.",
       "choice_c":"They are sold at the current net asset value.",
       "choice_d":"They are continually offering new shares for sale.",
       "correct_answer":"B",
       "explanation":"Closed end investment company shares are sold at the current asking price in the marketplace."
    },
    {
       "id":5856,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The following closed-end funds are listed in the Wall Street Journal: <ol style='margin-left: 25px; list-style-type: disc;'><li>American Fund - Net Asset Value 23.75, Market Price 24.25 </li><li>bunker Hill Fund - Net Asset Value 21.85, Market Price 21.50 </li></ol>A customer purchasing the Bunker Hill Fund at the current market price would pay:",
       "choice_a":"$21.50 + sales charge.",
       "choice_b":"$21.50 + commission",
       "choice_c":"$21.85 + sales charge.",
       "choice_d":"$21.85 + commission.",
       "correct_answer":"B",
       "explanation":"An investor would purchase the shares of the closed end fund at the offering price and would pay a commission to the firm to execute the order."
    },
    {
       "id":5857,
       "practice_test_id":"",
       "topic_id":6,
       "question":"What kind of investment company makes no provision for future purchases or redemptions?",
       "choice_a":"An open-end fund.",
       "choice_b":"A closed-end fund.",
       "choice_c":"A unit investment trust.",
       "choice_d":"A face-amount certificate company.",
       "correct_answer":"B",
       "explanation":"A closed end fund makes no provisions for repurchasing or redeeming its shares."
    },
    {
       "id":5858,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Your customer wishes to invest $50,000 in three different mutual funds, with income as his main objective. You should notify your customer that if he invested the entire $50,000 in one fund he could save money because of the quantity discount on large purchases available through:",
       "choice_a":"Automatic reinvestment of dividends and capital gains.",
       "choice_b":"The availability of a withdrawal plan.",
       "choice_c":"The possibility of exchanging one fund for another without paying a sales charge.",
       "choice_d":"Purchases at sales charge breakpoints.",
       "correct_answer":"D",
       "explanation":"A breakpoint schedule will allow an investor to pay a reduced sales charge for larger purchases."
    },
    {
       "id":5859,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A customer investing in a contractual plan who has plan completion insurance dies. The insurance company would pay the proceeds of the policy to the:",
       "choice_a":"Estate.",
       "choice_b":"Custodian bank.",
       "choice_c":"Mutual fund.",
       "choice_d":"50% to the fund and 50% to the estate.",
       "correct_answer":"B",
       "explanation":"The full contribution would be made to the custodian bank."
    },
    {
       "id":5860,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following does not have a net asset value associated with their share price?",
       "choice_a":"Open end fund",
       "choice_b":"Closed end fund",
       "choice_c":"Preferred stock",
       "choice_d":"ETF",
       "correct_answer":"C",
       "explanation":"Preferred stock is an equity investment with fixed dividend payments. Preferred stock is purchased by investors who are seeking income. There is no NAV associated with preferred stock. Open end funds are priced by a formula based on the fund\u0027s NAV, or in the case of no load funds are sold to investors at the NAV. ETFs and closed funds do have a NAV. However the shares are priced by supply and demand so that the shares may trade higher or lower than the NAV."
    },
    {
       "id":5861,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following investments would have a net asset value associated with their share price? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Open end fund </li><li>Corporate Bond </li><li>ETF </li><li>Preferred stock</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I only",
       "choice_d":"IV only",
       "correct_answer":"A",
       "explanation":"Preferred stock is an equity investment with fixed dividend payments. Preferred stock is purchased by investors who are seeking income. There is no NAV associated with preferred stock or with corporate bonds. Open end funds are priced by a formula based on the fund\u0027s NAV, or in the case of no load funds are sold to investors at the NAV. ETFs do have an NAV. However the shares are priced by supply and demand so that the shares may trade higher or lower than the NAV."
    },
    {
       "id":5862,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A mutual fund announces a dividend on December 1st with a record date of December 15th and a payment date of December 30th.  When could an investor buy the mutual fund to avoid receiving the dividend?",
       "choice_a":"December 14th",
       "choice_b":"December 1st",
       "choice_c":"December 15th",
       "choice_d":"December 16 th",
       "correct_answer":"D",
       "explanation":"Of the dates listed the only date on which an investor could purchase the mutual fund and not receive the dividend would be December 16th. An open end mutual fund unlike a stock goes ex dividend on the day after the record date, or in this case December 16th."
    },
    {
       "id":5863,
       "practice_test_id":"",
       "topic_id":6,
       "question":"When comparing closed end versus open end mutual funds, which of the following is true regarding closed end funds but not of open end funds?",
       "choice_a":"There are fewer transaction costs",
       "choice_b":"The investor might have to trade stock at inopportune times",
       "choice_c":"Closed end funds are always looking for new opportunities for new money",
       "choice_d":"Closed end funds may be traded any time the market is open and the investor pays a fee to execute the order",
       "correct_answer":"D",
       "explanation":"Closed end funds may be traded any time the market is open and the investor pays a fee to execute the order. Open end funds may not be traded intraday."
    },
    {
       "id":5864,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A 12b-1 fee includes:",
       "choice_a":"Management fee",
       "choice_b":"Custodian bank fee",
       "choice_c":"Printing and promotional fees",
       "choice_d":"Transfer agent fee",
       "correct_answer":"C",
       "explanation":"A 12b-1 fee includes printing and promotional fees as well as other distribution fees and expenses. The other fees are separate fees that are expenses of the fund."
    },
    {
       "id":24703,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An FA goes out to lunch with a wholesaler and the wholesaler provides the FA with sales literature relating to the fund. The FA returns to the office and wants to recommend the fund to one of his clients. Which of the following is true? ",
       "choice_a":"The branch manager must approve the fund",
       "choice_b":"The FA must send a prospectus with the literature",
       "choice_c":"The branch manager must file the literature with FINRA within 10 days",
       "choice_d":"The FA may only recommend the fund if the fund is on the firm\u0027s preferred list",
       "correct_answer":"B",
       "explanation":"If the FA wanted to send the sales literature relating to the fund to a prospective investor the FA would have to send a prospectus to the potential investor at the same time."
    },
    {
       "id":24647,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An investor has begun a dollar cost averaging plan and has made the following contributions resulting the in following purchases: <img src='/question_assets/series7/3.png'></img> What is the investor's average cost?",
       "choice_a":"$13.33",
       "choice_b":"$15",
       "choice_c":"$7.50",
       "choice_d":"$17.50",
       "correct_answer":"A",
       "explanation":"To determine the investor\u0027s average cost use the following formula: Total dollars invested / total number of shares purchased. In this case, $400/30= $13.33."
    },
    {
       "id":24649,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An investor who has been investing in an open end mutual fund has placed $540 into the fund over the last several months. The investments have purchased 22 shares. The investor now wants to sell 8 of these shares to meet an unexpected expense. The mutual fund has an NAV of $26.10 and a POP of $27.05. What is the investor\u0027s gain or loss on the shares?",
       "choice_a":"$12.48 gain",
       "choice_b":"$20.08 gain",
       "choice_c":"$12.48 loss",
       "choice_d":"$20.08 loss",
       "correct_answer":"A",
       "explanation":"To determine the investor\u0027s gain or loss you must first find out the investor\u0027s average cost. This is found by taking the total amount invested and dividing it by the number of shares purchased. $540/ 22 shares = $24.54. The investor will sell the shares at the current NAV of $26.10 for a gain of $1.56 per share. The investor is selling 8 shares for a total gain of $12.48"
    },
    {
       "id":24676,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Sally Smith, a new investor, has just paid down a major portion of her student loan and is meeting with you as a representative for the first time. When discussing the performance characteristics of an open end fund you should explain to her which two of the following would cause an increase in the net asset value of the fund? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The net asset value of the fund will increase when the fund pays a dividend to shareholders </li><li>The net asset value will increase when the securities in the fund appreciate </li><li>The net asset value of the fund will increase when the fund receives income </li><li>The net asset value of the fund will increase when capital gains are distributed</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I and III",
       "correct_answer":"B",
       "explanation":"The NAV of a mutual fund will increase when the value of the securities in the fund increase or when the fund receives investment income in the form of an interest payment or dividend payment. If the fund distributes assets as is the case in choices I and IV the NAV of the fund will decrease."
    },
    {
       "id":24677,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Sally Smith, a new investor, has just paid down a major portion of her student loan and is meeting with you as a representative for the first time. When discussing the performance characteristics of an open end fund you should explain to her which two of the following would not cause an increase in the net asset value of the fund? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> The net asset value of the fund will increase when the fund pays a dividend to shareholders </li><li>The net asset value will increase when the securities in the fund appreciate </li><li>The net asset value of the fund will increase when the fund receives income </li><li>The net asset value of the fund will increase when capital gains are distributed</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"I and II",
       "choice_d":"II and IV",
       "correct_answer":"A",
       "explanation":"The NAV of a mutual fund will increase when the value of the securities in the fund increase or when the fund receives investment income in the form of an interest payment or dividend payment. If the fund distributes assets as is the case in choices I and IV the NAV of the fund will decrease."
    },
    {
       "id":24678,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An investor owns $5,000 worth of TRY closed end fund and is inquiring about the liquidation procedures for the fund. As the investor\u0027s registered representative you should tell him.",
       "choice_a":"You will liquidate the fund at the net asset value",
       "choice_b":"You will liquidate the fund the fund at the net asset value less a redemption fee",
       "choice_c":"You will liquidate the shares in the open market and will be charged a fee for the liquidation",
       "choice_d":"You will liquidate the shares in the open market and since closed end funds do not charge a sales charge you will not pay any fees upon liquidation",
       "correct_answer":"C",
       "explanation":"TRY is a closed end fund and the shares are bought and sold in the open market. An investor who is looking to sell shares in a closed end fund would enter an order to sell the shares and would be charged a commission by the brokerage firm to execute the order."
    },
    {
       "id":24679,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A woman has been investing in a mutual fund by placing her extra savings in the account whenever she has money available. Over the last several years the woman\u0027s investments have been as follows: <img src='/question_assets/series7/4.png'></img> The investor now enters a sell order and liquidates $3,500 of the fund providing no further instructions other than to forward her a check. The money will be redeemed as follows:",
       "choice_a":"$3,500 versus her average cost",
       "choice_b":"$2,000 from year four, $1,400 from year three and $100 from year two",
       "choice_c":"$1,300 from Year three, $1,200 from year two and $1,000 from year one",
       "choice_d":"$3,500 versus her average price",
       "correct_answer":"C",
       "explanation":"When an investor liquidates shares of an open end mutual fund, the shares will be sold on a FIFO (first in first out) basis if the investor does not provide instructions on how to sell the shares."
    },
    {
       "id":24680,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A large investor has placed a significant amount of money into an open end mutual fund. The investor owns 10 percent of the total outstanding shares of the fund. Which of the following is correct? ",
       "choice_a":"The large investor has a continuous preemptive right",
       "choice_b":"The large investor owns an undivided interest in the fund",
       "choice_c":"The large investor will have a say regarding asset allocation",
       "choice_d":"The large investor will have a right to specific assets held by the fund",
       "correct_answer":"B",
       "explanation":"Regardless of how big or small the investor\u0027s holdings are in a mutual fund all investors own an undivided interest in the portfolio. "
    },
    {
       "id":24684,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An investor wants to place money into a pooled investment that will offer him the opportunity to move money between managed portfolios at the NAV to time the market. Which of the following investments would be the best asset selection for this investor?",
       "choice_a":"A UIT",
       "choice_b":"A closed end fund",
       "choice_c":"An ETF",
       "choice_d":"An open end fund",
       "correct_answer":"D",
       "explanation":"The only investment that would allow the investor to move money between portfolios at the NAV would be the open end mutual fund. A closed end fund and an ETF can trade at, above or below the NAV. Therefore, these choices are eliminated. A UIT is not the correct choice because UITs usually have portfolios that are either fixed or that invest in specific funds as part of a variable product. "
    },
    {
       "id":19352,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A prominent financial services executive retires from his position at a large financial services firm. 6 months after retiring he is asked to serve as a member of the board of directors for a mutual fund company. He is interested in serving but also wants to enjoy his retirement and wants to know what the minimum term he must serve is. His advisor should tell him.",
       "choice_a":"2 years",
       "choice_b":"3 years",
       "choice_c":"1 year",
       "choice_d":"You may serve as long or as short a term as you would like",
       "correct_answer":"C",
       "explanation":"A member of the board for a mutual fund company must serve a minimum term of 1 year."
    },
    {
       "id":19365,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A member of the board for a mutual fund company may serve for a maximum of how many years without being reelected?",
       "choice_a":"1 year",
       "choice_b":"3 years",
       "choice_c":"5 years",
       "choice_d":"10 years",
       "correct_answer":"C",
       "explanation":"A member of the board for a mutual fund company may serve for a maximum of 5 years without being reelected by the shareholders"
    },
    {
       "id":19381,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Sales Co broker dealer is acting as the principal underwriter for GTY mutual fund. Sales Co enters into a selling agreement with RKL broker dealer that will allow RKL Broker Dealer to:",
       "choice_a":"Act as a broker when executing orders for the GTY portfolio",
       "choice_b":"Act as an adviser for GTY portfolio",
       "choice_c":"Purchase shares of GTY at  a discount from POP and immediately resell them at the POP",
       "choice_d":"Purchase share of GTY at a discount from POP in order to fill  bonafide   customer orders that it anticipates receiving",
       "correct_answer":"C",
       "explanation":"A selling agreement allows a broker dealer who is a selling group member to purchase shares of the mutual fund at a discount from the POP to fill customer orders that it already has by selling the shares immediately to those customers at the POP. "
    },
    {
       "id":19383,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Sales Co broker dealer is acting as the principal underwriter for GTY mutual fund. Sales Co enters into a selling agreement with RKL Broker dealer that allows RKL to distribute GTY mutual fund shares and to receive part of the selling concession for sales to its clients. RKL broker dealer would be required to return any sales concession received for sales of mutual fund shares which are redeemed within: ",
       "choice_a":"3 days",
       "choice_b":"5 days",
       "choice_c":"7 days",
       "choice_d":"10 days",
       "correct_answer":"C",
       "explanation":"RKL broker dealer would be required to return any sales concession received for sales of mutual fund shares which are redeemed within 7 days of purchase by the customer. "
    },
    {
       "id":36998,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A principal who has been reviewing the activity in a customer\u0027s account has noticed that the customer liquidated his portfolio in High Growth Fund Company and reinvested those proceeds in a conservative portfolio offered by Rock Solid Income Fund company. Which of the following choices would the principal be most concerned with?",
       "choice_a":"Whether or not the investor\u0027s investment objective has changed",
       "choice_b":"The income portfolio might be too conservative for this investor",
       "choice_c":"The risk of loss to the income portfolio in the event interest rates rise",
       "choice_d":"The fact that the investor switched fund companies",
       "correct_answer":"D",
       "explanation":"A principal would be most concerned with the fact that the customer switched fund companies. When an investor wishes to move money between portfolios or should the investor\u0027s investment objective change, a registered rep should ensure that the money stays with the same fund company. A principal would be most concerned with the fact that the customer switched fund companies. When an investor wishes to move money between portfolios or should the investor\u0027s investment objective change, a registered rep should ensure that the money stays with the same fund com"
    },
    {
       "id":36995,
       "practice_test_id":"",
       "topic_id":6,
       "question":"You have a client who wants to use mutual funds to time the market. He feels that he can move his money between sectors and in and out of the market to maximize returns. Which fund class would be best suited for this investor?",
       "choice_a":"A shares",
       "choice_b":"B shares",
       "choice_c":"C shares",
       "choice_d":"D shares",
       "correct_answer":"C",
       "explanation":"While mutual funds are not seen as short term trading vehicles, for an investor who is going to actively move money between funds and in and out of the market a C share would be the most suitable. A C share charges a level load based on the value of the share. A shares charge a front end load, B shares charge a back end load and D shares charge a level load and a back end load."
    },
    {
       "id":37021,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An Investor who is concerned about the tax implications of owning an open-end mutual fund Is looking for the value of his holdings to increase over time. This investor would be best suited for which of the following funds?",
       "choice_a":"A municipal bond Fund",
       "choice_b":"An equity fund with a low turnover ratio",
       "choice_c":"A balanced mutual fund",
       "choice_d":"An equity fund with a low expense ratio",
       "correct_answer":"B",
       "explanation":"The investor has a growth objective, therefore the municipal bond fund is out automatically. Of the remaining funds, the equity fund with a low turnover ratio would be best suited for this investor as the question clearly states that the investor is concerned about the tax implications of owning open-end mutual funds. An open-end mutual fund with a low turnover ratio tends to hold the securities in the portfolio for a long period of time thus reducing the taxable events to the investor."
    },
    {
       "id":5901,
       "practice_test_id":"",
       "topic_id":7,
       "question":"A firm participating in the offering of a private placement may offer the private placement to:",
       "choice_a":"No more than 12 non accredited investors in any 12 month period.",
       "choice_b":"No more than 6 non accredited investors in any 12 month period.",
       "choice_c":"no more than 35 non accredited investors in any 12 month period.",
       "choice_d":"No more than 15 non accredited investors in any 12 month period.",
       "correct_answer":"C",
       "explanation":"The number of non accredited investors is limited to 35  in any 12 month period."
    },
    {
       "id":5902,
       "practice_test_id":"",
       "topic_id":7,
       "question":"What is an investment banker\u0027s primary function?",
       "choice_a":"To furnish investment information to banks",
       "choice_b":"To finance new stock offerings",
       "choice_c":"To assist corporations in obtaining money for long-term use",
       "choice_d":"To purchase unexercised stock rights",
       "correct_answer":"C",
       "explanation":"The main function of an investment bank is to help corporations obtain long term financing."
    },
    {
       "id":5903,
       "practice_test_id":"",
       "topic_id":7,
       "question":"Which of the following is not a type of underwriting distribution?",
       "choice_a":"Institutional distribution",
       "choice_b":"Combined distribution",
       "choice_c":"Primary distribution",
       "choice_d":"Secondary distribution",
       "correct_answer":"A",
       "explanation":"An institutional distribution is not a type of underwriting"
    },
    {
       "id":5904,
       "practice_test_id":"",
       "topic_id":7,
       "question":"XYZ Corporation has issued rights to subscribe to additional shares of its stock. The market price of XYZ Corporation is $70 per share and the subscription price is $55 per share. Five rights are required to subscribe to one new share of stock. The value of the rights when they are selling ex-rights is:",
       "choice_a":"$2.00",
       "choice_b":"$2.50",
       "choice_c":"$3.00",
       "choice_d":"$3.50",
       "correct_answer":"C",
       "explanation":"The stock is trading ex rights so the value of the right equals:<br>Market price - Subscription price / number of rights required to purchase one share. In this case:<br>70-55 = 15. 15/5 rights required to purchase 1 share = 3"
    },
    {
       "id":5905,
       "practice_test_id":1,
       "topic_id":7,
       "question":"A corporation is making a public offering of one million shares and has designated that 200,000 shares be directed to employees of the company. What will the total amount of shares outstanding be as a result of this offering?",
       "choice_a":"200,000.00",
       "choice_b":"800,000.00",
       "choice_c":"1,000,000.00",
       "choice_d":"1,200,000.00",
       "correct_answer":"C",
       "explanation":"1,000,000 shares will be outstanding as a result of the offering. Stock purchased by employees is still outstanding stock"
    },
    {
       "id":5906,
       "practice_test_id":2,
       "topic_id":7,
       "question":"All of the following are required to be included in a preliminary prospectus, according the Federal Acts, except:",
       "choice_a":"A written statement in red on the left border of a preliminary prospectus (red herring) that says that the prospectus may be subject to changes.",
       "choice_b":"The purpose for which the funds that are being raised will be used.",
       "choice_c":"The final offering price.",
       "choice_d":"The financial status and history of the company.",
       "correct_answer":"C",
       "explanation":"The final offering price is not in the preliminary prospectus"
    },
    {
       "id":5907,
       "practice_test_id":3,
       "topic_id":7,
       "question":"All of the following take place during the cooling-off period, except: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The due diligence meeting. </li><li>The issuance of a red herring. </li><li>Stabilization of the issue. </li><li>\u0027Blue-skying\u0027 of the issue.</li></ol>",
       "choice_a":"I only.",
       "choice_b":"I and II only.",
       "choice_c":"III only.",
       "choice_d":"II only.",
       "correct_answer":"C",
       "explanation":"An issue is not stabilized until it is trading in the secondary market."
    },
    {
       "id":5908,
       "practice_test_id":4,
       "topic_id":7,
       "question":"The price at which a new issue of corporate stock will be sold to the public will usually be determined by all of the following, except:",
       "choice_a":"The earnings history of the company.",
       "choice_b":"The past dividend payment record of the company.",
       "choice_c":"A comparison with other corporations in the same industry.",
       "choice_d":"The selling group\u0027s decision as to what the offering price should be.",
       "correct_answer":"D",
       "explanation":"The selling group does not determine the price at which the securities will be sold. They are only allowed to sell the security that is being offered."
    },
    {
       "id":5909,
       "practice_test_id":5,
       "topic_id":7,
       "question":"In an underwriting of a new issue by a syndicate, which of the following is true?",
       "choice_a":"The underwriting spread is larger than the selling concession.",
       "choice_b":"The selling concession is larger than the underwriting spread.",
       "choice_c":"The reallowance is larger than the underwriting spread.",
       "choice_d":"The reallowance is larger than the selling concession.",
       "correct_answer":"A",
       "explanation":"The underwriting spread is larger than the selling concession. The underwriting spread contains the selling concession."
    },
    {
       "id":5910,
       "practice_test_id":6,
       "topic_id":7,
       "question":"In a combined offering who receives the proceeds of the sale?",
       "choice_a":"The issuer",
       "choice_b":"A selling group of stockholders",
       "choice_c":"The issuer and a selling group of stockholders",
       "choice_d":"The issuer and investors who have exercised their rights.",
       "correct_answer":"C",
       "explanation":"In a combined offering the issuing corporation and a selling group of stockholders receive the proceeds from the sale."
    },
    {
       "id":5911,
       "practice_test_id":"",
       "topic_id":7,
       "question":"The SEC rule covering the sale of restricted securities by an officer of a corporation is:",
       "choice_a":144,
       "choice_b":146,
       "choice_c":147,
       "choice_d":"15c3-3.",
       "correct_answer":"A",
       "explanation":"Rule 144 covers the sale of restricted securities by an officer of the issuer."
    },
    {
       "id":5912,
       "practice_test_id":"",
       "topic_id":7,
       "question":"A Tier 2 Regulation A offering pertains to:",
       "choice_a":"An intrastate offering of securities",
       "choice_b":"An offering of bonds",
       "choice_c":"An offering of $50,000,000 or less",
       "choice_d":"An offering of $30,000,000 or less",
       "correct_answer":"C",
       "explanation":"A Tier 2 regulation A offering covers an offering of $50,000,000 or less in a 12 month period"
    },
    {
       "id":5913,
       "practice_test_id":6,
       "topic_id":7,
       "question":"For an insider to sell unregistered stock under an exemption from registration with the SEC, a \u0022Form 144 Notice of Offering\u0022, which contains certain information must be filed with the SEC. The insider can sell securities during the period of time in which the 144 Notice of Offering is effective, which is:",
       "choice_a":"60 days.",
       "choice_b":"6 months.",
       "choice_c":"90 days.",
       "choice_d":"One year.",
       "correct_answer":"C",
       "explanation":"An insider may sell securities under rule 144 for 90 days."
    },
    {
       "id":5914,
       "practice_test_id":"",
       "topic_id":7,
       "question":"Which of the following would be nonexempt securities, according to the Securities Act of 1933?",
       "choice_a":"U.S. Government and municipal securities.",
       "choice_b":"Securities of a publicly held finance company.",
       "choice_c":"Securities of a small business investment company.",
       "choice_d":"Securities of a nonprofit benevolent association.",
       "correct_answer":"B",
       "explanation":"The publicly held finance company would most likely be non exempt and would be required to register under The Securities Act of 1933. "
    },
    {
       "id":5915,
       "practice_test_id":"",
       "topic_id":7,
       "question":"After the closing date of the syndicate, a broker/dealer must wait how many days before extending credit on a new issue if the broker/dealer has participated in the distribution of that issue?",
       "choice_a":120,
       "choice_b":60,
       "choice_c":45,
       "choice_d":30,
       "correct_answer":"D",
       "explanation":"Credit may not be extended on new issues for 30 days"
    },
    {
       "id":5916,
       "practice_test_id":"",
       "topic_id":7,
       "question":"When an issuer is in the process of raising additional capital they can do a preemptive rights offering. The advantages to the company\u0027s existing shareholders include all of the following except:",
       "choice_a":"Right to buy new shares below the CMV",
       "choice_b":"Right to sell existing shares back to the issuer",
       "choice_c":"Right to sell the rights in the secondary market",
       "choice_d":"Right to maintain a proportional investment in the company",
       "correct_answer":"B",
       "explanation":"Subscription or preemptive rights are a way for the issuer to raise new capital from existing shareholders."
    },
    {
       "id":5917,
       "practice_test_id":6,
       "topic_id":7,
       "question":"When an issuer is applying for listing on the NASDAQ all of the following are considered except:",
       "choice_a":"Price",
       "choice_b":"Total assets",
       "choice_c":"Debt to equity ratio",
       "choice_d":"Public float",
       "correct_answer":"C",
       "explanation":"All of the items are criteria for listing on the NASDAQ except the debt to equity ratio."
    },
    {
       "id":5918,
       "practice_test_id":"",
       "topic_id":7,
       "question":"XYZ is a publicly traded company seeking additional capital to fund an expansion of its production facilities. Which of the following would be a suitable way for the company to sell equity to a venture capital firm?",
       "choice_a":"Regulation S offering",
       "choice_b":"Best effort underwriting",
       "choice_c":"A PIPE transaction",
       "choice_d":"A firm commitment underwriting",
       "correct_answer":"C",
       "explanation":"Since XYZ is a publicly traded company wanting to raise new capital through the sale of equity to one firm a PIPE transaction would be the most suitable way to sell the securities. A PIPE transaction is a private investment in a public equity. In This case XYZ, a publicly traded company, will sell XYZ stock to the venture capital firm through a private placement."
    },
    {
       "id":5919,
       "practice_test_id":"",
       "topic_id":7,
       "question":"All of the following are features of a PIPE transaction except:",
       "choice_a":"Full Disclosure of the proposed transaction to shareholders prior to completion",
       "choice_b":"Reduced transaction costs",
       "choice_c":"Quick closing",
       "choice_d":"Increased institutional ownership",
       "correct_answer":"A",
       "explanation":"The details of any proposed PIPE transaction are not disclosed to shareholders prior to the completion of the transaction. Details are only disclosed upon the completion of the transaction. PIPE transactions provide companies with the ability to raise capital more quickly and with lower costs than a traditional offering."
    },
    {
       "id":5920,
       "practice_test_id":"",
       "topic_id":7,
       "question":"ABC Tool Co. an aerospace manufacturer is coming public next week. There is a lot of interest in the shares as the company is one of the leaders in the field. Which of the following could purchase shares of ABC during the offering?",
       "choice_a":"The manager of an ERISA regulated pension plan for the benefit of the plan members",
       "choice_b":"A principal of the broker dealer buying the shares in the firm\u0027s trading account to fill customer orders in the secondary market",
       "choice_c":"An agent of the broker dealer who is allowed to purchase 500 shares as a bonus",
       "choice_d":"The son of the broker dealer\u0027s partner",
       "correct_answer":"A",
       "explanation":"Of the choices listed only the manager of the ERISA pension plan may buy the shares for the benefit of the plan members.  Employees of broker dealers and their immediate family are restricted from purchasing shares in the offering."
    },
    {
       "id":5921,
       "practice_test_id":"",
       "topic_id":7,
       "question":"ABC International is a publicly traded company seeking to raise additional capital through a PIPE transaction with several institutional investors. Which of the following securities may be offered by ABC to the investors in the PIPE transaction? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Warrants  </li><li>Rights  </li><li>Convertible debt </li><li>Non convertible debt</li></ol>",
       "choice_a":"III only",
       "choice_b":"IV only",
       "choice_c":"III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"All of the securities listed may be sold to institutional investors through a PIPE transaction."
    },
    {
       "id":37007,
       "practice_test_id":6,
       "topic_id":7,
       "question":"Jill is a registered representative working at New York Stock Exchange member broker-dealer. Jill\u0027s firm is participating in a firm commitment underwriting of a new issue for XYZ Technologies. Jill sends her customer a preliminary prospectus regarding the offering. the customer phones in and says he\u0027s interested in buying 500 shares. Prior to the effective date the customer sends in a check to pay for the 500 shares. Which of the following actions should Jill take?",
       "choice_a":"Jill should promptly forward the check to the cashiering department for deposit into the customer\u0027s account to ensure the funds have cleared for payment of the  shares",
       "choice_b":"Jill should promptly forward the check to the syndicate department for deposit  to ensure the customer\u0027s interest is recorded",
       "choice_c":"Jill should promptly forward the check to the escrow department for deposit to ensure the customer\u0027s fund\u0027s are available to purchase the shares",
       "choice_d":"Jill should promptly return the check to the customer to ensure compliance with new issue regulations",
       "correct_answer":"D",
       "explanation":"During the cooling off period a registered rep may not promise shares to customers nor may they accept checks for payment for shares. Therefore, the check should be promptly returned to the customer."
    },
    {
       "id":24675,
       "practice_test_id":"",
       "topic_id":7,
       "question":"New Growth Broker Dealers is underwriting KLM Techno, Inc. A new offering coming to market to be listed on the NASDAQ. The firm and its agents are excited about the prospects for the company. To gauge the demand for the shares, the firm would send:",
       "choice_a":"a red herring",
       "choice_b":"an offering circular",
       "choice_c":"a final prospectus",
       "choice_d":"a research report",
       "correct_answer":"A",
       "explanation":"To determine the level of interest in a new issue the firm would send out a red herring also known as a preliminary prospectus. The preliminary prospectus must be sent in hard copy. "
    },
    {
       "id":20917,
       "practice_test_id":"",
       "topic_id":7,
       "question":"ABC Micro has just gone public and has offered 10,000,000 common shares with a par value of $1. The IPO price was $20 per share. The difference between the par value and the IPO price would best be described as:",
       "choice_a":"A premium",
       "choice_b":"Additional paid in capital",
       "choice_c":"Capital premium",
       "choice_d":"Proceeds to issuer",
       "correct_answer":"B",
       "explanation":"The amount by which the offering price of common shares exceeds the par value is known as additional paid in capital. The total par value along with the additional paid in capital are entered on the company\u0027s balance sheet as part of stockholders equity."
    },
    {
       "id":20920,
       "practice_test_id":"",
       "topic_id":7,
       "question":"An agent at XYZ Broker Dealers, receives a call from an investment advisory client inquiring about Super Chips Inc., a computer chip company that XYZ is taking public next week. The advisor wants to purchase 500 shares of the offering for one of his clients. The interest in Super Chips is strong and the common stock is expected to open at a premium when trading begins. Which of the following is true?",
       "choice_a":"The advisor may not purchase the shares Super Chips for the client",
       "choice_b":"The agent must speak to the client and get the client\u0027s authorization to purchase Super Chips",
       "choice_c":"The agent must speak to the client to ensure that the client is not a restricted person",
       "choice_d":"The agent must obtain a representation by the advisor that the client is not a restricted person",
       "correct_answer":"D",
       "explanation":"When a third party with discretionary authority over a client\u0027s account wishes to purchase shares of a new issue on behalf of that client, the third party must provide a representation that the client is not a restricted person. In this case, it is the responsibility of the advisor placing the order."
    },
    {
       "id":19332,
       "practice_test_id":"",
       "topic_id":7,
       "question":"XYA, a manufacturer of computer circuit boards, has $50,000,000 worth of subordinated debentures outstanding. Each debenture carries an interest rate of 6.5% and has warrants attached to the debenture to purchase 5 shares of XYA at $25 per share. XYA\u0027s stock is trading in the marketplace at $28 per share and the warrants are about to expire. The company would expect to receive proceeds of:",
       "choice_a":"$5,000,000",
       "choice_b":"$7,500,000",
       "choice_c":"$6,250,000",
       "choice_d":"$7,000,000",
       "correct_answer":"C",
       "explanation":"There are 50,000 $1,000 par bonds (50,000,000 / 1000) outstanding each bond has warrants attached to purchase 5 shares of stock at $25 per share. The company would expect that all of the warrants will be exercised as the warrants are in the money and about to expire. As a result the company would expect to issue 250,000 new shares at $25 and receive proceeds of $6,250,000."
    },
    {
       "id":19333,
       "practice_test_id":"",
       "topic_id":7,
       "question":"XYA, a manufacturer of computer circuit boards, has $50,000,000 worth of subordinated debentures outstanding. Each debenture carries an interest rate of 6.5% and has warrants attached to the debenture to purchase 5 shares of XYA at $25 per share. XYA\u0027s stock is trading in the marketplace at $28 per share and the warrants are about to expire. How many new shares can XYA reasonably expect to issue?",
       "choice_a":"50,000",
       "choice_b":"250,000",
       "choice_c":"500,000",
       "choice_d":"25,000",
       "correct_answer":"B",
       "explanation":"There are 50,000 $1,000 par bonds (50,000,000 / 1000) outstanding each bond has warrants attached to purchase 5 shares of stock at $25 per share. The company would expect that all of the warrants will be exercised as the warrants are in the money and about to expire. As a result the company would expect to issue 250,000 new shares."
    },
    {
       "id":19353,
       "practice_test_id":"",
       "topic_id":7,
       "question":"An investor in Colorado purchases securities as part of a Rule 147 offering. When may the investor sell the securities to a resident of Texas?",
       "choice_a":"6 months from the date he paid for the trade",
       "choice_b":"6 months from the date he purchased the securities",
       "choice_c":"6 months from the date he received his certificate",
       "choice_d":"6 months from the date the offering was completed",
       "correct_answer":"D",
       "explanation":"An investor who purchases securities as part of a Rule 147 may sell the securities to a resident of another state 6 months from the date the offering was completed."
    },
    {
       "id":19357,
       "practice_test_id":6,
       "topic_id":7,
       "question":"A large multinational corporation is selling a new issue of securities to investors in Europe. Which of the following is true?",
       "choice_a":"The securities must be registered with The SEC",
       "choice_b":"The securities must be an offering of debt only",
       "choice_c":"This is an exempt transaction and the securities need not register with The SEC",
       "choice_d":"Prior to offering the securities for sale FINRA\u0027s corporate finance department must issue an exemption",
       "correct_answer":"C",
       "explanation":"The issuer is selling securities in a foreign country to non US residents as such this is an exempt transaction and the securities do not need to be registered with The SEC. "
    },
    {
       "id":19368,
       "practice_test_id":"",
       "topic_id":7,
       "question":"All of the following would require the approval of stockholders pursuant to SEC Rule 145 except: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>New shares are issued under the terms of a 3:1 stock split </li><li>XYZ exchanges its shares for all shares of ABC </li><li>TRY offers its shares in exchange for the assets of another company </li><li>A change in the par value of stock after a stock split </li></ol>",
       "choice_a":"I only",
       "choice_b":"II and III",
       "choice_c":"I and IV",
       "choice_d":"II only",
       "correct_answer":"C",
       "explanation":"SEC Rule 145 regulates certain merger, acquisition and reorganization of securities as well as the exchange of corporate assets for securities. While stockholders do vote on stock splits it is not under SEC Rule 415."
    },
    {
       "id":20260,
       "practice_test_id":"",
       "topic_id":7,
       "question":"The rules governing the issuing of corporate securities to the public are covered under which act?",
       "choice_a":"Act of 1929",
       "choice_b":"Act of 1933",
       "choice_c":"Act of 1934",
       "choice_d":"Act of 1935",
       "correct_answer":"B",
       "explanation":"The Act of 1933 was the first legislation Congress passed to address the regulation of the securities markets; and it dealt with the primary, or new issue, market. The Act of 1934 dealt with the secondary market places and the Act of 1935 regulated public utility holding companies."
    },
    {
       "id":20262,
       "practice_test_id":"",
       "topic_id":7,
       "question":"Which of the following is a non-exempt issuer according to the Act of 1933?",
       "choice_a":"ABC, Inc",
       "choice_b":"The State of NY",
       "choice_c":"The City of Miami",
       "choice_d":"The US government",
       "correct_answer":"A",
       "explanation":"In order to become a publicly traded entity a non-exempt security must file a registration statement with the SEC. Most corporate entities are non-exempt. Exempt securities do not need to file with the SEC. Examples of exempt issuers are municipalities and national governments."
    },
    {
       "id":20263,
       "practice_test_id":"",
       "topic_id":7,
       "question":"Which of the following activities may an underwriter engage in during the cooling off period? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Blue Sky the issue  </li><li>Obtain indications of interest </li><li>Send out red herrings</li></ol>",
       "choice_a":"II only",
       "choice_b":"I, II",
       "choice_c":"II, III",
       "choice_d":"I, II, III",
       "correct_answer":"D",
       "explanation":"During the cooling off period an underwriter cannot solicit sales, but they can obtain indications of interest from investors, which will help them gauge the demand for the new issue. Any customer who gives an indication of interest is given a preliminary prospectus, or red herring. The underwriter will also use the time during the cooling off period to register the securities in the states in which they will be sold, otherwise known as Blue Skying the issue."
    },
    {
       "id":20264,
       "practice_test_id":"",
       "topic_id":7,
       "question":"All of the following are true when a customer gives an indication of interest for a new issue of corporate securities except:",
       "choice_a":"The indication is not binding on the customer",
       "choice_b":"The indication is binding on the broker dealer",
       "choice_c":"The customer will receive a preliminary prospectus",
       "choice_d":"The red herring will not contain the price of the securities",
       "correct_answer":"B",
       "explanation":"Indications of interest are not binding on the part of the customer or the broker dealer. They are used solely to help the underwriter determine demand. When a customer gives an indication of interest he will receive a preliminary prospectus (red herring) which will not contain the final offering price. The final price will be stated in the final prospectus."
    },
    {
       "id":20265,
       "practice_test_id":"",
       "topic_id":7,
       "question":"ECS, Inc., a non-exempt issuer, wishes to issue securities to the public for the first time. All of the following statements are true except:",
       "choice_a":"ECS, Inc. must file a registration statement with the SEC",
       "choice_b":"The cooling off period for ECS, Inc. will last a maximum of 20 days",
       "choice_c":"ECS, Inc. securities will have to be registered in the states in which they will be offered",
       "choice_d":"The preliminary prospectus for ECS, Inc. will be given to prospective buyers",
       "correct_answer":"B",
       "explanation":"The cooling off period for a non-exempt security begins when the issuer\u0027s registration statement is filed with the SEC. It is a minimum of 20 days, and could be longer as the SEC deems necessary. During the cooling off period the issuer\u0027s securities are registered in the states they will be offered in (Blue Sky the issue) and the underwriter will garner indications of interest from prospective investors, who will then receive a preliminary prospectus (red herring)."
    },
    {
       "id":20266,
       "practice_test_id":"",
       "topic_id":7,
       "question":"Which of the following are true regarding a final prospectus for a new issue of corporate securities? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> The final prospectus must be delivered to all purchasers  </li><li>If the prospectus is posted on the SEC website it is considered to have been delivered to the purchasers  </li><li>The prospectus will contain the date and price of the offering </li><li>The prospectus will contain the underwriter\u0027s discount</li></ol>",
       "choice_a":"I, III",
       "choice_b":"III, IV",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"A final prospectus contains the date and price of the offering, as well as information regarding how the underwriters are compensated for their services, and must be delivered to all purchasers of a new issue. As per the \u0022access equals delivery\u0022 rule, if the prospectus is posted on the SEC website for inspection it is considered delivered to the customer."
    },
    {
       "id":20267,
       "practice_test_id":"",
       "topic_id":7,
       "question":"When a corporate issuer is granted an effective date by the SEC it means that:",
       "choice_a":"The SEC has approved the securities for sale to the public",
       "choice_b":"The SEC has reviewed the documents and checked for accuracy",
       "choice_c":"The SEC has received the required documentation",
       "choice_d":"The SEC guarantees the integrity of the new issue",
       "correct_answer":"C",
       "explanation":"The SEC disclaimer specifically states that they do not endorse or guarantee anything that relates to the issuer or its securities. When the SEC ends the cooling off period by granting the issuer an effective date it is because they have received all the necessary documentation from the issuer."
    },
    {
       "id":20268,
       "practice_test_id":"",
       "topic_id":7,
       "question":"All of the following statements are true when an issuer runs a tombstone ad except:",
       "choice_a":"The tombstone must be filed with the SEC",
       "choice_b":"The tombstone may run in a National newspaper during the cooling off period",
       "choice_c":"The tombstone will list the names of the underwriters and where to obtain a prospectus",
       "choice_d":"A tombstone is not considered an offer to sell securities",
       "correct_answer":"A",
       "explanation":"Tombstone ads are announcements only and may be run during the cooling off period. The ad contains the names of the underwriters, where to obtain a prospectus and a disclaimer that this is not a solicitation to buy. It does not need to be filed with the SEC."
    },
    {
       "id":20269,
       "practice_test_id":"",
       "topic_id":7,
       "question":"According to FINRA Rule 5130, when a broker dealer is acting as an underwriter for an issuer of securities they must make a bonafide distribution of the securities being offered, and are therefore prohibited from which of the following?",
       "choice_a":"Withholding securities for their own account",
       "choice_b":"Withholding securities for another broker dealer",
       "choice_c":"Withholding securities for the account of a registered representative",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"In making a bonafide distribution of a new issue the underwriter is prohibited from withholding securities for their own account, accounts of other broker dealers or FINRA members, and employees or financially dependent family members of the broker dealer."
    },
    {
       "id":20270,
       "practice_test_id":"",
       "topic_id":7,
       "question":"In an IPO of corporate securities the investment banker is responsible for all of the following except:",
       "choice_a":"Marketing the issuers securities to the public",
       "choice_b":"Establishing the terms of the offering",
       "choice_c":"Buying the securities from the issuer and reselling them to the public",
       "choice_d":"Determining the underwriter\u0027s compensation",
       "correct_answer":"D",
       "explanation":"In an IPO of non-exempt securities the investment banker, or underwriter, is responsible for establishing the terms of the offering and the marketing and selling of the issuer\u0027s securities. The issuer is responsible for determining the duties of the underwriter and how they will be compensated."
    },
    {
       "id":20271,
       "practice_test_id":2,
       "topic_id":7,
       "question":"In an initial offering of non-exempt securities which of the following is the responsibility of the issuer?",
       "choice_a":"Filing a registration statement with the SEC",
       "choice_b":"Marketing the securities to the public",
       "choice_c":"Setting the terms of the offering",
       "choice_d":"Creating and distributing a red herring",
       "correct_answer":"A",
       "explanation":"The issuer is responsible for filing the registration statement with the SEC, registering the securities in the states in which the securities will be offered and determining the underwriters responsibilities and compensation. The underwriter\u0027s duties include setting the terms of the offering, marketing the securities and delivering the red herring."
    },
    {
       "id":20272,
       "practice_test_id":3,
       "topic_id":7,
       "question":"Which of the following is/are true with regard to a hot issue of securities? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> A hot issue trades at an immediate premium to its offering price the first day of trading </li><li>Financially dependent family members of the broker dealer\u0027s employees are prohibited from buying hot issues  </li><li>Broker dealers are prohibited from withholding hot issues for their own accounts  </li><li>Conditional persons who have never purchased a new issue may buy as long as the amount is insubstantial</li></ol>",
       "choice_a":"I, II",
       "choice_b":"I, III",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"A hot issue is a new issue that trades at an immediate premium to its public offering price the first day of trading. Broker dealers, their employees and their financially dependent family members are all prohibited from purchasing hot issues. Conditional persons may be able to purchase a hot issue if they have a history of buying new issues and the amount is not substantial."
    },
    {
       "id":20273,
       "practice_test_id":4,
       "topic_id":7,
       "question":"All of the following are types of underwriting commitments except:",
       "choice_a":"Firm Commitment",
       "choice_b":"Not held Commitment",
       "choice_c":"Mini max commitment",
       "choice_d":"All or none commitment",
       "correct_answer":"B",
       "explanation":"When acting as an underwriter for an issuer the underwriter can give a firm commitment or a best efforts commitment. Both mini max and all or none are types of best efforts commitments. Not held refers to a type of order, not a type of underwriting commitment."
    },
    {
       "id":20274,
       "practice_test_id":5,
       "topic_id":7,
       "question":"All of the following a regulated under the Act of 1933 except:",
       "choice_a":"An initial public offering",
       "choice_b":"A registered secondary offering",
       "choice_c":"An arbitrated offering",
       "choice_d":"A subsequent primary offering",
       "correct_answer":"C",
       "explanation":"The Act of 1933 regulates the primary market. IPOs, registered secondary offerings and subsequent primary offerings are all primary market transactions. There is no arbitrated offering."
    },
    {
       "id":20275,
       "practice_test_id":6,
       "topic_id":7,
       "question":"A broker dealer that is acting as a selling group member in an initial public offering of corporate securities is paid:",
       "choice_a":"The spread",
       "choice_b":"The total takedown",
       "choice_c":"The underwriting fee",
       "choice_d":"The selling concession",
       "correct_answer":"D",
       "explanation":"When acting as a selling group member the broker dealer assumes no management responsibilities and no risk for the unsold securities and therefore is not entitled to the management fee or the underwriting fee."
    },
    {
       "id":20276,
       "practice_test_id":"",
       "topic_id":7,
       "question":"When acting as a syndicate manager in selling a new issue of corporate securities, how will a broker dealer be compensated?",
       "choice_a":"It will be paid a manager\u0027s fee",
       "choice_b":"It will be paid the underwriting fee",
       "choice_c":"It will be paid the selling concession",
       "choice_d":"It will be paid the underwriting spread",
       "correct_answer":"D",
       "explanation":"When acting as a syndicate manager in an offering of corporate securities the broker dealer will be paid the underwriting spread; which includes the manager\u0027s fee, the underwriting fee and the selling concession."
    },
    {
       "id":20277,
       "practice_test_id":"",
       "topic_id":7,
       "question":"In an offering of corporate securities, which of the following factors determine the size of the underwriting spread? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> The number of registered reps the syndicate manager employs  </li><li>The type of securities being offered to the public  </li><li>The demand for the new issue  </li><li>The overall size of the offering</li></ol>",
       "choice_a":"I, III",
       "choice_b":"II, IV",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"The size of the underwriting spread is based on several factors including: the type of securities; the demand for the securities; the size of the offering; the quality of the securities; the quality of the issuer and the type of underwriting agreement the issuer and broker dealer entered into. The number of registered reps employed by the underwriter is not a factor."
    },
    {
       "id":20278,
       "practice_test_id":"",
       "topic_id":7,
       "question":"Which of the following is true with regards to Rule 144?",
       "choice_a":"It allows small businesses to file an abbreviated registration statement with the SEC when issuing securities",
       "choice_b":"It sets limitations on how many shares of control stock can be sold by control persons",
       "choice_c":"It only allows for the sale of private placement shares by accredited investors",
       "choice_d":"It eliminates the need for a cooling off period with SEC",
       "correct_answer":"B",
       "explanation":"Rule 144 determines the procedures and limits for the sale of restricted securities (Reg D securities) and the sale of control stock by control persons. It allows the seller to liquidate either 1% of the outstanding shares or the average of the prior 4 weeks trading volume, whichever is greater, every 90 days."
    },
    {
       "id":20279,
       "practice_test_id":"",
       "topic_id":7,
       "question":"ABC corporation located in Bakersfield, CA, wishes to make an offer of its securities only to the residents of California. Which of the following are true statements? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> ABC can make the securities available through a Rule 147 offering </li><li>ABC will not have to file a standard registration statement with the SEC </li><li>ABC must meet at least 1 of the doing business tests </li><li>Buyers of ABC securities will have a 6 month resale restriction</li></ol>",
       "choice_a":"I only",
       "choice_b":"II, III",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"When offering securities to residents of one state an issuer may do so through a Rule 147 Intrastate Offering. Rule 147 allows the issuer to forego a full SEC registration provided 100% of the investors are residents; the company has the corporate headquarters in the state, and meets at least one of the \u0022doing business\u0022 tests. Furthermore, resident buyers may not resell their securities to non-residents for a period of 6 months."
    },
    {
       "id":21462,
       "practice_test_id":"",
       "topic_id":7,
       "question":"A member firm offering a private placement may allow offering memoranda to be viewed online, if: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The site is available to all investors  </li><li>The visitors are required to submit a questionnaire </li><li>The site has been registered with the SEC as a funding portal </li><li>Access to the pages are protected by passwords</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"A member firm may allow online access to private placement offering memoranda if it requires visitors to fill out and submit a qualification questionnaire. Once the member firm has qualified the investor as accredited or higher, the member may then issue the investor a password to gain access to the offering materials. Access to the material must be protected by a password. "
    },
    {
       "id":21473,
       "practice_test_id":"",
       "topic_id":7,
       "question":"A broker dealer who is underwriting a new equity issue, receives an order to purchase the shares for an unknown client of a bank. Which of the following is true? ",
       "choice_a":"The broker dealer must ascertain the identity of the final purchaser of the security",
       "choice_b":"The broker dealer must open an account for the ultimate purchaser of the security",
       "choice_c":"The broker dealer must reject the order if the bank is not part of the selling group",
       "choice_d":"The broker dealer must receive notification from the banking intermediary that the purchaser is not restricted",
       "correct_answer":"D",
       "explanation":"When a FINRA member receives an order for a new issue from a third party, the broker dealer is required to obtain the assurance from the financial intermediary that the ultimate purchaser of the securities is not restricted from purchasing new issues. The firm does not need to know the identity of the purchaser nor are they required to open an account for the purchaser. "
    },
    {
       "id":21474,
       "practice_test_id":"",
       "topic_id":7,
       "question":"A hedge fund has raised a substantial amount of capital from both restricted and non restricted investors. If the hedge fund receives an allocation of a new issue, under the carve out procedure, what is the maximum amount of the allocation that can be for the benefit of the restricted investors? ",
       "choice_a":"5 percent",
       "choice_b":"3 percent",
       "choice_c":"10 percent",
       "choice_d":"15 percent",
       "correct_answer":"C",
       "explanation":"The carve out procedure states that when a fund has investors who are restricted from purchasing a new issue, the fund may allocate a maximum of 10 percent of their allocation for the benefit of restricted persons. "
    },
    {
       "id":36997,
       "practice_test_id":"",
       "topic_id":7,
       "question":"A client who has just purchased shares pursuant to a regulation A offering must get which of the following?",
       "choice_a":"A prospectus 48 hours prior to the sale",
       "choice_b":"A prospectus within 48 Hours of completion of the transaction",
       "choice_c":"An offering circular within 48 Hours of completion of the transaction",
       "choice_d":"An offering circular 48 hours prior to the sale",
       "correct_answer":"D",
       "explanation":"A client who is purchasing shares under regulation A offering must receive an offering circular 48 hours prior to the sale."
    },
    {
       "id":37008,
       "practice_test_id":"",
       "topic_id":7,
       "question":"A registered representative who is working for a broker-dealer that is part of an underwriting syndicate, has informed one of his clients that Argood Technologies will be coming public in the next few weeks. The registered representative has sent the client a preliminary prospectus in hard copy. After reading the preliminary prospectus, the client likes what he sees and sends the representative a check in order to reserve shares in the upcoming offering. Which of the following is correct?",
       "choice_a":"The representative may deposit the check in the client\u0027s account but may not guarantee the shares",
       "choice_b":"The representative may deposit the check in the client\u0027s account and reserve shares if the allocation remains open",
       "choice_c":"The representative may deposit the check in the client\u0027s account only if the funds are probably swept into a money market fund pending the effective date of the offering",
       "choice_d":"The registered representative should promptly return the check to the customer",
       "correct_answer":"D",
       "explanation":"During the cooling off period a registered representative may not accept checks nor may they promise customers that they will be able to buy shares when the offer is deemed effective. The registered representative should promptly return the check to the customer."
    },
    {
       "id":37009,
       "practice_test_id":"",
       "topic_id":7,
       "question":"A sophisticated individual investor had purchased shares of restricted stock through a private placement 3 weeks ago. Now the investor has the opportunity to sell those shares to a qualified institutional buyer. Which of the following choices is correct?",
       "choice_a":"The shares may be sold without regard to volume limits and the shares will be freely transferable  once acquired  by the qualified institutional buyer",
       "choice_b":"The shares may be sold but are limited to volume limitations of rule 144 and will remain restricted once acquired by the institutional buyer",
       "choice_c":"The shares may not be sold unless the investor has held the shares fully paid for for 6 months",
       "choice_d":"The shares may be sold without regard to any holding period  required under rule 144 and will remain restricted",
       "correct_answer":"D",
       "explanation":"Rule 144a allows for the sale of restricted stock to qualified institutional buyers without regard to any holding. The amount of shares that may be sold to the qualified institutional buyer are not limited under the volume limitations of rule 144. However the shares acquired by the qualified institutional buyer will remain restricted and may not be freely sold"
    },
    {
       "id":5949,
       "practice_test_id":1,
       "topic_id":8,
       "question":"What is the minimum amount of equity that must be in the account to satisfy the NYSE minimum maintenance requirement?",
       "choice_a":"$2,000.00",
       "choice_b":"$3,500.00",
       "choice_c":"$5,500.00",
       "choice_d":"$7,000.00",
       "correct_answer":"A",
       "explanation":"The minimum account requirement established by the NYSE is $2,000"
    },
    {
       "id":5950,
       "practice_test_id":2,
       "topic_id":8,
       "question":"Under Regulation T, credit may be extended on all of the following long positions, except:",
       "choice_a":"Listed stocks.",
       "choice_b":"Listed bonds.",
       "choice_c":"Listed options.",
       "choice_d":"Convertible Bonds selling below par",
       "correct_answer":"C",
       "explanation":"Listed options have no loan value and must be paid for fully."
    },
    {
       "id":5951,
       "practice_test_id":3,
       "topic_id":8,
       "question":"A sale of securities in a long margin account would have all of the following results, except:",
       "choice_a":"The market value of the account will be reduced.",
       "choice_b":"The equity of the account will be increased.",
       "choice_c":"50% of the proceeds of the sale can be added to the SMA account if the account is restricted.",
       "choice_d":"The proceeds of the sale will be credited to the account and the debit balance will be reduced.",
       "correct_answer":"B",
       "explanation":"A sale of securities in a margin account will not cause the equity in the account to increase. All of the other choices listed are true."
    },
    {
       "id":5952,
       "practice_test_id":4,
       "topic_id":8,
       "question":"If a customer wanted to purchase warrants listed on the AMEX trading at $7.40 the  customer would have to deposit what percentage of the warrants value?",
       "choice_a":"25%.",
       "choice_b":"30%.",
       "choice_c":"50%.",
       "choice_d":"100%.",
       "correct_answer":"C",
       "explanation":"Listed warrants can be purchased on margin."
    },
    {
       "id":37344,
       "practice_test_id":5,
       "topic_id":8,
       "question":"A customer purchases 1,000 shares of BCV at $60 on margin with Reg. T at 50%. The stock subsequently falls to $50. After the decline, the new debit balance in the account will be:",
       "choice_a":"$30,000",
       "choice_b":"$20,000",
       "choice_c":"$25,000",
       "choice_d":"$40,000",
       "correct_answer":"A",
       "explanation":"For a long margin account the formula is as follows; LMV (1000 shares at $60 = $60,000) \u2013 Debit (50% x $60,000 = $30,000) = Equity ($30,000). After the price declines to $50 the formula would show as follows; LMV ($50,000) \u2013 Debit ($30,000) = Equity ($20,000). Note that the debit balance represents the amount initially borrowed ($30,000) and that does not change."
    },
    {
       "id":37345,
       "practice_test_id":6,
       "topic_id":8,
       "question":"In his margin account a customer who has made the Reg T deposit, is long 200 shares of GBT at $50. If the stock rises to $55, the new debit balance in the account will be how much?",
       "choice_a":"$5,500",
       "choice_b":"$5,000",
       "choice_c":"$6,000",
       "choice_d":"$4,500",
       "correct_answer":"B",
       "explanation":"For a long margin account the formula is as follows; LMV (200 shares at $50 = $10,000) \u2013 Debit (50% x $10,000 = $5,000) = Equity ($5,000). After the price rises to $55 the formula would show as follows; LMV ($11,000) \u2013 Debit ($5,000) = Equity ($6,000). While the LMV and the EQ in the account have increased, the debit balance represents the amount initially borrowed ($5,000) and that does not change."
    },
    {
       "id":37346,
       "practice_test_id":"",
       "topic_id":8,
       "question":"In a new margin account, a customer buys 1000 TCV at $62 per share and simultaneously buys 1 TCV Mar. 65 put at 2. The debit balance in the account will show as:",
       "choice_a":"$29,000",
       "choice_b":"$32,500",
       "choice_c":"$31,000",
       "choice_d":"$16,250",
       "correct_answer":"C",
       "explanation":"Remember that options must be paid for in full, therefore the put is not marginable. In that light the margin formula for this stock purchase is not impacted by the put purchase. The formula, as always, would be as follows; LMV $62,000 \u2013 DB (50% x $62,000 = $31,000) = EQ $31,000."
    },
    {
       "id":37347,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Assume a long position is held in a margin account. If the position increases in value, all of the following is impacted except?",
       "choice_a":"Excess equity (EE) balance",
       "choice_b":"Equity (EQ) balance",
       "choice_c":"Long market value (LMV) balance",
       "choice_d":"Debit (DB) balance",
       "correct_answer":"D",
       "explanation":"Remember the basic long margin account formula is as follows; LMV \u2013 DB = EQ. If a long position held in a margin account increases in value, the long market value has gone up which increases the equity in the account. The increase in equity will result in excess equity. Therefore, LMV, EQ and EE are all impacted. The only balance not impacted by the increase in the price is the debit balance; the amount initially borrowed."
    },
    {
       "id":37348,
       "practice_test_id":6,
       "topic_id":8,
       "question":"Your customer purchases $30,000 worth of stock in his margin account. He makes the initial Regulation T required deposit. Later, the account is charged with $200 interest on the amount borrowed. Assuming no movement in the price of the stock, the new debit balance is:",
       "choice_a":"$15,200",
       "choice_b":"$2,000",
       "choice_c":"$15,800",
       "choice_d":"$15,000",
       "correct_answer":"A",
       "explanation":"The initial Regulation T requirement is 50% of the long market value (50% x $30,000), therefore the customer deposits $15,000 and is loaned $15,000 (debit balance) for the $30,000 purchase. If the account is charged with $200 interest expense, the new debit balance is $15,200. This is the total amount the customer now owes."
    },
    {
       "id":37349,
       "practice_test_id":"",
       "topic_id":8,
       "question":"An investor shorts 1,000 shares of CHG at 40. After meeting the initial margin requirement, the price of CHG falls to 35. The credit balance in the account is;",
       "choice_a":"$35,000",
       "choice_b":"Unchanged",
       "choice_c":"$55,000",
       "choice_d":"$35,000",
       "correct_answer":"B",
       "explanation":"The initial margin requirement for a $40,000 short sale is $20,000. Therefore, the account shows as follows; $60,000 CR - $40,000 SMV = $20,000 EQ. After the fall in price the account will show as follows; $60,000 CR - $35,000 SMV = $25,000 EQ. Note that the EQ increases by the same amount that the SMV fell. Therefore, it is the CR balance that remains unchanged."
    },
    {
       "id":37350,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Your customer places an order to buy 400 shares of stock at $25 per share, and tells you he will meet the margin call by depositing fully-paid for listed stock he owns currently trading at $10. How many shares of the fully-paid for stock will he need to deposit?",
       "choice_a":400,
       "choice_b":"1,000",
       "choice_c":250,
       "choice_d":100,
       "correct_answer":"B",
       "explanation":"To meet a margin call with marginable stock, an investor must deposit twice the value of the call. Given Reg. T is 50%, the margin deposit required on the $10,000 purchase (400shares at $25) is 50%; $5,000. In order to meet the $5,000 margin call, the customer will need to deposit twice that amount in fully-paid for stock; $10,000. If the stock he intends to deposit is currently trading at $10, he will need to deposit 1000 shares ($10,000 / $10 = 1000 shares)."
    },
    {
       "id":37351,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Your customer fails to meet an initial margin call deposit requirement of $7,250. Your broker-dealer has the authority to meet the call by selling out securities in the customer\u0027s account. In this instance securities valued at what amount must be sold?",
       "choice_a":"$3,625",
       "choice_b":"$21,750",
       "choice_c":"$7,250",
       "choice_d":"$14,500",
       "correct_answer":"D",
       "explanation":"The initially missed margin deposit would equal 50% of the purchase. If the deposit required was $7,250, the purchase would have been for twice that amount; $14,500. Therefore, securities equal to that amount must be sold in order to meet the $7,250 missed deposit."
    },
    {
       "id":37352,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Your customer\u0027s margin account has a long market value of $23,000 and a debit balance of $12,000. Which of the following statements are true?",
       "choice_a":"The account is restricted and in order to withdraw securities from the account the client must make a deposit equal to 50% of the securities\u0027 value.",
       "choice_b":"The account is restricted and in order to withdraw securities from the account the client must make a deposit equal to 100% of the securities\u0027 value.",
       "choice_c":"The account has excess equity and in order to withdraw securities from the account the client must make a deposit equal to 50% of the securities\u0027 value.",
       "choice_d":"The account has excess equity and in order to withdraw securities from the account the client must make a deposit equal to 100% of the securities\u0027 value.",
       "correct_answer":"A",
       "explanation":"The account is restricted by $500 because the equity of $11,000 ($23,000 LMV - $12,000 DB = $11,000 EQ) is less than the Regulation T requirement of 50% of the LMV (50% x $23,000 = $11,500). Because the account is restricted, any withdrawal of securities requires a cash deposit of 50% or a deposit of securities with a loan value of 50% of the value of the securities withdrawn. For example; in order to withdraw securities from the account with a market value of $10,000, the customer would need to deposit 50% of the securities value ($5,000), either in cash or in fully-paid for securities."
    },
    {
       "id":37353,
       "practice_test_id":6,
       "topic_id":8,
       "question":"A client\u0027s margin account shows the following; LMV $42,000, DB $12,000, SMA $9,000. If the stock falls sharply and the LMV falls to $32,000, how much stock can the client purchase utilizing the SMA?",
       "choice_a":"None",
       "choice_b":"Stock with a market value of $4,500",
       "choice_c":"Stock with a market value of $9,000",
       "choice_d":"Stock with a market value of $18,000",
       "correct_answer":"D",
       "explanation":"Remember that SMA is credited whenever an account generates excess equity. While the market can generate excess equity and thus SMA, once credited to SMA the market cannot take SMA away. Given the above, recognize that the subsequent fall in the price of the stock would not have taken or reduced the SMA balance. As it stood, the account generated $9,000 excess equity; LMV $42,000 - DB $12,000 = $30,000 EQ. $21,000 EQ is required (50% x $42,000) but we have $30,000, therefore, $9,000 excess. Excess equity is always credited to SMA which has a buying power of 2X. With $9,000 SMA the customer can purchase stock valued at $18,000."
    },
    {
       "id":37354,
       "practice_test_id":"",
       "topic_id":8,
       "question":"An investor sells securities in a restricted margin account. Which of the following balances in the account will not be impacted?",
       "choice_a":"Equity",
       "choice_b":"Long market value",
       "choice_c":"Debit balance",
       "choice_d":"SMA",
       "correct_answer":"A",
       "explanation":"When securities are sold out of a restricted account, half of the proceeds must be used to reduce the debit balance and the remainder can be credited to SMA making it available for the customer to withdraw if they wish to. Because LMV decreases by the amount of stock sold, and DB decreases by 50% of that amount, the equity remains unchanged."
    },
    {
       "id":37355,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Your customer receives a $5,000 margin maintenance call. To meet the call, he can:",
       "choice_a":"deposit $5,000 in cash, deposit $10,000 in fully paid for securities or sell $10,000 in securities",
       "choice_b":"deposit $5,000 in cash, deposit $5,000 in fully paid for securities or sell $5,000 in securities",
       "choice_c":"deposit $2,500 in cash, deposit $5,000 in fully paid for securities or sell $10,000 in securities",
       "choice_d":"deposit $2,500 in cash, deposit $10,000 in fully paid for securities or sell $5,000 in securities",
       "correct_answer":"A",
       "explanation":"The call can be met by depositing cash, dollar for dollar ($5,000) or by either depositing stock or selling stock in an amount equal to 2x the call ($10,000). Think of it this way, stock is only marginable up to 50% of its value. Either depositing or selling $10,000 in stock would satisfy up to $5,000 in debt."
    },
    {
       "id":37356,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Assume a margin account is not restricted. Which of the following accurately describes the utilization of any balance in the special memorandum account (SMA)?",
       "choice_a":"SMA can be borrowed dollar for dollar or used to purchase stock dollar for dollar, but never used to meet a margin call.",
       "choice_b":"SMA can be borrowed dollar for dollar or used to purchase stock equal to 2x the amount of SMA balance, but never used to meet a margin call.",
       "choice_c":"SMA can be borrowed up to 2x the balance amount or used to purchase stock equal to 2x the amount of the SMA balance, but never used to meet a margin call.",
       "choice_d":"SMA is a credit line solely available for the purpose of meeting margin calls.",
       "correct_answer":"B",
       "explanation":"When generated, SMA is an available line of credit. In a non-restricted account, it can be borrowed dollar for dollar or used to purchase stock up to an amount equal to 2x the SMA balance. EX; with $3,000 SMA, $3,000 can be borrowed, or up to $6,000 in stock can be purchased. Because it is a line of credit, and its use incurs more debt, it cannot be used to pay off debt, such as meeting a margin call."
    },
    {
       "id":37357,
       "practice_test_id":"",
       "topic_id":8,
       "question":"A customer has a margin account with the following balances; LMV $80,000, DB $40,000. The customer then deposits $22,000 worth of fully paid for securities into the account. How will this impact the SMA balance?",
       "choice_a":"SMA increases by $11,000",
       "choice_b":"SMA increases by $22,000",
       "choice_c":"SMA increases by $44,000",
       "choice_d":"SMA remains unchanged",
       "correct_answer":"A",
       "explanation":"The account before the deposit is balanced; LMV $80,000 - DB $40,000 = $40,000 EQ. After the deposit of fully paid for stock valued at $22,000 the account is as follows; LMV $102,000 - DB $40,000 = $62,000 EQ. The Reg. T requirement is 50% of the LMV; 50% x $102,000 = $51,000. Having $62,000 EQ with only $51,000 required, $11,000 of excess equity has been generated. This $11,000 excess equity will be credited to the special memorandum account (SMA)."
    },
    {
       "id":37358,
       "practice_test_id":6,
       "topic_id":8,
       "question":"An investor sells $20,000 worth of stock in a restricted margin account. Which of the following is true?",
       "choice_a":"SMA will be credited by $10,000 and the debit balance will be reduced by $10,000.",
       "choice_b":"SMA will be credited by $5,000 and the debit balance will be reduced by $15,000.",
       "choice_c":"SMA will be debited by $5,000 the debit balance will be increased by $10,000.",
       "choice_d":"SMA will be debited by $10,000 the debit balance will be increased by $10,000.",
       "correct_answer":"A",
       "explanation":"Whenever securities are sold in a restricted account, 50% of the sale proceeds are credited to SMA and 50% of the sale proceeds must be retained in the account to reduce the debit balance. The investor is permitted to withdraw the 50% credited to SMA, the remaining 50% that reduces the debit balance is known as the retention requirement."
    },
    {
       "id":37359,
       "practice_test_id":"",
       "topic_id":8,
       "question":"An investor sells 2,000 shares of RAF short at $50. After meeting the initial margin requirement RAF declines in price to $45 per share. The decline in price will generate SMA in the account of how much?",
       "choice_a":"$20,000",
       "choice_b":"$10,000",
       "choice_c":"$5,000",
       "choice_d":"$15,000",
       "correct_answer":"D",
       "explanation":"The initial margin requirement for a $100,000 short sale is $50,000 (50% x $100,000). Therefore, initially the account appears as follows; $150,000 CR - $100,000 SMV = $50,000 EQ. When the stock drops $5 per share on the 2000 share position, it represents a $10,000 decrease in the SMV from $100,000 to $90,000. The account now appears as follows; CR $150,000 - SMV $90,000 = EQ $60,000. However, with the new short market value of $90,000, the Reg T requirement is only $45,000 (50% x $90,000), giving us excess equity of $15,000 ($60,000 EQ - $45,000 Reg. T requirement = $15,000 Excess Equity). The excess equity is the amount credited to SMA."
    },
    {
       "id":37360,
       "practice_test_id":"",
       "topic_id":8,
       "question":"A customer\u0027s margin account has a current long market value of $6,400 and a debit balance of $2,750. Assuming Reg. T is 50%, how much buying power does the customer currently have in the account?",
       "choice_a":"$0",
       "choice_b":"$2,000",
       "choice_c":"$900",
       "choice_d":"$450",
       "correct_answer":"C",
       "explanation":"The margin accounting for the account is as follows; $6,400 LMV - $2,750 DB = $3,650 EQ. The Reg. T requirement is 50% of the LMV of $6,400; $3,200. Given the account has $3,650 in EQ, but only needs $3,200, it currently has $450 excess equity. This amount is credited to SMA, and SMA always has a buying power of 2x. 2 x $450 SMA gives the customer $900 in buying power. The easiest rule for SMA to remember is; 2X buying power, 1X loan or withdraw power."
    },
    {
       "id":37361,
       "practice_test_id":"",
       "topic_id":8,
       "question":"A margin account shows the following balances; long 200 shares of RIO at 20, and 400 shares of AZB at 10. The debit balance in the account is $5,000. If 200 shares of AZB are sold for $2,000, how much will the credit to SMA be?",
       "choice_a":"$4,000",
       "choice_b":"$0",
       "choice_c":"$2,000",
       "choice_d":"$1,000",
       "correct_answer":"D",
       "explanation":"In this account the total LMV = $4,000 RIO + $4,000 AZB = $8,000. Therefore, the margin accounting is as follows; $8,000 LMV - $5,000 DB = $3,000 EQ. Note that the account is restricted at this time. This is because the Reg. T requirement is 50% x $8,000 or $4,000, but the EQ is only $3,000. Whenever stock is sold in a restricted account, 50% of the sales proceeds are credited to SMA. 50% x $2,000 sold = $1,000."
    },
    {
       "id":37362,
       "practice_test_id":"",
       "topic_id":8,
       "question":"Your client\u0027s margin account shows the following balances; long market value $12,000, debit balance $8,000 and SMA of $2,000. Given these balances, how much can your client withdraw from the account?",
       "choice_a":"$1,000",
       "choice_b":"$0",
       "choice_c":"$2,000",
       "choice_d":"$1,500",
       "correct_answer":"A",
       "explanation":"The margin accounting here is as follows; $12,000 LMV \u2212 $8,000 DB = $4,000 EQ. Given SMA is a line of credit, one of the ways it can be used is to withdraw it in cash. But it may only be withdrawn to the extent that the account would not fall below minimum maintenance EQ requirements. Minimum maintenance is 25% of EQ, therefore for this account $3,000 (25% of $12,000). With a current EQ of $4,000, only $1,000 of the SMA balance may be withdrawn. This keeps the current equity at the minimum required; $3,000."
    },
    {
       "id":37363,
       "practice_test_id":2,
       "topic_id":8,
       "question":"An investor\u0027s margin account shows an SMA balance of $2,500. If she wants to purchase 500 shares of SDF at $30 per share, and Reg. T is 50%, how much must she deposit to complete the purchase?",
       "choice_a":"$0",
       "choice_b":"$2,500",
       "choice_c":"$5,000",
       "choice_d":"$10,000",
       "correct_answer":"C",
       "explanation":"The purchase of 500 shares of SDF at $30 per share amounts to a $15,000 purchase. With Reg. T at 50% this requires a $7,500 deposit. SMA may be used to reduce the required $7,500 deposit dollar for dollar. Using the $2,500 existing SMA the investor would only need to deposit the remainder of the $7,500 required; $5,000."
    },
    {
       "id":24667,
       "practice_test_id":3,
       "topic_id":8,
       "question":"In a new margin account an investor purchases 100 shares of RFG at $45 per share. The investor\u0027s minimum required deposit when Reg T is 50 %, is:",
       "choice_a":"$2,250",
       "choice_b":"$2,000",
       "choice_c":"$1,250",
       "choice_d":"$1,750",
       "correct_answer":"A",
       "explanation":"The investor must deposit $2,250 which is 50 percent of the purchase price since it is greater than the NYSE / FINRA minimum initial requirement of $2,000."
    },
    {
       "id":19364,
       "practice_test_id":4,
       "topic_id":8,
       "question":"A customer meets with his investment representative and decides to open a margin account in addition to the cash investment account he maintains at the firm. In his new margin account he buys 1000 XVD at $44, 300 GTT at $100 and 1000 shares of Grow Fast open end mutual fund at $20. How much must the customer deposit in the account?",
       "choice_a":"$57,000",
       "choice_b":"$47,000",
       "choice_c":"$77,000",
       "choice_d":"$37,000",
       "correct_answer":"A",
       "explanation":"The customer must make the deposit as follows: $22,000 for the 1000 shares of XVD at $44, $15,000 for the 300 GTT at $100 and $20,000 for the 1000 shares of the Grow Fast mutual fund at $20. For a total of $57,000. The customer must pay for the open end mutual fund shares fully. An open end mutual fund is considered to be a new issue and cannot be purchased on margin. However after holding the shares fully paid for for 30 days the shares may be used as collateral to purchase other securities on margin. "
    },
    {
       "id":21452,
       "practice_test_id":5,
       "topic_id":8,
       "question":"An investor who wishes to open a new margin account and sell 1,000 shares of stock short at $2.10, would have a margin requirement when Reg T is 50 percent equal to: ",
       "choice_a":"$1,050",
       "choice_b":"$2,000",
       "choice_c":"$2,500",
       "choice_d":"$2,100",
       "correct_answer":"C",
       "explanation":"An investor selling stock short with a market value of less than $5 per share would be subject to the greater of 100 percent of the market value or $2,500. Since the investor sold $2,100 worth of stock short the margin requirement would be $2,500. "
    },
    {
       "id":21466,
       "practice_test_id":6,
       "topic_id":8,
       "question":"A customer has an established margin account with 5,000 shares of RTY held long and 3,000 shares of JKL held short. Which of the following would not result in an increase in the customer\u0027s SMA? ",
       "choice_a":"RTY increases in price",
       "choice_b":"Interest on credit balance exceeds margin interest",
       "choice_c":"Customer deposits approved OTC securities",
       "choice_d":"JKL pays a dividend",
       "correct_answer":"D",
       "explanation":"When an investor has sold stock short, the investor owes the dividend to the investor whose shares were borrowed. Therefore, when a stock held short pays a dividend the short seller\u0027s account will be debited the amount of the dividend. This will result in a decrease in SMA. All of the other choices would result in an increase in the SMA. "
    },
    {
       "id":25788,
       "practice_test_id":"",
       "topic_id":8,
       "question":"An investor with an open margin account with a long market value of $78,000 and a debit balance of $40,000 deposits fully paid for stock worth $20,000. How much will the investor\u0027s SMA increase?",
       "choice_a":"$20,000",
       "choice_b":"$10,000",
       "choice_c":"$8,000",
       "choice_d":"$9,000",
       "correct_answer":"C",
       "explanation":"The investor has a restricted margin account with equity below 50% of the long market value. The loan value of the $20,000 worth of securities is 50% or $10,000. $2,000 of this amount is used to restore the account to 50% equity. the remaining $8,000 will be credited to the Investor\u0027s SMA."
    },
    {
       "id":6121,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Who enforces MSRB rules upon NYSE member firms?",
       "choice_a":"FINRA",
       "choice_b":"FDIC",
       "choice_c":"MSRB",
       "choice_d":"NYSE",
       "correct_answer":"A",
       "explanation":"For broker-dealers, the rules are enforced only by FINRA and/or the SEC.  Municipal bonds don\u0027t trade on the floor of the NYSE, and the MSRB doesn\u0027t enforce anything.  They make the rules; they don\u0027t enforce them."
    },
    {
       "id":6122,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Your customer is skeptical about purchasing municipal bonds from you.  In order to ease her concerns, you are permitted to offer",
       "choice_a":"the option to put the bonds back to your firm at par",
       "choice_b":"a personal guarantee to repay any losses suffered in the first 30 days",
       "choice_c":"a guarantee from the firm\u0027s duly authorized principal good for 90 days",
       "choice_d":"a guarantee from a 10% owner of the firms\u0027 outstanding shares good for 90 days",
       "correct_answer":"A",
       "explanation":"Only a put option/puttable bond may be used to protect a customer against market loss.  No other types of \u0022guarantees\u0022 allowed."
    },
    {
       "id":6123,
       "practice_test_id":6,
       "topic_id":9,
       "question":"A new customer has failed to provide financial information such as net worth, income, and marginal tax bracket.  However, on the first meeting with you she is driving a Bentley and wearing an expensive mink coat.  Therefore, you should",
       "choice_a":"recommend municipal bonds based on what the MSRB deems \u0022prima facia evidence\u0022",
       "choice_b":"administer the MSRB\u0027s customer suitability in lieu of fact oral exam",
       "choice_c":"administer the MSRB\u0027s customer suitability in lieu of fact written exam",
       "choice_d":"not recommend municipal bonds at this time and discuss the situation with a principal",
       "correct_answer":"D",
       "explanation":"Suitability rules require the firm to gather basic financial information before recommending municipal securities, which are"
    },
    {
       "id":6124,
       "practice_test_id":"",
       "topic_id":9,
       "question":"If a municipal bond issued in bearer form is already in default, good delivery requirements demand that",
       "choice_a":"only the unpaid coupons must be attached",
       "choice_b":"all coupons, including unpaid coupons, must be attached",
       "choice_c":"the buyer\u0027s option agreement satisfies coupon delivery requirement",
       "choice_d":"there are no coupons attached to municipal bonds issued in bearer form",
       "correct_answer":"A",
       "explanation":"Bearer bonds definitely do have coupons attached, and if the bond is in default all unpaid coupons must be attached to meet good delivery requirements."
    },
    {
       "id":6125,
       "practice_test_id":"",
       "topic_id":9,
       "question":"XYZ broker-dealership is a member of FINRA and the MSRB.  XYZ violates one of the bylaws of FINRA and claims that this will have no bearing on the status of their MSRB membership.  In this instance XYZ is",
       "choice_a":"correct, since the SRO\u0027s are separate entities",
       "choice_b":"incorrect, since FINRA rules always take precedence over MSRB rules",
       "choice_c":"correct, since the firm may use its best judgment when involved with what the SEC deems an \u0022untenable conflict of competing regulatory authorities,\u0022 or UCCRA.",
       "choice_d":"incorrect, since MSRB Rule G-5 clearly states that persons involved in the municipal securities business must follow the rules of any SRO to which it/they belong",
       "correct_answer":"D",
       "explanation":"Problems with one SRO can definitely lead to problems with another.  The SRO\u0027s also contact state regulators when firms/associated persons are sanctioned."
    },
    {
       "id":6126,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following is a true statement?",
       "choice_a":"a new municipal sales representative can never continue as an apprentice beyond 90 days",
       "choice_b":"a new apprentice must pass his/her exam within 90 days",
       "choice_c":"a new apprentice must pass his/her exam within 180 days",
       "choice_d":"all persons who provide municipal securities quotes must be licensed",
       "correct_answer":"C",
       "explanation":"The apprenticeship runs a minimum of 90 days.  The rep must pass her license exam within 180 days.  Providing approved quotes to customers does not require a license."
    },
    {
       "id":6127,
       "practice_test_id":"",
       "topic_id":9,
       "question":"What is typically true of the good faith deposit?",
       "choice_a":"it is the amount the issuer returns to the state\u0027s municipal oversight board",
       "choice_b":"it is usually 20% of the issue",
       "choice_c":"it is usually 1-2% of the total par value",
       "choice_d":"it is not returned to the losing syndicates",
       "correct_answer":"C",
       "explanation":"The good faith deposit is usually 1-2% of the total par value of bonds to be offered.  The losing syndicates get their deposit returned, while the issuer keeps the winning syndicate\u0027s deposit, similar to \u0022earnest money\u0022 on a home purchase."
    },
    {
       "id":6128,
       "practice_test_id":1,
       "topic_id":9,
       "question":"All of the following might lower the credit rating on a GO bond except",
       "choice_a":"Unemployment rates are falling",
       "choice_b":"Unemployment rates are rising",
       "choice_c":"Population has decreased",
       "choice_d":"Lack of economic diversity",
       "correct_answer":"A",
       "explanation":"Falling unemployment is a GOOD thing.  It means more of the citizens are working, making money, spending money, buying houses, paying taxes, etc.  More money and jobs are GOOD things for GO credit ratings.  Remember, it\u0027s the community as a whole who pays back the debt service, so we want the community working and making money and buying houses and paying taxes."
    },
    {
       "id":6129,
       "practice_test_id":2,
       "topic_id":9,
       "question":"All of the following might raise the credit rating on a GO bond except",
       "choice_a":"Unemployment rates are falling",
       "choice_b":"Unemployment rates are rising",
       "choice_c":"Population has increased",
       "choice_d":"Economic diversity",
       "correct_answer":"B",
       "explanation":"Rising unemployment is a bad thing.  Means fewer citizens are working, making money, spending money, buying houses, paying property taxes, etc.  Fewer jobs spells trouble for a GO\u0027s credit rating. Remember, it\u0027s the community as a whole who pays back the debt service, so we want the community working and making money and buying houses and paying taxes."
    },
    {
       "id":6130,
       "practice_test_id":3,
       "topic_id":9,
       "question":"What is true of NHA / PHA bonds?",
       "choice_a":"They are issued by the Public Health Association",
       "choice_b":"They are issued by the states of New Hampshire and Pennsylvania",
       "choice_c":"They are called double barreled bonds",
       "choice_d":"They are backed by the federal government",
       "correct_answer":"D",
       "explanation":"A \u0022double-barreled\u0022 bond would be backed by the issuer\u0027s full faith and credit in addition to revenues. For PHA / NHA bonds the federal government backs the bonds in case of a revenue shortfall."
    },
    {
       "id":6131,
       "practice_test_id":4,
       "topic_id":9,
       "question":"One would expect to see a flow of funds statement in the indenture for which of the following?",
       "choice_a":"General Obligation bonds",
       "choice_b":"TAN",
       "choice_c":"PHA",
       "choice_d":"Revenue bonds",
       "correct_answer":"D",
       "explanation":"Revenue bonds build facilities that generate revenue.  The flow of funds statement tells bondholders how revenue will be used to cover the debt service.  GO bonds don\u0027t need a \u0022flow of funds\u0022 statement, because the facility isn\u0027t supporting itself--it\u0027s being supported by tax dollars.  The municipal notes (TAN, RAN, etc.) don\u0027t have flow of funds statements in their indenture for purposes of the test."
    },
    {
       "id":6132,
       "practice_test_id":5,
       "topic_id":9,
       "question":"Your customer is in the 30% marginal tax bracket and sees that a corporate bond offers a 10% yield.  This would be equal to a municipal bond paying",
       "choice_a":"5%",
       "choice_b":"13%",
       "choice_c":"7%",
       "choice_d":"0.70%",
       "correct_answer":"C",
       "explanation":"How much of the 10% would the investor keep on the corporate bond? 70% of it, or 7%."
    },
    {
       "id":6133,
       "practice_test_id":6,
       "topic_id":9,
       "question":"Your customer buys a zero coupon municipal bond on the primary market @500, maturing in 10 years.  After holding the bond for six years, she sells the bond @85, realizing",
       "choice_a":"A gain of $50",
       "choice_b":"no gain or loss",
       "choice_c":"A loss of $50",
       "choice_d":"A capital gains tax plus penalties and interest",
       "correct_answer":"A",
       "explanation":"His principal will be accreted from $500 to $1,000 par over 10 years, or $50 per year.  After 6 years (6 x $50 = $300) add $300 to his cost base to get an adjusted cost base of $800.  If he sells for $850, that\u0027s a $50 capital gain."
    },
    {
       "id":6134,
       "practice_test_id":"",
       "topic_id":9,
       "question":"In a municipal bond mutual fund, what is true of dividend and capital gains distributions?",
       "choice_a":"dividends are taxed at long-term capital gains rates, capital gains distributions are tax-free",
       "choice_b":"dividends and short-term gains are tax-free",
       "choice_c":"dividends and long-term gains are tax-free",
       "choice_d":"dividend distributions are tax-free, capital gains are taxable at capital gains rates",
       "correct_answer":"D",
       "explanation":"The \u0022dividends\u0022 or \u0022income distributions\u0022 made from the mutual fund to the investor come from the tax-free interest payments from the issuers of the municipal bonds to the holders of the bonds--the mutual fund.   Therefore, those distributions are tax-free to the investor."
    },
    {
       "id":6135,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following is probably least important to an investor considering municipal bonds?",
       "choice_a":"income",
       "choice_b":"growth",
       "choice_c":"tax benefits",
       "choice_d":"safety",
       "correct_answer":"B",
       "explanation":"Muni bond investors\u0027 objective is usually income not growth."
    },
    {
       "id":6136,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following usually offer the highest yields?",
       "choice_a":"T-notes",
       "choice_b":"Revenue bonds",
       "choice_c":"T-bonds",
       "choice_d":"GO bonds",
       "correct_answer":"B",
       "explanation":"Since they are not backed by the full taxing authority of the issuer, revenue bonds are less secure than a GO of the same issuer."
    },
    {
       "id":6137,
       "practice_test_id":6,
       "topic_id":9,
       "question":"A registered rep with discretion over an account must contact the customer before purchasing",
       "choice_a":"more than $10,000 of revenue bonds",
       "choice_b":"under $10,000 of revenue bonds",
       "choice_c":"more than $10,000 of moral obligation bonds",
       "choice_d":"bonds where a control relationship exists",
       "correct_answer":"D",
       "explanation":"Normally, a customer in a discretionary account does not need to be notified prior to the execution of a trade.  A control relationship requires disclosure, however."
    },
    {
       "id":6138,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Insurance is often attached to a revenue bond issue because",
       "choice_a":"it is required by federal law",
       "choice_b":"it is required by all state laws",
       "choice_c":"this increases the marketability of the bonds",
       "choice_d":"the MSRB stipulates that all revenue bonds in excess of $5 million be insured",
       "correct_answer":"C",
       "explanation":"An insured revenue bond can be sold at a higher price, which is what the syndicate is hoping to sell all bonds for--a higher price."
    },
    {
       "id":6139,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A \u0022re-allowance\u0022 is:",
       "choice_a":"the difference between the POP and the proceeds paid to the issuer",
       "choice_b":"the largest piece of the underwriting spread",
       "choice_c":"paid to firms not in the syndicate or selling group",
       "choice_d":"no longer allowed by the SEC or MSRB",
       "correct_answer":"C",
       "explanation":"A re-allowance is a sales commission paid to a member firm who is allowed to sell a new issue, but who is not part of the syndicate or the selling group. "
    },
    {
       "id":6140,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following municipalities are most likely coterminous?",
       "choice_a":"city and state governments",
       "choice_b":"city government and large local manufacturing firm",
       "choice_c":"city government and public utility companies covered under the Public Utility Holding  Company Act of 1935",
       "choice_d":"county government and a school district",
       "correct_answer":"D",
       "explanation":"Coterminous issuers have \u0022overlapping debt,\u0022 as their bonds are backed by the same homeowner\u0027s property."
    },
    {
       "id":6141,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Interpolation is",
       "choice_a":"converting yield to price and price to yield",
       "choice_b":"misinterpreting a likely bid",
       "choice_c":"re-interpreting a likely offer",
       "choice_d":"simultaneously selling two inter-related international currencies",
       "correct_answer":"A",
       "explanation":"A highly unlikely--but possible--Series 7 question."
    },
    {
       "id":6142,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following are typical covenants found in a trust indenture for a revenue bond except",
       "choice_a":"rate covenant",
       "choice_b":"debt limit covenant",
       "choice_c":"maintenance covenant",
       "choice_d":"books and records covenant",
       "correct_answer":"B",
       "explanation":"Debt limits are for general obligation bonds."
    },
    {
       "id":6143,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following taxes are used to service revenue bond debt except",
       "choice_a":"liquor taxes",
       "choice_b":"cigarette taxes",
       "choice_c":"ad valorem taxes",
       "choice_d":"business license taxes",
       "correct_answer":"C",
       "explanation":"A \u0022special tax\u0022 is virtually any tax levied by a local government other than ad valorem/property taxes."
    },
    {
       "id":6144,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following are used to service general obligation debt except",
       "choice_a":"marriage licenses",
       "choice_b":"hunting and fishing licenses",
       "choice_c":"driver\u0027s licenses",
       "choice_d":"user fees",
       "correct_answer":"D",
       "explanation":"User fees service revenue bond debt.  For example, tolls collected from users of the tollway service the debt service on the bonds issued to build the tollway."
    },
    {
       "id":6145,
       "practice_test_id":6,
       "topic_id":9,
       "question":"Which of the following is a true statement?",
       "choice_a":"the placement ratio indicates the total par value of municipal bonds sold out of the total par value offered the previous week",
       "choice_b":"the placement ratio indicates how many bids were placed the previous week for general obligation issues",
       "choice_c":"the placement ratio indicates how many bids were accepted for the previous week for both revenue and GO bonds",
       "choice_d":"the visible supply is the number of institutional buyers signed up to receive more than $25,000 par value of a new issue",
       "correct_answer":"A",
       "explanation":"The placement ratio is found in the Daily Bond Buyer, indicating to underwriters how well the market absorbed new offers of municipal bonds the previous week."
    },
    {
       "id":6146,
       "practice_test_id":"",
       "topic_id":9,
       "question":"If a municipal securities dealer gives an \u0022out firm with recall\u0022 quote, this means",
       "choice_a":"the transaction is being offered outside the scope of the dealer\u0027s normal services",
       "choice_b":"the firm quote can be recalled in five minutes",
       "choice_c":"the firm quote can be nullified if demand for the bonds heats up unexpectedly",
       "choice_d":"the quote is firm for a stated time but may be subject to a recall giving the other side minutes to decide if they want to trade at the quoted price",
       "correct_answer":"D",
       "explanation":"This choice defines an \u0022out firm with recall\u0022 quote."
    },
    {
       "id":6147,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following is not a true statement?",
       "choice_a":"the bid price is what a dealer will pay",
       "choice_b":"municipal market makers maintain bid and ask prices valid for one round lot",
       "choice_c":"municipal securities are frequently listed on national exchanges",
       "choice_d":"the offer price is what the buyer pays",
       "correct_answer":"C",
       "explanation":"Muni bonds do not trade on exchanges."
    },
    {
       "id":6148,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A municipal bond delivered without the legal opinion attached",
       "choice_a":"Is automatically considered \u0022not good delivery\u0022",
       "choice_b":"Must be marked \u0022ex-legal\u0022",
       "choice_c":"Is a violation of Rule G-57",
       "choice_d":"Is a criminal offense subject to regulatory fines and proceedings",
       "correct_answer":"B",
       "explanation":"The prefix \u0022ex-\u0022 means \u0022without.\u0022  If the bond has no legal opinion it is \u0022ex\u0022 or \u0022without\u0022 a legal opinion."
    },
    {
       "id":6149,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The fact that states don\u0027t tax the interest on federal government obligations and the federal government, in turn, generally does not tax the interest on state obligations is often referred to as the",
       "choice_a":"anti-reciprocity protocol",
       "choice_b":"doctrine of reciprocal immunity",
       "choice_c":"The Taft Act of 1986",
       "choice_d":"Dominant Domain Reform Act of 1987",
       "correct_answer":"B",
       "explanation":"A Supreme Court decision long ago ruled that the states have no authority to tax the interest paid on US Treasury securities."
    },
    {
       "id":6150,
       "practice_test_id":"",
       "topic_id":9,
       "question":"How often must the holder of a fully registered municipal bond submit coupons for payment?",
       "choice_a":"biannually",
       "choice_b":"semi-annually",
       "choice_c":"annually",
       "choice_d":"none of the choices listed",
       "correct_answer":"D",
       "explanation":"There are no coupons on fully registered bonds.  Coupons were used for bearer and registered as to principal-only bonds."
    },
    {
       "id":6151,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A Morton Township GO bond yields 7.5% while a Port Authority Revenue bond yields 7.9%.  This represents a difference of",
       "choice_a":"400 basis points",
       "choice_b":"basis points",
       "choice_c":"40 basis points",
       "choice_d":"none of the choices listed",
       "correct_answer":"C",
       "explanation":"Forty basis points would be the difference between 7.50% and 7.90%.  Four basis points would be the difference between 7.50% and 7.54%. 400 basis points would be the difference between 7.50% and 11.50%."
    },
    {
       "id":6152,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A municipal bond investor would likely place which of the following investment objectives as her lowest priority?",
       "choice_a":"tax benefits",
       "choice_b":"safety",
       "choice_c":"income",
       "choice_d":"capital appreciation",
       "correct_answer":"D",
       "explanation":"If capital appreciation is the highest priority for an investor, equity/stock would be a more appropriate investment."
    },
    {
       "id":6153,
       "practice_test_id":"",
       "topic_id":9,
       "question":"In a divided account, the unsold bonds are confirmed to",
       "choice_a":"Each syndicate member based on the percentage of the firm\u0027s participation",
       "choice_b":"The syndicate members who failed to sell them",
       "choice_c":"Syndicate members in either a random or FIFO basis",
       "choice_d":"Syndicate members who sold the least amount of bonds",
       "correct_answer":"B",
       "explanation":"In a divided or \u0022western\u0022 account, the only firms who receive unsold bonds are the firms who failed to sell those bonds.  In an undivided or \u0022eastern\u0022 account, each firm must sell their percentage interest in the unsold bonds."
    },
    {
       "id":6154,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Orders credited to a specific member of the underwriting syndicate are called",
       "choice_a":"member orders",
       "choice_b":"designated orders",
       "choice_c":"specified orders",
       "choice_d":"declared orders",
       "correct_answer":"B",
       "explanation":"The customer designates that the order should be credited to a particular firm in the syndicate.  Note that these orders receive a lower priority in the allocation process."
    },
    {
       "id":6155,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The components of the spread and the terms for operation of the syndicate would be explained thoroughly in the",
       "choice_a":"underwriting agreement",
       "choice_b":"legal opinion",
       "choice_c":"official notice of sale",
       "choice_d":"agreement among underwriters",
       "correct_answer":"D",
       "explanation":"The underwriters have to agree to the terms of the underwriting among themselves, which is why the term \u0022agreement among underwriters\u0022 is used."
    },
    {
       "id":6156,
       "practice_test_id":6,
       "topic_id":9,
       "question":"A customer concerned with credit risk would least likely purchase a(an)",
       "choice_a":"T-bond",
       "choice_b":"T-bill",
       "choice_c":"GO bond",
       "choice_d":"IDR",
       "correct_answer":"D",
       "explanation":"An IDR is backed by a particular corporation\u0027s credit--the company leasing the facility from the issuer."
    },
    {
       "id":6157,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Where would a municipal securities underwriter look for the visible supply?",
       "choice_a":"DJIA",
       "choice_b":"The Daily Bond Buyer",
       "choice_c":"S \u0026 P 500",
       "choice_d":"Brown List",
       "correct_answer":"B",
       "explanation":"The Daily Bond Buyer is the trade publication that underwriters consult for important information such as the various bond indices, the placement ratio, visible supply, etc."
    },
    {
       "id":6158,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following represents a quote for a municipal bond with a serial maturity?",
       "choice_a":"6.65% - 6.60%",
       "choice_b":"110 1/8 - 101 7/8",
       "choice_c":"4.70% - 4.75%",
       "choice_d":"98.20 - 98.29",
       "correct_answer":"A",
       "explanation":"For serial bonds, look for yield quotes, not dollar or percentage of par quotes. Serial bonds are quoted based on a yield to maturity. While the bid is higher than the offer on a yield basis, the higher yield represents a lower dollar price. "
    },
    {
       "id":6159,
       "practice_test_id":"",
       "topic_id":9,
       "question":"What is a \u0022bond appraisal?",
       "choice_a":"Credit rating, such as AA+, provided by S\u0026P or Moody\u0027s",
       "choice_b":"Credit rating for a revenue bond only",
       "choice_c":"A firm price that the municipal dealer would pay for the bond",
       "choice_d":"A likely price at which a particular municipal bond would trade",
       "correct_answer":"D",
       "explanation":"A bond appraisal is an estimate of the market value of a particular bond, not a firm bid price."
    },
    {
       "id":6160,
       "practice_test_id":"",
       "topic_id":9,
       "question":"What is true of a trust indenture for a revenue bond?",
       "choice_a":"It contains the flow of funds statement and other covenants",
       "choice_b":"It is required under the Trust Indenture Act of 1933",
       "choice_c":"It is required under the Trust Indenture Act of 1939",
       "choice_d":"It is a requirement for all general obligation bonds issued post-1972",
       "correct_answer":"A",
       "explanation":"The Trust Indenture Act of 1939 covers corporate, not municipal, bonds.  While not a requirement, the indenture generally makes the bonds more marketable to investors."
    },
    {
       "id":6161,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following municipal securities would be quoted in terms of price as a percentage of par?",
       "choice_a":"revenue bonds",
       "choice_b":"general obligation bonds",
       "choice_c":"term bonds",
       "choice_d":"serial bonds",
       "correct_answer":"C",
       "explanation":"Term bonds all have the same yield because they all mature at the same time.   They are, therefore, quoted in terms of dollar price.  The serial maturities have different yields depending on the maturity of the bonds, so they are quoted in terms of yield or \u0022basis."
    },
    {
       "id":6162,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The term used to denote the difference between the amount bid for the issue and the reoffering price is the",
       "choice_a":"reallowance",
       "choice_b":"spread",
       "choice_c":"additional takedown",
       "choice_d":"straddle",
       "correct_answer":"B",
       "explanation":"The spread is the difference between what the underwriters pay the issuer for the bonds and what they sell them to the public for."
    },
    {
       "id":6163,
       "practice_test_id":"",
       "topic_id":9,
       "question":"According to MSRB rules, municipal dealers must do which of the following?",
       "choice_a":"secure the best available price for their retail customers",
       "choice_b":"secure the best available price for all institutional customers",
       "choice_c":"disclose order priority upon customer request",
       "choice_d":"disclose the spread / reoffering yield when reoffering issues",
       "correct_answer":"C",
       "explanation":"Under MSRB Rule G-18 municipal dealers must give clients a \u0022fair and reasonable price,\u0022 not the \u0022best price.\u0022"
    },
    {
       "id":6164,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The MSRB requires that municipal dealers disclose control relationships",
       "choice_a":"to institutional buyers only",
       "choice_b":"to retail customers only",
       "choice_c":"in all customer transactions",
       "choice_d":"none of the above",
       "correct_answer":"C",
       "explanation":"Control relationships must be disclosed."
    },
    {
       "id":6165,
       "practice_test_id":"",
       "topic_id":9,
       "question":"When calculating a capital gain or loss on a municipal bond purchased at a premium, the premium is",
       "choice_a":"multiplied",
       "choice_b":"accreted",
       "choice_c":"disclosed",
       "choice_d":"amortized",
       "correct_answer":"D",
       "explanation":"Premiums are amortized (stepped down); original issue discounts are accreted (stepped up).  In both cases we adjust the price of the bond toward par."
    },
    {
       "id":6166,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following information is provided on a trade confirmation for a municipal bond except",
       "choice_a":"tax-equivalent yield",
       "choice_b":"lower of YTM, YTC",
       "choice_c":"issue date",
       "choice_d":"maturity date",
       "correct_answer":"A",
       "explanation":"Not everyone is in the same tax bracket, and state taxes may also apply, at different rates.  Therefore, it would be unrealistic to calculate tax-equivalent yield on a trade confirmation."
    },
    {
       "id":6167,
       "practice_test_id":1,
       "topic_id":9,
       "question":"Members of the selling group buy bonds from the syndicate at the",
       "choice_a":"par",
       "choice_b":"concession",
       "choice_c":"additional takedown",
       "choice_d":"total takedown",
       "correct_answer":"B",
       "explanation":"The syndicate, literally, concedes this amount of the spread to the selling group members."
    },
    {
       "id":6168,
       "practice_test_id":2,
       "topic_id":9,
       "question":"A municipal securities dealer may do all of the following except",
       "choice_a":"sell bonds to retail customers at a 4% markup",
       "choice_b":"indicate more than one market while participating in a joint account",
       "choice_c":"exceed its participation in a new offering",
       "choice_d":"submit competitive bids in states where the principal(s) reside(s)",
       "correct_answer":"B",
       "explanation":"There is one public offering price (POP) for a new issue--syndicate members may not sell the new offerings at varying prices to different customers."
    },
    {
       "id":6169,
       "practice_test_id":3,
       "topic_id":9,
       "question":"Which of the following terms would not relate to municipal bond underwritings?",
       "choice_a":"standby",
       "choice_b":"firm commitment",
       "choice_c":"negotiated",
       "choice_d":"best efforts",
       "correct_answer":"A",
       "explanation":"A standby underwriting is for a rights offering connected to corporate stock, not municipal bonds."
    },
    {
       "id":6170,
       "practice_test_id":4,
       "topic_id":9,
       "question":"ABC Broker-Dealers has just informed a family of municipal bond mutual funds that the fund should award more trading business to ABC based on the fact that ABC distributed more of the fund\u0027s shares than any other distributor.  This action is",
       "choice_a":"a violation of CBOE rules",
       "choice_b":"prohibited unless approved in advance by a principal",
       "choice_c":"a violation of the MSRB\u0027s anti-reciprocity rule",
       "choice_d":"punishable by up to 25 years in federal prison",
       "correct_answer":"C",
       "explanation":"This would also be a violation of FINRA rules.  Member firms (broker-dealers) cannot tie the sale of mutual fund shares to the amount of trading business the mutual fund will do through the member."
    },
    {
       "id":6171,
       "practice_test_id":5,
       "topic_id":9,
       "question":"Which of the following municipal bonds trading on a 5% basis is least likely to be called?",
       "choice_a":"4.5% nominal yield, callable at 106 in 2013",
       "choice_b":"4.5% nominal yield, callable at 102 in 2013",
       "choice_c":"6% nominal yield, callable at 106 in 2013",
       "choice_d":"6% nominal yield, callable at 102 in 2013",
       "correct_answer":"A",
       "explanation":"Using the bond seesaw, you see that two bonds are trading at discounts, while the other two are trading at premiums.  Call the premium bonds first.  Now, you\u0027re down to the two bonds trading at discounts to par.  One of these bonds costs $1,060 to call, the other just $1,020.  The"
    },
    {
       "id":6172,
       "practice_test_id":6,
       "topic_id":9,
       "question":"Why do some municipalities maintain a debt limit?",
       "choice_a":"to protect residents against excessive taxes",
       "choice_b":"to improve the marketability on revenue bond issues",
       "choice_c":"to set a ceiling on the maximum amount that may be borrowed annually",
       "choice_d":"to satisfy the reporting requirements under the Securities Exchange Act of 1934",
       "correct_answer":"A",
       "explanation":"Taxes pay back the bondholders, so the municipality doesn\u0027t want to issue too many bonds, which would require too many taxes on the residents.  The amount of GO debt they have at any one time is often stipulated by their self-imposed debt limit."
    },
    {
       "id":6173,
       "practice_test_id":"",
       "topic_id":9,
       "question":"If a revenue bond has been pre-refunded, the bond",
       "choice_a":"has been put back to the issuer",
       "choice_b":"has been defeased",
       "choice_c":"carries a lower credit rating",
       "choice_d":"has been redeemed by the issuer",
       "correct_answer":"B",
       "explanation":"To \u0022defease\u0022 means to pay off a loan.  Note that on an UGMA question, the exam might point out that gifts to minors are irrevocable and \u0022indefeasible.\u0022  That means that gifts cannot be taken back (irrevocable) and cannot be treated as loans to be repaid when the child becomes an adult (defeased)."
    },
    {
       "id":6174,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The bid form submitted by a syndicate is",
       "choice_a":"required by the Securities Act of 1933",
       "choice_b":"defined as an uncompleted contract to purchase municipal bonds",
       "choice_c":"also called the \u0022Official Notice of Sale\u0022",
       "choice_d":"often referred to as the \u0022Trust Indenture\u0022",
       "correct_answer":"B",
       "explanation":"The syndicate will bid a certain price for all the bonds--that is an uncompleted contract to purchase the bonds from the issuer."
    },
    {
       "id":6175,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following information is material to the selection of a municipal bond investment except",
       "choice_a":"denominations of the bonds",
       "choice_b":"customer\u0027s state of residence",
       "choice_c":"credit quality",
       "choice_d":"maturities",
       "correct_answer":"A",
       "explanation":"The denominations of municipal bonds are generally either $1,000 par of $5,000 par.  The difference is immaterial to an investor, who will receive a particular rate of interest, regardless of the par value."
    },
    {
       "id":6176,
       "practice_test_id":"",
       "topic_id":9,
       "question":"What is true of a separately identifiable division of a bank that acts as a municipal securities dealer?",
       "choice_a":"it is illegal under FINRA regulations",
       "choice_b":"it is illegal under MSRB regulations",
       "choice_c":"it is often called a \u0022bank dealer\u0022",
       "choice_d":"it is exempt from the Anti-Fraud Provisions of the Act of 1934",
       "correct_answer":"C",
       "explanation":"This is simply MSRB Rule G-1."
    },
    {
       "id":6177,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A confirmation sent to a customer purchasing a new issue of general obligation bonds must disclose which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> current yield </li><li>lower of YTM, YTC </li><li>amount of the spread </li><li>customer\u0027s name and address</li></ol>",
       "choice_a":"I",
       "choice_b":"I, II, III",
       "choice_c":"III, IV",
       "choice_d":"II, IV",
       "correct_answer":"D",
       "explanation":"Current yield does not need to be disclosed on a customer confirmation.  The amount of the spread would only be disclosed on a revenue bond underwritten on a negotiated basis."
    },
    {
       "id":6178,
       "practice_test_id":"",
       "topic_id":9,
       "question":"After completing a secondary market transaction for a customer, a municipal securities dealer must provide all of the following information except",
       "choice_a":"price the firm paid for the bonds",
       "choice_b":"customer\u0027s name and address",
       "choice_c":"firm\u0027s name and address",
       "choice_d":"whether the firm acted as agent or principal",
       "correct_answer":"A",
       "explanation":"This is simply MSRB Rule G-15, which stipulates the required contents of a trade confirmation."
    },
    {
       "id":6179,
       "practice_test_id":"",
       "topic_id":9,
       "question":"In a municipal bond underwriting, the additional takedown + selling concession equals the:",
       "choice_a":"total spread",
       "choice_b":"total takedown",
       "choice_c":"additional takedown",
       "choice_d":"reallowance",
       "correct_answer":"B",
       "explanation":"A member of the syndicate makes the additional takedown for the bonds they\u0027re responsible for and makes the selling concession whenever they sell a bond themselves (as opposed to conceding it to the selling group). Those pieces together are called the total takedown, which is the most that a syndicate member other than the manager can make on any sale of a municipal bond."
    },
    {
       "id":6180,
       "practice_test_id":"",
       "topic_id":9,
       "question":"If a municipal bond offering is oversubscribed, which of the following documents would detail the priority for acceptance of orders?",
       "choice_a":"legal opinion",
       "choice_b":"agreement among underwriters",
       "choice_c":"indenture",
       "choice_d":"bond resolution",
       "correct_answer":"B",
       "explanation":"The underwriters have to come to agreement on this, the spread, the liability for unsold shares, etc.  They come to an agreement among themselves, which is why the industry calls the document the agreement among underwriters."
    },
    {
       "id":6181,
       "practice_test_id":6,
       "topic_id":9,
       "question":"If a customer purchases an OID municipal bond, how will the difference between the purchase and redemption price be treated for tax purposes if held to maturity?",
       "choice_a":"short-term capital gain",
       "choice_b":"long-term capital gain",
       "choice_c":"ordinary income",
       "choice_d":"tax-exempt income",
       "correct_answer":"D",
       "explanation":"For an OID municipal bond, the investor adds the annualized discount to the cost base every year.  Unlike a zero-coupon corporate bond or US Treasury STRIP, there is no interest to report for the discount, since municipal bond interest is tax-free at the federal level.  So, while holders of zero-coupon bonds accrete their cost basis each year, the accretion on a municipal OID is tax-free."
    },
    {
       "id":6182,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A municipal securities dealer is acting as a financial advisor to the city of Flint, Michigan.  If the dealer wants to participate in a competitive, sealed bid underwriting, all of the following must occur except",
       "choice_a":"the dealer must get permission from the issuer to participate in a syndicate",
       "choice_b":"the dealer must disclose the advisory relationship on customer confirmations",
       "choice_c":"the dealer must officially terminate the advisory relationship",
       "choice_d":"the dealer must abide by suitability requirements when recommending the bonds",
       "correct_answer":"C",
       "explanation":"Dealers only have to terminate the advisory relationship if they\u0027re doing a negotiated underwriting, which is for most revenue bonds.  To win a competitive, sealed bid, the syndicate has to turn in the lowest borrowing cost, so there is no conflict of interest."
    },
    {
       "id":6183,
       "practice_test_id":"",
       "topic_id":9,
       "question":"What should a registered representative consider when recommending a municipal bond to a customer?",
       "choice_a":"customer\u0027s state of residence",
       "choice_b":"customer\u0027s risk tolerance",
       "choice_c":"both choices listed",
       "choice_d":"neither choice listed",
       "correct_answer":"C",
       "explanation":"The state of residence is important for tax considerations, and risk tolerance is always a factor when recommending any security."
    },
    {
       "id":6184,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The REVDEX consists of: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> 20 revenue bonds </li><li>25 revenue bonds </li><li>with 20-year maturities </li><li>with 30-year maturities</li></ol>",
       "choice_a":"I, III",
       "choice_b":"I, IV",
       "choice_c":"II, IV",
       "choice_d":"II, III",
       "correct_answer":"C",
       "explanation":"The Revdex is an index of 25 revenue bonds with 30-year maturities."
    },
    {
       "id":6185,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following statements concerning municipal OID\u0027s is/are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>the discount must be accreted </li><li>the discount must be amortized </li><li>if held to maturity, there will be no capital gain or loss</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"II, III",
       "choice_d":"I, III",
       "correct_answer":"D",
       "explanation":"Since the cost basis is accreted up to the par value, there is no capital gain at maturity. The cost base is adjusted up annually and that adjustment is considered to be tax free additional interest to the holder."
    },
    {
       "id":6186,
       "practice_test_id":"",
       "topic_id":9,
       "question":"If your customer is concerned about tax preference items for AMT, you would least likely recommend",
       "choice_a":"school bonds",
       "choice_b":"GO bonds",
       "choice_c":"private purpose bonds",
       "choice_d":"public purpose bonds",
       "correct_answer":"C",
       "explanation":"Private purpose bonds don\u0027t get the favorable tax treatment from the IRS that public purpose/essential/GO bonds receive."
    },
    {
       "id":6187,
       "practice_test_id":"",
       "topic_id":9,
       "question":"What is the difference between NIC and TIC?",
       "choice_a":"TIC is required by the IRS",
       "choice_b":"TIC includes the time value of money",
       "choice_c":"NIC includes the time value of money",
       "choice_d":"TIC produces a lower cost of borrowing",
       "correct_answer":"B",
       "explanation":"TIC-TOC, like a clock.  TIC includes the TIME value of money."
    },
    {
       "id":6188,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following gifts from municipal securities representatives would probably adhere to MSRB rules except",
       "choice_a":"a gift of a single-game box seat ticket to a baseball game to a principal at another firm",
       "choice_b":"a gift of a single-game box seat ticket to a favorite customer",
       "choice_c":"bottle of wine worth $80 per bottle to 50 customers",
       "choice_d":"1 bottle of $500-per-bottle wine to a favorite customer",
       "correct_answer":"D",
       "explanation":"The maximum gift that may be given by a FINRA member or associated person is $100 per person per year.  So, the gift of wine worth $500 to one person would be a violation.  Had the tickets been season tickets, that would have been a violation.  Occasional tickets to sporting events, concerts, plays, etc. are okay.  Season tickets exceed the $100 limit in virtually all cases."
    },
    {
       "id":6189,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Straight-line amortization is used to determine",
       "choice_a":"annual increase in an OID\u0027s cost basis",
       "choice_b":"annual decrease in a premium bond\u0027s cost basis",
       "choice_c":"annual decrease to an OID\u0027s cost basis",
       "choice_d":"annual increase to a premium bond\u0027s cost basis",
       "correct_answer":"B",
       "explanation":"Amortize the premium to reduce the bond\u0027s cost basis--accretion is done for discount (OID) bonds."
    },
    {
       "id":6190,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following information is included in a municipality\u0027s Official Notice of Sale except",
       "choice_a":"agreement among underwriters",
       "choice_b":"dated date",
       "choice_c":"term or serial maturity",
       "choice_d":"name of the bond counsel",
       "correct_answer":"A",
       "explanation":"The Notice of Sale attracts underwriters to bid--the agreement among underwriters would come later and would be agreed to among the underwriters."
    },
    {
       "id":6191,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following eventualities represent reasons to invoke a catastrophic call provision for a municipal bond except",
       "choice_a":"property is condemned",
       "choice_b":"tornado destroys the sports complex",
       "choice_c":"interest rates rise sharply",
       "choice_d":"tax-exempt status is lost",
       "correct_answer":"C",
       "explanation":"If interest rates rise, a put provision/puttable bond would help the investor, but a catastrophic call provision results from the other three choices."
    },
    {
       "id":6192,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A credit analyst would include which of the following when assigning a rating to a municipality\u0027s general obligation bond? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> direct debt </li><li>overlapping debt </li><li>defeased debt</li></ol>",
       "choice_a":"I",
       "choice_b":"I, II",
       "choice_c":"I, II, III",
       "choice_d":"II",
       "correct_answer":"B",
       "explanation":"Defeased debt would be bond issues whose debt service has already been covered by funds locked up temporarily in escrow.  So, if the debt has been covered already, why include it when assigning a credit rating on a totally separate bond issue?"
    },
    {
       "id":6193,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following is/are a true statement(s) concerning callable municipal bonds? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> callable bonds yield less than non-callable </li><li>call premiums tend to increase over time </li><li>call premiums tend to decrease over time </li><li>call prices are stated as a percentage of the market price to be returned to the investor</li></ol>",
       "choice_a":"I only",
       "choice_b":"I, II only",
       "choice_c":"III only",
       "choice_d":"IV only",
       "correct_answer":"C",
       "explanation":"Read the answer choices carefully.  Callable bonds are offered at a higher yield, since the issuer can retire the debt early.  A call price is a percentage of the par value, not the current market price, to be paid to bondholders."
    },
    {
       "id":6194,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Where would the flow of funds statement be found for a revenue bond?",
       "choice_a":"notice of sale",
       "choice_b":"bond resolution",
       "choice_c":"legal opinion",
       "choice_d":"prospectus",
       "correct_answer":"B",
       "explanation":"The bond resolution or indenture contains information such as the flow of funds statement, protective covenants, etc."
    },
    {
       "id":6195,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A municipal securities principal must approve which of the following?",
       "choice_a":"official statements",
       "choice_b":"legal opinions",
       "choice_c":"preliminary official statements",
       "choice_d":"abstracts/summaries of official statements",
       "correct_answer":"D",
       "explanation":"The firm only has to approve the documents created by the firm.  The other three things are either created or obtained by the issuer."
    },
    {
       "id":6196,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which document contains the amount of the takedown and concession?",
       "choice_a":"official statement",
       "choice_b":"syndicate letter",
       "choice_c":"official notice of sale",
       "choice_d":"bond indenture",
       "correct_answer":"B",
       "explanation":"The syndicate letter or \u0022agreement among underwriters\u0022 contains the terms for the syndicate operation.  The amount of money to be made, the liability for unsold bonds, and the order priority are some of the main items detailed in the syndicate letter."
    },
    {
       "id":6197,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A municipal term bond is quoted @ 96 1/8 - 96 5/8, which represents a spread of <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> 500 basis points </li><li>50 basis points </li><li>$50 </li><li>$5</li></ol>",
       "choice_a":"I only",
       "choice_b":"I, III only",
       "choice_c":"II, IV only",
       "choice_d":"II only",
       "correct_answer":"C",
       "explanation":"The difference of 4/8ths is also \u00BD, or $5."
    },
    {
       "id":6198,
       "practice_test_id":6,
       "topic_id":9,
       "question":"Which of the following terms are associated with municipal revenue bonds?",
       "choice_a":"coterminous debt",
       "choice_b":"negotiated underwriting",
       "choice_c":"voter approval by referendum",
       "choice_d":"ad valorem",
       "correct_answer":"B",
       "explanation":"The other three terms are associated with general obligation bonds."
    },
    {
       "id":6199,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A variable-rate municipal bond would most likely",
       "choice_a":"get a higher credit rating",
       "choice_b":"present increased interest rate risk to the investor",
       "choice_c":"present decreased interest rate risk to the investor",
       "choice_d":"receive the SEC\u0027s approval for sale",
       "correct_answer":"C",
       "explanation":"The interest rate paid fluctuates with interest rates, eliminating the risk that rates will rise and leave the investor locked into a fixed rate of interest."
    },
    {
       "id":6200,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following statements concerning municipal securities advertising is true?",
       "choice_a":"official statements must be promptly approved by a municipal securities principal",
       "choice_b":"preliminary official statements must be approved by a municipal securities principal",
       "choice_c":"copies of advertising are filed for three years by a principal",
       "choice_d":"copies of advertising must be filed with the MSRB within 15 days of first use",
       "correct_answer":"C",
       "explanation":"The official and preliminary official statements are prepared by the issuer.  Advertising is filed internally at the firm."
    },
    {
       "id":6201,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Municipal bonds offered in the primary market are currently available in which of the following forms?",
       "choice_a":"bearer",
       "choice_b":"registered as to principal only",
       "choice_c":"both",
       "choice_d":"neither",
       "correct_answer":"D",
       "explanation":"New bond issues come either in book-entry or fully registered form."
    },
    {
       "id":6202,
       "practice_test_id":"",
       "topic_id":9,
       "question":"When an issuer determines the winning bid, which of the following is most significant in determining the winning syndicate?",
       "choice_a":"net interest cost",
       "choice_b":"total spread",
       "choice_c":"re-allowance",
       "choice_d":"concession",
       "correct_answer":"A",
       "explanation":"Borrowers always determine the winning bid in terms of the lowest cost of borrowing--whether it\u0027s a homeowner, a corporation, or"
    },
    {
       "id":6203,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A municipal securities representative may give a gift of $150 to",
       "choice_a":"a customer",
       "choice_b":"a principal at another firm",
       "choice_c":"both",
       "choice_d":"neither",
       "correct_answer":"D",
       "explanation":"The maximum gift is $100."
    },
    {
       "id":6204,
       "practice_test_id":"",
       "topic_id":9,
       "question":"What is the purpose of the fidelity bond required under MSRB rules?",
       "choice_a":"protects against theft/embezzlement of a municipal security",
       "choice_b":"protects customer against sharp market declines",
       "choice_c":"protects customer against sharp upward spikes in interest rates",
       "choice_d":"none of the choices listed",
       "correct_answer":"A",
       "explanation":"Fidelity bonds protect against missing (stolen, lost) assets, not market movements."
    },
    {
       "id":6205,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A municipal securities dealer buys a bond @ 98 3/8 and immediately sells it @99 for a profit of",
       "choice_a":"$5",
       "choice_b":"$5.80",
       "choice_c":"$6.25",
       "choice_d":"$62.50",
       "correct_answer":"C",
       "explanation":"The dealer makes 5/8ths of a bond point, or $6.25 per bond."
    },
    {
       "id":6206,
       "practice_test_id":"",
       "topic_id":9,
       "question":"What is a \u0022workable indication\u0022?",
       "choice_a":"An indication given by the issuer that a particular syndicate is likely to win a competitive sealed bid",
       "choice_b":"Likely prices at which a dealer is willing to trade",
       "choice_c":"A likely re offering yields",
       "choice_d":"None of the choices listed",
       "correct_answer":"B",
       "explanation":"This is not a firm price, but a price that would be \u0022workable.\u0022 for the bonds in question."
    },
    {
       "id":6207,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following bonds is least sensitive to interest rate risk?",
       "choice_a":"puttable bond",
       "choice_b":"non-callable bond",
       "choice_c":"callable bond",
       "choice_d":"zero coupon bond",
       "correct_answer":"A",
       "explanation":"A puttable bond can be sold for a set price when interest rates rise, reducing interest rate risk to the holder."
    },
    {
       "id":6208,
       "practice_test_id":"",
       "topic_id":9,
       "question":"What is true of the official statement? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> its purpose is to attract underwriters interested in bidding on an issue </li><li>if available, must be delivered at or before confirmation of sale </li><li>is required by the SEC for all new issues </li><li>is required by the SEC for most new issues</li></ol>",
       "choice_a":"I only",
       "choice_b":"I, III only",
       "choice_c":"II, III only",
       "choice_d":"II, IV only",
       "correct_answer":"D",
       "explanation":"The official notice of sale (not official statement) is what attracts underwriters."
    },
    {
       "id":6209,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A bond analyst checking a municipal bond will examine: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The past performance of the payment of interest. </li><li>The per-capita income of the citizens.  </li><li>The municipality\u0027s PE ratio.  </li><li>The industrial development of the area.</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"II and III",
       "choice_d":"I, II, IV",
       "correct_answer":"D",
       "explanation":"An analyst looking at a municipal bond would look at all of the items except the PE ratio.  PE ratios are used in analyzing corporations."
    },
    {
       "id":6210,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A bond issued by the US Virgin Islands, and purchased by a resident of Illinois, is exempt from which of the following taxes? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Federal </li><li>State of Illinois </li><li>US Virgin Islands </li><li>City of Chicago</li></ol>",
       "choice_a":"I and III.",
       "choice_b":"I and IV.",
       "choice_c":"I, II and IV.",
       "choice_d":"I, II, III, IV.",
       "correct_answer":"D",
       "explanation":"Interest payments on municipal bonds issued by a territory or a possession of the US are free from federal, state and local taxes."
    },
    {
       "id":6211,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A customer has been holding $ 100,000 worth of municipal bonds in her portfolio.  The bonds pay interest at 4.5% per year.  She is in the 28% bracket and wants to know what her federal tax liability will be.  You should tell her:",
       "choice_a":"$4,500",
       "choice_b":"$2,750",
       "choice_c":"$2,025",
       "choice_d":"$0",
       "correct_answer":"D",
       "explanation":"municipal bond\u0027s interest is free from federal income taxes."
    },
    {
       "id":6212,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A customer in the 30% tax bracket is considering investing in a municipal bond with a current yield of 4%. If they were to consider a corporate bond of equal quality the corporate bond must yield at least:",
       "choice_a":"5.70%",
       "choice_b":"7.80%",
       "choice_c":"9%",
       "choice_d":"4.20%",
       "correct_answer":"A",
       "explanation":"To find the tax equivalent yield use the following:<br />municipal rate / (100% -tax bracket) = 4% / .7= 5.71%"
    },
    {
       "id":6213,
       "practice_test_id":1,
       "topic_id":9,
       "question":"A customer of an MSRB member firm must be allowed to review which of the following upon request? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Trading records  </li><li>Commission runs  </li><li>MSRB Rule Book  </li><li>Compliance manual</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"III only",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"All MSRB member firms must have a copy of the MSRB rule book and it must be made available to customers up request."
    },
    {
       "id":6214,
       "practice_test_id":2,
       "topic_id":9,
       "question":"A customer\u0027s only position in a margin account is $50,000 of 4.75% municipal bonds. What is the net interest income or interest expense that is reportable for Federal tax purposes if the debit balance in the account is $20,000 at 7%?",
       "choice_a":"$0.00",
       "choice_b":"$2,100 expense.",
       "choice_c":"$2,375 income.",
       "choice_d":"$1,400 expense.",
       "correct_answer":"A",
       "explanation":"Interest on municipal bonds is free from federal income taxes."
    },
    {
       "id":6216,
       "practice_test_id":3,
       "topic_id":9,
       "question":"A gross revenue pledge requires which of the following to be paid first from the facilities revenues?",
       "choice_a":"Operational Expenses",
       "choice_b":"Debt Service",
       "choice_c":"Reserve provisions",
       "choice_d":"Sinking fund allocations",
       "correct_answer":"B",
       "explanation":"An issue with a gross revenue pledge requires payment of debt service before operational expenses and maintenance costs. Reserve provisions and sinking fund allocations are only made if there is excess revenue remaining after the bonds are paid on."
    },
    {
       "id":6217,
       "practice_test_id":4,
       "topic_id":9,
       "question":"A new employee of a FINRA member firm must wait how long before dealing with the public.",
       "choice_a":"45 days",
       "choice_b":"30 days",
       "choice_c":"60 days",
       "choice_d":"0 days",
       "correct_answer":"D",
       "explanation":"A new employee of a FINRA member firm may deal with the public immediately upon passing her exam."
    },
    {
       "id":6218,
       "practice_test_id":5,
       "topic_id":9,
       "question":"A notice of sale can be found in the:",
       "choice_a":"Wall Street Journal.",
       "choice_b":"Daily Bond Buyer.",
       "choice_c":"Investor\u0027s Business Daily.",
       "choice_d":"NY Times.",
       "correct_answer":"B",
       "explanation":"A municipal issuer will publish an official notice of sale in The Daily Bond Buyer to attract an underwriter."
    },
    {
       "id":6219,
       "practice_test_id":6,
       "topic_id":9,
       "question":"All of the following are false regarding a revenue bond\u0027s rate covenant except?",
       "choice_a":"It insures the bond\u0027s interest rate will remain the same",
       "choice_b":"It insures the bond\u0027s interest rate will adjust to market interest rates",
       "choice_c":"It insures the rates charged for use of the facility will support its debt service",
       "choice_d":"It insures the issuer will not raise the user fees charged by the facility",
       "correct_answer":"C",
       "explanation":"The revenues or user fees generated by a facility will adjust in accordance with the issuers need to maintain the facility and support its debt service."
    },
    {
       "id":6220,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following is not a round lot?",
       "choice_a":"100 shares of ABC common stock",
       "choice_b":"$100,000 of par value City Of Boston municipal bonds",
       "choice_c":"50 shares of TRF Preferred stock",
       "choice_d":"100,000 of par value State of Nevada municipal bonds",
       "correct_answer":"C",
       "explanation":"A round lot for municipal bonds is $100,000 of par value and a round lot for common and preferred stock is 100 shares."
    },
    {
       "id":6221,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A small town might issue a general obligation bond (GO bond) for which of the following?",
       "choice_a":"To fund a private corporation that is purchasing equipment",
       "choice_b":"To build a new park",
       "choice_c":"To improve a theatre which will pay back the investors from its revenues collected",
       "choice_d":"To lower the sales tax for that state or municipality",
       "correct_answer":"B",
       "explanation":"A general obligation bond is issued to fund projects which will benefit an entire community and the financed projects generally do not produce any kind of revenue."
    },
    {
       "id":6222,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A municipality might issue a revenue bond for which of the following?",
       "choice_a":"To fund a private corporation that is purchasing equipment",
       "choice_b":"To build a new school",
       "choice_c":"To build a new airport",
       "choice_d":"To lower the sales tax for that state or municipality",
       "correct_answer":"C",
       "explanation":"In this case the revenue bonds will repay the issue based on the revenues generated from the airport."
    },
    {
       "id":6223,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A municipality might issue an industrial development bond for which of the following?",
       "choice_a":"To benefit a private corporation that is building a corporate office",
       "choice_b":"To build a new prison",
       "choice_c":"To improve an airport which will pay back the investors from its revenues collected",
       "choice_d":"To lower the sales tax for that state or municipality",
       "correct_answer":"A",
       "explanation":"An industrial development bond is a municipal bond issued for the benefit of a corporation. The corporation will then lease the improved facility or equipment from the municipality to support the repayment of the bond."
    },
    {
       "id":6224,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An underwriter interested in bidding on a new issue of municipal bonds would find the most information in:",
       "choice_a":"The Blue List",
       "choice_b":"Munifacts",
       "choice_c":"The Daily Bond Buyer",
       "choice_d":"The Yellow Sheets",
       "correct_answer":"C",
       "explanation":"Issuers of municipal bonds will publish the official notice of sale in the Daily Bond Buyer to announce the issue and to attract an underwriter."
    },
    {
       "id":6225,
       "practice_test_id":"",
       "topic_id":9,
       "question":"When selling new municipal bonds to the public, the syndicate members are paid:",
       "choice_a":"The Selling Concession",
       "choice_b":"The Additional Takedown",
       "choice_c":"The Total Takedown",
       "choice_d":"The Manager\u0027s Fee",
       "correct_answer":"C",
       "explanation":"A syndicate member will receive the total takedown, which is equal to the additional takedown plus the selling concession, for filling a customer\u0027s order."
    },
    {
       "id":6226,
       "practice_test_id":6,
       "topic_id":9,
       "question":"All of the following are incorrect, except:",
       "choice_a":"The premium paid on municipal bonds, if held to maturity, will increase the yield to maturity.",
       "choice_b":"A profit on the sale of municipal bonds is not taxable.",
       "choice_c":"Interest on Puerto Rico municipal bonds is exempt from state income taxation.",
       "choice_d":"Interest on all municipal bonds is exempt from local income taxation.",
       "correct_answer":"C",
       "explanation":"Interest on municipal bonds may be subject to state income taxes. Interest on municipal bonds issued in the state in which the investor resides will be free from that state\u0027s income tax.  Profits are taxable.  Interest on municipal bonds issued by a US Territory are federal, state and local tax free."
    },
    {
       "id":6227,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following is an income source available to support GO bond debt?",
       "choice_a":"Tolls",
       "choice_b":"Sales Tax",
       "choice_c":"Concessions",
       "choice_d":"User fees",
       "correct_answer":"B",
       "explanation":"User fees are generated by facilities and they are used to support revenue bonds not GOs.  Sales tax, license fees and ad valorem tax are all used to pay the debt service for municipal GO bonds."
    },
    {
       "id":6228,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following are true about a municipal good faith deposit? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is applied against payment for the issue.  </li><li>It is returned to the unsuccessful bidders.  </li><li>It is lost if the syndicate fails to carry out the provisions of the underwriting agreement.  </li><li>It is returned to the winning syndicate to cover any loss incurred in the subsequent sale of the issue.</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"The good faith deposit of the winning syndicate is kept by the issuer."
    },
    {
       "id":6229,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following are true about municipal bond taxation?<ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Interest is exempt from Federal taxes.  </li><li>Interest is exempt from State taxes for residents of the state of issuance.  </li><li>Capital gains are subject to Federal taxes.  </li><li>Capital gains are subject to State taxes.</li></ol>",
       "choice_a":"II only",
       "choice_b":"I, II, IV",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"States do not tax gains on municipal securities."
    },
    {
       "id":6230,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following are true about municipal bonds? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>If an investor buys a municipal bond issued within the state where they reside, the interest is free from federal, state, and local taxes  </li><li>If an investor buys a municipal bond and sells it at a profit, the capital gain is taxed as ordinary income  </li><li>If an investor buys a municipal bond and sells it at a profit, the capital gain is not taxed federally, but it is taxed by the state and local governments  </li><li>If an investor buys a municipal bond issued by a territory such as Guam or the Virgin Islands, the interest is tax-free on all levels.</li></ol>",
       "choice_a":"I, II",
       "choice_b":"I, II, III",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, IV",
       "correct_answer":"D",
       "explanation":"If an investor realizes a profit on a sale of a municipal bond, the capital gain is taxed at the federal level as ordinary income."
    },
    {
       "id":6231,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which is true of municipal bonds?",
       "choice_a":"If an investor buys a municipal bond issued within the state where they reside, the interest is subject to federal, state, and local taxes",
       "choice_b":"If an investor buys a municipal bond and sells it at a profit, the capital gain is not taxable",
       "choice_c":"If an investor buys a municipal bond and sells it at a profit, the capital gain is taxable",
       "choice_d":"If an investor buys a municipal bond issued by a territory such as Guam or the Virgin Islands, the interest is taxable on all levels.",
       "correct_answer":"C",
       "explanation":"If an investor realizes a profit on a sale of a municipal bond, the capital gain is taxed as ordinary income."
    },
    {
       "id":6232,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following facilities generate user fees that can support a revenue bond issue except:",
       "choice_a":"Airports",
       "choice_b":"Prisons",
       "choice_c":"Tunnels",
       "choice_d":"Water treatment plants",
       "correct_answer":"B",
       "explanation":"Airports, bridges and tunnels, as well as water treatment plants all generate revenues which can be used to pay off revenue bond obligations."
    },
    {
       "id":6233,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following concerning an investor who buys a municipal bond at 94, maturing in 3 years, are correct? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor must accrete the discount each year.  </li><li>The coupon interest is free from Federal income tax.  </li><li>The investor will have a capital gain at maturity.  </li><li>If the amount of the discount is an \u0027original issue\u0027 discount, it will have no tax liability at maturity.</li></ol>",
       "choice_a":"II, III",
       "choice_b":"I, II, III",
       "choice_c":"I, II, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"An investor who purchases a municipal bond at discount must step up or accrete the discount each year. This will not result in a capital gain at maturity."
    },
    {
       "id":6234,
       "practice_test_id":"",
       "topic_id":9,
       "question":"In a new municipal bond offering, how the bonds will be allocated is detailed in the:",
       "choice_a":"Syndicate Agreement.",
       "choice_b":"Indenture.",
       "choice_c":"Notice of Sale.",
       "choice_d":"Official statement.",
       "correct_answer":"A",
       "explanation":"The syndicate agreement will detail the order in which bonds will be allocated."
    },
    {
       "id":6235,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An investor in the 30% tax bracket buys 100m of FL 5% general obligation bonds maturing in 2030. The bond is an OID bond. Any capital appreciation at maturity will be:",
       "choice_a":"A capital gain",
       "choice_b":"Ordinary income",
       "choice_c":"Subject to the investor\u0027s AMT",
       "choice_d":"Tax free",
       "correct_answer":"D",
       "explanation":"All capital gains on OID municipal bonds are tax free if the bonds are held to maturity. A capital gain on a municipal bond purchased in the secondary market is taxed as ordinary income."
    },
    {
       "id":6236,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An investor in the 32% tax bracket can buy a municipal bond with a yield to maturity of 4.6%. What yield would the investor need in a corporate bond to receive the same after-tax return?",
       "choice_a":"5.7%.",
       "choice_b":"7.51%.",
       "choice_c":"6.76%.",
       "choice_d":"3.12%.",
       "correct_answer":"C",
       "explanation":"To determine the taxable rate the investor must receive, divide the muni rate by the complement of the investor\u0027s tax bracket. In this case 4.6/.68 = 6.76"
    },
    {
       "id":6237,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An investor in the 28% tax bracket can buy a municipal bond yielding 9.75%. What yield would the investor require in a corporate bond to realize the same after-tax return?",
       "choice_a":"17.50%.",
       "choice_b":"13.54%.",
       "choice_c":"12.00%.",
       "choice_d":"15.56%.",
       "correct_answer":"B",
       "explanation":"The investor would need to invest in a corporate bond yielding at least 13.54%. Found by dividing the municipal rate by the complement of the investor\u0027s tax rate. In this case 9.75 / .72 = 13.54"
    },
    {
       "id":6238,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An investor is in the 31% tax bracket, and invests in a municipal bond that yields 6.25%. The Tax Equivalent Yield would be:",
       "choice_a":"6.05%",
       "choice_b":"9.56%",
       "choice_c":"9.06%",
       "choice_d":"8.88%",
       "correct_answer":"C",
       "explanation":"To calculate the Tax Equivalent Yield for this example, divide the Tax Exempt yield of the Municipal Bond (6.25 ) by, 1 minus the investor\u0027s tax bracket of 31%, or (1 - 0.31, which equals 0.69). So, (6.25 divided by 0.70 = 9.057%). This means that the Taxable Equivalent Yield would need to be at least 9.06% if invested in a taxable type vehicle."
    },
    {
       "id":6239,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An investor purchases a municipal bond on Wednesday July 3. The bond interest payment dates are November 15 and May 15. The buyer will have to pay the seller of the bond the purchase price and accrued interest for:",
       "choice_a":"48 days.",
       "choice_b":"49 days.",
       "choice_c":"54 days.",
       "choice_d":"53 days.",
       "correct_answer":"D",
       "explanation":"The buyer would have to pay the seller accrued interest for 53 days. Municipal bonds use a 30 day month and settle regular way in two business days. If interest is payable on the 15th of the month, there are 16 days remaining to be paid in the month. And since July 4 is a holiday, settlement will take 1 extra day (because the market will be closed for the holiday) and the buyer must pay the seller for all days up to, but not including, settlement date. So, May has 16 days, June has 30 days and July has 7, for a total of 53"
    },
    {
       "id":6240,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An investor who purchases a municipal bond as an OID bond must:",
       "choice_a":"Amortize the premium",
       "choice_b":"Accrete the discount",
       "choice_c":"Amortize the discount",
       "choice_d":"Reduce the amount of their income by the amount of the discount over time",
       "correct_answer":"B",
       "explanation":"The original issue discount on municipal bonds must be accreted each year. The discount will be added to the investor\u0027s cost base and will be considered to be additional interest and free from federal income tax."
    },
    {
       "id":6241,
       "practice_test_id":2,
       "topic_id":9,
       "question":"According to MSRB rule G-15 all of the following must be on the customer\u0027s confirmation except:",
       "choice_a":"Extended principal",
       "choice_b":"Type of securities registration",
       "choice_c":"Signature of the registered rep",
       "choice_d":"Accrued interest",
       "correct_answer":"C",
       "explanation":"All of the answers are required on the confirmation except the registered rep\u0027s signature."
    },
    {
       "id":6242,
       "practice_test_id":3,
       "topic_id":9,
       "question":"As a Municipal bond trader you call a market maker asking for a quote on a specific municipal bond. The trader responds \u0022I have them 5.2 bid offered 4.9 firm\u0022 What does this mean?",
       "choice_a":"That it is a firm quote and you may trade at those prices with the market maker immediately.",
       "choice_b":"The dealer is obligated to another party at those prices",
       "choice_c":"The quote is for informational purposes only",
       "choice_d":"The trader would have to go to another dealer to get the bonds at those prices.",
       "correct_answer":"A",
       "explanation":"When a municipal bond trader says a quote is firm it means that they are obligated to trade at those prices."
    },
    {
       "id":6243,
       "practice_test_id":4,
       "topic_id":9,
       "question":"Who insures municipal GO bonds against the risk of default? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>FDIC </li><li>SIA </li><li>MBIA </li><li>AMBAC</li></ol>",
       "choice_a":"I  and  II",
       "choice_b":"I, II, III",
       "choice_c":"III  and  IV",
       "choice_d":"II, III, IV",
       "correct_answer":"C",
       "explanation":"Both MBIA and AMBAC insure municipal issuers against the risk of default. The issuer of the municipal bond must request and pay for the insurance. The issuer would pay for the insurance to make the bonds more marketable."
    },
    {
       "id":6244,
       "practice_test_id":5,
       "topic_id":9,
       "question":"If a municipal bond yield increases from 5.25% to 5.5%, it increases:",
       "choice_a":"1/4 basis point.",
       "choice_b":"25 basis points.",
       "choice_c":"2.5 basis points.",
       "choice_d":".25 basis points.",
       "correct_answer":"B",
       "explanation":"A yield that has increased from 5.25% to 5.5% has increased 25 basis points."
    },
    {
       "id":6245,
       "practice_test_id":6,
       "topic_id":9,
       "question":"If an investor purchases a municipal bond at a premium and holds it to maturity, the result will be:",
       "choice_a":"A capital loss.",
       "choice_b":"A capital gain.",
       "choice_c":"Ordinary income.",
       "choice_d":"Neither a gain nor a loss.",
       "correct_answer":"D",
       "explanation":"An investor who purchases a municipal bond at a premium is required to amortize the premium over the life of the bond, therefore at maturity the bond will be worth par which is equal to what the customer will receive from the issuer."
    },
    {
       "id":6246,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Interest income on which of the following is exempt from all federal, state, and local taxes? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>US Treasury bonds. </li><li>US Virgin Islands municipal bonds. </li><li>City of Sacramento Revenue bonds. </li><li>State of California GO bonds.</li></ol>",
       "choice_a":"II only.",
       "choice_b":"I and II.",
       "choice_c":"III and IV.",
       "choice_d":"II, III, and IV",
       "correct_answer":"A",
       "explanation":"Interest income from bonds issued by possessions of the US is free from federal, state, and local taxes."
    },
    {
       "id":6247,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Investors living in New Jersey and purchasing bonds from which of the following issuers would be subject to state taxation?",
       "choice_a":"U.S. Government.",
       "choice_b":"State of Montana.",
       "choice_c":"Commonwealth of Puerto Rico.",
       "choice_d":"Protectorate of Guam.",
       "correct_answer":"B",
       "explanation":"Of the choices listed only the Montana municipal bonds would be subject state taxes from other states."
    },
    {
       "id":6248,
       "practice_test_id":"",
       "topic_id":9,
       "question":"MBIA and AMBAC do not insure against: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Losses on municipal bonds  </li><li>Interest rate risk relating to municipal bonds  </li><li>Market losses on municipal bonds for long term investors  </li><li>Credit risk of the issuer of municipal bonds</li></ol>",
       "choice_a":"II, III",
       "choice_b":"I, III",
       "choice_c":"I, II, III",
       "choice_d":"IV only",
       "correct_answer":"C",
       "explanation":"MBIA and AMBAC insure credit risk for municipal bonds.  Credit risk is also known as default risk."
    },
    {
       "id":6249,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following are true of municipal bonds except:",
       "choice_a":"They are guaranteed by the US government and are just as safe as Treasury securities",
       "choice_b":"Are issued by cities, counties and other political subdivisions",
       "choice_c":"Are issued to help state and local governments meet their financial needs",
       "choice_d":"Are nearly as safe as Treasury securities but the degree of safety varies depending on the creditworthiness of the issuer",
       "correct_answer":"A",
       "explanation":"Municipal bonds are not guaranteed by the Federal government, but rather by the state or municipality issuing them"
    },
    {
       "id":6250,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following are true of muni GO bonds except: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>They are as safe as Treasury securities since the federal government guarantees them  </li><li>They are issued by state and local governments  </li><li>They are issued to help state and local governments meet their financial needs  </li><li>They are always tax free at the state level</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I and IV",
       "choice_d":"II and IV",
       "correct_answer":"C",
       "explanation":"Municipal bonds are not guaranteed by the Federal government, but rather by the state or municipality issuing them.  Municipal bonds may be state and locally taxable depending on the investor\u0027s state of residence."
    },
    {
       "id":6251,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following can validate a mutilated muni bond certificate?",
       "choice_a":"The registrar.",
       "choice_b":"An MSRB member",
       "choice_c":"The CUSIP committee.",
       "choice_d":"The transfer agent.",
       "correct_answer":"D",
       "explanation":"The transfer agent could validate the certificates."
    },
    {
       "id":6252,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Who can issue a municipal bond? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Salt Lake City Olympic Committee </li><li>NYC Port Authority </li><li>City of Denver, CO   </li><li>Turnpike Authorities</li></ol>",
       "choice_a":"II  and  III",
       "choice_b":"I, II,  and  III",
       "choice_c":"III Only",
       "choice_d":"I, II, III,  and  IV",
       "correct_answer":"D",
       "explanation":"Municipal Bonds are debts incurred by any public body or Commission, Agency or Authority."
    },
    {
       "id":6253,
       "practice_test_id":"",
       "topic_id":9,
       "question":"With regard to a municipal bond underwriting all of the following are acceptable except?",
       "choice_a":"An MSRB member who acts as a financial advisor for the issuer submits a competitive bid with the issuer\u0027s approval.",
       "choice_b":"An MSRB member who acts as the advisor to the issuer uses a list of current bondholders obtained from the issuer to solicit new business for the firm.",
       "choice_c":"An MSRB member who is a financial advisor to an issuer terminates the relationship to submit a negotiated bid",
       "choice_d":"An MSRB member who had a financial advisory relationship with the issuer discloses its total compensation for a negotiated underwriting.",
       "correct_answer":"B",
       "explanation":"A firm with a financial advisory relationship to an issuer may not use the information obtained from the issuer to solicit business."
    },
    {
       "id":6254,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following appear in a municipal revenue bond indenture except:",
       "choice_a":"Rate covenant",
       "choice_b":"Additional bonds test",
       "choice_c":"Insurance covenant",
       "choice_d":"Terms of delivery",
       "correct_answer":"D",
       "explanation":"The terms of delivery are discussed in the official notice of sale, not the bond indenture."
    },
    {
       "id":6255,
       "practice_test_id":6,
       "topic_id":9,
       "question":"The REVDEX Index that is published in The Bond Buyer includes revenue bonds with an average maturity of:",
       "choice_a":"5 years",
       "choice_b":"10 years",
       "choice_c":"25 years",
       "choice_d":"30 years",
       "correct_answer":"D",
       "explanation":"Two of the major indices reported in The Bond Buyer have 20 year average <br>maturities; the 40 Bond Index and the 20 Bond Index. The REVDEX 25 has an average maturity of 30 years."
    },
    {
       "id":6256,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The Bond Buyer\u0027s 20 bond Index shows the average yield of:",
       "choice_a":"20 GO bonds and 20 revenue bonds with 30 year maturities.",
       "choice_b":"20 revenue bonds with 20 year maturities.",
       "choice_c":"Both GO and revenue bonds with an average maturity of 15 years",
       "choice_d":"20 GO bonds with 20 year maturities",
       "correct_answer":"D",
       "explanation":"The 20 bond index is a weekly index that is comprised of 20 GO bonds with an average maturity of 20 years rated A or better."
    },
    {
       "id":6257,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The city of Phoenix, Arizona has published an advertisement stating that it is willing to accept bids for the sale of $20,000,000 of sewer bonds. Where would an underwriter look to find this information?",
       "choice_a":"In the Phoenix Sun-Times.",
       "choice_b":"In the Wall Street Journal.",
       "choice_c":"In the Daily Bond Buyer.",
       "choice_d":"In the prospectus.",
       "correct_answer":"C",
       "explanation":"The official notice of sale is printed in the Daily Bond Buyer."
    },
    {
       "id":6258,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The conditions of a western account provide that syndicate members:",
       "choice_a":"Have no liability if they have sold their allotted commitment.",
       "choice_b":"Have a liability in proportion to their participation even though they have sold their commitment.",
       "choice_c":"Have an additional liability to sell future offerings issued by the municipality.",
       "choice_d":"None of the choices listed",
       "correct_answer":"A",
       "explanation":"A western account is a divided account. If any bonds remain unsold they will be the responsibility of the syndicate member who was unable to sell their allocation."
    },
    {
       "id":6259,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The formula for computing current yield on a municipal dollar bond is:",
       "choice_a":"Annual interest payment / Current market price",
       "choice_b":"Annual dividend payment / Current market price",
       "choice_c":"Quarterly interest payment / Current market price",
       "choice_d":"Monthly dividend payment / Current market price",
       "correct_answer":"A",
       "explanation":"The current yield on a municipal bond is found by dividing the annual interest by the current price of the bond."
    },
    {
       "id":6260,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following are true regarding the dated date of a new municipal bond? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is the date from which interest accrues.  </li><li>It may differ from the sale date. </li><li>It is the date on which the bond can be called.  </li><li>It is the date when the bond matures.</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II",
       "choice_c":"III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"The dated date is the date when interest starts to accrue.  It may or may not be the same as the sale date."
    },
    {
       "id":6261,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The disclosure document used in the municipal securities industry is prepared by the issuer and it must contain all of the following, if applicable, except:",
       "choice_a":"Purpose of the issue",
       "choice_b":"Feasibility statement",
       "choice_c":"Sources of collateral",
       "choice_d":"Name of managing underwriter",
       "correct_answer":"D",
       "explanation":"The official statement of a municipal issue discloses all material and <br>financial information regarding the issue. The name of the managing underwriter or syndicate members is not a disclosure requirement and not included in the official statement."
    },
    {
       "id":6262,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following are submitted when making a municipal bond bid except:",
       "choice_a":"Scale.",
       "choice_b":"Net interest cost.",
       "choice_c":"Name of the Bond Counsel.",
       "choice_d":"Total take-down and management fee.",
       "correct_answer":"C",
       "explanation":"All of the choices listed will be submitted by a syndicate making a bid except the bond counsel.  The bond counsel is chosen by the issuer not the syndicate."
    },
    {
       "id":6263,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following must be on a municipal bond for it to be good delivery? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Legal opinion  </li><li>Signature of previous registered owner.  </li><li>Coupon rate.  </li><li>All paid coupons</li></ol>",
       "choice_a":"I, II",
       "choice_b":"I, II, III",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"The paid coupons would have been clipped and sent in for payment."
    },
    {
       "id":6264,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following is the disclosure document prepared by the municipal issuer to be given to the customer at or before confirmation?",
       "choice_a":"Prospectus",
       "choice_b":"Official notice of sale",
       "choice_c":"Official statement",
       "choice_d":"Syndicate agreement",
       "correct_answer":"C",
       "explanation":"Municipal bonds are exempt from the Act of 1933 so issuers are not required to file a prospectus.  However, they are required to provide the customer with a disclosure document called an official statement if one is prepared."
    },
    {
       "id":6265,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A municipality\u0027s bond counsel will do all of the following except:",
       "choice_a":"Ensure the bond certificates have been properly printed",
       "choice_b":"Issue a legal opinion",
       "choice_c":"Confirm the issuer is legally allowed to issue the bonds",
       "choice_d":"Obtain a CUSIP number for the bonds",
       "correct_answer":"D",
       "explanation":"CUSIP numbers are obtained by the underwriter, not the bond counsel."
    },
    {
       "id":6266,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The manager of a municipal syndicate is a dealer who will: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Act for the underwriting group.  </li><li>Take the largest position.  </li><li>Act for the issuing municipality.  </li><li>Provide the legal opinion.</li></ol>",
       "choice_a":"I only",
       "choice_b":"I, II",
       "choice_c":"III, IV",
       "choice_d":"I, III",
       "correct_answer":"A",
       "explanation":"The lead underwriter, also called the syndicate manager, will act for the syndicate."
    },
    {
       "id":6267,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The official notice of sale for a municipal bond contains which of the following?",
       "choice_a":"Yield to Maturity",
       "choice_b":"The bond\u0027s rating",
       "choice_c":"The name of the underwriter",
       "choice_d":"Call features relating to the bond",
       "correct_answer":"D",
       "explanation":"The official notice of sale does not contain the bond\u0027s rating, name of the underwriter or yield."
    },
    {
       "id":6268,
       "practice_test_id":"",
       "topic_id":9,
       "question":"When a city and a county are both responsible for the same debt it is referred as:",
       "choice_a":"Double barreled debt",
       "choice_b":"Prorated debt",
       "choice_c":"Coterminous debt",
       "choice_d":"Shared debt",
       "correct_answer":"C",
       "explanation":"The portion of a county\u0027s debt that a city is responsible for is known as coterminous or overlapping debt."
    },
    {
       "id":6269,
       "practice_test_id":2,
       "topic_id":9,
       "question":"The REVDEX has been hitting new lows. What does that say about the municipal bond market?",
       "choice_a":"GO bond prices have been rising",
       "choice_b":"Revenue bond prices have been falling",
       "choice_c":"GO bond prices have been falling",
       "choice_d":"Revenue bond prices have been rising",
       "correct_answer":"D",
       "explanation":"The REVDEX is a yield based index. Anytime the index falls revenue bond prices are rising."
    },
    {
       "id":6270,
       "practice_test_id":3,
       "topic_id":9,
       "question":"Where can a dealer find information regarding the specific criteria for awarding a bond issue?",
       "choice_a":"Blue List.",
       "choice_b":"Syndicate letter.",
       "choice_c":"Offering circular.",
       "choice_d":"Notice of sale.",
       "correct_answer":"D",
       "explanation":"The criteria for awarding a municipal issue will be detailed in the official notice of sale."
    },
    {
       "id":6271,
       "practice_test_id":4,
       "topic_id":9,
       "question":"The spread on a municipal bond is:",
       "choice_a":"Paid to the issuer.",
       "choice_b":"Paid to the selling group.",
       "choice_c":"Paid to the syndicate members.",
       "choice_d":"Paid to the syndicate manager.",
       "correct_answer":"D",
       "explanation":"The spread on a municipal bond is the difference between the proceeds to the issuer and the offering price to the public.  This is the amount a syndicate manager earns when they sell a new municipal bond."
    },
    {
       "id":6272,
       "practice_test_id":5,
       "topic_id":9,
       "question":"The term \u0027 total takedown\u0027 in the municipal securities business is equal to the:",
       "choice_a":"Selling concession.",
       "choice_b":"Manager\u0027s fee plus the selling concession.",
       "choice_c":"Selling Concession plus the additional takedown .",
       "choice_d":"Entire spread.",
       "correct_answer":"C",
       "explanation":"The term total take down is equal to the additional takedown plus the selling concession.  Syndicate members earn the total takedown when they sell new municipal bonds."
    },
    {
       "id":6273,
       "practice_test_id":6,
       "topic_id":9,
       "question":"The Trust Indenture Act of 1939 requires the disclosure for which of the following?",
       "choice_a":"Issues of common stock",
       "choice_b":"Issues of municipal bonds",
       "choice_c":"Issues of preferred stock",
       "choice_d":"Issues of corporate bonds",
       "correct_answer":"D",
       "explanation":"The Trust Indenture Act of 1939 governs the issuance of corporate bonds and has no jurisdiction over common stock, municipal bonds or preferred stock. Additionally, municipal issuers are exempt from federal registration but they do provide disclosure to the customer in the official statement."
    },
    {
       "id":6274,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following municipal issues is the safest?",
       "choice_a":"New housing authority bonds",
       "choice_b":"Special tax bonds",
       "choice_c":"Moral obligation bonds",
       "choice_d":"State GO bonds",
       "correct_answer":"A",
       "explanation":"NHA bond issues are considered the safest municipal issue because they provide low-income housing that the US government often jointly funds, in addition to guaranteeing rental payments that support its debt service."
    },
    {
       "id":6275,
       "practice_test_id":"",
       "topic_id":9,
       "question":"According to MSRB Rule G-9, for how long must customer complaints be kept?",
       "choice_a":"3 years",
       "choice_b":"6 years",
       "choice_c":"7 years",
       "choice_d":"Indefinitely",
       "correct_answer":"B",
       "explanation":"MSRB rules require that member firms keep customer complaints for 6 years.  Note: FINRA rules require only 3 years."
    },
    {
       "id":6276,
       "practice_test_id":"",
       "topic_id":9,
       "question":"What is meant by the statement \u00275.25% less \u00BD\u0027 for a municipal bond traded in the secondary market?",
       "choice_a":"5.25% coupon rate less $5.00 per $1,000.",
       "choice_b":"5.25% coupon rate less $.50 per $1,000.",
       "choice_c":"5.25% yield to maturity less $5.00 per $1,000.",
       "choice_d":"5.25% yield to maturity less $.50 per $1,000.",
       "correct_answer":"C",
       "explanation":"Municipal bonds are quoted on a yield to maturity basis and the dealer in this case is taking $5.00 per bond"
    },
    {
       "id":6277,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following best describes a municipal issuer\u0027s sinking fund?",
       "choice_a":"A fund where the money is invested in AAA corporate bonds",
       "choice_b":"A fund where the money is invested in other municipal issues",
       "choice_c":"A fund where the money is invested in money market funds",
       "choice_d":"A fund where the money is invested in US treasury issues",
       "correct_answer":"D",
       "explanation":"In general, sinking fund assets are invested in U.S. government securities to provide safety and offsetting income for the issuer."
    },
    {
       "id":6278,
       "practice_test_id":"",
       "topic_id":9,
       "question":"When a municipality issues a revenue bond its trust indenture will provide all of the following: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Flow of funds  </li><li>Schedule of interest payments  </li><li>Call features  </li><li>Records covenant</li></ol>",
       "choice_a":"I, II, III",
       "choice_b":"I, II, IV",
       "choice_c":"II, III, IV",
       "choice_d":"I, III, IV",
       "correct_answer":"D",
       "explanation":"The interest payment schedule is generally found in the issue\u0027s official statement, not its trust indenture."
    },
    {
       "id":6279,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The City of Oshkosh needs to even out its cash flow. It will most likely issue:",
       "choice_a":"Short term notes",
       "choice_b":"Commercial paper",
       "choice_c":"Money market fund securities",
       "choice_d":"GO bonds",
       "correct_answer":"A",
       "explanation":"Tax anticipation notes are short term financing instruments used by municipalities to even out their cash flow"
    },
    {
       "id":6280,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following are included in the bond indenture for a municipal revenue bond except?",
       "choice_a":"Provisions for an outside audit",
       "choice_b":"Provisions for a sinking fund",
       "choice_c":"Provisions for the return of the good faith deposit",
       "choice_d":"Call provisions",
       "correct_answer":"C",
       "explanation":"The good faith deposit is discussed in the official notice of sale, not the bond indenture."
    },
    {
       "id":6281,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Where can an investor who is interested in a new municipal bond issue find information about the financial condition of the issuer?",
       "choice_a":"Official statement",
       "choice_b":"Notice of sale",
       "choice_c":"Bond resolution",
       "choice_d":"Prospectus",
       "correct_answer":"A",
       "explanation":"Municipalities disclose all material and financial information relevant to a new bond issue in its official statement."
    },
    {
       "id":6282,
       "practice_test_id":"",
       "topic_id":9,
       "question":"When an issuer is reviewing the competitive bids on a new GO issue, the winning syndicate is the one that provides the:",
       "choice_a":"Lowest net interest cost",
       "choice_b":"Highest yield to maturity",
       "choice_c":"Lowest true interest cost",
       "choice_d":"Smallest underwriting spread",
       "correct_answer":"A",
       "explanation":"The net interest cost (NIC) is the primary factor the issuer must consider <br>when awarding the bid. The NIC is the cost of borrowing the funds from the investing public and since GOs bonds are funded with tax dollars the issuer is obligated to accept the bid that has the lowest cost to the taxpayers."
    },
    {
       "id":6283,
       "practice_test_id":"",
       "topic_id":9,
       "question":"When analyzing the primary municipal bond market a municipal financial professional can find all of the following in The Bond Buyer except:",
       "choice_a":"Placement ratio indexes",
       "choice_b":"30-day visible supply",
       "choice_c":"Official notice of sale",
       "choice_d":"Interdealer inventories",
       "correct_answer":"D",
       "explanation":"Interdealer inventories can be found in the blue sheets. All the remaining information is published in The Bond Buyer."
    },
    {
       "id":6284,
       "practice_test_id":6,
       "topic_id":9,
       "question":"A highly conservative investor is considering an investment in a municipal bond, which of the following will provide the greatest safety?",
       "choice_a":"AAA rated GO bond",
       "choice_b":"AAA rated Revenue bonds",
       "choice_c":"Public Housing Authority bonds",
       "choice_d":"Double barreled bonds",
       "correct_answer":"C",
       "explanation":"PHA/ NHA\u0027s are considered the safest because they are guaranteed by the US Government"
    },
    {
       "id":6285,
       "practice_test_id":"",
       "topic_id":9,
       "question":"When considering investing in a municipal bond, which of the following opinions on the issue that the bond is a binding obligation on behalf of the issuer?",
       "choice_a":"Syndicate",
       "choice_b":"MSRB",
       "choice_c":"FINRA",
       "choice_d":"Bond counsel",
       "correct_answer":"D",
       "explanation":"The bond counsel issues a legal opinion about the municipal bond and states that it is a legally binding obligation of the issuer and that its interest should be free from federal income taxes."
    },
    {
       "id":6286,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Rank the following in order of safety: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Municipal bonds  </li><li>Corporate bonds  </li><li>PHAs  </li><li>US Treasury bonds</li></ol>",
       "choice_a":"I, III, II, IV",
       "choice_b":"IV, III, I, II",
       "choice_c":"IV, I, III, II",
       "choice_d":"II, I, III, IV",
       "correct_answer":"B",
       "explanation":"US Government securities are considered the safest, followed by PHAs, since they are often backed by the US Government, and therefore considered safer than other types of munis.  Corporate bonds offer the least amount of safety."
    },
    {
       "id":6287,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following would raise concerns regarding the quality of a municipal bond?",
       "choice_a":"The bond has an unqualified legal opinion.",
       "choice_b":"The bond has no legal opinion.",
       "choice_c":"The bond has a qualified legal opinion.",
       "choice_d":"The bond trades ex-legal.",
       "correct_answer":"C",
       "explanation":"When a legal opinion is qualified it is an indication that the issue\u0027s validity may be in question and an investor may have concerns with the quality of the issue. No legal opinion or a bond traded ex-legal is not necessarily an issue for concern; it may be that the issue doesn\u0027t require a legal opinion due to the size of the issue or municipality."
    },
    {
       "id":6288,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Competitive bidding is used for:",
       "choice_a":"Revenue bond issues only",
       "choice_b":"GO bond issues only",
       "choice_c":"Both Revenue and GO bond issues",
       "choice_d":"Neither Revenue nor GO bond issues",
       "correct_answer":"B",
       "explanation":"The competitive bid process is used only for GO bond issues.  Revenue bonds use negotiated bidding."
    },
    {
       "id":6289,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following are true regarding municipal bonds except:",
       "choice_a":"GO bonds quoted on a yield to maturity basis",
       "choice_b":"Revenue bonds are quoted in dollars",
       "choice_c":"Most of them are priced based on predicted inflation",
       "choice_d":"They can be issued by a city, county or state to raise capital",
       "correct_answer":"C",
       "explanation":"Municipal bonds are not priced based on predicted inflation.  All the other statements are true."
    },
    {
       "id":6290,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following are found in the official notice of sale? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Denomination of bonds </li><li>Right of rejection  </li><li>Maturity schedule  </li><li>Terms of the delivery</li></ol>",
       "choice_a":"I  and  II",
       "choice_b":"I, II,  and  III",
       "choice_c":"I, III,  and  IV",
       "choice_d":"I, II, III,  and  IV",
       "correct_answer":"D",
       "explanation":"All of these are found in the official notice of sale."
    },
    {
       "id":6292,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following provide short term financing for a municipality except:",
       "choice_a":"Tax anticipation notes",
       "choice_b":"Construction loan notes",
       "choice_c":"Banker\u0027s acceptances",
       "choice_d":"Bond anticipation notes",
       "correct_answer":"C",
       "explanation":"TANs, CLNs and BANs are short term obligations used by a municipality to manage their cash flow. Banker\u0027s acceptances are a type of money market security and are not issued by municipalities."
    },
    {
       "id":6293,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following projects is least likely to be financed by a GO bond?",
       "choice_a":"Public golf course",
       "choice_b":"Jails",
       "choice_c":"County courthouse",
       "choice_d":"Public school",
       "correct_answer":"A",
       "explanation":"The public golf course will generate user fees that will support a revenue bond issue. County courthouses, jails and public schools benefit the public and therefore GO bonds would be used."
    },
    {
       "id":6294,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following is true when a new issue of municipal bonds is being sold? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Pre-sale orders have the highest priority </li><li>Designated orders are filled before Group Net orders </li><li>Member orders are usually smaller orders for individual accounts </li><li>The bonds may be sold as soon as the issue is awarded</li></ol>",
       "choice_a":"I and III.",
       "choice_b":"I, III, and IV",
       "choice_c":"I, II, and III.",
       "choice_d":"I, II, III, and IV.",
       "correct_answer":"B",
       "explanation":"Orders are filled in the following order:  Presale, syndicate or group net, designated, member and member related.  Munis are not subject to a cooling off period and therefore may trade immediately upon being awarded to the syndicate."
    },
    {
       "id":6295,
       "practice_test_id":"",
       "topic_id":9,
       "question":"All of the following are terms used with regards to a new municipal bond offering except:",
       "choice_a":"Bond indenture.",
       "choice_b":"Official statement.",
       "choice_c":"Notice of sale.",
       "choice_d":"Prospectus.",
       "correct_answer":"D",
       "explanation":"Municipal bond offerings are exempt from the Act of 1933 and therefore no prospectus is required."
    },
    {
       "id":6296,
       "practice_test_id":2,
       "topic_id":9,
       "question":"An investment in municipal bonds is most suitable for:",
       "choice_a":"Investors whose primary objective is safety",
       "choice_b":"Investors whose primary objective is tax relief",
       "choice_c":"Investors whose primary objective is income",
       "choice_d":"Investors whose primary objective is speculation",
       "correct_answer":"B",
       "explanation":"Because interest earned from municipal bonds is free of federal income tax, investors whose primary objective is tax relief are best suited to munis."
    },
    {
       "id":6297,
       "practice_test_id":3,
       "topic_id":9,
       "question":"Pizza Guy, Inc. needs $ 20,000,000 to build their corporate headquarters.  They asked the state for help raising the funds.  The new corporate center will create jobs and will help the economy of the state. The state decides to raise the money for the company through the sale of municipal bonds.  What type of bonds are these?",
       "choice_a":"Construction loan notes",
       "choice_b":"General obligation",
       "choice_c":"Industrial development bonds",
       "choice_d":"Double barreled bonds",
       "correct_answer":"C",
       "explanation":"An industrial development revenue bond is a municipal bond sold to benefit a private corporation. A state or municipality would sell IDBs to attract corporations to create jobs and tax revenue."
    },
    {
       "id":6298,
       "practice_test_id":4,
       "topic_id":9,
       "question":"Your client purchases bonds trading ex legal and asks you what this means.  You tell him:",
       "choice_a":"The legal opinion was lost",
       "choice_b":"The bonds are illegal in his state of residence",
       "choice_c":"No legal opinion was obtained",
       "choice_d":"The bond issue is in default",
       "correct_answer":"C",
       "explanation":"Many small municipal issuers choose not to get a legal opinion because the issue is too small to justify the cost."
    },
    {
       "id":6299,
       "practice_test_id":5,
       "topic_id":9,
       "question":"Your city has a statutory debt limit of $300,000,000. Currently there is $225,000,000 worth of debt outstanding. The city will be hosting the Olympics and wants to issue a revenue bond to build a new facility in the amount of $175,000,000. Which of the following is true?",
       "choice_a":"They can not issue the bond as it would cause the city to exceed their statutory debt limit.",
       "choice_b":"They may issue only $75,000,000 the remaining $100,000,000 will need to be raised privately.",
       "choice_c":"They may issue the whole $175,000,000 immediately.",
       "choice_d":"They may issue the $175,000,000 but only with the approval of the voters.",
       "correct_answer":"C",
       "explanation":"The City may issue the whole $175,000,000 immediately.  Revenue bonds, which are self supporting debt, do not count towards the debt limit."
    },
    {
       "id":6300,
       "practice_test_id":6,
       "topic_id":9,
       "question":"Your customer bought 10m State of New York 7% J \u0026 J bonds on Tuesday April 5th at 99. The total due excluding commission is:",
       "choice_a":"$10,700.00",
       "choice_b":"$10,169.44",
       "choice_c":"$9,000.00",
       "choice_d":"$10,086.66",
       "correct_answer":"D",
       "explanation":"Your customer paid $9,900 for the bonds plus accrued interest. The accrued interest is found as follows: principal x rate x time 10,000 x 7% x 96/360 = 186.66 in accrued interest. When added to the total = $10,086.66. The buyer owes 30 days\u0027 interest in January, February and March. The buyer owes 6 days of accrued interest in April."
    },
    {
       "id":6301,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Your firm is a member of a syndicate underwriting a municipal bond offering. The bonds are in high demand.  Which orders will get the lowest priority?",
       "choice_a":"Syndicate",
       "choice_b":"Designated",
       "choice_c":"Presale",
       "choice_d":"Member",
       "correct_answer":"D",
       "explanation":"When there are more orders than bonds for municipal bond offers the order is: presale, syndicate, designated, member."
    },
    {
       "id":6302,
       "practice_test_id":"",
       "topic_id":9,
       "question":"If your city is selling municipal bonds to raise money to build a new park, the underwriting will most likely be awarded to a syndicate:",
       "choice_a":"With the highest NIC",
       "choice_b":"With the lowest TIC",
       "choice_c":"Through negotiation",
       "choice_d":"Through competitive bid",
       "correct_answer":"D",
       "explanation":"GO bonds are awarded to syndicates through competitive bidding."
    },
    {
       "id":6303,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Your state needs to raise $75,000,000 in new funds for a highway improvement project. The issue will be award to the syndicate:",
       "choice_a":"With the highest TIC",
       "choice_b":"With the lowest TIC",
       "choice_c":"With the lowest NIC",
       "choice_d":"With the highest NIC",
       "correct_answer":"C",
       "explanation":"The bonds being sold are general obligation bonds and will be awarded to the syndicate with the lowest NIC."
    },
    {
       "id":6304,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A city is going to build a new dam.  The city hires a contractor to build it and floats bonds to pay for the dam that will be financed by new water fees.  What type of bond is this?",
       "choice_a":"Revenue bond because they are paying for the bond with future fees",
       "choice_b":"Corporate bond because the bond is floated by the contractor",
       "choice_c":"General obligation bond",
       "choice_d":"Build America bond",
       "correct_answer":"A",
       "explanation":"A municipal bond that is issued to finance a revenue producing facility with the interest and principal payments being made from the fees generated by the facility are revenue bonds."
    },
    {
       "id":24698,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which two of the following types of municipal securities does not require voter approval? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>An industrial development bond </li><li> A moral obligation bond </li><li>Overlapping debt </li><li>An insured general obligation bond </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"III and IV",
       "correct_answer":"A",
       "explanation":"The issuance of revenue bonds do not require voter approval as they do not draw on the taxes received by the state or municipal issuer. An industrial revenue bond and a moral obligation bond are both revenue bonds."
    },
    {
       "id":24646,
       "practice_test_id":"",
       "topic_id":9,
       "question":"When a syndicate allocates orders during a municipal bond underwriting the order that usually gets filled first after pre sale orders is:",
       "choice_a":"net group",
       "choice_b":"group minus concession",
       "choice_c":"group plus take down",
       "choice_d":"group plus additional take down",
       "correct_answer":"A",
       "explanation":"If any bonds remain after presale orders, the next orders to get filled are net group or group net orders. Both presentations of the orders mean orders where the syndicate will split the credit for sale of the bonds."
    },
    {
       "id":24681,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A municipal securities dealer who is analyzing the condition of the new issue market would be most influenced by which of the following? ",
       "choice_a":"Current interest rates",
       "choice_b":"Interest rates over the last 12 months",
       "choice_c":"The 30 day visible supply",
       "choice_d":"How many official notices of sale are published each week in the daily bond buyer",
       "correct_answer":"C",
       "explanation":"A dealer who is looking at the new issue market for municipal bonds would be most concerned with the 30 day visible supply. This will tell the dealer the total par value of all municipal bonds coming to market in the next 30 days. A high visible supply is bearish, a low visible supply is bullish. "
    },
    {
       "id":24688,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Under MSRB regulations which of the following situations would be subject to the most scrutiny?",
       "choice_a":"An employee is the former governor of the state of New York",
       "choice_b":"An employee is the current president of the school board of a large city",
       "choice_c":"The broker dealer is the financial adviser to an issuer",
       "choice_d":"The broker dealer retains a municipal bond consultant to help secure negotiated underwritings",
       "correct_answer":"C",
       "explanation":"While all of the choices would be cause for additional review or disclosures, the broker dealer who is an adviser to an issuer of municipal securities would be cause for the highest concern. There are significant potential conflicts of interest which all must be disclosed and a number of required actions that need to be taken to ensure compliance."
    },
    {
       "id":20915,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Dallas Texas is seeking to issue $100,000,000 worth of new bonds and publishes an invitation to underwriters who may be interested in offering the bonds for sale to investors. This is known as:",
       "choice_a":"An invitation only sale",
       "choice_b":"A negotiated sale",
       "choice_c":"A competitive bid",
       "choice_d":"A direct issue sale",
       "correct_answer":"C",
       "explanation":"When a municipality wants to offer bonds for sale it will publish an official notice of sale in the Daily Bond Buyer. The underwriting will be awarded through competitive bidding. The underwriter with the lowest net interest cost to the issuer will be awarded the underwriting. "
    },
    {
       "id":20924,
       "practice_test_id":"",
       "topic_id":9,
       "question":"You work for ABC Muni Brokers and are part of the syndicate team at ABC. Your firm is the lead underwriter of $100 million worth of state GO bonds. When must your firm settle the syndicate account? ",
       "choice_a":"Within 15 days of when the last bond is sold",
       "choice_b":"Within 15 days of the dated date",
       "choice_c":"Within 30 calendar days after receipt of the bonds from the issuer",
       "choice_d":"Within 30 calendar days of delivery of the official statement",
       "correct_answer":"C",
       "explanation":"The syndicate account must be settled within 30 calendar days of delivery of the bonds from the issuer, to the syndicate. "
    },
    {
       "id":20925,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A municipal bond syndicate is offering $300 million worth of county GO bonds. The syndicate consists of 5 members and is organized as a western account. $25 million worth of bonds remain unsold. When must the determination of liability for the unsold bonds occur?",
       "choice_a":"At the end of the order period",
       "choice_b":"At the time the syndicate account is settled",
       "choice_c":"At the time confirmations are mailed",
       "choice_d":"At the time the bonds are available for delivery",
       "correct_answer":"B",
       "explanation":"The determination of liability for any unsold bonds will take place at the time the syndicate account is settled. The syndicate account must be settled within 30 calendar days of receipt of the bonds from the issuer. "
    },
    {
       "id":20928,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A municipal bond scale reflects which of the following?",
       "choice_a":"Various yields to maturity for bonds of different maturities",
       "choice_b":"Various prices for revenue bonds",
       "choice_c":"Various mil rates for local GO bonds",
       "choice_d":"Various ratings for GO bonds of different quality",
       "correct_answer":"A",
       "explanation":"A municipal bond scale reflects the various yield to maturities for GO bonds with different maturity dates. Bonds with shorter maturities will have lower yields than bonds with longer maturities in a normal interest rate environment."
    },
    {
       "id":20931,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A municipal bond investor is looking at the 30 day visible supply to gauge the condition of the municipal bond market. The 30 day visible supply contains which of the following issues?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>GO bonds  </li><li>Revenue bonds  </li><li>Tax anticipation notes </li><li>Revenue anticipation notes</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I only",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"A",
       "explanation":"The 30 day visible supply contains the total par value of all GO bonds and revenue bonds to be issued in the next 30 days. The 30 day visible supply does not contain the par value of any short term notes.  "
    },
    {
       "id":20934,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A county is offering a new issue of 10 year GO bonds that are not in high demand. As a result the issue must be sold to investors at a price that is equal to 92. An investor who holds the bonds until they mature will have which of the following?",
       "choice_a":"A tax liability of $80 per bond",
       "choice_b":"A reduced yield to maturity",
       "choice_c":"Zero tax liability per bond",
       "choice_d":"Significant reinvestment risk",
       "correct_answer":"C",
       "explanation":"When an investor purchases an original issue discount bond and holds the bonds until maturity, the investor will not have any taxable gain on the appreciation to par."
    },
    {
       "id":20935,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The department of transportation has been inspecting a toll bridge and determines that the bridge is unsafe for traffic. As a result the bridge is condemned. Which of the following would occur?",
       "choice_a":"All of the bonds would go into default",
       "choice_b":"All of the bonds would be called under the catastrophe call",
       "choice_c":"All of the bonds would be paid off from the assets in the sinking fund",
       "choice_d":"All of the bonds would be paid from funds allocated from a moral obligation fund",
       "correct_answer":"B",
       "explanation":"If a revenue producing structure is destroyed or condemned all of the bonds will be called in under the catastrophe call provision. The bonds will be paid off from proceeds from the catastrophe insurance policy."
    },
    {
       "id":19330,
       "practice_test_id":1,
       "topic_id":9,
       "question":"1 mill when determining tax liability for real property would best be described as: ",
       "choice_a":"$10 per $1,000",
       "choice_b":"$1 per $1,000",
       "choice_c":"$10 per $100,000",
       "choice_d":"$1 per $100",
       "correct_answer":"B",
       "explanation":"1 mill equals $1 of tax for every $1,000 of assessed value of property . "
    },
    {
       "id":19331,
       "practice_test_id":2,
       "topic_id":9,
       "question":"Which of the following municipal bond issues would have the debt supported by revenue received based on a mil rate?",
       "choice_a":"PHA issue",
       "choice_b":"State issued GO",
       "choice_c":"Locally issued GO",
       "choice_d":"State bond anticipation note",
       "correct_answer":"C",
       "explanation":"A locally issued GO bond would have the debt supported by revenue received based on a mil rate. Local GOs are supported by property taxes. State issued GOs are supported by sales taxes."
    },
    {
       "id":19334,
       "practice_test_id":3,
       "topic_id":9,
       "question":"A bridge connecting two states would like to issue new bonds to be supported by the same toll revenue as the outstanding issue. The outstanding bonds have an open end covenant. Which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> The bonds may not have an equal claim on the facility as the original bonds </li><li>The bonds are subject to a study to ensure that the facility can support the payments for both bond issues </li><li>The bonds as an additional issue would be subject to a mandatory sinking fund </li><li>The new issue must amortize at the same rate as the original bond issue</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II only",
       "choice_c":"III and IV",
       "choice_d":"I, II and IV",
       "correct_answer":"B",
       "explanation":"A facility with an outstanding bond issue with an open end covenant may issue bonds with the same claim on the facility and its revenue. The new issues will be subject to an additional bonds test to make sure that the revenue received by the facility can support the total outstanding debt. The new issue will not be subject to a mandatory sinking fund and there is no amortization requirement. "
    },
    {
       "id":19336,
       "practice_test_id":4,
       "topic_id":9,
       "question":"The US Government guarantees the payments on which of the following local issues? ",
       "choice_a":"IDB for a project in a low income area",
       "choice_b":"Low income housing PHA issue",
       "choice_c":"Historical Rehab issue",
       "choice_d":"HHA low income housing issue",
       "correct_answer":"B",
       "explanation":"Bonds issued by the public housing authority / PHA are back by the full faith and credit of the federal Government. If the rent received from the tenants is not sufficient to support the bond payments the federal Government will make up the shortfall. "
    },
    {
       "id":19337,
       "practice_test_id":5,
       "topic_id":9,
       "question":"A municipality after years of financial difficulty defaults on an outstanding issue of GO bonds. The bond issue was rather small and had no legal opinion issued. Which of the following are not required in order for the bonds to be considered good delivery? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> The bonds must be accompanied by an official default notice </li><li>All past unpaid coupons must be attached </li><li>All coupons for future payment must be attached </li><li>The bonds must be accompanied by an escrow receipt</li></ol>",
       "choice_a":"I only",
       "choice_b":"IV only",
       "choice_c":"II and III",
       "choice_d":"I and IV",
       "correct_answer":"D",
       "explanation":"In order for a bond in default to be considered to be in good deliverable form, all unpaid past coupons and all coupons for future payment must be attached. The bonds do not need to be accompanied by an official default notice or an escrow receipt."
    },
    {
       "id":19338,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A municipality after years of financial difficulty defaults on an outstanding issue of GO bonds. The bond issue was rather small and had no legal opinion issued. In order for the bonds to be considered good delivery , which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> The bonds must be accompanied by an official default notice </li><li>All past unpaid coupons must be attached </li><li>All coupons for future payment must be attached </li><li>The bonds must be accompanied by an escrow receipt</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"In order for a bond in default to be considered to be in good deliverable form, all unpaid past coupons and all coupons for future payment must be attached. The bonds do not need to be accompanied by an official default notice or an escrow receipt."
    },
    {
       "id":19348,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following are true as it relates to the collection ratio? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> The collection ratio is concerned with the revenue assessed and collected for user fees </li><li>The collection ratio is used to evaluate all municipal bonds </li><li>The collection ratio is concerned with the amount of tax assessed and the amount of tax collected </li><li>The lower the collection ratio the higher the risk associated with the bonds</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IIII",
       "choice_c":"I and IV",
       "choice_d":"III and IV",
       "correct_answer":"D",
       "explanation":"The collection ratio is concerned with the amount of tax assessed and the amount of tax collected and is used to evaluate the credit quality of GO bonds. The lower the collection ratio the lower the amount of tax that was actually collected and the higher the risk associated with the bonds."
    },
    {
       "id":19380,
       "practice_test_id":"",
       "topic_id":9,
       "question":"The MSRB regulates which of the following quotes entered for municipal securities? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Offers wanted </li><li>Quotes entered by a broker dealer for the benefit of a third party </li><li>Bids wanted </li><li>Quotes entered by a broker dealer into a third party network</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I, II and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"The MSRB regulates all quotes entered for municipal securities no matter where that quote is disseminated"
    },
    {
       "id":19394,
       "practice_test_id":"",
       "topic_id":9,
       "question":"A town has a total of $100,000,000 worth of property within its limits. The town uses s 70% assessment and a rate of 10 mills. The town will receive how much in tax revenue?",
       "choice_a":"$1,000,000",
       "choice_b":"$700,000",
       "choice_c":"$7,000,000",
       "choice_d":"$10,000,000",
       "correct_answer":"B",
       "explanation":"$100,000,000 X .7 = $70,000,000 of assessed value. 1 mill = $1 per $1000 in tax. 70,000,000 / 1000 = 70,000 X 10 mils = $700,000 in tax revenue annually "
    },
    {
       "id":19395,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following bonds would have the interest payments backed by the federal government in the case of financial difficulty?",
       "choice_a":"Special tax bond",
       "choice_b":"PHA Bond",
       "choice_c":"Industrial development bond",
       "choice_d":"Grant anticipation note",
       "correct_answer":"B",
       "explanation":"PHA or Public Housing Authority bonds would have the interest payments backed by the federal government in the case of financial difficulty."
    },
    {
       "id":19396,
       "practice_test_id":"",
       "topic_id":9,
       "question":"An investor is inquiring about the visible supply. The visible supply may be found in:",
       "choice_a":"REVDEX",
       "choice_b":"Munifacts",
       "choice_c":"Bond Buyer",
       "choice_d":"Level III",
       "correct_answer":"C",
       "explanation":"The visible supply may be found in the Daily Bond Buyer and tells investors the amount of municipal bonds being offered for sale in the next 30 days."
    },
    {
       "id":20944,
       "practice_test_id":"",
       "topic_id":9,
       "question":"Which of the following issues would have a MIG rating?",
       "choice_a":"A revenue bond",
       "choice_b":"A GO Bond",
       "choice_c":"A limited tax bond",
       "choice_d":"A tax anticipation note",
       "correct_answer":"D",
       "explanation":"A Moody\u0027s Investment Grade or MIG rating is assigned to short term municipal debt. Bonds are long term municipal debt and would not be assigned a MIG rating. Only the Tax anticipation note would receive a MIG rating."
    },
    {
       "id":6458,
       "practice_test_id":"",
       "topic_id":14,
       "question":"With a diagonal spread all of the following are different in regard to the to options except:",
       "choice_a":"Expiration month",
       "choice_b":"Strike price",
       "choice_c":"Type of option",
       "choice_d":"Long or short",
       "correct_answer":"C",
       "explanation":"With a diagonal spread all of the choices listed are different except the type of option."
    },
    {
       "id":6459,
       "practice_test_id":6,
       "topic_id":14,
       "question":"A combination is most like a:",
       "choice_a":"Spread",
       "choice_b":"Straddle",
       "choice_c":"Naked call",
       "choice_d":"Long stock position",
       "correct_answer":"B",
       "explanation":"A combination is like a straddle with either a long call and long put or with a short call and short put, except the strike prices on the call and the put are different."
    },
    {
       "id":6460,
       "practice_test_id":"",
       "topic_id":14,
       "question":"A price spread can be established as which of the following: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A bull call spread </li><li>A bull put spread </li><li>A credit call spread </li><li>A debit put spread</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"II,III, and IV",
       "choice_d":"I,II, III, IV",
       "correct_answer":"D",
       "explanation":"A price spread is another name for all of the choices listed. With a price spread the strike price and action are different. The type of option and the expiration month are the same."
    },
    {
       "id":6461,
       "practice_test_id":1,
       "topic_id":14,
       "question":"Your customer is short 10 KJH Nov 50 calls at 4.10. Which of the following trades should he execute to establish a credit call spread?",
       "choice_a":"Buy 10 KJH Nov 50 calls",
       "choice_b":"Sell 10 KJH Nov 40 calls",
       "choice_c":"Buy 10 KJH Nov 60 calls",
       "choice_d":"Write 10 KJH Nov 45 calls",
       "correct_answer":"C",
       "explanation":"Your customer is short 10 KJH Nov 50 calls to establish a credit call spread the customer would have to buy 10 KJH Nov 60 calls."
    },
    {
       "id":6462,
       "practice_test_id":2,
       "topic_id":14,
       "question":"Your customer is short 10 KJH Nov 50 calls at 4.10. Which of the following trades should he execute to establish a debit call spread?",
       "choice_a":"Buy 10 KJH Nov 50 calls",
       "choice_b":"Write 10 KJH Nov 60 calls",
       "choice_c":"Buy 10 KJH Nov 40 calls",
       "choice_d":"Sell 10 KJH Nov 40 calls",
       "correct_answer":"C",
       "explanation":"To establish a debit spread your customer would have to buy 10 KJH Nov 40 calls."
    },
    {
       "id":6463,
       "practice_test_id":3,
       "topic_id":14,
       "question":"Which of the following option positions subject the investor to an unlimited loss? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Short a naked put </li><li>Short a straddle </li><li>Short a call Spread </li><li>Short a put spread</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II only",
       "choice_c":"I only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"B",
       "explanation":"Of the choices listed only the short straddle will subject the investor to an unlimited loss."
    },
    {
       "id":6464,
       "practice_test_id":4,
       "topic_id":14,
       "question":"Which of the following option positions will not subject the investor to an unlimited loss?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Short a naked put </li><li>Short a straddle </li><li>Short a call spread </li><li>Short a put spread</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II",
       "choice_c":"I,III and IV",
       "choice_d":"I,II,III and IV",
       "correct_answer":"C",
       "explanation":"The only position that will subject the investor to an unlimited loss is the short straddle. The investor will not be subject to an unlimited loss with any of the other positions. Nothing is ever unlimited with a put and nothing is ever unlimited with a price spread."
    },
    {
       "id":6465,
       "practice_test_id":5,
       "topic_id":14,
       "question":"Which of the following is (are) true about the buyer and seller of a put spread? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Both parties will breakeven at the same price. </li><li>Both parties enter the spread with opening transactions </li><li>Both parties will use the same formula to determine their breakeven </li><li>The buyer\u0027s debit will equal the seller\u0027s credit</li></ol>",
       "choice_a":"I only",
       "choice_b":"II and IV",
       "choice_c":"I,II, and IV",
       "choice_d":"I,II,III and IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed are correct as it relates to the two parties to a spread."
    },
    {
       "id":6466,
       "practice_test_id":6,
       "topic_id":14,
       "question":"Which of the following is (are) not true about the buyer and seller of a put spread? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Both parties will breakeven at the same price. </li><li>The buyer enters the trade with an opening transaction while the seller enters the trade with a closing transaction </li><li>Both parties will use the same formula to determine their breakeven </li><li>The buyer\u0027s debit will equal the seller\u0027s credit</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and IV",
       "choice_c":"II only",
       "choice_d":"III only",
       "correct_answer":"C",
       "explanation":"All of the choices listed are correct except II. Buyers and sellers of spreads both establish the position with opening transactions."
    },
    {
       "id":6467,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following stock splits will cause the option contract to cover more than 100 shares?",
       "choice_a":"2:1",
       "choice_b":"3:1",
       "choice_c":"3:2",
       "choice_d":"1:2",
       "correct_answer":"C",
       "explanation":"A 3:2 forward stock split will cause the number of shares covered by the contract to increase to 150 shares and the strike price will be adjusted downward."
    },
    {
       "id":6468,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Your customer is long 10 ERT Oct 60 calls at 6.22. ERT has just declared a 3:2 stock split. Your customer will now own:",
       "choice_a":"10 contracts",
       "choice_b":"15 contracts",
       "choice_c":"8 contracts",
       "choice_d":"12 contracts",
       "correct_answer":"A",
       "explanation":"With a 3:2 stock split the number of contracts remains the same and the number of shares covered by the contract will increase from 100 to 150."
    },
    {
       "id":6469,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Your customer is long 10 ERT Oct 60 calls at 6.22. ERT has just declared a 3:2 stock split. Your customer will now own:",
       "choice_a":"Contracts covering 100 shares",
       "choice_b":"Contracts covering 150 shares",
       "choice_c":"Contracts covering 120 shares",
       "choice_d":"Contracts covering 80 shares",
       "correct_answer":"B",
       "explanation":"With a 3:2 stock split the number of contracts remains the same and the number of shares covered by the contract increases to 150."
    },
    {
       "id":6470,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Your customer is long 10 ASD Oct 40 calls at 4.05. ASD has just declared a 10% stock dividend. Your customer will now own:",
       "choice_a":"10 contracts with a $40 strike price",
       "choice_b":"11 contracts with a $40 strike price",
       "choice_c":"10 contracts with a $36 strike price",
       "choice_d":"14 contracts with a $36 strike price",
       "correct_answer":"C",
       "explanation":"The price of the option contract will be adjusted down for a stock dividend. In this case the customer will now own 10 contracts with a $36 strike price."
    },
    {
       "id":6471,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Your customer is long 10 ERT Oct 60 calls at 3.22. The customer exercises the calls when ERT is at 62.05. For tax purposes the customer\u0027s cost base is:",
       "choice_a":"$60",
       "choice_b":"$62.05",
       "choice_c":"$63.22",
       "choice_d":"$65.27",
       "correct_answer":"C",
       "explanation":"To determine the customer\u0027s cost base you must add the option\u0027s premium to the exercise price. In this case 60 + 3.22 = 63.22"
    },
    {
       "id":6472,
       "practice_test_id":6,
       "topic_id":14,
       "question":"Your customer is long 7 ZNM April 45 puts at 3.11. The customer exercises the puts when ZNM is at 42.65. For tax purposes the customer\u0027s proceeds are:",
       "choice_a":"$42.65",
       "choice_b":"$45.72",
       "choice_c":"$42.65",
       "choice_d":"$41.89",
       "correct_answer":"D",
       "explanation":"With a put option you must subtract the option\u0027s premium from the strike price. In this case 45- 3.11 = 41.89"
    },
    {
       "id":6473,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor has held 1000 shares of UYT for 8 months. The investor paid $56.78 for the shares. The stock has increased in value to $59.76. The investor sells 10 UYT May 60 calls at $2.11. Which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Any gain on the sale of the shares will be short term. </li><li>The investor has lowered their breakeven on the stock </li><li>The investor has not affected their holding period for the stock </li><li>If the calls are exercised against the investor The investor\u0027s sales price for tax purposes will be $62.11</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I ,II and IV",
       "choice_d":"II, III and IV",
       "correct_answer":"D",
       "explanation":"To determine if the investor has a long term or short term gain or loss the investor in this case must sell the shares. All of the choices listed are correct."
    },
    {
       "id":6474,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor has held 1000 shares of UYT for 8 months. The investor paid $56.78 for the shares. The stock has increased in value to $59.76. The investor sells 10 UYT May 55 calls at $5.26. Which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Any gain on the sale of the shares will be short term. </li><li>The investor has lowered their breakeven on the stock </li><li>The investor has not affected their holding period for the stock </li><li>If the calls are exercised against the investor The investor\u0027s sales price for tax purposes will be $60.26</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and II",
       "choice_c":"I, II, and IV",
       "choice_d":"II, III and IV",
       "correct_answer":"C",
       "explanation":"The investor has sold in the money calls against a stock that has been held for less than 12 months therefore any gain on the sale of the stock will be short term."
    },
    {
       "id":6475,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor has held 1,000 shares of UYT for 8 months. The investor paid $56.78 for the shares. The stock has increased in value to $59.76. The investor buys 10 UYT May 55 puts at $2.05. Which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Any gain on the sale of the shares will be short term. </li><li>The investor has lowered their breakeven on the stock </li><li>The investor has not affected their holding period for the stock </li><li>If the puts are exercised the investor the investor\u0027s sales price for tax purposes will be $ $57.05</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and IV",
       "choice_c":"II and IV",
       "choice_d":"III and IV",
       "correct_answer":"A",
       "explanation":"The investor has purchased puts to protect a stock position held less than 12 months therefore any gain or loss will be short term. All of the other choices are false."
    },
    {
       "id":6476,
       "practice_test_id":"",
       "topic_id":14,
       "question":"The position limit for Foreign Currency options is:",
       "choice_a":"50,000 contracts",
       "choice_b":"75,000 contracts",
       "choice_c":"100,000 contracts",
       "choice_d":"600,000 contracts",
       "correct_answer":"D",
       "explanation":"The position limit for foreign currency options is 600,000 contracts on the same side of the market. The bullish side of the market is long calls and short puts. The bearish side of the market is long puts and short calls."
    },
    {
       "id":6477,
       "practice_test_id":"",
       "topic_id":14,
       "question":"The OCC publishes its disclosure document The Characteristics and Risk of Standardized Options in order to: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Meet the prospectus requirements of The Securities Act of 1933 </li><li>Disclose the risks of option investing </li><li>Protect issuers of the underlying securities </li><li>Advise on the suitability of option strategies for different investment objectives.</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and II",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"B",
       "explanation":"The OCC publishes the disclosure document to meet the prospectus requirement of The securities Act of 1933 and to disclose the risks of option investing. The other choices are not part of the intent of the disclosure document."
    },
    {
       "id":6478,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An options trader feels that interest rates are likely to rise after the Federal Reserve Board meets. The investor may execute which of the following trades in order to profit from their belief? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Sell rate based puts </li><li>Purchase price based calls </li><li>Write price based calls </li><li>Buy rate based calls</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and II",
       "choice_c":"I,III and IV",
       "choice_d":"I,II and IV",
       "correct_answer":"C",
       "explanation":"An investor could profit from a rise in rates by executing all of the trades except purchasing price based calls."
    },
    {
       "id":6479,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following settle in cash? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A rate based call </li><li>An index option </li><li>A foreign currency option </li><li>A price based put</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I, II and III",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"B",
       "explanation":"Of the choices listed the rate based call, the foreign currency option and the index option settle in cash. A Price based put would result in the delivery of the underlying bond."
    },
    {
       "id":6480,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following settle with the delivery of the underlying investment? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A rate based call </li><li>An index option </li><li>A foreign currency option </li><li>A price based put</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I and IV",
       "choice_d":"IV Only",
       "correct_answer":"D",
       "explanation":"Price based options are the only options in the question that settle with the delivery of the underlying investment. All of the other options settle in cash"
    },
    {
       "id":6481,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following is (are) not false relating to a credit put spread? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor is bullish </li><li>The investor wants the options to be exercised </li><li>The investor\u0027s maximum loss is unlimited </li><li>The investor wants the options to expire</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"I and II",
       "choice_d":"IV only",
       "correct_answer":"B",
       "explanation":"An investor who establishes a credit put spread is bullish and wants the options to expire."
    },
    {
       "id":6482,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following is (are) not false relating to a credit call spread? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor is bullish </li><li>The investor wants the options to be exercised </li><li>The investor\u0027s maximum loss is unlimited </li><li>The investor wants the options to expire</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I and II",
       "choice_d":"IV only",
       "correct_answer":"D",
       "explanation":"An investor who establishes a credit call spread wants the options to expire. All of the other choices are false."
    },
    {
       "id":6483,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who has written 10 ABC Nov 75 calls will automatically have the stock called away from them at expiration if the options are:",
       "choice_a":"5 cents in the money",
       "choice_b":"10 cents in the money",
       "choice_c":"1 cent in the money",
       "choice_d":"15 cents in the money",
       "correct_answer":"C",
       "explanation":"All options held for the accounts of customers will automatically be exercised if the option is 1 cent in the money."
    },
    {
       "id":6484,
       "practice_test_id":"",
       "topic_id":14,
       "question":"A broker dealer who is long options and has not given exercise instructions will have the options automatically exercised if the options are:",
       "choice_a":"10 cents in the money",
       "choice_b":"1 cent in the money",
       "choice_c":"20 cents in the money",
       "choice_d":"5 cents in the money",
       "correct_answer":"B",
       "explanation":"All options held for the accounts of broker dealers will automatically be exercised if the option is 1 cent in the money."
    },
    {
       "id":6485,
       "practice_test_id":6,
       "topic_id":14,
       "question":"An investor who establishes which of the following may realize a gain that is unlimited? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Long puts, long stock </li><li>Long calls, long puts </li><li>Long calls, short stock </li><li>Short calls, short puts</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I only",
       "choice_c":"I and II",
       "choice_d":"III and IV",
       "correct_answer":"C",
       "explanation":"An investor who is long stock with a protective put and an investor who is long a straddle have a maximum gain that is unlimited."
    },
    {
       "id":6486,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following options have a loan value?",
       "choice_a":"An in the money call with 6 months to expiration",
       "choice_b":"An out of the money call with 10 months to expiration",
       "choice_c":"An in the money put with 8 months to expiration",
       "choice_d":"Options do not have any loan value",
       "correct_answer":"B",
       "explanation":"A LEAP or an option with more than 9 months remaining to maturity may be purchased on margin by depositing 75% of the option\u0027s premium."
    },
    {
       "id":6487,
       "practice_test_id":"",
       "topic_id":14,
       "question":"A customer thinks that XCV is likely to rise in price over the next year and wants to know how much of the premium to purchase a 12 month option may be borrowed. You should tell him:",
       "choice_a":"0%",
       "choice_b":"50%",
       "choice_c":"30%",
       "choice_d":"25%",
       "correct_answer":"D",
       "explanation":"A LEAP or an option with more than 9 months remaining to maturity may be purchased on margin by depositing 75% of the option\u0027s premium. The customer may borrow the remaining 25%"
    },
    {
       "id":6488,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An option holder who wants to exercise their options just prior to expiration must send an exercise notice by:",
       "choice_a":"3:00 CST",
       "choice_b":"3:30 CST",
       "choice_c":"4:30 CST",
       "choice_d":"5:30 CST",
       "correct_answer":"C",
       "explanation":"All exercise notices must be sent by 4:30 PM CST on the Friday prior to expiration."
    },
    {
       "id":6489,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following are not false regarding option trading? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A customer or firm may not have more than 600,000 currency contracts on the same side of the market.  </li><li>A European style option may be exercised any time prior to expiration. </li><li>Option contracts may never cover more than 100 shares of stock </li><li>Foreign currency options trade on the NASDAQ OMX / PHLX from 9:30 AM - 4:00 PM EST</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"III and IV",
       "choice_d":"III only",
       "correct_answer":"B",
       "explanation":"The position limit for currency option contracts is 600,000 on the same side of the market and foreign currency options trade from 9:30 AM - 4:00 PM EST. A European style option may only be exercised at expiration and in the case of certain stock splits an option contract can be for more than 100 shares."
    },
    {
       "id":6490,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following are not true regarding option trading? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A customer or firm may not have more than 600,000 currency contracts on the same side of the market.  </li><li>A European style option may be executed any time prior to expiration. </li><li>Option contracts may never cover more than 100 shares of stock </li><li>Foreign currency options trade on the NASDAQ / PHLX from 9:30 AM - 4:30 PM EST</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"II and III",
       "choice_d":"I and IV",
       "correct_answer":"C",
       "explanation":"The position limit for currency option contracts is 600,000 on the same side of the market and foreign currency options trade from 9:30 AM - 4:30 PM EST. A European style option may only be exercised at expiration and in the case of certain stock splits an option contract can be for more than 100 shares."
    },
    {
       "id":6491,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Most customer option orders will be executed by:",
       "choice_a":"Super Display Book",
       "choice_b":"CAES",
       "choice_c":"NASDAQ",
       "choice_d":"AutoEx",
       "correct_answer":"D",
       "explanation":"Most customer orders will be executed by the AutoEx system. This system routes order to the option post for execution."
    },
    {
       "id":6492,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following is (are) not false relating to option markets? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Options expire at 10:59 PM CST on third Friday </li><li>The position limit for foreign currency options is 150,000 contracts </li><li>Equity options that are exercised will result in the delivery of the stock the next business day </li><li>Equity options cease trading at 4:00 EST the day of Expiration</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"Options expire at 10:59 Pm the third Friday . Equity options also cease trading at 4:00 PM EST on the third Friday prior to expiration. If an equity option is exercised the underlying stock will be delivered regular way in three business days. The position limit for currency contracts is 600,000 contracts on the same side of the market."
    },
    {
       "id":6493,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following is (are) not true relating to option markets? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Options expire at 10:59 PM CST on the third Friday  </li><li>The position limit for foreign currency options is 150,000 contracts </li><li>Equity options that are exercised will result in the delivery of the stock the next business day </li><li>Equity options cease trading at 4:00 EST on the day of expiration</li></ol>",
       "choice_a":"II only",
       "choice_b":"III only",
       "choice_c":"II and III",
       "choice_d":"I and IV",
       "correct_answer":"C",
       "explanation":"The position limit for foreign currency options is 600,000 contracts. If a customer exercises and equity option the stock will be delivered for regular way settlement or T+3"
    },
    {
       "id":6494,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who exercises their long calls on Friday at 3:42 PM EST will receive the underlying shares:",
       "choice_a":"Friday",
       "choice_b":"Monday",
       "choice_c":"Tuesday",
       "choice_d":"Wednesday",
       "correct_answer":"C",
       "explanation":"Equity options that are exercised will result in the delivery of the underlying stock in two business days."
    },
    {
       "id":6495,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who exercises their long index puts on Tuesday at 2:10 PM EST will receive: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A credit for the in the money amount at the time of exercise </li><li>A credit for the in the money amount at the close of business </li><li>A credit in two business days </li><li>A credit the next business day</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"D",
       "explanation":"An investor who exercises their index options will receive a credit for the in the money amount as of the close of business on the next business day."
    },
    {
       "id":6496,
       "practice_test_id":"",
       "topic_id":14,
       "question":"As it relates to the opening rotation for options which of the following is true?",
       "choice_a":"Puts with the highest strike price and nearest expiration open first",
       "choice_b":"Calls with the highest strike price and nearest expiration open first",
       "choice_c":"Puts with the lowest strike price and nearest expiration open first",
       "choice_d":"Calls with the lowest strike price and nearest expiration open first",
       "correct_answer":"D",
       "explanation":"Calls with the lowest strike price and nearest expiration open first. Followed by calls with the next lowest strike price."
    },
    {
       "id":6497,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following is (are) true relating to the options market and the OCC? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>All options of the same series are fungible </li><li>An investor who closes out their short option contract has their obligations eliminated by the OCC </li><li>The OCC is the SRO for the options markets </li><li>The OCC is owned by the option exchanges</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I, III and IV",
       "choice_d":"I, II, and IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed are correct except the OCC is not an Self Regulatory organization. The OCC is owned by the exchanges that trade options."
    },
    {
       "id":6498,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following is (are) false relating to the options market and the OCC? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The OCC assigns exercise notices directly to a customer who is short the option </li><li>An investor who closes out their short option contract has their obligations eliminated by the OCC </li><li>The OCC is the SRO for the options markets </li><li>The OCC is owned by the option exchanges</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"IV only",
       "choice_d":"I and III",
       "correct_answer":"D",
       "explanation":"The OCC will assign an exercise notice to a broker dealer who has a customer who is short the option. The broker dealer then must assign the exercise notice to a customer who is short the option on a random basis. The OCC is not a self regulatory organization."
    },
    {
       "id":6499,
       "practice_test_id":1,
       "topic_id":14,
       "question":"As it relates to foreign currency options which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The US Dollar is the base currency </li><li>The position limit is 250,000 contracts </li><li>The premium for the Japanese Yen is quoted in hundredths of a cent </li><li>Options are available in both American and European exercise</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I, III and IV",
       "choice_d":"I, II and IV",
       "correct_answer":"C",
       "explanation":"All of the choices are correct except the position limit for foreign currency options is 600,000 contracts on the same side of the market. The US dollar is the base currency and all foreign currency options settle in the delivery of US dollars"
    },
    {
       "id":6500,
       "practice_test_id":2,
       "topic_id":14,
       "question":"As it relates to foreign currency options which of the following are not true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The US Dollar is the base currency </li><li>The position limit is 250,000 contracts </li><li>All premiums are quoted in tenths of a cent </li><li>Options are available in American exercise only</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I, II and IV",
       "choice_d":"II, III and IV",
       "correct_answer":"D",
       "explanation":"All of the choices are false except that the US Dollar is the base currency for all foreign currency options. Currency options are issued as both American and European style options. The premium for the Japanese Yen is quoted in hundredths of a cent. "
    },
    {
       "id":6501,
       "practice_test_id":3,
       "topic_id":14,
       "question":"The primary exchange for foreign currency options is:",
       "choice_a":"CBOE",
       "choice_b":"NASDAQ /PHLX",
       "choice_c":"PSE",
       "choice_d":"AMEX",
       "correct_answer":"B",
       "explanation":"The primary exchange for foreign currency options is the NASDAQ / PHLX."
    },
    {
       "id":6502,
       "practice_test_id":4,
       "topic_id":14,
       "question":"An OEX 610 call has contract value of?",
       "choice_a":"$6,100",
       "choice_b":"$61,000",
       "choice_c":"$610,000",
       "choice_d":"$6,100,000",
       "correct_answer":"B",
       "explanation":"An OEX 610 call has a contract value of $61,000. The multiplier for the contract is 100."
    },
    {
       "id":6503,
       "practice_test_id":5,
       "topic_id":14,
       "question":"All of the following trade on the floor of the CBOE except:",
       "choice_a":"Board broker",
       "choice_b":"Floor broker",
       "choice_c":"Specialist",
       "choice_d":"Competitive trader",
       "correct_answer":"C",
       "explanation":"The CBOE uses a board broker to maintain a fair and orderly market in the options that trade on the floor. The CBOE does not use a specialist."
    },
    {
       "id":6504,
       "practice_test_id":6,
       "topic_id":14,
       "question":"An investor wants to realize the greatest possible gain on a long stock position that has increased in value and protect his stock from a correction. The stock is currently trading at $62.20. Which of the following would you recommend?",
       "choice_a":"Sell calls with a strike price of 65",
       "choice_b":"Buy puts with a strike price of 60",
       "choice_c":"Buy puts with a strike price of 65",
       "choice_d":"Sell calls with a strike price of 70",
       "correct_answer":"B",
       "explanation":"Buying the puts with a strike price of 60 would be the most appropriate choice for this investor. The in the money puts with a strike price of 65 do not make sense."
    },
    {
       "id":6505,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following are not false relating to a board broker? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>They are employees of the exchange </li><li>They are required to provide liquidity to the market by acting as a principal </li><li>The execute orders for members </li><li>The supervise the opening rotations</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I, III and IV",
       "choice_d":"I and IV",
       "correct_answer":"C",
       "explanation":"Board brokers are employees of the exchange and may not trade for their own account. They supervise opening rotation and execute orders for members. "
    },
    {
       "id":6506,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following are not true relating to a board broker? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>They are employees of the exchange </li><li>They are required to provide liquidity to the market by acting as a principal </li><li>The execute orders for members </li><li>The supervise the opening rotations</li></ol>",
       "choice_a":"II only",
       "choice_b":"I and II",
       "choice_c":"II, III and IV",
       "choice_d":"IV only",
       "correct_answer":"A",
       "explanation":"All of the choices are true except a board broker may not trade as a principal."
    },
    {
       "id":6507,
       "practice_test_id":"",
       "topic_id":14,
       "question":"You are short 500 ASD at 43.24 and the stock has fallen to 39.43. You think that the stock will continue to decline but want to protect your profit in case the stock rallies back. If you purchase 5 ASD April 40 calls at 2.10 and you have to exercise the call at expiration to protect your short stock position, what is your gain or loss?",
       "choice_a":"$570 loss",
       "choice_b":"$570 gain",
       "choice_c":"$1,905 gain",
       "choice_d":"$855 gain",
       "correct_answer":"B",
       "explanation":"You made $570 on the trade. You had to repurchase the stock by exercising the calls. Your cost was the $40 strike price plus the premium of 2.10 or 42.10. You received 43.24 when you sold the stock short so your gain was 1.14 per share or $570 for the entire position."
    },
    {
       "id":6508,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Your customer is long 10 OEX 575 calls at 8.15. The OEX has  had a major move in the last two days and the OEX is at 592.15. Your customer wants to lock in the profit and there are three days to expiration. Which of the following would recommend?",
       "choice_a":"Exercise the options at the close",
       "choice_b":"Sell the options",
       "choice_c":"Sell 10 OEX 595 calls to lock in the gain and have the chance for even greater profits",
       "choice_d":"Buy 10 OEX 590 puts in case the market falls",
       "correct_answer":"B",
       "explanation":"The best choice in this case is to always sell the options. Index options settle in cash with the in the money amount being credited to the holder. The settlement value of the index on the day the option is exercised will be used to determine the amount that is credited to the holder. The amount received may vary greatly from the in the money amount at the time of exercise if the market goes against the option holder. Additionally, if an investor exercises the option prior to expiration they will lose any time value in the option premium and would receive more if the option was sold."
    },
    {
       "id":6509,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Your customer is long 10 OEX 575 calls at 8.15. The OEX has had a major advance over the last two days and is now at 592.10, there are three days left to expiration and they want to lock in a profit. Which of the following would you recommend.",
       "choice_a":"Exercise the options at the close",
       "choice_b":"Sell the options",
       "choice_c":"Sell 10 OEX 595 calls",
       "choice_d":"Buy 10 OEX 590 puts",
       "correct_answer":"B",
       "explanation":"The best choice in this case is to always sell the options. Index  options settle in cash with the in the money amount being credited to  the holder. The settlement value of the index on the day the option is  exercised will be used to determine the amount that is credited to the  holder. The amount received may vary greatly from the in the money  amount at the time of exercise if the market goes against the option  holder. Additionally, if an investor exercises the option prior to  expiration they will lose any time value in the option premium and would  receive more if the option was sold. "
    },
    {
       "id":6510,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Your customer is short 1000 IOU at 39.43 and has sold 10 IOU May 35 puts at 1.20. Which of the following is (are) true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor\u0027s potential loss is limited </li><li>The investor\u0027s breakeven is 40.63 </li><li>If the stock rises the investor will have the stock called away from them </li><li>If at expiration IOU is at 39.43 the investor will realize a profit</li></ol>",
       "choice_a":"II only",
       "choice_b":"III only",
       "choice_c":"I and III",
       "choice_d":"II and IV",
       "correct_answer":"D",
       "explanation":"The investor is short stock and short puts therefore the potential loss is unlimited. The investor will breakeven at 40.63 found by adding the proceeds from the short sale to the premium received for selling the puts. If at expiration IOU is at 39.43 the investor will realize a profit when the short puts expire."
    },
    {
       "id":6511,
       "practice_test_id":6,
       "topic_id":14,
       "question":"Your customer is short 1000 IOU at 39.43 and has sold 10 IOU May 35 puts at 1.20. Which of the following is (are) false? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor\u0027s potential loss is limited </li><li>The investor\u0027s breakeven is 40.63 </li><li>If the stock rises the investor will have the stock called away from them </li><li>If at expiration IOU is at 39.43 the investor will realize a profit</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I only",
       "choice_c":"I and III",
       "choice_d":"I and II",
       "correct_answer":"C",
       "explanation":"The investor is short stock and short puts. Their potential loss is unlimited. The investor is short puts not calls so the stock cannot be called away from them."
    },
    {
       "id":6512,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor has a portfolio with worth $500,000 and a beta of 1.2. They are concerned about a market correction and want to protect their holdings. Which of the following would you recommend?",
       "choice_a":"Purchase puts on the stocks in the portfolio",
       "choice_b":"Sell calls on the stocks in their portfolio",
       "choice_c":"Purchase 8 OEX 600 Puts",
       "choice_d":"Purchase 10 OEX 600 puts",
       "correct_answer":"D",
       "explanation":"It would be more effective for the investor to purchase index puts to protect their portfolio. The investor\u0027s portfolio has a beta adjusted value of $600,000. Found by multiplying the value of the account by its beta. In this case $500,000 X 1.2 = $600,000. To determine how many puts the investor would need to buy, divide the beta adjusted value by the index value in the strike price. In this case $600,000 / 60,000 = 10"
    },
    {
       "id":6513,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following are not false relating to index options? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Capped options will be automatically exercised if they are 20 points in the money. </li><li>Settlement of exercised options will be in cash in two business days. </li><li>Broad based index options stop trading at 4:10 PM EST </li><li>Index options opening rotation starts with the near term calls</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"III and IV",
       "choice_d":"I, III and IV",
       "correct_answer":"C",
       "explanation":"Broad based index options stop trading at 4:10 PM EST and the opening rotation starts with the near term calls. Index options settle in cash the next business day and capped index options will automatically be exercised if they are 30 points in the money."
    },
    {
       "id":6514,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following are not true relating to index options? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Capped options will automatically be exercised if they are 20 points in the money. </li><li>Settlement of exercised options will be in cash in two business days. </li><li>Broad based index options stop trading at 4:10 PM EST </li><li>Index options opening rotation starts with the near term calls</li></ol>",
       "choice_a":"III and IV",
       "choice_b":"I and II",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"B",
       "explanation":"Broad based index options stop trading at 4:10 PM EST and the opening rotation starts with the near term calls. Index options settle in cash the next business day and capped index options will automatically be exercised if they are 30 points in the money."
    },
    {
       "id":6515,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An option investor would have a risk reward profile most like that of an investor who is long stock if they establish which of the following positions?",
       "choice_a":"Long calls, long puts",
       "choice_b":"Short calls, short puts",
       "choice_c":"Long calls, short puts",
       "choice_d":"short calls, long puts",
       "correct_answer":"C",
       "explanation":"An investor who is long calls and short puts will have a risk reward profile most like that of an investor who is long stock."
    },
    {
       "id":6516,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An option investor would have a risk reward profile most like that of an investor who is short stock if they establish which of the following positions?",
       "choice_a":"Long puts, short calls",
       "choice_b":"Long puts, long calls",
       "choice_c":"Short puts, short calls",
       "choice_d":"Short puts, long calls",
       "correct_answer":"A",
       "explanation":"An option investor would have a risk reward profile most like an investor who is short stock if they were long puts and short calls."
    },
    {
       "id":6517,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor is long 10 UTI Oct 75 calls at 4.10. If UTI declares a 2:1 stock split which of the following is ( are ) true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor\u0027s cost base will be $2.05 </li><li>The number of shares covered by the contract will increase </li><li>The investor\u0027s aggregate exercise value be $75,000 </li><li>The quote for the contract will appear with an asterisk</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"I, III and IV",
       "correct_answer":"B",
       "explanation":"If The stock splits 2:1 the investor\u0027s cost base will be $2.05 for the option and the aggregate exercise price will remain $75,000."
    },
    {
       "id":6518,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor is long 10 UTI Oct 75 calls at 4.10. If UTI declares a 2:1 stock split which of the following is ( are ) false? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor\u0027s cost base will be $2.05 </li><li>The number of shares covered by the contract will increase </li><li>The investor\u0027s aggregate exercise value be $75,000 </li><li>The quote for the contract will appear with an asterisk</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I only",
       "choice_d":"I, II and IV",
       "correct_answer":"A",
       "explanation":"If a stock splits 2:1 the number of contracts will increase and the number of shares covered by the contract will remain the same. Only options that are for a number of shares other than 100 will appear with an asterisk."
    },
    {
       "id":6519,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Option advertising must at be approved by:",
       "choice_a":"A branch manager",
       "choice_b":"A ROP",
       "choice_c":"FINRA",
       "choice_d":"NYSE",
       "correct_answer":"B",
       "explanation":"option advertising must be approved by a registered options principal or ROP."
    },
    {
       "id":6520,
       "practice_test_id":"",
       "topic_id":14,
       "question":"As it relates to option taxation which of the following is true?",
       "choice_a":"Gains and losses on all options are short term",
       "choice_b":"Buyers of options will always have a short term gain on the sale of an option sold at a profit",
       "choice_c":"Writers of options will always have a short term capital gain if the option expires worthless",
       "choice_d":"All tax consequences for options will be factored independently from the  underlying stock position",
       "correct_answer":"C",
       "explanation":"Writers of options will always have a short term capital gain if the option expires worthless regardless if the option involved is a traditional option or a LEAP. Buyers of LEAPS can have a long term capital gain"
    },
    {
       "id":6521,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who exercises a put must do which of the following for tax purposes?",
       "choice_a":"Add the put\u0027s premium to the strike price",
       "choice_b":"Subtract the put\u0027s premium from the strike price",
       "choice_c":"Subtract the put\u0027s premium from the price paid for the stock",
       "choice_d":"Add the put\u0027s premium to the execution costs of the transaction",
       "correct_answer":"B",
       "explanation":"The investor must subtract the put\u0027s premium from the put\u0027s strike price."
    },
    {
       "id":6522,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An option investor who is long price based puts would least likely realize a gain from which of the following?",
       "choice_a":"A poor economic report is released",
       "choice_b":"A poor Treasury auction",
       "choice_c":"The Treasury issues more debt than expected",
       "choice_d":"The FRB increases the overnight lending rate by 25 basis points",
       "correct_answer":"A",
       "explanation":"A poor economic report will usually drive interest rates down, causing the price on Treasury securities to rise. All of the other choices will likely cause the price of Treasury securities to fall."
    },
    {
       "id":6523,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An option investor who is long price based calls would most likely realize a gain from which of the following?",
       "choice_a":"The FRB raises the overnight lending rate by 25 basis points",
       "choice_b":"A large foreign government invests substantial reserves in Treasury securities",
       "choice_c":"A report shows producer prices are heading higher",
       "choice_d":"Strong economic data is released",
       "correct_answer":"B",
       "explanation":"If a foreign government invests a large amount of their reserves in Treasury securities it will increase demand and drive Treasury prices up.The other choices listed will most likely cause Treasury prices to fall."
    },
    {
       "id":6524,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following would most likely not cause an options trader to sell price based calls?",
       "choice_a":"The FRB raises the overnight lending rate by 25 basis points",
       "choice_b":"A large foreign government invests substantial reserves in Treasury securities",
       "choice_c":"A report shows producer prices are heading higher",
       "choice_d":"Strong economic data is released",
       "correct_answer":"B",
       "explanation":"A foreign government that invests a substantial amount of its reserves in Treasury securities would cause the price of Treasury securities to raise. All of the other choices listed may be a reason for an investor to sell price based calls."
    },
    {
       "id":6525,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An options investor who believes that prices in the marketplace will increase would least likely execute which of the following trades?",
       "choice_a":"Sell OEX index puts to open",
       "choice_b":"Sell OEX index calls to close",
       "choice_c":"Buy OEX call spreads",
       "choice_d":"Buy OEX index calls to open",
       "correct_answer":"B",
       "explanation":"An option investor who thinks that the prices in the marketplace will increase would be least likely to sell OEX index call options to close."
    },
    {
       "id":6526,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following would least likely result in a profit for an investor who has established a credit call spread?",
       "choice_a":"A large increase in volatility",
       "choice_b":"An increase in the price of the underlying security",
       "choice_c":"A decrease in the price of the underlying security",
       "choice_d":"The price of the underlying security remains stagnant",
       "correct_answer":"B",
       "explanation":"An investor who has established a credit call spread would lose money if the price of the underlying security increases."
    },
    {
       "id":6527,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor sells 7 TGH April 45 puts at 3.15 to open when TGH is at $46.35. At expiration TGH closes $43.11 and the investor closes out the position at its intrinsic value. What is the investor\u0027s gain or loss?",
       "choice_a":"$882 gain",
       "choice_b":"$882 loss",
       "choice_c":"$1,890 gain",
       "choice_d":"$1,890 loss",
       "correct_answer":"A",
       "explanation":"The investor sold the options at $3.15 and bought them back at $1.89, making $1.26 per share. $1.26 X 700 = $882"
    },
    {
       "id":6528,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor sells 7 TGH April 45 calls at 4.15 to open when TGH is at $46.35. At expiration TGH closes $47.41 and the investor closes out the position at its intrinsic value. What is the investor\u0027s gain or loss?",
       "choice_a":"$1,218 gain",
       "choice_b":"$742 gain",
       "choice_c":"$1,960 loss",
       "choice_d":"$1,960 gain",
       "correct_answer":"A",
       "explanation":"The investor sold the calls at $4.15 and bought them back at 2.41 for a 1.74 profit. $1.74 X 700 = $1,218"
    },
    {
       "id":6529,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor sells 9 KIO April 45 puts at 2.15 to open when KIO is at $46.04. At expiration KIO closes $43.09 and the investor closes out the position at its intrinsic value. What is the investor\u0027s gain or loss?",
       "choice_a":"$216 gain",
       "choice_b":"$216 loss",
       "choice_c":"$1,719 loss",
       "choice_d":"$1,719 gain",
       "correct_answer":"A",
       "explanation":"The investor sold the options at 2.15 and bought them back at 1.91, making 24 cents. .24 x 900 = $216"
    },
    {
       "id":6530,
       "practice_test_id":"",
       "topic_id":14,
       "question":"The central bank of Japan has just increased its short term interest rates for the first time in several years. An investor who wanted to profit from this action would:",
       "choice_a":"Buy calls on the US Dollar",
       "choice_b":"Buy puts on the US Dollar",
       "choice_c":"Buy puts on the Japanese Yen",
       "choice_d":"Buy calls on the Japanese Yen",
       "correct_answer":"D",
       "explanation":"If a country\u0027s central bank increases its short term interest rates the currency in that country becomes more valuable. The investor in this case should buy calls on the Yen."
    },
    {
       "id":6531,
       "practice_test_id":6,
       "topic_id":14,
       "question":"The central bank of Japan has just lowered its short term interest rates for the first time in several years. An investor who wanted to profit from this action would:",
       "choice_a":"Buy calls on the Yen",
       "choice_b":"Sell puts on the Yen",
       "choice_c":"Buy puts on the Yen",
       "choice_d":"Sell puts on the US Dollar",
       "correct_answer":"C",
       "explanation":"If a country\u0027s central bank lowers its interest rates, that country\u0027s currency will become weaker relative to other currencies."
    },
    {
       "id":6532,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who sells 5 ABC June 50 calls at 2.10 to open and who buys 5 ABC June 40 calls at 5.05 will have to deposit how much to maintain the position?",
       "choice_a":"$505",
       "choice_b":"$295",
       "choice_c":"$1,475",
       "choice_d":"$2,525",
       "correct_answer":"C",
       "explanation":"The investor will have to deposit the total net debit for the spread of $1,475. Found by subtracting the credit of 2.10 from the debit of 5.05 = 2.95 X 500 = $1,475."
    },
    {
       "id":6533,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who sells 5 ABC June 50 calls at 2.10 to open and who buys 5 ABC June 40 calls at 5.05 has a maximum gain on the position of:",
       "choice_a":"$1,475",
       "choice_b":"$705",
       "choice_c":"$3,525",
       "choice_d":"$2,525",
       "correct_answer":"C",
       "explanation":"This is a debit call spread. The investor\u0027s maximum gain is found by subtracting the net debit of 2.95 from the 10 point spread and multiplying by 500. 7.05 X 500 = $3,525."
    },
    {
       "id":6534,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who sells 5 ABC June 50 calls at 2.10 to open and who buys 5 ABC June 40 calls at 5.05 has a maximum loss on the position of:",
       "choice_a":"$1,475",
       "choice_b":"$705",
       "choice_c":"$3,525",
       "choice_d":"$2,525",
       "correct_answer":"A",
       "explanation":"This is a debit call spread. The investor\u0027s maximum loss is equal to the net debit of $1,475. The investor bought the lower strike price call and sold the call with a higher strike price. The spread was established for a net debit of $2.95 per share or $295 per contract X 5 contracts = $1,475"
    },
    {
       "id":6535,
       "practice_test_id":"",
       "topic_id":14,
       "question":"ABC as a utility company pays a higher than average dividend of 75 cents per share. ABC goes ex dividend on Friday May 2. When is the first day an investor who is long puts on ABC can exercise the puts and still receive the dividend?",
       "choice_a":"Monday May 2",
       "choice_b":"Sunday May 1",
       "choice_c":"Saturday April 30",
       "choice_d":"Friday April 29",
       "correct_answer":"A",
       "explanation":"An investor who exercises a put option will be required to deliver the stock in two business days. If the owner of the puts exercises the puts they will receive the dividend only if they exercise the options on the ex dividend date or later."
    },
    {
       "id":6536,
       "practice_test_id":"",
       "topic_id":14,
       "question":"ABC as a utility company pays a higher than average dividend of 75 cents per share. ABC goes ex dividend on Friday May 2. When is the last day an investor who is long calls on ABC can exercise the calls and receive the dividend?",
       "choice_a":"Monday May 2",
       "choice_b":"Sunday May 1",
       "choice_c":"Saturday April 30",
       "choice_d":"Friday April 29",
       "correct_answer":"B",
       "explanation":"An investor who exercises a call option will be required to take delivery of the stock in two business days. If the owner of the calls exercises the calls they will receive the dividend only if they exercise the options before the ex dividend date."
    },
    {
       "id":6537,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who sells 15 OEX 500 calls at 12.15 to open could effectively hedge which of the following portfolio values?",
       "choice_a":"$450,000",
       "choice_b":"$750,000",
       "choice_c":"$500,000",
       "choice_d":"$512,500",
       "correct_answer":"B",
       "explanation":"To determine the total index value covered by the option position take the number of contracts and multiply it times the index value of the strike price. In this case 50,000 (500 x100) X 15 = $750,000."
    },
    {
       "id":6538,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor could profit from which of the following trades after the EU raises interest rates?",
       "choice_a":"Buy puts on the Euro",
       "choice_b":"Sell puts on the Euro",
       "choice_c":"Buy calls on the US Dollar",
       "choice_d":"Sell calls on the US Dollar",
       "correct_answer":"B",
       "explanation":"If a central bank raises interest rates it will make that currency more valuable relative to other currencies. Of the choices listed, the investor could make a profit by selling puts on the Euro. Options do not trade domestically on the US Dollar."
    },
    {
       "id":6539,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following: <ol style='margin-left: 25px; list-style-type: disc;'><li>Long 10 ABC Oct 45 calls at 6 </li><li>Short 10ABC Oct 50 calls at 1 </li></ol>The investor\u0027s maximum gain is:",
       "choice_a":"$1,000",
       "choice_b":"$5,000",
       "choice_c":"$0",
       "choice_d":"$4,000",
       "correct_answer":"C",
       "explanation":"The investor who purchased this spread cannot make a profit. The investor paid $5 for a 5 point spread so a profit is not possible."
    },
    {
       "id":6540,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who is long 1 US T Bond 105 call at 1.30 exercises the call. Which of the following is / are not false? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> The bond will be delivered in 1 business day </li><li>The investor will pay 1050 for the bond </li><li> The investor exercising the call will owe interest </li><li> The investor will break even on the bond at 102.70</li></ol>",
       "choice_a":"II,III and IV",
       "choice_b":"I, II and III",
       "choice_c":"I, III and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"B",
       "explanation":"All of the choices listed are true or not false except the investor purchased the call so the premium of 1.30 is added to the strike price to determine the breakeven not subtracted from it."
    },
    {
       "id":6541,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who is short 1 US T Bond 105 call at 1.30 receives an exercise notice for the call. Which of the following are not false? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The bond will be delivered in 1 business day </li><li>The investor will receive 1050 for the bond </li><li>The investor exercising the call will owe interest </li><li>The investor will be given an additional settlement day for delivery if they are not long the underlying bond.</li></ol>",
       "choice_a":"II,III and IV",
       "choice_b":"I, II and III",
       "choice_c":"I, III and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"B",
       "explanation":"All of the choices listed are true or not false except the investor will not be given an extra day to deliver the bond."
    },
    {
       "id":6542,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor sells 12 IJK Nov 50 puts at 4.90 to open when IJK is at 48.30. At expiration IJK is at 46.40 and the investor closes out the position at its intrinsic value. Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor is bullish </li><li>The investor made a profit of $1,560 </li><li>The investor closed the position by purchasing the options </li><li>The investor lost money on the investment</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I, II, and III",
       "choice_d":"I, III and IV",
       "correct_answer":"C",
       "explanation":"The investor purchased the options back at expiration and realized a profit of $1,560. The investor sold the options at 4.90 and bought them back at 6.60, realizing a profit of 1.30 X 1200 $1,560."
    },
    {
       "id":6543,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor is long 700 FGH at 43.46. The stock has increased in value to 48.91. If the investor is concerned that the company may not meet its earnings and would like to protect against a decline in the stock, yet still be able to realize any additional appreciation they should:",
       "choice_a":"Buy puts at 50",
       "choice_b":"Sell calls at 50",
       "choice_c":"Sell calls at 50 and buy 45 puts",
       "choice_d":"Buy puts at 45",
       "correct_answer":"D",
       "explanation":"The investor should purchase puts with a strike price of 45. Buying the in the money puts does not make economic sense."
    },
    {
       "id":6544,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who is short 1000 TYU at 72.45 has watched the stock decline to 68.30 during a broad based market correction. The investor then sells 10 TYU May 65 puts at 2.15 to open. Which of the following is or are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor has increased their breakeven on the stock </li><li>The investor has limited their gain on the position  </li><li>The investor has reduced their potential loss on the position </li><li>The investor has increased their income on the position</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"I, III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed are correct. Selling puts increases the investor\u0027s income and raises their breakeven on the stock. Selling puts also lowers their potential loss and potential gain for the position."
    },
    {
       "id":6545,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following option positions have a risk reward profile similar to that of a long stock position?",
       "choice_a":"Short put, short call",
       "choice_b":"Long call, short put",
       "choice_c":"Long put, long call",
       "choice_d":"Short put, long call",
       "correct_answer":"D",
       "explanation":"An investor who is short a put and long a call has a risk reward profile similar to a long stock position."
    },
    {
       "id":6546,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following option positions have a risk reward profile similar to that of a short stock position?",
       "choice_a":"Short put, short call",
       "choice_b":"Long call, short put",
       "choice_c":"Long put, short call",
       "choice_d":"Short put, long call",
       "correct_answer":"C",
       "explanation":"An investor who is long a put and short a call has a risk reward profile similar to a short stock position."
    },
    {
       "id":6547,
       "practice_test_id":2,
       "topic_id":14,
       "question":"YTR has been hitting a lot of resistance at 50. An investor who feels that the stock is likely to remain inside its recent trading range and decline may profit from:",
       "choice_a":"Buying a call",
       "choice_b":"Selling a put",
       "choice_c":"Buying a put",
       "choice_d":"Selling a straddle",
       "correct_answer":"C",
       "explanation":"Of the choices listed only buying a put would allow the investor to realize a profit if the stock were to fall."
    },
    {
       "id":6548,
       "practice_test_id":3,
       "topic_id":14,
       "question":"An investor who is short 10 JGH May 70 calls could create a diagonal spread by:",
       "choice_a":"Selling 10 JGH Oct 70 calls",
       "choice_b":"Buying 10 JGH Nov 70 calls",
       "choice_c":"Selling 10 JGH Sept 60 calls",
       "choice_d":"Buying 10 JGH Dec 60 calls",
       "correct_answer":"D",
       "explanation":"A diagonal spread consists of one long and one short call on the same stock with different strike prices and expiration months."
    },
    {
       "id":6549,
       "practice_test_id":4,
       "topic_id":14,
       "question":"An investor who is long 1000 shares of HJT stock at 56.22 sells 10 HJT Dec 55 calls at 3.05 to open against his long stock position. HJT increases to 59.30 by expiration and the investor closes out the option position at its intrinsic value and sells the stock at 59.30. What was the investor\u0027s gain or loss?",
       "choice_a":"$1,830 loss",
       "choice_b":"$1,830 gain",
       "choice_c":"$2,470 loss",
       "choice_d":"$2,470 gain",
       "correct_answer":"B",
       "explanation":"The investor purchased the stock at 56.22 and sold it at 59.30 for a gain of 3.08 per share. The investor also sold December 55 calls at 3.05 and bought them back at 4.30 for a loss of 1.25. When you net the gain on the stock position and the loss on the option position the investor made 1.83 per share found as follows: 3.08 \u2013 1.25 = 1.83. The gain for the entire position is found as follows: 1.83 X 1000 = $1,830"
    },
    {
       "id":6550,
       "practice_test_id":5,
       "topic_id":14,
       "question":"A pension plan manager feels that interest rates are likely to rise over the next few months. The pension plan is holding $10,000,000 worth of Treasury bonds that the manager wants to hedge against a price decline. How many price based put options would the manager have to purchase to hedge the plan\u0027s portfolio?",
       "choice_a":10,
       "choice_b":100,
       "choice_c":200,
       "choice_d":20,
       "correct_answer":"B",
       "explanation":"Price based Treasury bond options cover $100,000 par value. The portfolio manager would have to purchase 100 put options."
    },
    {
       "id":6551,
       "practice_test_id":6,
       "topic_id":14,
       "question":"An investor sells 12 OWG 22.50 calls at 3.04 to open when OWG is trading at 23.12. OWG trades up to 25.30 at expiration and the investor closes out the position at its intrinsic value with a closing purchase. What is the investor\u0027s gain or loss?",
       "choice_a":"$288 Gain",
       "choice_b":"$240 Gain",
       "choice_c":"$288 loss",
       "choice_d":"$ 240 loss",
       "correct_answer":"A",
       "explanation":"The investor made $288. The investor sold the options at $3.04 and bought them back at their intrinsic value of $2.80 therefore making a profit of 24 cents per share. 24 cents X 1200 shares = $288."
    },
    {
       "id":6552,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following position: <ol style='margin-left: 25px; list-style-type: disc;'><li>Short 10 NMB 75 puts at 4.12 </li><li>Short 1000 NMB at 76.03 </li></ol>Which of the following are not true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor has an unlimited loss potential </li><li>If at expiration NMB is at 80.15 the investor will breakeven </li><li>If at expiration NMB is at 78.40 the investor will lose money </li><li>If at expiration NMB is at 80.22 the investor will make money</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"IV only",
       "choice_d":"II and III",
       "correct_answer":"B",
       "explanation":"The question asks which is not true? The investor will lose money above 80.15 and will make money below 80.15 therefore  III and IV are not true."
    },
    {
       "id":6553,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following position: <ol style='margin-left: 25px; list-style-type: disc;'><li>Short 10 NMB 75 puts at 4.12 </li><li>Short 1000 NMB at 76.03 </li></ol>Which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor has an unlimited loss potential </li><li>If at expiration NMB is at 80.15 the investor will breakeven </li><li>If at expiration NMB is at 78.40 the investor will loss money </li><li>If at expiration NMB is at 80.22 the investor will make money</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and IV",
       "choice_c":"IV only",
       "choice_d":"II and III",
       "correct_answer":"A",
       "explanation":"The investor has the potential for an unlimited loss and will breakeven at 80.15 The investor will lose money above 80.15 and will make money below 80.15 therefore III and IV are not true."
    },
    {
       "id":6554,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following position: <ol style='margin-left: 25px; list-style-type: disc;'><li>Short 10 NMB 75 puts at 4.12 </li><li>Short 1000 NMB at 76.03 </li></ol>What is the investor\u0027s maximum gain?",
       "choice_a":"Unlimited",
       "choice_b":"$5,150",
       "choice_c":"$2,650",
       "choice_d":"$11,150",
       "correct_answer":"B",
       "explanation":"The investor is short stock and short puts. To determine the investor\u0027s maximum gain you must subtract the put\u0027s strike price from the investor\u0027s breakeven. In this case 80.15 – 75 = 5.15 X 1000 = $5,150"
    },
    {
       "id":6555,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following position:<ol style='margin-left: 25px; list-style-type: disc;'><li>Short 10 NMB 75 puts at 4.12 </li><li>Short 1000 NMB at 76.03</li></ol>What is the investor\u0027s maximum loss?",
       "choice_a":"Unlimited",
       "choice_b":"$5,150",
       "choice_c":"$2,650",
       "choice_d":"$11,150",
       "correct_answer":"A",
       "explanation":"The investor is short stock and short puts the investor has a loss that is unlimited."
    },
    {
       "id":6556,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who is bearish on a stock may want to establish all of the following positions except:",
       "choice_a":"Short puts",
       "choice_b":"Short calls at 50 long calls at 60",
       "choice_c":"Long puts at 85 short puts at 70",
       "choice_d":"Short calls",
       "correct_answer":"A",
       "explanation":"An investor who is bearish may want to establish all of the positions listed except short puts. A short put position may be established by a bullish investor."
    },
    {
       "id":6557,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who is bullish on a stock may want to establish which of the following positions?",
       "choice_a":"Short puts",
       "choice_b":"Short calls at 50 long calls at 60",
       "choice_c":"Long puts at 85 short puts at 70",
       "choice_d":"Short calls",
       "correct_answer":"A",
       "explanation":"An investor who is bullish may want to establish a short put position."
    },
    {
       "id":6558,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Currency options expire:",
       "choice_a":"On the the third Friday",
       "choice_b":"On the Tuesday following the third Friday",
       "choice_c":"On the third Friday preceding the third Wednesday",
       "choice_d":"On the Tuesday preceding the third Wednesday",
       "correct_answer":"A",
       "explanation":"Currency options expire on the third Friday of each month."
    },
    {
       "id":6559,
       "practice_test_id":"",
       "topic_id":14,
       "question":"You are looking at potential option trades and see the following quote:<br>*GYT Nov 75 calls 6.19<br>What does the \u0022*\u0022 tell you?",
       "choice_a":"GYT is paying a special cash dividend",
       "choice_b":"GYT is the subject of an open tender offer",
       "choice_c":"GYT Nov 75 calls cover more than 100 shares",
       "choice_d":"GYT Nov 75 calls are LEAPS",
       "correct_answer":"C",
       "explanation":"An asterisk next to an option quote means that the contract is for more than 100 shares. This would most likely be the result of a stock split."
    },
    {
       "id":6560,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who established all of the following positions would be considered bearish except:",
       "choice_a":"Short calls at 40, long calls at 55",
       "choice_b":"Long puts at 80, short puts at 60",
       "choice_c":"Short puts, short stock",
       "choice_d":"Short calls at 90, long calls at 85",
       "correct_answer":"D",
       "explanation":"All of the positions listed are bearish except an investor who is long a bull call spread. Being short calls at 90 and long calls at 85 is a bull call spread."
    },
    {
       "id":6561,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who is bullish would establish which of the following positions?",
       "choice_a":"Short calls at 40, long calls at 55",
       "choice_b":"Long puts at 80, short puts at 60",
       "choice_c":"Short puts, short stock",
       "choice_d":"Short calls at 90, long calls at 85",
       "correct_answer":"D",
       "explanation":"An investor who is bullish may establish a bull call spread. Being short calls at 90 and long calls at 85 is a bull call spread."
    },
    {
       "id":6562,
       "practice_test_id":"",
       "topic_id":14,
       "question":"The OCC will do which of the following?",
       "choice_a":"Automatically exercise options for a customer who long an option that is 10 cents in the money",
       "choice_b":"Randomly assign an exercise notice to a customer",
       "choice_c":"Eliminate the obligations of an investor who closes out a short option position",
       "choice_d":"Protect investors from losses in options trading",
       "correct_answer":"C",
       "explanation":"If an investor closes out an option position The OCC will close out their obligations."
    },
    {
       "id":6563,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Option contracts are issued by The OCC:",
       "choice_a":"Each month for which options are open for trading",
       "choice_b":"On the trade date",
       "choice_c":"On the business day following the trade date",
       "choice_d":"On the Monday following the third Friday",
       "correct_answer":"C",
       "explanation":"The OCC issues option contracts on the business day following the trade date"
    },
    {
       "id":6564,
       "practice_test_id":"",
       "topic_id":14,
       "question":"The premium for a Japanese Yen currency option is quoted in:",
       "choice_a":"Cents",
       "choice_b":"10th of a cent",
       "choice_c":"100th of a cent",
       "choice_d":"Yen",
       "correct_answer":"C",
       "explanation":"The premium for a Japanese Yen currency option is quoted in 100ths of a cent"
    },
    {
       "id":6565,
       "practice_test_id":6,
       "topic_id":14,
       "question":"An investor who purchases 5 price based Treasury bond call options at 1.04 will pay how much in total premium for the options?",
       "choice_a":"$5,625",
       "choice_b":"$5,250",
       "choice_c":"$2,600",
       "choice_d":"$2,812.50",
       "correct_answer":"A",
       "explanation":"The quote of 1.04 =1 4/32% or 1.125% X 100,000 par value = $1,125 X 5 contracts = $5,625 in total premium."
    },
    {
       "id":6566,
       "practice_test_id":"",
       "topic_id":14,
       "question":"A rate based option is based on A T\u0027bill with which maturity?",
       "choice_a":"1 month",
       "choice_b":"3 months",
       "choice_c":"6 months",
       "choice_d":"1 year",
       "correct_answer":"B",
       "explanation":"A rate based option is based on a T\u0027bill with a 3 month maturity"
    },
    {
       "id":6567,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who buys a rate based option with a premium of 1.25 will pay a premium of:",
       "choice_a":"$1,250",
       "choice_b":"$12,500",
       "choice_c":"$3,125",
       "choice_d":"$2,500",
       "correct_answer":"C",
       "explanation":"The premium on a rate based option is based on a 13 week T\u0027bill with a par value of $1,000,000 A quote to 1.25 = 1.25 % X $1,000,000. Since the T bill is a 13 week bill you must divide the premium by 4. In this case 12,500 / 4 = $3,125."
    },
    {
       "id":6568,
       "practice_test_id":"",
       "topic_id":14,
       "question":"All of the following are true about an investor who is short a priced based put option and who is assigned except:",
       "choice_a":"The investor will receive the underlying security on the next business day",
       "choice_b":"The investor will pay accrued interest",
       "choice_c":"The investor will receive $1,000,000 par value for each option assigned",
       "choice_d":"The investor believes that bond prices will rise",
       "correct_answer":"C",
       "explanation":"All of the choices listed are correct except that the investor will receive $100,000 par value not $1,000,000."
    },
    {
       "id":6569,
       "practice_test_id":"",
       "topic_id":14,
       "question":"A MSFT Jun 50 call is in the money when MSFT trades at which of the following prices?",
       "choice_a":"$48.00",
       "choice_b":"$49.00",
       "choice_c":"$50.00",
       "choice_d":"$51.00",
       "correct_answer":"D",
       "explanation":"A call is in-the-money when the underlying instrument trades ABOVE the strike price."
    },
    {
       "id":6570,
       "practice_test_id":"",
       "topic_id":14,
       "question":"How far is a MSFT Jan 90 call in the money with MSFT trading at $85?",
       "choice_a":"$5",
       "choice_b":"$90",
       "choice_c":"$87.50",
       "choice_d":"$0",
       "correct_answer":"D",
       "explanation":"A call is only in-the-money when the underlying instrument trades for more than the strike price.  In this question, the underlying stock is trading for $5 less than the strike price."
    },
    {
       "id":6571,
       "practice_test_id":"",
       "topic_id":14,
       "question":"How far are the IBM Aug 70 calls in the money if IBM trades at $77?",
       "choice_a":"$77",
       "choice_b":"$7",
       "choice_c":"$0",
       "choice_d":"$10",
       "correct_answer":"B",
       "explanation":"A call option is in-the-money by the amount that the underlying security trades ABOVE the call\u0027s strike price."
    },
    {
       "id":6572,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor is long an IBM Mar 90 call @3.  With IBM @94.75, the investor closes the option for its intrinsic value.  He has a",
       "choice_a":"Loss of $175",
       "choice_b":"Gain of $175",
       "choice_c":"Loss of $300",
       "choice_d":"Gain of $475",
       "correct_answer":"B",
       "explanation":"When the stock moves in the buyer\u0027s favor by more than the breakeven, the amount that it moves beyond the breakeven is the buyer\u0027s gain."
    },
    {
       "id":6573,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor is short an IBM Mar 90 call @3.  With the underlying security trading @92, she closes the contract for its intrinsic value.  She has a:",
       "choice_a":"Loss of $100",
       "choice_b":"Gain of $100",
       "choice_c":"Loss of $9,000",
       "choice_d":"Gain of $9,000",
       "correct_answer":"B",
       "explanation":"The seller wrote the contract for $3 per share, and closed it out by paying just $2 per share.  There are 100 shares per contract, so the gain is $100."
    },
    {
       "id":6574,
       "practice_test_id":"",
       "topic_id":14,
       "question":"A MSFT Jun 65 put @3 has how much intrinsic value with MSFT @65?",
       "choice_a":"$0",
       "choice_b":"$2",
       "choice_c":"$65",
       "choice_d":"$3",
       "correct_answer":"A",
       "explanation":"There is no value in the \u0022right to sell @65\u0022 when the stock is actually worth $65 per share.  The $3 in this question would represent time value, since there is no intrinsic value at this point."
    },
    {
       "id":6575,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An IBM Mar 75 put @3 has how much time value with IBM @74?",
       "choice_a":"$1",
       "choice_b":"$3",
       "choice_c":"$2",
       "choice_d":"$0",
       "correct_answer":"C",
       "explanation":"There is $1 of intrinsic value, so the rest of the $3 premium represents time value."
    },
    {
       "id":6576,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor writes an XYZ Mar 75 put @4.  With XYZ @74, he closes the contract for its intrinsic value.  He has a",
       "choice_a":"Gain of $400",
       "choice_b":"Gain of $100",
       "choice_c":"Loss of $400",
       "choice_d":"Gain of $300",
       "correct_answer":"D",
       "explanation":"He sold the contract for $400 and can buy it back for just $100.  The \u0022right to sell @75\u0022 is worth exactly $1 per share with the stock at $74 per share."
    },
    {
       "id":6577,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor is short an IBM May 80 put @3.50.  With IBM @78, she closes the option for intrinsic value.  She has a",
       "choice_a":"Gain of $150",
       "choice_b":"Loss of $350",
       "choice_c":"Gain of $350",
       "choice_d":"Loss of $150",
       "correct_answer":"A",
       "explanation":"The investor sold the contract for $350 and can buy it back/close it out for the intrinsic value of $2 per share or $200. The difference of $150 represents her gain."
    },
    {
       "id":6578,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Your customer is long 100 shares of MSFT.  For best protection, what should he do?",
       "choice_a":"buy a call",
       "choice_b":"sell a call",
       "choice_c":"sell a put",
       "choice_d":"buy a put",
       "correct_answer":"D",
       "explanation":"When an investor is long stock, the risk is that the price could drop; therefore, he must buy a put or sell a call, buying a put will provide the most protection."
    },
    {
       "id":6579,
       "practice_test_id":2,
       "topic_id":14,
       "question":"Your customer is long 100 shares of MSFT.  To generate income, he should:",
       "choice_a":"buy a call",
       "choice_b":"buy a put",
       "choice_c":"sell a call",
       "choice_d":"sell a put",
       "correct_answer":"C",
       "explanation":"To generate income the investor must SELL an option.  His risk is that the stock could drop, so he should sell a call."
    },
    {
       "id":6580,
       "practice_test_id":3,
       "topic_id":14,
       "question":"Your customer is short 100 shares of MSFT.  For best protection, he should",
       "choice_a":"buy a call",
       "choice_b":"buy a put",
       "choice_c":"sell a put",
       "choice_d":"sell a call",
       "correct_answer":"A",
       "explanation":"Having already sold the stock, the customer needs the \u0022right to buy\u0022 the stock back for a set price, rather than letting the market determine the price he must pay (unlimited)."
    },
    {
       "id":6581,
       "practice_test_id":4,
       "topic_id":14,
       "question":"Your customer is short 100 shares of MSFT.  To increase yield, he should",
       "choice_a":"buy a put",
       "choice_b":"buy a call",
       "choice_c":"sell a call",
       "choice_d":"sell a put",
       "correct_answer":"D",
       "explanation":"Short stock is a bearish position, so the option used as a hedge must be bullish.  To generate income, the investor has to sell something, so this investor has to sell a put, which is bullish and generates income."
    },
    {
       "id":6582,
       "practice_test_id":5,
       "topic_id":14,
       "question":"Your investor is long 100 shares ABC @60 and short an ABC Mar 65 call @2.  With ABC @64, she sells the stock and closes the option for its intrinsic value.  She has a",
       "choice_a":"Gain of $200",
       "choice_b":"Loss of $200",
       "choice_c":"Gain of $600",
       "choice_d":"Gain of $700",
       "correct_answer":"C",
       "explanation":"The intrinsic value of a March 65 call with the stock at $64 is ZERO.  So, the investor gained $400 on the stock and $200 on the call when it expired."
    },
    {
       "id":6583,
       "practice_test_id":6,
       "topic_id":14,
       "question":"An investor who is short stock gets protection when he",
       "choice_a":"sells a call",
       "choice_b":"buys a put",
       "choice_c":"sells a put",
       "choice_d":"buys a call",
       "correct_answer":"D",
       "explanation":"After selling stock short, the investor has to buy the stock back.  He can let the market determine the price he pays, or he can buy the right to buy the stock for a set price.  The \u0022right to buy stock at the strike price\u0022 equals \u0022buy a call."
    },
    {
       "id":6584,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor is short 100 shares of RRT at 60 and long an RRT Mar 65 call at 1.50. if RRT goes to $68, how much does the investor lose if he exercises the call?",
       "choice_a":"$0",
       "choice_b":"$650",
       "choice_c":"$500",
       "choice_d":"$950",
       "correct_answer":"B",
       "explanation":"The investor has realized his maximum loss. He sold stock for $60 and can now buy it back for $65, even though it\u0027s trading higher. He also does not recover the premium, so the loss is $5 per share plus the $1.50-per-share premium."
    },
    {
       "id":6585,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Long 100 shares XYZ @40.  Short XYZ Oct 50 call @2.25.  What is the maximum loss in this hedged position?",
       "choice_a":"unlimited",
       "choice_b":"25 per share",
       "choice_c":"00 per share",
       "choice_d":"37.75 per share",
       "correct_answer":"D",
       "explanation":"Do not assume that the stock will be sold just because the investor wrote a call--the call is only exercised IF the stock rises above $50.  If the stock falls to zero, only the premium of $2.25 will offset the $40 per share paid for the stock."
    },
    {
       "id":6586,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor is long an IBM Apr 40 call.  Which position would complete the straddle?",
       "choice_a":"short IBM Apr 40 call",
       "choice_b":"short IBM Apr 40 put",
       "choice_c":"long IBM May 40 put",
       "choice_d":"long IBM Apr 40 put",
       "correct_answer":"D",
       "explanation":"A straddle involves two long or two short positions.  Every term in the series is the same except the type: one is a call, the other a put."
    },
    {
       "id":6587,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor is short a MSFT Jun 60 put.  Which position would complete the straddle?",
       "choice_a":"short MSFT Jun 60 put",
       "choice_b":"long MSFT Jun 50 put",
       "choice_c":"short MSFT Jun 60 call",
       "choice_d":"long MSFT Jun 50 call",
       "correct_answer":"C",
       "explanation":"A straddle involves two long or two short positions.  Every term in the series is the same except the type: one is a call, the other a put."
    },
    {
       "id":6588,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor anticipating volatility purchases an XRQ Oct 60 call at 4 and an XRQ Oct 60 put at 3. If XRQ is trading at 54 at expiration and the investor closes both positions at intrinsic value, what will be his gain or loss?",
       "choice_a":"$700 loss",
       "choice_b":"$700 gain",
       "choice_c":"$100 loss",
       "choice_d":"None of the above",
       "correct_answer":"C",
       "explanation":"The stock had to move $7 in either direction for the investor to simply breakeven; therefore, since it moved by only $6, the investor loses the difference per share. In this case $1 or $100 total."
    },
    {
       "id":6589,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor who anticipates stability, shorts a Jun 90 call @4 and a Jun 90 put @3.50.  He closes both positions for their intrinsic value at expiration, when the underlying stock is trading at $111.  What is the investor\u0027s gain or loss per share?",
       "choice_a":"$5 loss",
       "choice_b":"$13.50 loss",
       "choice_c":"$13.50 gain",
       "choice_d":"unlimited",
       "correct_answer":"B",
       "explanation":"The investor would have had no loss if the stock moved by no more than $7.50 in either direction (breakeven).  Since the stock moved by $21, the writer of the straddle loses the difference between $21 and $7.50 per share."
    },
    {
       "id":6590,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Rank the following options premiums from lowest to highest <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> MSFT Apr 40 call </li><li>MSFT Apr 50 call </li><li>MSFT Apr 30 call </li><li>MSFT May 30 call</li></ol>",
       "choice_a":"I, II, IV, III",
       "choice_b":"II, I, IV, III",
       "choice_c":"IV, III, I, II",
       "choice_d":"II, I, III, IV",
       "correct_answer":"D",
       "explanation":"Calls with lower strike prices have more value, and options with more time on them have more value.  Therefore, the call with the highest strike price (Apr 50) is worth the least, and the call with the lowest strike price and the most time (May 30) is worth the most."
    },
    {
       "id":6591,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Rank the following options premiums from lowest to highest <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> MSFT Apr 40 put </li><li>MSFT Apr 50 put </li><li>MSFT Apr 30 put </li><li>MSFT May 50 put</li></ol>",
       "choice_a":"I, II, III, IV",
       "choice_b":"II, I, III, IV",
       "choice_c":"III, IV, I, II",
       "choice_d":"III, I, II, IV",
       "correct_answer":"D",
       "explanation":"Puts with higher strike prices have more value, and options with more time on them have more value.  Therefore, the put with the lowest strike price (Apr 30) is worth the least, and the put with the highest strike price and the most time (May 50) is worth the most."
    },
    {
       "id":6592,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following: <ol style='margin-left: 25px; list-style-type: disc;'><li>Long 1 IBM Mar 90 call </li><li>Short 1 IBM Mar 100 call </li></ol>The investor will profit if the difference in premiums:",
       "choice_a":"narrows",
       "choice_b":"expires",
       "choice_c":"elongates",
       "choice_d":"widens",
       "correct_answer":"D",
       "explanation":"The Mar 90 call is worth more than the Mar 100 call, so this is a debit spread (the investor paid more for the option he bought).The investor will profit if the spread widens."
    },
    {
       "id":6593,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following: <ol style='margin-left: 25px; list-style-type: disc;'><li>Long 1 IBM Mar 90 call @6 </li><li>Short 1 IBM Mar 100 call @2 </li></ol>What is the investor\u0027s max loss and max gain, respectively?",
       "choice_a":"6, 2",
       "choice_b":"4, 6",
       "choice_c":"2, 6",
       "choice_d":"2, minus initial debit",
       "correct_answer":"B",
       "explanation":"Whenever an investor starts with a debit, that debit is all he can lose.  Only one answer has a maximum loss of $4--the initial debit--so that has to be the correct answer to this question."
    },
    {
       "id":6594,
       "practice_test_id":"",
       "topic_id":14,
       "question":"What is the breakeven for the following position? <ol style='margin-left: 25px; list-style-type: disc;'><li>Long ORCL 1 May 30 call @3.30 </li><li>Short ORCL 1 May 20 call @6.50</li></ol>",
       "choice_a":"$9.80",
       "choice_b":"$2.20",
       "choice_c":"$23.20",
       "choice_d":"$23.50",
       "correct_answer":"C",
       "explanation":"The breakeven on a spread will ALWAYS be between the two strike prices.  For a call spread take the net premium of $3.20 and add it to the lower strike price of $20. The breakeven is therefore $23.20"
    },
    {
       "id":6595,
       "practice_test_id":6,
       "topic_id":14,
       "question":"What is the breakeven for the following position? <ol style='margin-left: 25px; list-style-type: disc;'><li> Long 1 ORCL May 30 put @4.50 </li><li> Short 1 ORCL May 20 put @1.90</li></ol>",
       "choice_a":"$6.40",
       "choice_b":"$2.60",
       "choice_c":"$22.60",
       "choice_d":"$27.40",
       "correct_answer":"D",
       "explanation":"The breakeven on a spread will ALWAYS be between the two strike prices.  For a put spread take the net premium of $2.60 and subtract it from the higher strike price of $30."
    },
    {
       "id":6596,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following:<ol style='margin-left: 25px; list-style-type: disc;'><li>Short 1 IBM Mar 90 call </li><li>Long 1 IBM Mar 100 call </li></ol>The investor will profit if the difference in premiums",
       "choice_a":"narrows",
       "choice_b":"expires",
       "choice_c":"elongates",
       "choice_d":"widens",
       "correct_answer":"A",
       "explanation":"This is a credit spread, because the 90 call is worth more than the 100 call.  The difference in premiums, or \u0022the spread\u0022 must narrow for the investor to profit.  The investor would also want the options to expire."
    },
    {
       "id":6597,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following: <ol style='margin-left: 25px; list-style-type: disc;'><li>Long 1 XLZ Nov 50 put @4.75 </li><li>Short 1 XLZ Nov 60 put @6.25</li></ol>What is the investor\u0027s max gain and max loss, respectively?",
       "choice_a":"$6.25, $4.75",
       "choice_b":"$4.75, $6.25",
       "choice_c":"$1.50, $8.50",
       "choice_d":"$8.50, $1.50",
       "correct_answer":"C",
       "explanation":"For a spread the maximum gain and loss must always add up to the difference in strike prices--$10 in this case.  If the investor starts out with a credit of $1.50 per share, that represents his maximum gain.  $10 minus $1.50 gives us the maximum loss of $8.50 per share."
    },
    {
       "id":6598,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following: <ol style='margin-left: 25px; list-style-type: disc;'><li>Long 100 shares XYZ @55 </li><li>Long 1 XYZ Mar 50 put @2.25 </li></ol>What is the maximum loss on this position?",
       "choice_a":"$275",
       "choice_b":"$725",
       "choice_c":"$500",
       "choice_d":"none of the choices listed",
       "correct_answer":"B",
       "explanation":"The investor can sell the stock for $5 per share less than he bought it--no matter what.  The premium would not be recovered, so $7.25 per share is the maximum loss between now and the third Friday of March."
    },
    {
       "id":6599,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor is short 1  XYZ Nov 50 put <br>Which of the following positions will complete the straddle?",
       "choice_a":"Long XYZ Nov 50 call",
       "choice_b":"Short XYZ Dec 50 call",
       "choice_c":"Short ZYX Nov 50 call",
       "choice_d":"Short XYZ Nov 50 call",
       "correct_answer":"D",
       "explanation":"A straddle is either two long or two short positions.  Each term in the series is the same except the type: one is a call, the other a put. Also, read carefully, as \u0022ZYX\u0022 is not the same stock as \u0022XYZ\u0022."
    },
    {
       "id":6600,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following: <ol style='margin-left: 25px; list-style-type: disc;'><li>Long 1  IBM Mar 70 call </li><li>Short 1 IBM Mar 60 call </li></ol>This position will be profitable if the difference in premiums:",
       "choice_a":"widens",
       "choice_b":"narrows",
       "choice_c":"changes",
       "choice_d":"becomes volatile",
       "correct_answer":"B",
       "explanation":"The Mar 60 call is more valuable, and the investor sold that option.  Therefore, this is a credit spread.  C-R-E-D-I-T = N-A-R-R-O-W."
    },
    {
       "id":6601,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following: <ol style='margin-left: 25px; list-style-type: disc;'><li>Long 1  IBM Mar 70 call @4 </li><li>Short 1  IBM Mar 60 call @8 </li></ol>The maximum loss on this position is:",
       "choice_a":"unlimited",
       "choice_b":"$400",
       "choice_c":"$600",
       "choice_d":"$1,000",
       "correct_answer":"C",
       "explanation":"The seller of this spread starts with a net credit of $4 per share.  The maximum loss is $10 minus $4 or $6 per share."
    },
    {
       "id":6602,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following: <ol style='margin-left: 25px; list-style-type: disc;'><li>Long 1 IBM Mar 70 call @4 </li><li>Short 1 IBM Mar 60 call @8 </li></ol>The maximum gain on this position is:",
       "choice_a":"unlimited",
       "choice_b":"$400",
       "choice_c":"$600",
       "choice_d":"$1,000",
       "correct_answer":"B",
       "explanation":"The seller of this spread starts with a net credit of $4 per share.  Sellers can NEVER make more than their initial credit."
    },
    {
       "id":6603,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following: <ol style='margin-left: 25px; list-style-type: disc;'><li>Long 1 XYZ Oct 50 call @2 </li><li>Long 1  XYZ Oct 50 put @2 </li></ol>This position will prove profitable if XYZ trades above which price?",
       "choice_a":54,
       "choice_b":46,
       "choice_c":53,
       "choice_d":45,
       "correct_answer":"A",
       "explanation":"The buyer of the straddle will only profit if the stock moves beyond the breakeven, in this case either above $54 or below $46"
    },
    {
       "id":6604,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following: <ol style='margin-left: 25px; list-style-type: disc;'><li>Short 1 XYZ Oct 50 call @2 </li><li>Short 1 XYZ Oct 50 put @2 </li></ol>This position will prove profitable if XYZ trades at which price?",
       "choice_a":57,
       "choice_b":42,
       "choice_c":55,
       "choice_d":48,
       "correct_answer":"D",
       "explanation":"The writer of the straddle will profit as long as the stock fails to reach the breakeven of $54 or $46."
    },
    {
       "id":6605,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Jill is short an ABC Jun 45 put @2.  She will profit as long as the underlying security trades",
       "choice_a":"Below $40.00",
       "choice_b":"Below $45.00",
       "choice_c":"Above  $43.00",
       "choice_d":"Below  $42.25",
       "correct_answer":"C",
       "explanation":"The writer of the put will profit if the stock stays above the breakeven, in this case $43. To find the breakeven subtract the premium from the strike price. In this case $45-2 =$43."
    },
    {
       "id":6606,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor buys 100 shares of ABC @50, and also buys an ABC Apr 55 call @2, and writes an ABC Apr 50 put @2.25.  With ABC @56, he sells the stock and closes the options contracts at intrinsic value, for a",
       "choice_a":"gain of $275",
       "choice_b":"gain of $725",
       "choice_c":"loss of $275",
       "choice_d":"loss unlimited",
       "correct_answer":"B",
       "explanation":"In your T-chart, you should have $50 per share in the \u0022money out\u0022 column and $2 for the April 55 call.  $2.25 is in the \u0022money in\u0022 column, as well as the $56 for the stock. To finish the question, place the intrinsic value of the call ($1) in the \u0022money in\u0022 column and the intrinsic value of the put (0) in the \u0022money out\u0022 column. The investor made $7.25 per share."
    },
    {
       "id":6607,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Your investor is short 100 shares XYZ @50 and long an XYZ Oct 55 call @2. Therefore, her maximum gain is",
       "choice_a":"unlimited",
       "choice_b":"$5,225",
       "choice_c":"$4,800",
       "choice_d":"$5,275",
       "correct_answer":"C",
       "explanation":"If you short a stock at $50, $50 is the maximum gain, should the stock actually drop to zero.  Since you paid $2 a share to protect yourself against a sudden upsurge, $48 per share is now the maximum gain, should the stock become worthless."
    },
    {
       "id":6608,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Your customer sold short 100 XYZ @55.  With the stock currently @49, you would recommend that he protect his position by",
       "choice_a":"buying an XYZ Oct 50 call",
       "choice_b":"writing an XYZ Oct 50 put",
       "choice_c":"buying an XYZ Oct 50 put",
       "choice_d":"writing an XYZ Oct 45 put",
       "correct_answer":"A",
       "explanation":"With a $6 gain on paper, the investor could buy the right to buy the stock back at $50 per share.  At that point, he has locked in a profit--the stock will either continue to fall and increase his profit, or it will go up, forcing him to pay no more than $50 per share to close out the short position at a gain."
    },
    {
       "id":6609,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Dale Smith buys an XYZ Jan 50 call and writes an XYZ Jan 60 call.  He will profit if:",
       "choice_a":"the spread widens",
       "choice_b":"the spread narrows",
       "choice_c":"both options expire",
       "choice_d":"the spread elongates",
       "correct_answer":"A",
       "explanation":"The call that Dale bought is worth more than the call that he sold.  That\u0027s a debit spread, and D-E-B-I-T = W-I-D-E-N."
    },
    {
       "id":6610,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Your investor buys an ABC Mar 65 call @2.  He will complete the straddle by:",
       "choice_a":"buying an XYZ Mar 65 put",
       "choice_b":"writing an XYZ Mar 65 call",
       "choice_c":"purchasing an ABC Mar 60 put",
       "choice_d":"purchasing an ABC Mar 65 put",
       "correct_answer":"D",
       "explanation":"Read carefully--the underlying security has to be ABC, not XYZ.  The strike prices must also both be 65 in this question."
    },
    {
       "id":6611,
       "practice_test_id":1,
       "topic_id":14,
       "question":"OEX Jan 650 call @7.5 <br>If your customer sells the above position and subsequently receives an assignment notice with OEX @660, he ends up with a:",
       "choice_a":"gain of $750",
       "choice_b":"loss of $250",
       "choice_c":"gain of $7,500",
       "choice_d":"loss of $2,500",
       "correct_answer":"B",
       "explanation":"The customer took in $750 but has to pay the intrinsic value of 10 (times 100) to the holder of the S\u0026P 100 call option."
    },
    {
       "id":6612,
       "practice_test_id":2,
       "topic_id":14,
       "question":"If your customer buys an ABC Jan 50 call @3.75 and writes an ABC Jan 60 call @1, he will profit if ABC trades",
       "choice_a":"At $52.75",
       "choice_b":"Below $52.75",
       "choice_c":"At parity",
       "choice_d":"Above $52.75",
       "correct_answer":"D",
       "explanation":"Whenever the investor is long the lower strike price, it\u0027s a bull spread.  So, he wants the stock to move above the breakeven point of $52.75."
    },
    {
       "id":6613,
       "practice_test_id":3,
       "topic_id":14,
       "question":"What is the breakeven on a long XYZ Feb 75 put @2.50?",
       "choice_a":77.5,
       "choice_b":72.5,
       "choice_c":"unlimited",
       "choice_d":"strike price plus premium",
       "correct_answer":"B",
       "explanation":"Strike price minus premium = breakeven on a single put."
    },
    {
       "id":6614,
       "practice_test_id":4,
       "topic_id":14,
       "question":"Your customer is short 200 shares of XYZ @50 and short 2 XYZ Oct 45 puts @2.  What is the maximum gain per share?",
       "choice_a":"unlimited",
       "choice_b":48,
       "choice_c":7,
       "choice_d":9,
       "correct_answer":"C",
       "explanation":"If he sells the stock at $50 and is forced to buy it at $45, that\u0027s a gain of $5 per share.  The premium is kept, too, for a total of $7 per share."
    },
    {
       "id":6615,
       "practice_test_id":5,
       "topic_id":14,
       "question":"With XYZ trading @52.50, none of the following options is in the money except",
       "choice_a":"XYZ Mar 55 call",
       "choice_b":"XYZ Mar 55 put",
       "choice_c":"XYZ Mar 50 put",
       "choice_d":"XYZ Mar 45 put",
       "correct_answer":"B",
       "explanation":"Only the XYZ March 55 put is in the money with XYZ at 52.50."
    },
    {
       "id":6616,
       "practice_test_id":6,
       "topic_id":14,
       "question":"Your customer is long 100 shares XYZ @55 and short 2 XYZ Mar 60 calls @3.  His maximum loss is",
       "choice_a":"$5,200",
       "choice_b":"$800",
       "choice_c":"$4,900",
       "choice_d":"unlimited",
       "correct_answer":"D",
       "explanation":"This is NOT a covered call, since the writer is obligated to deliver 200 shares of XYZ when he owns only 100."
    },
    {
       "id":6617,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Your investor is long 100 shares ABC @50.  He writes an ABC Oct 50 call @1.50 and an ABC Oct 50 put @2.00.  His maximum loss is:",
       "choice_a":"unlimited",
       "choice_b":"$5,350",
       "choice_c":"$9,650",
       "choice_d":"zero",
       "correct_answer":"C",
       "explanation":"The investor can lose $4,850 on the long stock short call position if ABC falls to zero. The investor will also lose another $4,800 on the short put position if ABC falls to zero for a total potential loss of $9,650."
    },
    {
       "id":6618,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Tom is short an ARQ Mar 65 put @3.  With ARQ @60, Tom receives an assignment notice.  He ends up with a",
       "choice_a":"gain of $300",
       "choice_b":"loss of $300",
       "choice_c":"loss of $200",
       "choice_d":"gain of $200",
       "correct_answer":"C",
       "explanation":"Tom received $300 and pays $500 more than the stock is worth, for a loss of $200."
    },
    {
       "id":6619,
       "practice_test_id":"",
       "topic_id":14,
       "question":"You buy a stock that you think is likely to trade sideways for a period of time.  Which of the following would you most likely do to allow you make money during a sideways move?",
       "choice_a":"Sell a call",
       "choice_b":"Sell a put",
       "choice_c":"Buy a call",
       "choice_d":"Buy a put",
       "correct_answer":"A",
       "explanation":"If a stock is range bound or likely to move sideways for a period of time the best strategy to profit during this time would be to sell a covered call on that stock."
    },
    {
       "id":6620,
       "practice_test_id":"",
       "topic_id":14,
       "question":"What type of option can be converted to the underlying security early?",
       "choice_a":"American",
       "choice_b":"European",
       "choice_c":"Binary",
       "choice_d":"B-H",
       "correct_answer":"A",
       "explanation":"American style options may be exercised or converted in to the underlying securities at any time prior to expiration. European options may only be exercised at expiration."
    },
    {
       "id":37329,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Except for the Japanese Yen, where one contract represents 1,000,000 units of currency, most standard listed currency options contracts represent 10,000 units of currency. Using 10,000 units of currency per contract, if the premium is quoted as 1.35, how many US cents or dollars does this represent?",
       "choice_a":"13,500 US cents or $135",
       "choice_b":"135,000 US cents or $1,350",
       "choice_c":"1,350 US cents or $13.50",
       "choice_d":"135 US cents or $1.35",
       "correct_answer":"A",
       "explanation":"If one contract represents 10,000 units of currency, a premium of 1.35 represents 13,500 US cents (1.35 x 10,000) which is equal to $135."
    },
    {
       "id":37330,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Your client is long 1 Aug. 1.20 Australian Dollar put at .45. With the Australian Dollar trading at (spot price) .86, the position is closed at intrinsic value. Which of the following is the resulting gain or loss?",
       "choice_a":"$1,100 loss",
       "choice_b":"$450 loss",
       "choice_c":"$410 gain",
       "choice_d":"$750 gain",
       "correct_answer":"A",
       "explanation":"The 1.20 put is .34 in-the-money with the currency valued at .86; 1.20 - .86 = .34. Therefore .34 is the contract\u0027s intrinsic value. However, having paid .45 for the contract, the position is closed with a loss of .11; .45 paid - .34 IV = .11. 11-point loss x $100 = $1,100 loss. Alternately, .11 x 10,000 units of Australian Dollar per contract equals $1,100. Note, arriving at the correct answer could also be done by calculating the breakeven point first. For a put, strike price (1.20) \u2013 premium (.45) = BE (.75). For a long put to be profitable the currency must be below the BE at expiration. Here, it is above the BE by 11 points ($1,100 loss)."
    },
    {
       "id":37331,
       "practice_test_id":6,
       "topic_id":14,
       "question":"An investor, bullish, short term, on the Canadian Dollar decides to go long 2 call spreads. She buys the .80 calls and sells .90 calls paying .06 per spread. At expiration the currency is valued at (spot price) .98. What is the investor\u0027s gain or loss on the position?",
       "choice_a":"$800 gain",
       "choice_b":"$400 gain",
       "choice_c":"$800 loss",
       "choice_d":"$400 loss",
       "correct_answer":"A",
       "explanation":"With the currency valued at .98 at expiration, the .80 / .90 call spread is clearly in-the-money. However, the maximum gain is limited to the difference between the strike prices (.10 or 10 points x $100 = $1,000) minus what was paid (6 x $100 = $600); $1,000 - $600 = $400 gain per spread. The customer was long 2 spreads giving her a gain of $800 on the position. Note that the premium paid can be converted to dollars an alternate way; .06 x 10,000 units of currency per Australian Dollar contract = $600."
    },
    {
       "id":37332,
       "practice_test_id":"",
       "topic_id":14,
       "question":"With the Japanese Yen currently valued at 106, an investor long 1 Yen 101 currency call at 6 points would be holding a position showing a:",
       "choice_a":"$500 loss",
       "choice_b":"$100 loss",
       "choice_c":"$100 gain",
       "choice_d":"$500 gain",
       "correct_answer":"B",
       "explanation":"Having paid a premium of 6 points, the long 101 call has a breakeven of 107. With the currency valued at 106, the position is currently showing a 1-point ($100) loss. Remember, 1 point for a Japanese Yen contract equals 1/1000 of a US dollar (.0001). Therefore, alternately, to calculate what 1 point would be in $US, simply multiply .0001 x 1,000,000 units of Japanese Yen currency per contract (.0001 x 1,000,000 = $100)."
    },
    {
       "id":37333,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Your client is short 1 Canadian Dollar .74 / .80 put spread at $.02. If at expiration the currency is valued at .87 (spot price) the position will realize a:",
       "choice_a":"2-point loss; $200",
       "choice_b":"9-point gain; $900",
       "choice_c":"2-point gain; $200",
       "choice_d":"8-point loss; $800",
       "correct_answer":"C",
       "explanation":"<div>Breakeven for this put spread is calculated by subtracting the premium (.02) from the higher strike price (.80); .80 - .02 = .78. When short a put spread, one is bullish. Therefore, this position is profitable above the BE of .78. While the spread is well in the money with spot at .87, the maximum gain for any credit spread is the premium taken in. Here .02 or $200 gain. </div>"
    },
    {
       "id":37334,
       "practice_test_id":"",
       "topic_id":14,
       "question":"A customer, long 20,000 SF at 86 cents (spot price), purchases 2 May .85 SF puts at 1 cent per contract as a hedge. The customer\u0027s breakeven point per SF is:",
       "choice_a":"$0.86",
       "choice_b":"$0.85",
       "choice_c":"$0.84",
       "choice_d":"$0.87",
       "correct_answer":"D",
       "explanation":"This position represents a long currency / long put hedge. The breakeven point for a position where one is long currency and hedges with a long currency put equals the cost of the currency (.86) plus the premium paid for the put (.01). Therefore, the breakeven point is .87 (87 cents)."
    },
    {
       "id":37335,
       "practice_test_id":"",
       "topic_id":14,
       "question":"A customer buys 5 Jan. 1.20 Australian Dollar calls at $.02 when the currency is trading at 1.16 (spot price). The currency moves to 1.27 and the position is closed at intrinsic value for a:",
       "choice_a":"$200 loss",
       "choice_b":"$400 loss",
       "choice_c":"$500 gain",
       "choice_d":"$700 gain",
       "correct_answer":"C",
       "explanation":"The breakeven point for calls is strike price plus premium ($1.20 + $.02 = $1.22). Being long the calls, the customer wants the currency above the breakeven to be profitable. With the currency trading at 1.27 the position is closed with a 5-point gain; 1.27 - 1.22 BE = .05 or 5 points. Alternately, .05 x 10,000 units of Australian Dollar currency per contract = $500."
    },
    {
       "id":37336,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor closes 6 Euro currency spreads for a profit of $.23 per spread. How much did the investor gain?",
       "choice_a":"$1,380",
       "choice_b":"$2,300",
       "choice_c":"$23,000",
       "choice_d":"$13,800",
       "correct_answer":"D",
       "explanation":"Remember that the easiest way to calculate the gain is to simply ignore the decimal and use the 100-multiplier; 23 x 100 = $2,300 per spread or $13,800 for the entire 6 spread position (6 x $2,300). Alternately, the profit per spread can be calculated; .23 x 10,000 units of Australian Dollar currency per contract = $2,300."
    },
    {
       "id":37337,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Your customer is short 1 Japanese Yen 1.06 straddle at a premium of .0042. At expiration the currency is trading at 1.0524. With this position the customer has realized a:",
       "choice_a":"$3,400 loss",
       "choice_b":"$4,200 loss",
       "choice_c":"$7,600 gain",
       "choice_d":"$10,482 gain",
       "correct_answer":"A",
       "explanation":"For the short straddle to be profitable, the currency must be valued somewhere in between the two breakeven points at expiration. Those BE\u0027s are calculated by both adding and subtracting the premium from the strike price of 1.06. Therefore, the two BE\u0027s are 1.0642 and 1.0558. With the currency valued at 1.0524 the position has a loss of .0034; 1.0558 \u2013 1.0524 = .0034 or $3,400. Alternately, .0034 x 1,000,000 units of Japanese Currency per contract = $3,400."
    },
    {
       "id":37338,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor is long 3 Nov. 1.10 Euro calls at $0.91. At expiration the Euro is valued at 1.02 (spot price) giving the investor:",
       "choice_a":"a gain of 9,100 Euros",
       "choice_b":"a loss of 91 Euros",
       "choice_c":"a gain of $9,100",
       "choice_d":"a loss of $27,300",
       "correct_answer":"D",
       "explanation":"Remember that all listed foreign currency options are settled in US dollars. At expiration, with the currency valued at 1.02, the 1.10 calls are out-of-the-money and therefore worthless. The investor will have a loss equal to the entire premium paid; 3 contracts x .91 x $100 = $27,300. Alternately, .91 x 10,000 units of Euro currency per contract x 3 contracts = $27,300."
    },
    {
       "id":37339,
       "practice_test_id":"",
       "topic_id":14,
       "question":"A client is the holder of 14.5 million Japanese Yen, the byproduct of a business venture he was a part of. Anticipating more business opportunities in Japan he wants to hold on to the currency but protect against fluctuations, particularly a downward movement in the currency. Using US exchange listed currency options, which of the following would best protect his currency holdings?",
       "choice_a":"Long 15 Japanese yen puts",
       "choice_b":"Long 14 US dollar puts",
       "choice_c":"Short 15 Japanese yen calls",
       "choice_d":"Short 14 US dollar calls",
       "correct_answer":"A",
       "explanation":"When hedging a long position against loss there are two appropriate hedges; long puts or short calls. However, the best protection is obtained utilizing long puts because as the holder of the puts you are in control and can decide if they should be exercised. Short calls offer only limited protection to the extent of the premium collected. Also remember that utilizing US listed currency options limits one to using options on the foreign currency only because there are no US exchange listed options offered on the US dollar. Therefore, long Japanese yen puts is the best hedge. Regarding how many puts are needed, remember that one yen contract overlays 1,000,0000 yen. To protect 14.5 million yen 14 contracts isn\u0027t sufficient and therefore 15 contracts would be needed to fully implement the hedge."
    },
    {
       "id":37340,
       "practice_test_id":6,
       "topic_id":14,
       "question":"An investor who believes the US dollar will strengthen (increase in value) against the Euro could realize a profit utilizing which of the following option strategies?",
       "choice_a":"Buying puts on the Euro or establishing a call credit spread on the Euro.",
       "choice_b":"Writing puts on the Euro or writing a straddle on the Euro.",
       "choice_c":"Buying puts on the Euro or writing a straddle on the Euro.",
       "choice_d":"Writing puts on the Euro or establishing a call credit spread on the Euro",
       "correct_answer":"A",
       "explanation":"If the US dollar is strengthening against the EURO, the EURO is decreasing (bearish attitude). To realize a profit if one is bearish on the Euro an investor could; buy Euro puts, write Euro calls, or write Euro call spreads. These are all bearish strategies. Writing puts is a bullish strategy and one would only utilize short straddles if they think the underlying will not move in either direction."
    },
    {
       "id":37341,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An Australian exporter wants to hedge a recent sale of grain to a U.S. buyer. The exporter has contracted to be paid in US dollars when the grain is delivered. Utilizing US exchange listed currency options. The best hedge would be to:",
       "choice_a":"buy Australian dollar calls",
       "choice_b":"sell Australian dollar calls",
       "choice_c":"sell Australian dollar puts",
       "choice_d":"buy Australian dollar puts",
       "correct_answer":"A",
       "explanation":"The Australian exporter has contracted to be paid in U.S. dollars upon delivery of the grain. Therefore, the risk is that the US dollar declines in value against the Australian dollar. Given the inverse relationship between currencies against one another, if the US dollar were to decline, the Australian dollar would rise. To benefit from this potential scenario, the Australian dollar rising in value against the US dollar, one could either buy calls or sell puts. But the best hedge is always to own the contracts, therefore, the Australian exporter would buy Australian dollar calls."
    },
    {
       "id":37342,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An institutional investor managing a hedge fund wants to speculate on the movement of currencies to enhance the returns of the fund portfolio. Using US exchange listed options, contracts on all of the following currencies would be available for this purpose except the:",
       "choice_a":"US dollar",
       "choice_b":"Australian dollar",
       "choice_c":"Euro",
       "choice_d":"Canadian dollar",
       "correct_answer":"A",
       "explanation":"Utilizing US exchange listed options eliminates the use of contracts on the US dollar because they do not exist. This is because for US exchange listed currency options the US dollar is the base currency. That is, the movement of all currencies is judged against the US dollar. The US exchange listed currency contracts are based on the assumption that if any foreign currency is rising or decreasing in value, it is rising or decreasing in value relative to the US dollar."
    },
    {
       "id":37343,
       "practice_test_id":"",
       "topic_id":14,
       "question":"A US exporter enters a contract to be paid 13,500 Canadian dollars when his exported products arrive in Canada two months from now. The US exporters best hedge is to:",
       "choice_a":"buy Canadian dollars calls",
       "choice_b":"buy Canadian dollars puts",
       "choice_c":"sell Canadian dollars calls",
       "choice_d":"sell Canadian dollars puts",
       "correct_answer":"B",
       "explanation":"The risk here is that the value of the Canadian dollar will fall between the time the contract was made and the time the exporter will be paid. Should the Canadian dollar fall in value, owning Canadian dollar puts which will rise in value if the underlying falls, would help compensate for the loss in the value of the underlying Canadian dollar. While selling Canadian dollar calls would also provide protection, it is only limited protection to the extent of the premium received and therefore not the best hedge."
    },
    {
       "id":38137,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following investors would best be described as having a market attitude that is mildly bearish?",
       "choice_a":"An investor who has purchased a put",
       "choice_b":"An investor who has sold a call",
       "choice_c":"An investor who has established a debit put spread",
       "choice_d":"An investor who has established a debit call spread",
       "correct_answer":"C",
       "explanation":"An investor who has purchased a put spread would best be described as having a market attitude that is mildly bearish. The investor believes that the stock is going to fall in price, but does not feel that the stock is going to fall substantially lower than the strike price of the short put."
    },
    {
       "id":38136,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which of the following investors would best be described as having a market attitude that is mildly bullish?",
       "choice_a":"An investor who has sold a put",
       "choice_b":"An investor who has purchased a call",
       "choice_c":"An investor who has established a debit put spread",
       "choice_d":"An investor who has established a debit call spread",
       "correct_answer":"D",
       "explanation":"An investor who has purchased a call spread would best be described as having a market attitude that is mildly bullish. The investor believes that the stock is going to increase in price, but does not feel that the stock is going to appreciate substantially higher than the strike price of the short call."
    },
    {
       "id":24694,
       "practice_test_id":"",
       "topic_id":14,
       "question":"A customer has an established margin account and has been trading puts and calls on equities and index options with your firm for several years. If the OCC updates the current options disclosure its current disclosure document (ODD) which of the following is true? ",
       "choice_a":"The ODD should be delivered no later than the time a confirmation of a transaction in the category of options to which the amendment pertains is delivered to such customer.",
       "choice_b":"The ODD should be delivered no later than the time of the next monthly statement is sent containing a new position in the category of options to which the amendment pertains is delivered to such customer.",
       "choice_c":"The ODD must be delivered within 30 days of the change",
       "choice_d":"The ODD must be delivered within 15 days of the change",
       "correct_answer":"A",
       "explanation":"If the OCC updates the risk disclosure document, the updated document must be delivered to a customer who executes a transaction in an option subject to the change in the disclosure by the time the confirmation is sent."
    },
    {
       "id":24695,
       "practice_test_id":2,
       "topic_id":14,
       "question":"A branch office manager who is not a registered options principal may approve a customer\u0027s account to trade options:",
       "choice_a":"under not circumstances",
       "choice_b":"If approved by a ROP within 15 days",
       "choice_c":"If approved by a ROP within 10 days",
       "choice_d":"If approved by a ROP within 5 days",
       "correct_answer":"C",
       "explanation":"A branch office manager who is not a ROP may initially approve an account to trade options so long as the account receives approval from a ROP within 10 days. "
    },
    {
       "id":24697,
       "practice_test_id":3,
       "topic_id":14,
       "question":"A small broker dealer who does not have a computerized system in place to review orders, has several discretionary options accounts. Which of the following statements is true? ",
       "choice_a":"The firm is required to specify a Registered Options Principal to review discretionary accounts and to approve and initial each discretionary order on the day entered.",
       "choice_b":"The firm is required to specify a Registered Options Principal to review discretionary accounts and to approve and initial each discretionary order on the day after it is entered.",
       "choice_c":"The firm is not required to specify a Registered Options Principal to review discretionary accounts, but a ROP must approve and initial each discretionary order on the day after it is entered.",
       "choice_d":"The firm is not required to specify a Registered Options Principal to review discretionary accounts, but a ROP must approve and initial each discretionary order on the day it is entered.",
       "correct_answer":"A",
       "explanation":"A firm who does not have a computerized system to monitor trades must review and approve discretionary option trades on the day the order is entered."
    },
    {
       "id":24701,
       "practice_test_id":4,
       "topic_id":14,
       "question":"A customer purchases 1 BVC November 45 Put at 3 and simultaneously purchases 100 shares of BVC at 44. At expiration which of the following prices would result in a profit for the customer? ",
       "choice_a":47,
       "choice_b":51,
       "choice_c":43,
       "choice_d":42,
       "correct_answer":"B",
       "explanation":"Of the choices listed, the customer would be profitable if the stock was at 51. The customer purchased the stock and 44 and purchased the 45 put at 3, making the customer\u0027s breakeven 47. The customer wants the stock to be above the breakeven. "
    },
    {
       "id":24633,
       "practice_test_id":5,
       "topic_id":14,
       "question":"When an option agreement is not returned by the customer within the required 15 days, the firm must: ",
       "choice_a":"Freeze the customer\u0027s options account",
       "choice_b":"Close the customer\u0027s open option positions",
       "choice_c":"Prohibit opening transactions",
       "choice_d":"Resend the option agreement to the customer",
       "correct_answer":"C",
       "explanation":"Should a customer fail to return a signed options agreement within 15 days the firm may not allow the customer to establish any new option positions. The customer however would be able to close any open positions."
    },
    {
       "id":24634,
       "practice_test_id":6,
       "topic_id":14,
       "question":"A stock is selling in the market at 53.5. An investor feels that the stock is ready to make a move higher and wants profit from the move and take in some income. Which of the following positions should the investor establish?",
       "choice_a":"A credit call spread with a long 55 strike and a short 50 strike",
       "choice_b":"A credit put spread with a short 55 strike and a long 50 strike",
       "choice_c":"A bull call spread with a long 50 strike and a short 55 strike",
       "choice_d":"A debit put spread with a long 55 strike and a short 50 strike",
       "correct_answer":"B",
       "explanation":"The key to this question is the fact that the investor wants to take in income. Therefore, the investor is going to sell the option position. Based on the fact that the investor is bullish, the only choice is to sell a credit put spread."
    },
    {
       "id":24638,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor establishes the following position <ol style='margin-left: 25px; list-style-type: disc;'><li>Long 10 XYZ March 60 puts @ 3 </li><li>Short 10 XYZ March 55 puts at 2.5 </li></ol>Which of the following prices would result in the greatest gain for the investor? ",
       "choice_a":"55-60",
       "choice_b":"60-70",
       "choice_c":"50-55",
       "choice_d":"57.5-60",
       "correct_answer":"C",
       "explanation":"An investor who is long the spread wants the options to exercise. The options will be exercised if the stock is past the strike price of the short option. In the case of a put spread, the investor wants the stock to be at or below the lower strike price, in this case 50-55 is the best choice."
    },
    {
       "id":24662,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor sells 100 shares of ASD short at 66 and buys 1 ASD March 65 call at 3.50. The investor closes out the positing when ASD is at 68. What is his gain or loss on the position?",
       "choice_a":"$250 loss",
       "choice_b":"$250 gain",
       "choice_c":"$150 loss",
       "choice_d":"$150 gain",
       "correct_answer":"A",
       "explanation":"The investor sold the stock short at $66 and purchased the 65 call at 3.50. The call was in the money, not the best hedge but this is the question as it is presented. To determine the investor\u0027s breakeven, subtract the premium of the call from the proceeds of the short sale. In this case 66- 3.50 = 62.50. The investor covers his shout by exercising the 65 call. Therefore, his loss is found by subtracting the breakeven from the strike price of the call. In this case 65 - 62.50 = 2.50 X 100 shares = $250. "
    },
    {
       "id":24663,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An options trader establishes the following position: <ol style='margin-left: 25px; list-style-type: disc;'><li>Long 1 TRY October 60 call at 4 </li><li>Short 1 TRY October 70 call at 3 </li></ol>At which of the following prices will the investor breakeven at expiration? ",
       "choice_a":69,
       "choice_b":61,
       "choice_c":63,
       "choice_d":62,
       "correct_answer":"B",
       "explanation":"The is a call spread and with all call spreads to determine the breakeven for the spread you must add the net premium to the lower strike price. The spread was established for a net debit of $1. We need to take the net debit of $1 and add it to the lower strike price of $60. In this case we get 60 +1 = 61. "
    },
    {
       "id":24672,
       "practice_test_id":"",
       "topic_id":14,
       "question":"Which two of the following are spreads? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Buy an ABV May 50 call, Sell an ABV May 60 call </li><li>Sell a HGF January 60 call, Sell a HGF January 70 put </li><li>Write an XYZ March 85 put, Purchase an XYZ July 95 put </li><li>Buy an REW April 65 Call, Purchase and REW April 75 put</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"III and IV",
       "choice_d":"I and III",
       "correct_answer":"D",
       "explanation":"A spread is always the purchase and sale of two options of the same type. Therefore, a spread must contain a long call and a short call or a long put and a short put on the same underlying instrument. Choices I and III are spreads. Choice I is a price spread, choice III is a calendar spread. "
    },
    {
       "id":24682,
       "practice_test_id":"",
       "topic_id":14,
       "question":"A woman purchased shares of DFG corporation stock at $70 and has held the stock for 2 years. She purchases an 80 put at 3 and is forced to exercise her put when shares of DFG have fallen to 78 in the market. What is her gain or loss? ",
       "choice_a":"$5",
       "choice_b":"$7",
       "choice_c":"$8",
       "choice_d":"$10",
       "correct_answer":"B",
       "explanation":"The investor purchased the stock at $70 and after the stock had increased in value, purchased an 80 put at $3. The stock falls and the investor is forced to exercise the put, receiving the strike price of $80. To determine the proceeds from the sale, subtract the premium from the strike price, in this case 80-3 =77. To determine the profit subtract the proceeds from the purchase price, 77-70= 7."
    },
    {
       "id":24683,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor is long 200 shares of QWER at $49 per share and goes short 2 QWER May 50 calls at $2.50. What is the investor\u0027s breakeven on QWER?",
       "choice_a":"$51.50",
       "choice_b":"$52.50",
       "choice_c":"$47.50",
       "choice_d":"$46.50",
       "correct_answer":"D",
       "explanation":"When an investor has established a covered call position, to determine the breakeven you must subtract the call premium from the purchase price of the stock. In this case 49-2.50= 46.50. The stock could fall to 46.50 and the investor will be at the breakeven point. If the stock falls further the investor will start losing money."
    },
    {
       "id":24689,
       "practice_test_id":6,
       "topic_id":14,
       "question":"Standard VIX options measure the volatility of which of the following?",
       "choice_a":"S \u0026 P 100",
       "choice_b":"S \u0026 P 500",
       "choice_c":"Dow Jones",
       "choice_d":"NASDAQ 100",
       "correct_answer":"B",
       "explanation":"Standard VIX options measure the volatility of the S \u0026 P 500 index. As the market falls the VIX increases and vice versa."
    },
    {
       "id":19397,
       "practice_test_id":"",
       "topic_id":14,
       "question":"At option expiration the price of the underlying stock is pegged at the strike price of the option. Which of the following would result in a profit for an investor? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Short call </li><li>Short put </li><li>Short straddle </li><li>Long put</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I, II and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"If at expiration the price of the underlying stock price is equal to or pegged at the strike price of the option the options will expire worthless. Short option positions will result in a profit."
    },
    {
       "id":20948,
       "practice_test_id":"",
       "topic_id":14,
       "question":"As it relates to the OCC position exercise limit, the maximum number of contracts may not be exceeded by a person or group over:",
       "choice_a":"3 days",
       "choice_b":"5 days",
       "choice_c":"10 days",
       "choice_d":"2 days",
       "correct_answer":"B",
       "explanation":"The OCC sets exercise limits as to the maximum number of contracts that may be exercised by a person or group in any 5 day period. "
    },
    {
       "id":20949,
       "practice_test_id":"",
       "topic_id":14,
       "question":"As XYZ is approaching its earnings release date, the price of XYZ is becoming increasingly more volatile. As a result an option investor would expect: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Call premiums to increase  </li><li>Put premiums to increase  </li><li>Call premiums to decrease  </li><li>Put premiums to decrease </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II only",
       "choice_c":"III and IV",
       "choice_d":"III only",
       "correct_answer":"A",
       "explanation":"As volatility increases the price of options increase. when the price of the underlying security changes more rapidly as the result of an increase in volatility, the premiums of calls and puts will both increase. "
    },
    {
       "id":20950,
       "practice_test_id":"",
       "topic_id":14,
       "question":"An investor owns 10 XYZ 8 percent convertible debentures. The debentures are convertible at $25 per share. How many XYZ call options may the investor write against his long bond position and be considered covered? ",
       "choice_a":10,
       "choice_b":4,
       "choice_c":40,
       "choice_d":"0",
       "correct_answer":"B",
       "explanation":"Each bond is convertible into 40 shares of XYZ common stock, found as follows Par / CVP = 1,000 / 25 = 40 shares. Since the investor owns 10 bonds the investor may receive 400 shares of XYZ upon conversion. Therefore, this investor could write 4 XYZ call options and be covered. "
    },
    {
       "id":20951,
       "practice_test_id":"",
       "topic_id":14,
       "question":"The put / call ratio can best be used by an investor to:",
       "choice_a":"measure open interest",
       "choice_b":"measure liquidity",
       "choice_c":"measure market sentiment",
       "choice_d":"measure volatility",
       "correct_answer":"C",
       "explanation":"The put call ratio can be used by investors to measure market sentiment. The higher the ratio the more bearish market sentiment. A high put / call ratio indicates that more puts are being purchased than call."
    },
    {
       "id":37003,
       "practice_test_id":"",
       "topic_id":14,
       "question":"A bullish investor who was short an XYZ May 50 put at 2, has the stock put to him on the day prior to the ex-date. Which of the following is correct?",
       "choice_a":"the investor has lost money",
       "choice_b":"the investor has made a profit",
       "choice_c":"the investor will receive the dividend",
       "choice_d":"the investor who exercised the put will receive the dividend",
       "correct_answer":"C",
       "explanation":" Since there is no way of knowing where the stock was when XYZ was put to the investor, from the question we cannot determine if the investor made a profit or suffered a loss. The only correct answer is, the investor will receive the dividend. The investor had XYZ put to them the day prior to the ex-date and was forced to buy XYZ at the strike price of $50. because the stock was put to the investor prior to the ex-date the investor will be an owner of record on the record date and will therefore be entitled to receive the dividend on XYZ."
    },
    {
       "id":24671,
       "practice_test_id":"",
       "topic_id":10,
       "question":"When speaking to a client all of the following are not permissible for a registered representative to say, except:",
       "choice_a":"It think it is a good time to liquidate your oil and gas DPP and invest the proceeds into IOU stock it is going to appreciate by at least 10 points in the next few months",
       "choice_b":"If you purchase 200 shares of ABC I will make sure you get 200 share of GET enterprises, our next initial public offering",
       "choice_c":"At 35 XCV looks very attractive our research department has targeted the stock to go to 50 in the next quarter",
       "choice_d":"When thinking about an investment in a CMO, one could view it as similar to an investment in a bond or bond fund as it is designed to provide regular income",
       "correct_answer":"C",
       "explanation":"<div>An RR may never compare a CMO to another interest bearing security. It is also a serious violation to engage in quid pro quo trading by stating that the client will get shares in an upcoming IPO if the client purchases another investment. An RR may never state that a stock WILL go up, any prediction about price must be stated as a belief and not as a fact. Of the choices listed, only the recommendation stating that there is a price target would not be a violation. </div>"
    },
    {
       "id":24674,
       "practice_test_id":6,
       "topic_id":10,
       "question":"An investor wishing to purchase open end mutual funds with the performance characteristics of the S \u0026 P index would be said to have an investing style that is:",
       "choice_a":"Aggressive",
       "choice_b":"Passive",
       "choice_c":"Based on bottom up analysis",
       "choice_d":"Based on top down analysis",
       "correct_answer":"B",
       "explanation":"An investor who is seeking an investment that tracks the performance of an index such as the S \u0026 P 500 is engaging in a passive investment strategy. The assets in the fund are selected based on the makeup of the stocks in the index. Portfolio managers do not select the assets to be purchased or sold."
    },
    {
       "id":24691,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A wealthy client is in the maximum federal tax bracket and is seeking to avoid the potential impact of the AMT. Which of the following bonds would you most likely recommend?",
       "choice_a":"A 6% taxable municipal bond",
       "choice_b":"A 5.2 % GO bond",
       "choice_c":"A 5.4 % Treasury bond",
       "choice_d":"A 5.2 % interest protected AMT bond",
       "correct_answer":"B",
       "explanation":"Certain high income earners can be subject to the AMT on certain municipal revenue bonds. As such the best recommendation for this person is the GO bond. A Treasury bond is not the correct choice as the interest will always be taxed at the federal level."
    },
    {
       "id":20912,
       "practice_test_id":"",
       "topic_id":10,
       "question":"Which of the following investments would be least suitable for an investor seeking a short term, liquid investment providing safety of principal?",
       "choice_a":"T\u0027 Bills",
       "choice_b":"Auction rate securities",
       "choice_c":"Money market funds",
       "choice_d":"30-90 day brokered CDs",
       "correct_answer":"B",
       "explanation":"Auction rate securities are long term bonds that reset the interest rate paid on the bonds at set intervals. ARS are 20-30 years in maturity which pay interest based on the auction rate every 7, 28 or 35 days. If the auction fails investors will not be able to sell the bonds immediately. "
    },
    {
       "id":20918,
       "practice_test_id":"",
       "topic_id":10,
       "question":"In an effort to gain exposure to the market an optimistic investor takes on risk and purchases a stock with a beta equal to 1.4. If the S \u0026 P 500 is up 5 percent over the next several weeks what would the investor\u0027s expected return be on his purchase?",
       "choice_a":"6 Percent",
       "choice_b":"7 Percent",
       "choice_c":"9 percent",
       "choice_d":"11 percent",
       "correct_answer":"B",
       "explanation":"An investment with a beta of 1.4 would be expected to have a return equal to 140 percent of the return of the overall market. In this case the market was up 5 percent. The investor would therefore expect a return of 1.4 X 5 percent or a 7 percent return."
    },
    {
       "id":20921,
       "practice_test_id":1,
       "topic_id":10,
       "question":"Which of the following investments does not allow for the flow through of income and expenses?",
       "choice_a":"A real estate limited partnership",
       "choice_b":"An oil and gas drilling program",
       "choice_c":"A real estate investment trust",
       "choice_d":"A partnership organized to lease heavy equipment",
       "correct_answer":"C",
       "explanation":"All of the choices listed pass through both income and expenses to investors except a real estate investment trust or a REIT. A REIT must pass through 90 percent of its income, but does not pass expenses through to investors."
    },
    {
       "id":19329,
       "practice_test_id":2,
       "topic_id":10,
       "question":"An investor owns $50,000 worth of US T\u0027 bonds with an interest rate of 5%. The investor is in the 30% tax bracket at the federal level and 9% at the state level. The investor will have a tax liability based on the income received from the bonds equal to:",
       "choice_a":"$2,500",
       "choice_b":"$750",
       "choice_c":"$225",
       "choice_d":"$975",
       "correct_answer":"B",
       "explanation":"Interest on US T bonds is not taxed at the state or local level. The interest is only taxed that federal level. In this case the investor earned $2,500 in interest and is in the 30% tax rate. The tax liability is $750. ($2,500 X 30%)"
    },
    {
       "id":19345,
       "practice_test_id":3,
       "topic_id":10,
       "question":"Which of the following DPP programs would provide an investor with the largest write-offs?",
       "choice_a":"Raw land",
       "choice_b":"Oil and gas drilling",
       "choice_c":"Oil and income producing",
       "choice_d":"Real estate existing property",
       "correct_answer":"B",
       "explanation":"An oil and gas program would provide an investor with the largest write offs through the intangible drilling costs / IDCs. IDCs are passed through to the investors in the program and create large write-offs for investors."
    },
    {
       "id":19350,
       "practice_test_id":4,
       "topic_id":10,
       "question":"In a newly established oil and gas partnership program the general partner has agreed to pay for all of the tangible costs. The limit partners who have invested a significant amount of capital have agreed to absorb the intangible costs of the program. What type of sharing arrangement is this?",
       "choice_a":"Reversionary working interest",
       "choice_b":"Tangible / Intangible cost sharing",
       "choice_c":"Overriding royalty",
       "choice_d":"Functional allocation",
       "correct_answer":"D",
       "explanation":"This type of cost sharing arrangement in known as functional allocation. The general partner pays for the capital costs and the limited partners pay for the intangible costs."
    },
    {
       "id":19370,
       "practice_test_id":5,
       "topic_id":10,
       "question":"A client who is interested in investing in a whole loan private label CMO is asking you about the collateral and guarantees associated with the security. Upon review of the security you should tell him:",
       "choice_a":"The securities are backed by the full faith and credit of Ginnie Mae",
       "choice_b":"The securities are tied to a pool of mortgages backed by Freddie Mac",
       "choice_c":"The securities are tied to a pool of mortgages backed by Fannie Mae",
       "choice_d":"The securities are tied to a pool of mortgages backed by a letter of credit and or insurance taken out by the issuer",
       "correct_answer":"D",
       "explanation":"A private labeled CMO is created when a broker dealer purchases a large portfolio of mortgages and sells off the interest in the pool to investors in CMOs. Whole loan CMOs are backed by the pool of mortgages which in turn may have insurance or a letter of credit backing the loans in the pool, not the CMO itself. "
    },
    {
       "id":19374,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A long standing client is seeking to make an initial deposit into a college plan for his son\u0027s college expenses. His son will start college in 11 years. Which of the following is the lowest priority when determining the amount of the initial deposit?",
       "choice_a":"Client\u0027s current income",
       "choice_b":"The current average cost of college",
       "choice_c":"The time until his son starts college",
       "choice_d":"The projected annual increase in tuition",
       "correct_answer":"A",
       "explanation":"The lowest priority would be the client\u0027s current income as the client is seeking to make an initial deposit. The deposit will be coming from savings so the amount of the client\u0027s savings would be far more important. The other factors can be used to estimate what the anticipated cost of college may be and are therefore of high importance. "
    },
    {
       "id":19375,
       "practice_test_id":"",
       "topic_id":10,
       "question":"In response to a customer\u0027s request for information on a private label CMO you may inform them of all of the following except:",
       "choice_a":"The securities in the portfolio are all issued by a US agency and carry the same guarantees",
       "choice_b":"Interest payments due to investors are subject the credit risk of the issuing broker dealer",
       "choice_c":"If the interest payments in the portfolio are guaranteed by a Government agency the investor\u0027s interest payments are equally assured",
       "choice_d":"Private label CMOs may carry additional risks due the nature of the issuer\u0027s business",
       "correct_answer":"C",
       "explanation":"If the collateral in the portfolio of a private label CMO is guaranteed by a Government agency that guarantee does not pass through to the investors in the CMOs. There is no guarantee that the issuer will receive the payments and pass them on to the investors in a timely manner"
    },
    {
       "id":19386,
       "practice_test_id":"",
       "topic_id":10,
       "question":"Income from which of the following is most likely to subject a high income investor to the AMT (alternative minimum tax)?",
       "choice_a":"General Obligation (GO) bond",
       "choice_b":"Industrial revenue bond",
       "choice_c":"T Bill",
       "choice_d":"T Bond",
       "correct_answer":"B",
       "explanation":"Income from a private purpose municipal bond also known as an industrial revenue development bond is most likely to subject a high income investor to the AMT (alternative minimum tax)."
    },
    {
       "id":19387,
       "practice_test_id":"",
       "topic_id":10,
       "question":"Which of the following is a feature of a 529 college plan? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> High contribution limit  </li><li>Pre tax contributions </li><li>Federally tax free withdrawals for college expenses  </li><li>Contributions subject to income restrictions</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"I, III and IV",
       "choice_d":"I,II, III, IV",
       "correct_answer":"A",
       "explanation":"529 plans allow for high contribution limits. There are no income limits for contributors to a 529 plan. Students may make withdrawals from 529 plans federally tax free to meet college expenses. "
    },
    {
       "id":19388,
       "practice_test_id":"",
       "topic_id":10,
       "question":"Which of the following is not a feature of a 529 college plan? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> High contribution limit </li><li>Pre tax contributions </li><li>Federally tax free withdrawals for college expenses </li><li>Contributions subject to income restrictions</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"A",
       "explanation":"529 plans do not allow contributions to be made with pre tax dollars. There are no income limits for contributors to a 529 plan"
    },
    {
       "id":20122,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A 42 year old investor wants to put $20,000 into a plan to help meet the educational expenses of their 12 year old son. They want to make a lump sum deposit. Which would you recommend?",
       "choice_a":"A 529 plan",
       "choice_b":"A Coverdell IRA",
       "choice_c":"A Roth IRA",
       "choice_d":"A Growth mutual fund",
       "correct_answer":"A",
       "explanation":"A 529 plan would allow the investor to make a lump sum deposit. The key is that the investor is looking for a \u0022plan\u0022 to put money into and has a large sum of money to invest. The 529 plan is the correct option for this investor."
    },
    {
       "id":20281,
       "practice_test_id":"",
       "topic_id":10,
       "question":"An investor in a high tax bracket would receive the most benefit from the purchase of which of the following securities?",
       "choice_a":"CMOs",
       "choice_b":"Municipal bonds",
       "choice_c":"GMNAs",
       "choice_d":"US Treasury bonds",
       "correct_answer":"B",
       "explanation":"CMOs and GMNAs pay interest that is fully taxable, and US government securities pay interest that is federally taxed only. However, municipal bonds pay interest that is federally tax free. So investors in higher tax brackets receive the most tax benefits from investing in municipal bonds."
    },
    {
       "id":20284,
       "practice_test_id":"",
       "topic_id":10,
       "question":"CMOs are the most appropriate investment for a person seeking:",
       "choice_a":"Tax relief",
       "choice_b":"Long term growth potential",
       "choice_c":"Income",
       "choice_d":"Liquidity",
       "correct_answer":"C",
       "explanation":"CMOs are not a suitable investment for an investor seeking tax relief, as interest on CMOs is fully taxable. Many of the more complex CMOs can be highly illiquid; and being a pass through investment there is no long term growth potential However, CMOs do pay regular income in the form of principal, interest or both to the investor."
    },
    {
       "id":20287,
       "practice_test_id":"",
       "topic_id":10,
       "question":"Joe Smith, a customer of XYZ broker dealer wishes to diversify his portfolio by investing in many different types of securities. Joe will have to sign a suitability statement before investing in all of the following except:",
       "choice_a":"A CMO with a planned amortization class",
       "choice_b":"An Industrial development bond",
       "choice_c":"Penny stocks",
       "choice_d":"A real estate limited partnership",
       "correct_answer":"B",
       "explanation":"Due to a high degree of risk and a low degree of liquidity investors are required to sign a suitability statement when investing in CMOs, penny stocks and DPPs. IDRs are a type of municipal note and do not require a suitability statement."
    },
    {
       "id":20288,
       "practice_test_id":"",
       "topic_id":10,
       "question":"John Sno, a 38 year old customer with a 5 year old daughter, wants to begin saving for his daughter\u0027s college education. He is interested in a 529 plan. You tell him:",
       "choice_a":"He can choose a 529 plan that is a prepaid tuition plan and begin contributing immediately",
       "choice_b":"He can choose a 529 plan that is a college savings plan and begin contributing immediately",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"C",
       "explanation":"A 529 plan can be set up as either a prepaid tuition plan, which locks in today\u0027s tuition cost at a specific college; or as a college savings plan, which allows the contributions to grow tax deferred."
    },
    {
       "id":20289,
       "practice_test_id":"",
       "topic_id":10,
       "question":"Which of the following are considered benefits of a 529 plan?",
       "choice_a":"Contributions grow tax deferred",
       "choice_b":"The cost of tuition a specific school can be locked in",
       "choice_c":"The donor maintains ownership of the account",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Contributions to a 529 plan grow tax deferred and can be used to pre-pay the cost of tuition at a specific college at today\u0027s rate. And unlike an Education IRA, the individual who set up the plan retains ownership of the contributions."
    },
    {
       "id":20291,
       "practice_test_id":"",
       "topic_id":10,
       "question":"If a client wishes to open an account for a minor whereby he, the donor, retains ownership of the account he would most likely open a:",
       "choice_a":"Coverdell IRA",
       "choice_b":"529 plan",
       "choice_c":"UGMA",
       "choice_d":"UTMA",
       "correct_answer":"B",
       "explanation":"In a 529 plan the donor remains the owner of the account even when the minor reaches the age of majority. In a Coverdell IRA, UGMA and UTMA account, the minor is the beneficial owner of the account from its inception."
    },
    {
       "id":20292,
       "practice_test_id":"",
       "topic_id":10,
       "question":"All of the following are true regarding 529 plans except:",
       "choice_a":"Once established the account becomes the property of the minor",
       "choice_b":"The account can be established as a college savings plan",
       "choice_c":"Withdrawals for educational expenses are federally tax free",
       "choice_d":"The account can be established as a prepaid tuition plan",
       "correct_answer":"A",
       "explanation":"When a 529 plan is created the donor makes after tax contributions to the account and the withdrawals are federally tax free if used for educational expenses. The account is set up for the benefit of a minor, but the donor remains the owner of the account."
    },
    {
       "id":20295,
       "practice_test_id":"",
       "topic_id":10,
       "question":"Which of the following are considered benefits of a 529 plan? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Contributions grow tax deferred  </li><li>A pre-paid tuition plan locks in today\u0027s tuition rates for future enrollment at specific school  </li><li>Withdrawals are federally tax free if used for educational expenses  </li><li>Depending on the state, withdrawals may be state tax free</li></ol>",
       "choice_a":"I, III",
       "choice_b":"III, IV",
       "choice_c":"I, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"A 529 plan allows for contributions to grow tax deferred and withdrawals to be federally and, many times, state tax free. If the customer decides on a prepaid tuition program he will lock in the price of a future education."
    },
    {
       "id":20297,
       "practice_test_id":6,
       "topic_id":10,
       "question":"An investor who is concerned with liquidity risk would be least likely to purchase which of the following?",
       "choice_a":"Common stock",
       "choice_b":"Variable annuities",
       "choice_c":"Money market securities",
       "choice_d":"Mutual fund shares",
       "correct_answer":"B",
       "explanation":"Common stock, money market securities and mutual funds are all liquid investments. A variable annuity follows the same rules as a traditional IRA in that the investor cannot liquidate the annuity before the age of 59 \u00BD without a penalty and tax consequence."
    },
    {
       "id":20298,
       "practice_test_id":"",
       "topic_id":10,
       "question":"Which of the following is most suitable for a customer who is looking for growth potential with a minimum guaranteed rate of return?",
       "choice_a":"A balanced fund",
       "choice_b":"A variable annuity",
       "choice_c":"A money market fund",
       "choice_d":"A combination annuity",
       "correct_answer":"D",
       "explanation":"A combination annuity provides a guaranteed rate of return by investing in the general account plus a variable rate of return by investing in the separate account."
    },
    {
       "id":20958,
       "practice_test_id":"",
       "topic_id":10,
       "question":"Which of the following investors would be most likely to purchase an inverse ETF?",
       "choice_a":"A long term investor",
       "choice_b":"An institutional investor",
       "choice_c":"A bearish investor",
       "choice_d":"A bullish investor",
       "correct_answer":"C",
       "explanation":"An inverse ETF offers price performance that moves in the opposite direction of the underlying index. The S \u0026 P 500 inverse ETF will increase in price as the value of the S \u0026 P 500 falls. An investor who was bearish or who thought that the market may generally fall would be the most likely to purchase an inverse ETF."
    },
    {
       "id":20959,
       "practice_test_id":"",
       "topic_id":10,
       "question":"An investor who is long a large portfolio of large cap common stocks would most likely execute which of the following to protect the portfolio from a market correction?",
       "choice_a":"Purchase an inverse bond fund ETF",
       "choice_b":"Purchase a bond fund",
       "choice_c":"Purchase the S \u0026 P 500 inverse ETF",
       "choice_d":"Purchase puts on each holding in the portfolio",
       "correct_answer":"C",
       "explanation":"An investor who is long a large portfolio of large cap common stocks would most likely purchase the S \u0026 P 500 inverse ETF to provide protection to the overall portfolio in the event of a market correction. The price of the inverse ETF will increase as the value of the S \u0026 P 500 falls. Buying the inverse ETF is more efficient than purchasing puts on each and every stock in the portfolio."
    },
    {
       "id":20960,
       "practice_test_id":"",
       "topic_id":10,
       "question":"An inverse ETF would be suitable for which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Long term protection  </li><li>Short term protection  </li><li>Gaining short exposure </li><li>Portfolio hedging</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"I, II and IV",
       "choice_d":"II, III and IV",
       "correct_answer":"D",
       "explanation":"An inverse ETF could be used for short term protection, to gain short exposure to the market, or to hedge an overall portfolio against a market decline. An inverse ETF is not designed for long term protection."
    },
    {
       "id":25535,
       "practice_test_id":2,
       "topic_id":10,
       "question":"Mr. Walsh, a conservative investor in his mid seventies, is seeking to generate additional income in his IRA. His registered representative recommends covered calls on several of the larger positions in the account. Which of the following is correct?",
       "choice_a":"The rep should not recommend option strategies to IRA investors who have passed the age of required minimum distribution",
       "choice_b":"The rep should have consulted with the options supervisor prior to discussing covered calls with the client",
       "choice_c":"Option trading of this type is never appropriate for older investors",
       "choice_d":"The options supervisor may approve the account and the trades may be executed",
       "correct_answer":"D",
       "explanation":"Writing covered calls is a conservative strategy and most investors will be approved for this type of options trading. Covered calls are the only type of option training that may take place in an IRA account."
    },
    {
       "id":36996,
       "practice_test_id":3,
       "topic_id":10,
       "question":"Any short-term capital gains, ones that are earned or realized in less than one year, would subject an individual to which of the following?",
       "choice_a":"a 25% tax",
       "choice_b":"a 15% tax",
       "choice_c":"a tax based on their level of income",
       "choice_d":"a 20% tax",
       "correct_answer":"C",
       "explanation":"Short-term capital gains are taxed at the same rate as ordinary income therefore, an individual who realizes a short-term capital gain, one that has been earned in 12 months or less would be subject to ordinary income taxes on that short-term gain. income taxes are progressive taxes and the rate is based on the level of income earned by the individual."
    },
    {
       "id":39222,
       "practice_test_id":4,
       "topic_id":10,
       "question":"A new customer is interested in pursuing income. Regarding risk tolerance she says; \u0022I\u0027m a bit defensive about that, I\u0027d rather be in investments that are non-volatile\u0022. Of the following which would be most suitable for her?",
       "choice_a":"Short-term government bonds",
       "choice_b":"High yield corporate debt instruments",
       "choice_c":"Growth stocks",
       "choice_d":"Raw land limited partnerships",
       "correct_answer":"A",
       "explanation":"Of the above investments only short-term government bonds will produce the objective (income) with little price volatility."
    },
    {
       "id":39223,
       "practice_test_id":5,
       "topic_id":10,
       "question":"A registered representative\u0027s customer is bullish on US equity securities across a number of industry categories. The customer is hoping to participate in an anticipated upward movement of an index that would represent as many of these industry categories as possible. Aligning with her market outlook, which of the following investments would you recommend as being most closely related to the movement of equities in general and therefore the most suitable recommendation?",
       "choice_a":"Standard \u0026 Poor\u0027s depository receipts (SPDRs)",
       "choice_b":"American depositary receipts (ADRs)",
       "choice_c":"Real Estate Investment Trusts (REITs)",
       "choice_d":"Variable rate demand obligations (VRDOs)",
       "correct_answer":"A",
       "explanation":"Of the choices shown, only the spider (SPDR) is an index fund designed to replicate and track the performance of the S \u0026 P 500, a broad-based equity index. None of the remaining choices represent a broad base of equities. For example, REITs represent real estate holdings and VRDOs represent short-term debt obligations."
    },
    {
       "id":39224,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A married couple having a long-term growth objective is considering a mutual fund but they express a specific aversion to high annual fund expenses. Given their objective and preferences, a suitable recommendation would be a:",
       "choice_a":"common stock fund with a low portfolio turnover.",
       "choice_b":"dividend producing fund with a high portfolio turnover.",
       "choice_c":"long-term corporate bond fund that is actively managed.",
       "choice_d":"preferred stock fund that is actively managed.",
       "correct_answer":"A",
       "explanation":"Of the choices given, common stock is the only investment capable of providing long-term growth. A preferred stock fund or a dividend producing fund will provide income via the dividends collected but not provide much growth. Bond funds provide income and are not designed to meet a growth objective. Lower portfolio turnover (less trading in and out of the fund portfolio) should result in lower annual fund expenses."
    },
    {
       "id":39225,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A new customer in his early thirties has $100,000 to invest. He is single, has no dependents and tells you he is willing to tolerate a high degree of risk. He adds confidently that he has no anticipation of tapping into these invested funds for at least 15 years. With this profile, what would be a suitable recommendation regarding asset allocation for the customer\u0027s portfolio?",
       "choice_a":"$70,000 equities, $20,000 debt, and $10,000 money-market instruments",
       "choice_b":"$45,000 debt, $35,000 equities, and $20,000 money-market instruments",
       "choice_c":"$35,000 debt, $35,000 equities, $30,000 real estate investment trusts",
       "choice_d":"$65,000 debt, $30,000 equities and $5,000 money-market instruments",
       "correct_answer":"A",
       "explanation":"Given his 15-year time horizon and his willingness to tolerate higher levels of risk, a recommendation having a higher percentage of the portfolio in equities would be most suitable for this investor. Of the asset mixes presented only one has the majority invested in equities while the others have higher or equal concentrations in debt securities and would likely be too conservative."
    },
    {
       "id":39226,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A new customer says her investment philosophy is value oriented as opposed to growth oriented. Looking for a stock recommendation and considering that value is her primary objective, which of the following stock characteristics would she be least likely to consider?",
       "choice_a":"A stock with an above average price-to-earnings ratio.",
       "choice_b":"A stock with consistent and high dividend yields.",
       "choice_c":"A stock with a low price-to-earnings ratio.",
       "choice_d":"A stock that is presently selling at a price 15% below its current book value.",
       "correct_answer":"A",
       "explanation":"A value investor focuses on stocks with low PE ratios, low price-to-book values, and historically high dividend yields. Conversely, a growth investor looks for stocks with above-average price-to-earnings ratios. Therefore, a stock with an above average price-to-earnings ratio would be least attractive or suitable for this investor."
    },
    {
       "id":39227,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A married couple expresses having an investment objective of long-term growth. They have a joint account and mutually agree that they are willing to accept a reasonable amount of risk. Which type of mutual fund is the most suitable for them given their objective and risk tolerance?",
       "choice_a":"Common stock fund",
       "choice_b":"Money market fund",
       "choice_c":"Corporate bond fund",
       "choice_d":"Municipal bond fund",
       "correct_answer":"A",
       "explanation":"Of these broad fund categories offered, and given their willingness to accept a reasonable amount of risk, only a common stock fund could be expected to meet their long-term growth objective and would therefore be the most suitable."
    },
    {
       "id":39228,
       "practice_test_id":"",
       "topic_id":10,
       "question":"Among factors to be discussed with clients pertaining to suitability, which of the following pairs would always be included?",
       "choice_a":"Liquidity preferences and number of dependents",
       "choice_b":"Professional licenses or designations and education level",
       "choice_c":"Income and languages spoken",
       "choice_d":"Eligibility for employment bonuses and monthly expenses",
       "correct_answer":"A",
       "explanation":"Regarding suitability a number of factors would be considered but they would primarily have to do with investment needs and objectives, risk tolerance and financial ability. The only pair noted above that would be relevant to these is the preference or need for liquidity and the number of dependents lending to one\u0027s financial abilities and responsibilities."
    },
    {
       "id":39229,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A client profile can be summed up as follows; safety of principal, tax-free income and the need for liquidity. Of the following which would be the most suitable?",
       "choice_a":"Short-term municipal bond mutual fund",
       "choice_b":"High-yield dividend income mutual fund",
       "choice_c":"Income bonds",
       "choice_d":"Exploratory oil and gas DPP",
       "correct_answer":"A",
       "explanation":"Only the short-term municipal bond mutual fund would meet all three investment criteria. A mutual fund is liquid, municipal bond portfolios are relatively safe, and the bonds provide income free from federal tax. High-yield income funds usually invest in lower rated bonds to achieve a higher yield, income bonds only pay interest if the company can afford to meet the obligation, and exploratory oil \u0026 gas programs carry a high degree of risk."
    },
    {
       "id":39230,
       "practice_test_id":"",
       "topic_id":10,
       "question":"Consider the following customer profile; joint account, married, ages 44 and 47, combined annual income of $280,000, residents of Florida. With a conservative risk tolerance, they have been heavily invested in bonds up to this point. They are now willing to move outside their traditional comfort zone and accept higher risk to invest $150,000 of their $3,000,000 portfolio in a fund that will provide additional diversification and specifically offer a possible hedge against the effects of inflation. Which of the following mutual funds is the most suitable for this account?",
       "choice_a":"International equity opportunities fund",
       "choice_b":"Tax-free Florida State municipal bond fund",
       "choice_c":"Tax-free Florida State municipal bond fund",
       "choice_d":"US Treasury income fund",
       "correct_answer":"A",
       "explanation":"Investment in an international equity fund will not only provide diversification to a portfolio already heavily invested in bonds, but will also provide a potential hedge against U.S. inflation. The remaining choices all invest in debt securities that are generally not a suitable hedge against inflation. Nor would they add diversification to the aforementioned existing portfolio."
    },
    {
       "id":39231,
       "practice_test_id":"",
       "topic_id":10,
       "question":"You have a corporate client with the intention of investing a large sum and prefers a managed fund. The objective is simple; current income. The corporate charter allows for moderate risk. Given the profile which of the following would be suitable?",
       "choice_a":"Preferred stock fund",
       "choice_b":"Aggressive growth fund",
       "choice_c":"Money market fund",
       "choice_d":"High-yield bond fund",
       "correct_answer":"A",
       "explanation":"Preferred stock generates current income in the form of dividends and would thus be suitable here. The other choices would have to be eliminated as follows; aggressive growth funds strive for capital appreciation rather than current income, money market funds have low yields that would not align with the yields an income investor would seek, and while high-yield bonds would provide current income, they entail too high a degree of risk."
    },
    {
       "id":39232,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A client expresses that she wants the investment objective for a small $20,000 investment she wants to add to her portfolio to be income. She notes that the income stream should be reliable. She suggests four investments she thinks might be worth taking a look at. Of the four she suggests you would immediately point out that one of them is not suitable to meet her objective. Which is it?",
       "choice_a":"Income bonds",
       "choice_b":"U.S. Treasury notes",
       "choice_c":"Preferred stock",
       "choice_d":"Corporate bonds",
       "correct_answer":"A",
       "explanation":"Remember that income bonds, also known as adjustment bonds, pay interest only if the issuer has enough earnings to make those payments. They are often issued by companies coming out of bankruptcy and therefore could never be suitable for someone who has an income investment objective, particularly for someone who wants that income stream to be considered reliable."
    },
    {
       "id":39233,
       "practice_test_id":"",
       "topic_id":10,
       "question":"You are asked to make a recommendation to a client who notes having a moderate-risk tolerance. She is seeking long-term capital gains and places a high value on professional and active management to maximize potential returns. Which of the following would be best suited to her investment profile?",
       "choice_a":"Large-cap growth fund",
       "choice_b":"S \u0026 P 500 Index fund",
       "choice_c":"International index fund",
       "choice_d":"Small-cap growth fund",
       "correct_answer":"A",
       "explanation":"A large-cap growth fund is the most appropriate choice for a moderate-risk client because large capitalization stocks are generally less volatile than small capitalization stocks and generally seek to provide long-term capital growth. This is a more suitable choice than either of the index funds because those are not actively managed but invest instead to always align with the index."
    },
    {
       "id":39234,
       "practice_test_id":"",
       "topic_id":10,
       "question":"If a client is in a low tax bracket and wishes to invest only a moderate sum to gain some protection from inflation, which of the following would you offer as a suitable recommendation?",
       "choice_a":"Mutual fund with a growth objective investing in mid-cap companies.",
       "choice_b":"Municipal bond unit investment trust offering tax advantages.",
       "choice_c":"Money market mutual fund offering protection of principal.",
       "choice_d":"GNMA fund offering monthly dividends.",
       "correct_answer":"A",
       "explanation":"Historically, equities provide greater protection from inflation than debt securities do. Growth funds invest primarily in equities. Note that all of the remaining choices invest in debt securities."
    },
    {
       "id":39235,
       "practice_test_id":6,
       "topic_id":10,
       "question":"For a small portion of a $700,000 investment portfolio a client is comfortable seeking a fund with capital appreciation as its investment objective. Which of the following would meet that objective?",
       "choice_a":"Specialized fund investing primarily in the healthcare industry.",
       "choice_b":"Income fund investing primarily in high rated corporate bonds.",
       "choice_c":"Municipal bond fund investing only in Georgia State municipal bonds.",
       "choice_d":"Balanced fund actively managed to align with expected near term market conditions.",
       "correct_answer":"A",
       "explanation":"The objective of capital appreciation is most likely realized by an equity fund. Of the choices offered only a specialized fund would have such an objective. These are funds that invest in stocks of one particular industry or region."
    },
    {
       "id":39236,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A customer expresses the desire to collect regular dividends, wants a high degree of safety for the principal amount he intends to invest at this time and is seeking something that might offer tax advantages for someone like himself in a high-income tax bracket. Which of the following funds might be most suitable?",
       "choice_a":"Municipal bond fund",
       "choice_b":"Corporate bond fund",
       "choice_c":"Money market fund",
       "choice_d":"Aggressive growth fund",
       "correct_answer":"A",
       "explanation":"Of the choices offered, only the municipal bond fund could offer any tax advantages because interest received from the bonds is generally exempt from federal income tax. Regarding safety, a municipal bond fund satisfies that objective as well as they are generally considered second only to U.S. government securities. All of the funds shown could meet the dividend criteria."
    },
    {
       "id":39237,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A client expresses a goal to utilize funds he currently holds for a specific purpose in 5 to 7 years. Because he knows what his timeline is and currently has the funds in hand, he notes a very conservative / risk averse tolerance for this investment. As an after-thought he mentions that some type of investment with a stated maturity or expiration date is probably what he is envisioning but not something that would preclude divesting earlier if needed. Which of the following investment vehicle groups might be suitable to begin a conversation focusing on his needs, timeline and criteria?",
       "choice_a":"Treasury bonds, unit investment trusts and corporate bonds",
       "choice_b":"Treasury bills, hedge funds and specialized funds",
       "choice_c":"Listed options, exchange traded equity funds and major market index mutual funds",
       "choice_d":"Treasury bills, municipal bonds and variable annuities",
       "correct_answer":"A",
       "explanation":"Of the groupings shown, only Treasury bonds, unit investment trusts and corporate bonds could each meet this investor\u0027s criteria. Each of these has a stated maturity but can also be divested of earlier if need be. Given the stated maturity dates each could be selected to accommodate the specified time line noted and each can be chosen to align with the client\u0027s risk-averse criteria. For example, choosing AAA rated corporate bonds or a UIT that invests solely in government or AAA rated corporate debt instruments. Within the remaining groupings at least one selection within each of them would violate one or more of the investors stated criteria."
    },
    {
       "id":39238,
       "practice_test_id":1,
       "topic_id":10,
       "question":"A client notes that a few years ago debt securities tended to do well relative to the overall market but last year equities soared. While he isn\u0027t prepared to pick individual stocks or bonds himself, he asks if there are any investments relying on the expertise of others to do that and where he can rely on them to adjust the portfolio in accordance with future market expectations. Given his investment criteria you might best recommend?",
       "choice_a":"a balanced fund.",
       "choice_b":"a hedge fund.",
       "choice_c":"a specialized fund.",
       "choice_d":"an aggressive growth fund.",
       "correct_answer":"A",
       "explanation":"Balanced funds invest in both stocks and bonds. Fund managers attempt to adjust the percentage invested in the two types of securities in accordance with market expectations in order to maximize the yield obtained. The percentages invested in each class of security are not mandated by industry regulation and are therefore at the discretion of the fund manager."
    },
    {
       "id":39239,
       "practice_test_id":2,
       "topic_id":10,
       "question":"An investor\u0027s primary objective is to choose a mutual fund where dividends paid into the portfolio can be expected regardless of current market conditions. She also notes capital growth as being a reasonable secondary objective for her, given her risk tolerance. If recommending a mutual fund to this investor, which of the following industry groups would best fulfill her criteria?",
       "choice_a":"Public utilities",
       "choice_b":"Military contractors",
       "choice_c":"Blockchain technology",
       "choice_d":"Consumer retail",
       "correct_answer":"A",
       "explanation":"Utilities are defensive industries meaning that they tend to perform with some consistency regardless of market conditions. While capital growth is a reasonable expectation for utilities, their payment of dividends is historically consistent, fulfilling the investor\u0027s investment criteria."
    },
    {
       "id":39240,
       "practice_test_id":3,
       "topic_id":10,
       "question":"A client expresses an interest in investing in a portfolio that is fixed using municipal or corporate bonds. He prefers an investment with no, or limited active management so as to avoid high expense ratios. Which of the following would be a suitable recommendation?",
       "choice_a":"A unit investment trust holding debt instruments.",
       "choice_b":"A growth fund investing primarily in new issues.",
       "choice_c":"A utilities fund paying high dividends.",
       "choice_d":"An exchange traded fund for the purpose of allowing quick liquidation.",
       "correct_answer":"A",
       "explanation":"Of the options shown only a unit investment trust offers a portfolio with no, or limited active management. A unit investment trust issues shares that represent units of a fixed portfolio; one that is not actively traded."
    },
    {
       "id":39241,
       "practice_test_id":4,
       "topic_id":10,
       "question":"A growth investment is best described as being one where:",
       "choice_a":"the value of the investment will increase over time.",
       "choice_b":"the principal and dividends will increase over time.",
       "choice_c":"any investment appreciation will be tax-deferred.",
       "choice_d":"all interest and dividends received will be reinvested.",
       "correct_answer":"A",
       "explanation":"Growth is simply the increase in an investment\u0027s value over time. Remember that interest and dividends received, whether reinvested or not, represent income, not growth."
    },
    {
       "id":39242,
       "practice_test_id":5,
       "topic_id":10,
       "question":"An investor\u0027s portfolio consists of 50% blue-chip stocks (i.e., IBM, GM) and 50% growth stocks (i.e., AMZN, MSFT). This portfolio can best be described as:",
       "choice_a":"a growth and income portfolio.",
       "choice_b":"an aggressive growth portfolio.",
       "choice_c":"a high-yield income portfolio.",
       "choice_d":"a balanced portfolio.",
       "correct_answer":"A",
       "explanation":"A growth and income portfolio typically combines equities. More conservative blue-chip securities are used for their price stability, lending to capital preservation and payment of dividends for income, along with growth stocks for their appreciation potential. An aggressive portfolio contains securities of smaller companies that might have the potential for significant capital appreciation but may not provide much income. A high-yield income portfolio lends itself to lower rated debt securities and a balanced portfolio invests in both stocks and bonds."
    },
    {
       "id":39243,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A new client comes to you with an existing investment portfolio that is 45% growth stocks, 10% foreign stocks and 45% income producing stocks. She tells you she is satisfied with its performance so far but might be open to some diversification using a mutual fund or exchange traded fund. She has a moderate risk tolerance. Which of the following would best accommodate her objective to diversify?",
       "choice_a":"Corporate bond fund",
       "choice_b":"Emerging markets fund",
       "choice_c":"Global equity growth fund",
       "choice_d":"Domestic growth and income fund",
       "correct_answer":"A",
       "explanation":"All of the client\u0027s current investments are in equities. The portfolio holds income stocks, growth stocks and foreign equity securities, but what is missing are debt securities. If the objective is to further diversify the current portfolio, the corporate bond fund would be the best choice of those shown."
    },
    {
       "id":39244,
       "practice_test_id":"",
       "topic_id":10,
       "question":"One of the following transactions, upon review would be deemed unsuitable for any investor because it is deemed to be uneconomical. Which is it?",
       "choice_a":"Long 1 July 45-50 call spread paying a debit of 5.10",
       "choice_b":"Long 4 August 55-60 put spreads paying a debit of 3",
       "choice_c":"Short 2 November 40 straddles receiving a 6 credit",
       "choice_d":"Short 1 September 30-40 call spread receiving a credit of 6.25",
       "correct_answer":"A",
       "explanation":"An example of an uneconomical transaction is one where no profit could be realized. This would be the case with an option spread where the premium paid (debit) exceeded the spread between the strike prices. Long 1 July 45-50 call spread paying a debit of 5.10 represents a spread of 5 points (45-50) with a premium being paid (5.10) that exceeds 5 points."
    },
    {
       "id":39245,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A new client insists that whatever the individual securities, equities or debt, he wants to invest in managed portfolios. He notes that it is very important to him that a portfolio is being monitored and amended to meet market expectations. Given the stated criteria, which of the following would not be suitable?",
       "choice_a":"Unit investment trusts",
       "choice_b":"Open-end mutual funds",
       "choice_c":"Closed-end mutual funds",
       "choice_d":"Exchange traded funds",
       "correct_answer":"A",
       "explanation":"The Investment Company Act of 1940 defines closed and open-end funds as subclassifications of management companies; actively managed portfolios. So too are exchange traded funds. Unit investment trusts however are separate investment company classifications and do not have managed portfolios. Therefore, they would not be suitable to meet this investor\u0027s criteria."
    },
    {
       "id":39246,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A new client expresses that being able to get into and out of investments easily and quickly is important to her. She begins to talk about several investment types but you point out that two of them would not be suitable given her stated criteria. Which two are they?",
       "choice_a":"Unit investment trusts and open-end mutual funds",
       "choice_b":"Real estate investment trusts and exchange traded funds",
       "choice_c":"Exchange listed equities and closed-end funds",
       "choice_d":"Exchange traded funds and corporate bonds",
       "correct_answer":"A",
       "explanation":"Closed-end funds, exchange traded funds, listed equities, corporate bonds and real estate investment trusts trade actively in the secondary market. Open-end mutual funds and unit investment trusts do not trade in the secondary market making them unsuitable given this investor\u0027s stated criteria."
    },
    {
       "id":39247,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A client is considering investing in preferred shares of a company but is concerned with inflation risk. Which preferred stock feature if available would make the issue more suitable given his concern?",
       "choice_a":"Convertible",
       "choice_b":"Callable",
       "choice_c":"Cumulative",
       "choice_d":"Noncumulative",
       "correct_answer":"A",
       "explanation":"Some investments are subject to inflation risk; bonds and preferred shares which make fixed interest or dividend distributions among them. The ability to convert to common stock helps to mitigate inflation risk because common shares are more likely to keep pace with inflation."
    },
    {
       "id":39248,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A client with a well-balanced portfolio of both equity and debt securities wants to diversify allocating roughly 10% to real estate. He is concerned however about real estate being illiquid. Given this concern, which of the following real estate investments is most suitable?",
       "choice_a":"Purchasing shares of a real estate investment trust.",
       "choice_b":"Investing in a real estate limited partnership.",
       "choice_c":"Purchasing a small commercial retail building",
       "choice_d":"Purchasing a residential condominium to lease out.",
       "correct_answer":"A",
       "explanation":"Shares of a real estate investment trust (REIT) are best suited to the client because they trade in the secondary market making them easily divested of. None of the other options shown are considered liquid or easily divested of."
    },
    {
       "id":39249,
       "practice_test_id":"",
       "topic_id":10,
       "question":"An investor adamant that his investments be liquid is considering investing in American depositary receipts (ADRs). He is familiar and comfortable with all of the risks associated with investing in foreign companies. Considering his concerns about liquidity though, such an investment would:",
       "choice_a":"be suitable because shares of ADRs, whether listed on a US exchange or unlisted, trade freely in US markets.",
       "choice_b":"be suitable because they are only subject to market risk as is any security that trades freely in the open market.",
       "choice_c":"be unsuitable because the potential receipt of dividends in a foreign currency makes them subject to currency risk.",
       "choice_d":"be unsuitable given they represent ownership in a foreign entity making them subject to political risk.",
       "correct_answer":"A",
       "explanation":"American depositary receipts (ADRs) may be unsuitable for investors who are averse to political, currency, or market risk in general. However, if the investors only risk aversion has to do with liquidity, they would be deemed suitable because shares trade freely on US exchanges or in over the counter markets."
    },
    {
       "id":39250,
       "practice_test_id":2,
       "topic_id":10,
       "question":"Your client, who is in a high-income tax bracket and has a high net worth mentions several investments that she is thinking about that might be beneficial to her. Obviously, she is concerned about any tax consequences. Considering her profile, of the investments she\u0027s spoken about which of the following would be the most suitable recommendation?",
       "choice_a":"Low yielding municipal bonds",
       "choice_b":"High yielding non-investment-grade corporate bonds",
       "choice_c":"An exchange traded fund investing in blockchain technolog",
       "choice_d":"A real estate investment trust",
       "correct_answer":"A",
       "explanation":"Of the choices shown only municipal bonds offer a tax consequence that lends itself to being more suitable for high income, high net worth investors; tax-free interest payments. Conversely, corporate bond interest, ETF dividends and income from real estate investment trusts are all taxable."
    },
    {
       "id":39251,
       "practice_test_id":3,
       "topic_id":10,
       "question":"Your customer prefers investments that are short term and liquid because he sometimes needs unanticipated access to funds for cash flow purposes to run his business. He\u0027s considering auction rate securities given the higher rates of return he can realize with them as opposed to those offered by Treasury securities he is now holding in his account. For this customer auction rate securities would be:",
       "choice_a":"unsuitable because they are variable rate bonds with 20 to 30-year maturities and are therefore intended to be held long-term.",
       "choice_b":"unsuitable because interest rates are reset at predetermined intervals, typically weekly or monthly.",
       "choice_c":"suitable given that the rate of return is guaranteed short-term and reset over predetermined intervals going forward.",
       "choice_d":"suitable because they are short-term bonds and completely liquid at all times.",
       "correct_answer":"A",
       "explanation":"Auction rate securities (ARSs) are long-term variable rate bonds and therefore not suitable for an investor favoring short-term investments. These securities however are tied to short term interest rates which are reset at predetermined intervals using a Dutch auction system. A lack of demand for the securities can perpetuate a failed auction and until that can be rectified immediate access to funds can be limited, another reason they would not be suitable for this investor."
    },
    {
       "id":39252,
       "practice_test_id":4,
       "topic_id":10,
       "question":"Your client who has a high net worth and substantial income is interested in debt securities with favorable tax consequences. His investor profile however shows an aversion to credit risk which you must consider before making any tax favored investment recommendations. Which of the following would not be a suitable recommendation for this client?",
       "choice_a":"Industrial revenue bonds",
       "choice_b":"General obligation bonds",
       "choice_c":"New housing authority bonds",
       "choice_d":"US treasury securities",
       "correct_answer":"A",
       "explanation":"Industrial revenue bonds are a form of municipal security which are issued to build or support facilities that the municipality then leases, generally to a corporate entity. Like most municipals they offer favorable tax consequences for those in high income tax brackets or with a high net worth. However, they represent high credit risk (therefore not suitable for this investor) because the debt service is the responsibility of the corporation leasing the facility supported by the bonds, rather than the responsibility of the issuing municipality."
    },
    {
       "id":39253,
       "practice_test_id":5,
       "topic_id":10,
       "question":"As a registered municipal bond representative for your broker-dealer you have been given discretion over the account of a physician residing in New York. The client profile shows that he is conservative, avoids investment risk, and seeks long-term growth potential. Of the following choices, which would you deem to be the most suitable to include in the physician\u0027s portfolio?",
       "choice_a":"New York transit authority revenue bonds rated Aa.",
       "choice_b":"Iowa revenue bonds rated AA.",
       "choice_c":"California high-yield municipal bonds rated BB.",
       "choice_d":"Maryland Wetlands general obligation municipal bonds rated Aa.",
       "correct_answer":"A",
       "explanation":"The Iowa revenue bonds, the sub-investment grade California bonds, and the Maryland bonds have possible state disadvantages for a purchaser residing in New York. Additionally, two of them are less than investment grade. Of these choices, the in-state New York issued bonds rated Aa would be the most suitable."
    },
    {
       "id":39254,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A registered representative is making a recommendation to include municipal bonds in a customer\u0027s portfolio. Assuming the representative is well acquainted with the client\u0027s investment profile including risk tolerance, which of the following would be of least consideration regarding suitability when making a recommendation?",
       "choice_a":"What purpose the funds are being raised for.",
       "choice_b":"The customer\u0027s local municipality and state of residence.",
       "choice_c":"The customer\u0027s income, tax bracket and net worth.",
       "choice_d":"How the bonds are currently rated by Moody\u0027s.",
       "correct_answer":"A",
       "explanation":"The purpose for which the funds are being raised may be of interest to the client but it would generally be of little consideration regarding suitability when making a recommendation. However, the client\u0027s residence and financial profile, including income, net worth and tax bracket factor into suitability as these will help determine the extent of the tax benefits offered by the municipal bond. The bond\u0027s rating is important in evaluating the credit risk assumed by the investor and should align with the investor\u0027s risk tolerance."
    },
    {
       "id":39255,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A client\u0027s profile shows a moderate risk tolerance in general but little or no tolerance for default or credit risk. Given this preference to avoid such risk, which of the following choices would be deemed most suitable for such an investor?",
       "choice_a":"Municipal general obligation bonds.",
       "choice_b":"Municipal revenue bonds.",
       "choice_c":"High-yield corporate \u0022junk\u0022 bonds.",
       "choice_d":"Convertible corporate debentures.",
       "correct_answer":"A",
       "explanation":"The full taxing power of a municipality backs a general obligation municipal bond lending to it being the choice shown having the least amount of credit or default risk. Taxing power does not back municipal revenue bonds. Corporate debentures which are unsecured, and \u0022junk\u0022 or high-yield corporate bonds each have a greater or inherently high degree of risk."
    },
    {
       "id":39256,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A new client has transferred her account and all of its holdings to your broker-dealer. While getting to know her and constructing a client profile, she mentions wanting to add some municipal bonds to her portfolio because she feels her income and tax bracket warrants doing so. All of the following should be used to determine the suitability of any municipal recommendations you might make except the:",
       "choice_a":"customer\u0027s marital status and number of dependents.",
       "choice_b":"customer\u0027s annual income and tax bracket.",
       "choice_c":"customer\u0027s state and local municipal residence.",
       "choice_d":"structure of the customer\u0027s existing portfolio.",
       "correct_answer":"A",
       "explanation":"While a customer\u0027s marital status and number of dependents are a part of a customer\u0027s profile, they would not be critical factors when assessing municipal bond recommendations being suitable. When recommending municipal bonds and determining suitability, a registered representative should consider the customer\u0027s tax bracket, state of residence, recognizing that intrastate issues may be double or triple tax exempt, and existing portfolio structure; debt holdings versus equity holdings and whether municipal issues are already being held."
    },
    {
       "id":39257,
       "practice_test_id":"",
       "topic_id":10,
       "question":"One of your clients is considering purchasing a bond. He has narrowed the selection down to either a 2% yielding municipal bond offered by the state he lives in, or a 4.5% yielding corporate bond. He\u0027s at a loss as to how to determine which one would actually give him the greatest return for his investment. While many profile items would factor into suitability, one is critical for you to do the required calculation needed to answer his specific question. Which is it?",
       "choice_a":"His current tax bracket.",
       "choice_b":"His length of residency in the municipal issuers state.",
       "choice_c":"His current portfolio holdings.",
       "choice_d":"His current net worth.",
       "correct_answer":"A",
       "explanation":"In order to make the most suitable recommendation, you must do a tax-equivalent yield (corporate) or tax-free equivalent yield (municipal) calculation. For either formula you need the investor\u0027s tax bracket. Current portfolio holdings and net worth, while factoring into suitability, have no bearing on the calculation. Nor would the length of time he\u0027s resided in the state."
    },
    {
       "id":39258,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A client, you are well familiar with, wants to add municipal bonds to his portfolio. You are making a recommendation you feel is suitable; the purchase of a State of Texas General Obligation bond yielding 2.8%. While a number of items concerning both the client and the security would have been needed to be considered to make the recommendation a suitable one, which of the following would not have been?",
       "choice_a":"The municipality\u0027s coverage ratio.",
       "choice_b":"The clients state of residence.",
       "choice_c":"The client\u0027s tax bracket.",
       "choice_d":"The general obligation bonds rating.",
       "correct_answer":"A",
       "explanation":"The customer\u0027s state of residence and tax bracket are always factors determining suitability for a municipal bond recommendation. The bond\u0027s rating is equally important because it should align with the investors risk tolerance. The coverage ratio is specific to revenue bonds (not GO bonds) and tells how many times annual revenue from the bond issue will cover the debt service of the issue. It is not a factor of suitability to be considered when recommending a general obligation municipal bond. Primarily it is used when comparing two municipal revenue bonds."
    },
    {
       "id":39259,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A client profile shows a strong aversion to market risk. Considering this factor alone, which of the following debt issues would likely exhibit the least market risk and therefore be the most suitable recommendation for this client\u0027s portfolio?",
       "choice_a":"Revenue anticipation notes.",
       "choice_b":"Corporate bonds with long-term maturities.",
       "choice_c":"Municipal bonds with long-term maturities.",
       "choice_d":"AAA corporate debentures.",
       "correct_answer":"A",
       "explanation":"Market risk for debt securities is the risk that price will fluctuate during the time left to maturity.Of the choices shown, municipal revenue anticipation notes have the shortest term, which gives them the least market risk. If the aversion to market risk is the only consideration, of the choices shown, these would be the most suitable recommendation for this client\u0027s portfolio."
    },
    {
       "id":39260,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A new client in her early 40\u0027s notes that she is finally ready to consider tax deferred growth as an objective for a sum of cash she has been setting aside specifically for retirement income. Up to this point in time she has been diligent in funding an IRA each year and contributes as much as is allowed to her employer\u0027s 401k plan. Which of the following would be the most suitable for meeting her objective?",
       "choice_a":"A variable annuity",
       "choice_b":"AAA rated corporate bond",
       "choice_c":"Tax-free municipal bond",
       "choice_d":"Growth \u0026 income mutual fund",
       "correct_answer":"A",
       "explanation":"The only investment listed here offering tax-deferred growth and suitable for achieving supplemental retirement income outside of her IRA and 401k is a variable annuity. Ideally, VAs should be funded with readily available cash rather than using funds liquidated from existing investments."
    },
    {
       "id":39261,
       "practice_test_id":"",
       "topic_id":10,
       "question":"Given the following client profiles, for which might a variable annuity be a suitable recommendation?",
       "choice_a":"Age 51, with cash available and no anticipated need to access the funds until retirement.",
       "choice_b":"Age 71, retired for five years hoping to preserve capital currently invested in corporate bonds to leave to six children.",
       "choice_c":"Age 34, recently unemployed with several thousand dollars in severance pay available to invest.",
       "choice_d":"Age 29, with no need to access the funds until needed for college funding for two children beginning in roughly ten years.",
       "correct_answer":"A",
       "explanation":"Generating a supplemental income stream for retirement, not preservation of capital should be the primary objective present when considering a VA. Having cash on hand, rather than liquidating existing investments should also be a consideration for choosing a VA as suitable. Finally, for anyone who may need access to the funds invested for any reason other than supplementing retirement income, a VA would not be considered a suitable recommendation."
    },
    {
       "id":39262,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A registered representative is making recommendations to a client just recently approved for option spread strategies. The client\u0027s account records document a moderate risk exposure tolerance and a long-term growth objective and he fully understands that options spreads have defined maximum gain and maximum loss consequences. Of the following recommendations which is most likely to be flagged by a supervisor as being potentially unsuitable for this client?",
       "choice_a":"Selling a ten-point spread for a credit of 1.",
       "choice_b":"Buying a ten-point spread for a debit of 2.5",
       "choice_c":"Buying a five-point spread for debit of 2.",
       "choice_d":"Selling a five-point spread for a credit of 3.5.",
       "correct_answer":"A",
       "explanation":"Of the recommendations shown, selling a ten-point spread for a credit of 1 is most likely to raise a suitability red flag for a supervisor who would need to consider the customer being newly approved for spread strategies. With a ten-point spread, if sold for a credit of 1, the maximum loss potential (9-points) is 9 times greater than the maximum gain potential of 1. This should at least be flagged as representing unreasonable risk for such a customer, if not unsuitable. If it were not, the firm could be subject to sanctions for failing to supervise."
    },
    {
       "id":39263,
       "practice_test_id":"",
       "topic_id":10,
       "question":"One of your retail customers, uncomfortable with the recent volatile markets, suggests that she wants to invest a small sum in an inverse leveraged exchange traded fund tracking a major market index. She notes that if the market spikes downward anytime in the next month or two, she\u0027ll be positioned to realize a gain from the trade. You would correctly explain that:",
       "choice_a":"inverse leveraged exchange traded funds are considered to be non-traditional products. Additionally, FINRA has advised that these products are not suitable for retail investors intending to hold them for longer than one trading session, particularly in volatile markets.",
       "choice_b":"inverse leveraged exchange traded funds are considered to be ideal for hedging in volatile markets. Additionally, FINRA has advised that these products are most suitable for retail investors intending to hold them for longer periods of time as opposed to day trading them.",
       "choice_c":"inverse leveraged exchange traded funds are considered to be best suited for use by sophisticated investors needing to hedge large portfolios for extended periods of time. Additionally, FINRA has advised that these products were created, and therefore should be used, to offset long term volatile market exposure.",
       "choice_d":"inverse leveraged exchange traded funds were created to be used in the precise manner she intends. Additionally, FINRA has advised that these products are ideally suited for retail investors wanting to hedge volatility risk over long periods of time.",
       "correct_answer":"A",
       "explanation":"Inverse and leveraged exchange traded notes and funds are considered to be non-traditional products. FINRA has advised that NT-ETPs are not suitable for retail investors intending to hold them for longer than one trading session, particularly in volatile markets."
    },
    {
       "id":39264,
       "practice_test_id":1,
       "topic_id":10,
       "question":"Not all products can be deemed as suitable investments for all investors. For example, FINRA has cautioned that non-traditional exchange traded products (NT-ETPs) should be used by sophisticated investors only. NT-ETPs include:",
       "choice_a":"leveraged and inverse exchange traded notes and funds.",
       "choice_b":"leveraged exchange traded notes and funds only.",
       "choice_c":"inverse exchange traded notes and funds only.",
       "choice_d":"leveraged and exchange traded notes, but not funds.",
       "correct_answer":"A",
       "explanation":"FINRA has defined non-traditional exchange traded products (NT-ETPs) to include both leveraged and inverse exchange traded notes and leveraged and inverse exchange traded funds."
    },
    {
       "id":39265,
       "practice_test_id":2,
       "topic_id":10,
       "question":"Aligning with FINRA\u0027s suitability standards it should be understood that non-traditional exchange traded products (NT-ETPs) typically rebalance their portfolios :",
       "choice_a":"on a daily basis which is why there can be substantial risk incurred if holding them for longer than one trading session.",
       "choice_b":"on a daily basis which is why to realize any benefit they must be held over more than one trading session.",
       "choice_c":"annually which is why there should be an expectation that the holding period will be long term.",
       "choice_d":"only when deemed necessary which is why intended holding periods are not a factor to be considered when determining suitability.",
       "correct_answer":"A",
       "explanation":"Because (NT-ETPs) typically rebalance their portfolios on a daily basis, known as the daily reset, holding them for longer than a single trading session can subject investors to the effects of compounding of the daily returns. As a result, their performance over longer than a single trading session can differ significantly from the performance of the underlying index or benchmark they are intended to track."
    },
    {
       "id":39266,
       "practice_test_id":3,
       "topic_id":10,
       "question":"A new investor asks you to explain the difference regarding the standard of care that must be upheld by financial advisors and investment advisors regarding her investment account. You would correctly explain that:",
       "choice_a":"investment advisors must comply with a fiduciary standard of care while financial advisors must comply with a suitability standard and those outlined in the SEC\u0027s Regulation Best Interest.",
       "choice_b":"while their roles are different, neither acts as a fiduciary but both must comply with the SEC\u0027s Regulation Best Interest which applies a suitability standard of care.",
       "choice_c":"the SEC\u0027s Regulation Best Interest only applies to investment advisors because they are charging fees for advice and are required to pass specific licensing exams in order to do so.",
       "choice_d":"a fiduciary standard is applied to financial advisors only because there is no formal training required to act in such a capacity where charging commissions is the only form of compensation allowed.",
       "correct_answer":"A",
       "explanation":"Investment advisors must comply with a fiduciary standard of care. The SEC reaffirmed that as an investment advisor, in such a role these individuals are acting in a fiduciary capacity on behalf of their clients; giving advice for fee-based compensation. Financial advisors must comply with a suitability standard as well as the SEC\u0027s Regulation Best Interest in a capacity that allows them to charge commissions only, for buying and selling securities on behalf of clients."
    },
    {
       "id":39267,
       "practice_test_id":4,
       "topic_id":10,
       "question":"A new investor has been using the terms \u0022financial advisor\u0022 and \u0022investment advisor\u0022 interchangeably and not recognizing that there are key differences in their roles and qualifications. Understanding those differences in regards to being able to make suitable recommendations and receive compensation, which of the following is true?",
       "choice_a":"In addition to the exams a financial advisor must pass, an investment advisor must pass the Series 65; Uniform Investment Adviser Law Exam allowing the individual to offer advice in a fee-based compensation system.",
       "choice_b":"A financial advisor is an individual that, for fee-based compensation, is engaged in the business of providing advice to others. Passing the Series 6 or 7 licensing exam administered by FINRA is the only requirement.",
       "choice_c":"An investment advisor may only buy or sell securities on behalf of a client for commission-based compensation. No formal training is required other than passing the Series 63 licensing exam required by each state.",
       "choice_d":"Whether receiving fee-based or commission-based compensation an individual must pass the Series 65; Uniform Investment Adviser Law Exam. The only difference between the roles of a financial advisor and an investment advisor is defined by the type of products or services their employing firm offers.",
       "correct_answer":"A",
       "explanation":"A financial advisor buys and sells securities on behalf of a client for commission-based compensation. Passing the Series 6 or 7 licensing exam administered by FINRA and the Series 63 exam required by the state are the only requirements. In contrast, an investment advisor may charge fees for investment advice. In addition to the aforementioned licensing requirements for a financial advisor, an investment advisor must also pass the Series 65; Uniform Investment Adviser Law Exam."
    },
    {
       "id":39268,
       "practice_test_id":5,
       "topic_id":10,
       "question":"Under examination it is determined that a registered representative made excessive and unsuitable recommendations to a client resulting in both profits and losses. It is further determined that the firm\u0027s written procedures failed to provide branch managers with adequate instructions for reviewing customer accounts to detect unsuitable trades. Consequently, such reviews were not taking place. Which of the following would apply?",
       "choice_a":"The firm, branch managers and the RR would all be found accountable and could be subject to sanctions such as censure, suspension and fines.",
       "choice_b":"The firm, branch managers and the RR would all be found accountable and subject to possible sanctions but only the firm could be fined for lack of supervision.",
       "choice_c":"The firm and the RR would be found accountable and subject to sanctions including fines but not the branch managers because they were not given adequate instructions for reviewing accounts.",
       "choice_d":"Only the branch managers would be found accountable and subject to sanctions including fines for lack of supervision over the RR.",
       "correct_answer":"A",
       "explanation":"The firm would be found liable because it failed to establish and maintain a supervisory system reasonably designed to achieve compliance with FINRA\u0027s rules on suitability and standards of commercial honor and principles of trade. The branch managers would be found liable for failure to supervise and the RR would be found liable under rules mandating suitability and that churning not occur. All could be subject to fines and other sanctions such as censure and suspension."
    },
    {
       "id":39269,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A registered representative is having an exploratory conversation with a potential new client. During the conversation and based on the information the customer offers the RR makes a securities investment recommendation. Two months later the individual becomes a client of the broker-dealer and directs the RR to go ahead and execute the commissionable transaction to purchase the security she had recommended. Which of the following is true?",
       "choice_a":"FINRA\u0027s rules on suitability apply even though the recommendation was not acted upon until the individual became a client a much later.",
       "choice_b":"FINRA\u0027s rules on suitability do not apply because the recommendation was executed as a commissionable transaction and therefore did not fall under the regulations applicable to giving investment advice.",
       "choice_c":"FINRA\u0027s rules on suitability would only apply if the recommended security execution occurs within 10 business days of the initial recommendation being made.",
       "choice_d":"FINRA\u0027s rules on suitability do not apply to conversations had with individuals who are not clients regardless of what occurs after.",
       "correct_answer":"A",
       "explanation":"When a registered representative makes a recommendation to purchase a security to a potential investor, the suitability rule would apply to the recommendation if that individual executes the transaction through the broker-dealer with which the registered representative is associated or the broker-dealer receives or will receive, directly or indirectly, compensation as a result of the recommended transaction."
    },
    {
       "id":39270,
       "practice_test_id":"",
       "topic_id":10,
       "question":"FINRA rules require that a broker-dealer or associated person have a reasonable basis to believe that a recommended transaction or investment strategy involving a security is suitable for the customer. The SEC\u0027s Reg. BI\u0027s Care Obligation addresses the same conduct with respect to retail customers that is addressed by FINRA\u0027s suitability rules, but employs a best interest, rather than a suitability, standard. Considering the above, which of the following is true?",
       "choice_a":"Broker-dealers are held to both the suitability standards of FINRA\u0027s rules and the best interest application of the SEC\u0027s Reg. BI.",
       "choice_b":"Broker-dealers are held only to the suitability standards of FINRA\u0027s rules.",
       "choice_c":"Broker-dealers are held only to the best interest application outlined in the SEC\u0027s Reg. BI.",
       "choice_d":"Broker-dealers are given the option to be accountable under either FINRA\u0027s suitability rules or to apply the SEC\u0027s Reg. BI\u0027s best interest standard depending on which is best suited to their business model; customer base and the types of securities offered.",
       "correct_answer":"A",
       "explanation":"Broker-dealers are held to both the standards of FINRA\u0027s rule addressing suitability (Rule 2111) and the care obligation outlined in the SEC\u0027s Reg. BI."
    },
    {
       "id":39271,
       "practice_test_id":"",
       "topic_id":10,
       "question":"To ensure that suitable recommendations are being made by registered personnel, broker-dealers must establish, maintain, and enforce written policies and procedures reasonably designed to identify and eliminate sales contests, quotas, bonuses, or non-cash compensation that are based on the sales of specific securities or specific types of securities within a limited time period. Not doing such is a violation of:",
       "choice_a":"Regulation Best Interest (Reg. BI). ",
       "choice_b":"Regulation D.",
       "choice_c":"Regulation A.",
       "choice_d":"Securities Exchange Act of 1934.",
       "correct_answer":"A",
       "explanation":"While the SEC adopted Reg. BI under the Securities Exchange Act of 1934, Reg BI specifically establishes a \u0022best interest\u0022 standard of conduct for broker-dealers and associated persons when they make a recommendation to a retail customer. Additionally, it addresses the arrangements noted above under the conflict-of-interest obligation for broker-dealers."
    },
    {
       "id":39551,
       "practice_test_id":"",
       "topic_id":10,
       "question":"An investor is 60 years old and has the following asset allocation: <img src='/question_assets/series7/6.png'></img> After a discussion with his registered representative the customer changes his allocation as follows: <img src='/question_assets/series7/7.png'></img> Which of the following is correct with regard to the change in the investor\u0027s portfolio ? ",
       "choice_a":"Political risk has increased, credit risk has decreased",
       "choice_b":"Reinvestment risk has increased, systematic risk has increased",
       "choice_c":"Political risk has increased, interest rate risk has decreased",
       "choice_d":"Purchasing power risk has increased, systematic risk has increased",
       "correct_answer":"C",
       "explanation":"The investor has increased the political risk of the portfolio by allocating a greater percentage of his assets to emerging markets. Emerging markets are based in lesser developed foreign countries which tend to have a greater degree of political instability. The investor also substantially reduced the portion of the portfolio in long term bonds. As a result the investor has lowered his interest rate risk. The investor was not subject to a substantial amount of credit risk as the bonds were all AAA corporate bonds and government bonds."
    },
    {
       "id":39552,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A client\u0027s investment portfolio is as follows: <img src='/question_assets/series7/8.png'></img> After a discussion with his registered representative, over several weeks the investments are reallocated as follows: <img src='/question_assets/series7/9.png'></img> Which of the following best reflects the changes made?",
       "choice_a":"Both interest rate and liquidity risk have been lessened, market risk is higher.",
       "choice_b":"Interest rate risk is lower, liquidity risk is higher, market risk is lower.",
       "choice_c":"Interest rate risk, market risk and liquidity risk are all higher.",
       "choice_d":"Interest rate risk, market risk and liquidity risk have all been lessened.",
       "correct_answer":"A",
       "explanation":"The new allocation lowers interest rate risk given the smaller portion in long term bonds, both government and corporate. Liquidity risk has been lowered as well, moving from commercial real estate (real property is generally considered less liquid), to REITs which are marketable securities and liquid. A larger allocation to US equities raises market risk."
    },
    {
       "id":39553,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A client\u0027s investment portfolio is as follows: <img src='/question_assets/series7/10.png'></img> She meets with her registered representative and agrees to the following reallocation: <img src='/question_assets/series7/11.png'></img> Which of the following best reflects the changes made?",
       "choice_a":"Market risk, and reinvestment risk have decreased.",
       "choice_b":"Market risk has decreased, reinvestment risk is higher.",
       "choice_c":"Market risk has increased, reinvestment risk is lower.",
       "choice_d":"Market risk, and reinvestment risk have increased.",
       "correct_answer":"D",
       "explanation":"Market risk has increased with a larger portion of the portfolio in US equities, and moving from noncallable to callable bonds increases reinvestment risk, as callable bonds are likely to be called when interest rates are falling, leaving the investor challenged to find equal returns for the funds if they are to be reinvested."
    },
    {
       "id":39554,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A client tells you that given he is now age 55 he thinks he\u0027s becoming a bit more intolerant of market risk. His current portfolio has the following allocations: <img src='/question_assets/series7/12.png'></img> The client suggests reallocating as follows: <img src='/question_assets/series7/13.png'></img> If the client\u0027s reallocation suggestion were to be followed, would he have generally attained his goal of having less market risk?",
       "choice_a":"Yes, market risk and interest rate risk have both decreased.",
       "choice_b":"Yes, market risk has decreased and he\u0027s added to liquidity.",
       "choice_c":"No, nothing has been done to decrease interest rate risk.",
       "choice_d":"No, nothing has been done to add to liquidity",
       "correct_answer":"B",
       "explanation":"Yes, the suggested portfolio would incur less risk as follows; market risk decreases with a smaller US equities allocation. Additionally, money market funds and more cash are obviously less risky than hedge funds and much more liquid."
    },
    {
       "id":39555,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A client in his early thirties expresses the desire to \u0022get this conservative portfolio moving\u0022. Currently his investments are as follows: <img src='/question_assets/series7/14.png'></img> He works with his registered representative over several weeks to reconstruct the portfolio as follows: <img src='/question_assets/series7/15.png'></img> Which of the following best characterizes the risks associated with his new portfolio?",
       "choice_a":"Interest rate risk is lower, and market risk and legislative risk are higher.",
       "choice_b":"Interest rate risk, market risk and legislative risk are higher.",
       "choice_c":"Interest rate risk, market risk and legislative risk are lower.",
       "choice_d":"Interest rate risk and market risk are lower, and legislative risk is higher.",
       "correct_answer":"A",
       "explanation":"Interest rate risk has decreased given the smaller T-bond allocation. Market risk has increased given the new allocations to a growth fund, crypto currency and digital assets. Additionally, legislative risk has increased given the new investments in crypto currency and digital assets as these are currently unregulated markets with potential regulations likely to occur."
    },
    {
       "id":39556,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A young client\u0027s portfolio, mostly inherited from his grandfather, is structured as follows: <img src='/question_assets/series7/16.png'></img> His registered representative suggests the following allocation: <img src='/question_assets/series7/17.png'></img> Primarily, the suggested new allocation does which of the following:",
       "choice_a":"Diversification is greater, market risk is greater and credit risk has been decreased.",
       "choice_b":"Diversification is unaffected, market risk and credit risk are both greater.",
       "choice_c":"Diversification is unaffected, market risk and credit risk are both lower",
       "choice_d":"Diversification has been lessened, market risk is lower and credit risk has been increased.",
       "correct_answer":"A",
       "explanation":"Credit risk, the risk of losing principal due to the failure of the issuer, is greatly lessened given the much lower allocations to single stocks. Overall diversification is increased with the addition of the two equity funds (S \u0026 P index and Wilshire) as well as the two bond funds (government and corporate). With the diversification however, comes a greater exposure to market risk; the risk of losing principal due to volatility in the markets."
    },
    {
       "id":39557,
       "practice_test_id":6,
       "topic_id":10,
       "question":"The portfolio of a client, age 46 is as follows: <img src='/question_assets/series7/18.png'></img> After expressing his amended investment objectives to his registered representative, it is agreed to reallocate the portfolio in the following way: <img src='/question_assets/series7/19.png'></img> Which of the following best characterizes the changes in risk associated with the new allocation?",
       "choice_a":"Interest rate risk and market risk are higher, while purchasing power risk is lower.",
       "choice_b":"Interest rate risk, market risk and purchasing power risk are all higher.",
       "choice_c":"Interest rate risk, market risk and purchasing power risk are all lower.",
       "choice_d":"Interest rate risk and market risk are lower, while purchasing power risk is higher.",
       "correct_answer":"D",
       "explanation":"Interest rate risk has been decreased due to the smaller allocation in long-term Treasury securities. So too has market risk been decreased given the reduction in growth mutual funds. Purchasing power risk has increased substantially with the addition of the fixed annuity. The fixed payments lend themselves to being worth less as prices of goods and services increase over time; inflation."
    },
    {
       "id":39558,
       "practice_test_id":"",
       "topic_id":10,
       "question":"An investor has a small portfolio that he characterizes as being strictly for the purpose of  speculation. It is structured as follows: <img src='/question_assets/series7/20.png'></img> He amends the portfolio as follows: <img src='/question_assets/series7/21.png'></img> Which of the following has been accomplished?",
       "choice_a":"Business risk has been reduced, while a small portion of capital risk has been incurred.",
       "choice_b":"Purchasing power has been increased, while a small portion of capital risk has been incurred.",
       "choice_c":"Reinvestment risk has been reduced, while a small portion of capital risk has been lessened.",
       "choice_d":"Political risk has been increased, while a small portion of capital risk has been lessened.",
       "correct_answer":"A",
       "explanation":"The investor chose to hedge downside risk in each of his equity positions by purchasing puts on those stocks. Hedging the downside risk primarily reduced his exposure to business risk in these positions; generally defined as an operating risk due to poor management decisions. The fewer the positions that are held in a portfolio, the higher the business risk will be. Hedging those positions reduces the risk. Long options are generally associated with capital risk; the risk of losing all of the dollars invested. The low percentage allocated to the options positions increases capital risk slightly."
    },
    {
       "id":39559,
       "practice_test_id":"",
       "topic_id":10,
       "question":"An investor\u0027s portfolio is structured as follows: <img src='/question_assets/series7/22.png'></img> He decides he wants to diversify by investing in a few foreign companies. To accomplish that he amends the portfolio as follows: <img src='/question_assets/series7/23.png'></img> Which of the following best characterizes the changes made?",
       "choice_a":"Currency risk is increased, while interest rate risk and credit risk are decreased.",
       "choice_b":"Currency risk, interest rate risk and credit risk are all decreased.",
       "choice_c":"Currency risk, interest rate risk and credit risk are all increased.",
       "choice_d":"Currency risk and interest rate risk are increased, while credit risk is decreased.",
       "correct_answer":"A",
       "explanation":"The purchase of ADRs representing the shares of foreign companies introduces currency risk to the portfolio. Dividends paid by foreign companies are paid in the currency of the country of origin. The necessary conversion to US dollars at a time that may or may not be favorable is the risk. The corporate bond and Treasury fund positions having both been reduced lowers interest rate risk associated with fixed income securities. Finally, because the corporate bonds were BB rated, a small amount of credit risk was eliminated by the reduction in that position. "
    },
    {
       "id":39560,
       "practice_test_id":"",
       "topic_id":10,
       "question":"An investor\u0027s portfolio is as follows: <img src='/question_assets/series7/24.png'></img> She opts to amend her investments as follows: <img src='/question_assets/series7/25.png'></img> Which of the following best characterizes what has occurred with the portfolio changes?",
       "choice_a":"Interest rate risk and liquidity have both been reduced.",
       "choice_b":"Interest rate risk is reduced while liquidity is unaffected.",
       "choice_c":"Interest rate risk is increased while liquidity is unaffected.",
       "choice_d":"Interest rate risk and liquidity have both been increased.",
       "correct_answer":"A",
       "explanation":"With the reduction in the Treasury bond position, interest rate risk is reduced. While real estate DDPs and REITs are both ways to invest in real estate, DPPs are highly illiquid. REITs trade on exchanges and OTC making them very liquid. Essentially, replacement of the REITs with the DPP reduces liquidity."
    },
    {
       "id":39561,
       "practice_test_id":"",
       "topic_id":10,
       "question":"An investor\u0027s portfolio is as follows: <img src='/question_assets/series7/26.png'></img> After some thought about risk, he alters his portfolio as follows: <img src='/question_assets/series7/27.png'></img> The altered portfolio now has:",
       "choice_a":"less interest rate risk and less market risk.",
       "choice_b":"less interest rate risk and more market risk.",
       "choice_c":"more interest rate risk and less market risk.",
       "choice_d":"more interest rate risk and more market risk.",
       "correct_answer":"A",
       "explanation":"The reduction in fixed income securities (government and corporate bond funds) lowers interest rate risk. The addition of the broad-based market index inverse fund, intended to move opposite the market and therefore essentially hedging the S \u0026 P and Wilshire index funds, reduces market risk."
    },
    {
       "id":39562,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A client has the following portfolio: <img src='/question_assets/series7/28.png'></img> After noting that her income over the past two years has increased substantially moving her into a high-income tax bracket, she and her registered representative agree to alter the portfolio as follows: <img src='/question_assets/series7/29.png'></img> Which of the following best characterizes the result of the portfolio alterations?",
       "choice_a":"Market risk is increased, but tax liability and liquidity have been reduced.",
       "choice_b":"Market risk, liquidity and potential tax liability have all been reduced",
       "choice_c":"Market risk, liquidity and potential tax liability have all been increased.",
       "choice_d":"Market risk is reduced, but tax liability and liquidity have been increased.",
       "correct_answer":"A",
       "explanation":"The equity positions have been cut in half, reducing market risk. The addition of the government assisted housing direct participation program (DPP) does two things; reduces liquidity because DDPs are considered highly illiquid, and it reduces potential tax liability as government assisted housing programs allow for tax credits. Because tax credits reduce tax liability dollar for dollar, this would be a valuable tax consequence for someone in a high-income tax bracket."
    },
    {
       "id":39563,
       "practice_test_id":2,
       "topic_id":10,
       "question":"Consider the following client portfolio: <img src='/question_assets/series7/30.png'></img> The client wants to reallocate as follows: <img src='/question_assets/series7/31.png'></img> What will the result of this reallocation be?",
       "choice_a":"Income will be reduced but the opportunity to participate in the market is increased. Interest rate risk is increased.",
       "choice_b":"Income will be reduced as will the opportunity to participate in the market. Interest rate risk is unaffected.",
       "choice_c":"Income will be reduced as will the opportunity to participate in the market. Interest rate risk is decreased.",
       "choice_d":"Income will be reduced but the opportunity to participate in the market is increased. Interest rate risk is unaffected.",
       "correct_answer":"A",
       "explanation":"The reallocation from non-convertible bonds to convertible bonds will reduce the income produced from the corporate bond position. While convertible bonds allow for potential participation in the market, they have lower coupons than non-convertible bonds. The lower coupon means less income. Also note that interest rate risk would be somewhat increased because now there is a larger allocation of corporate bonds compared to the reduction in the more stable Treasury bond position."
    },
    {
       "id":39564,
       "practice_test_id":3,
       "topic_id":10,
       "question":"An investor\u0027s portfolio is structured as follows:<img src='/question_assets/series7/32.png'></img> After a discussion with her registered representative, it is agreed to alter the portfolio as follows: <img src='/question_assets/series7/33.png'></img> The new portfolio could be characterized as being",
       "choice_a":"slightly less conservative with a greater exposure to interest rate risk.",
       "choice_b":"slightly more conservative with a greater exposure to interest rate risk.",
       "choice_c":"slightly less conservative with a lower exposure to interest rate risk.",
       "choice_d":"slightly more conservative with a lower exposure to interest rate risk.",
       "correct_answer":"A",
       "explanation":"Moving a greater allocation of Treasury securities to T-bonds, from T-notes, exposes the portfolio to more interest rate risk; fixed securities with longer maturities (bonds vs notes) have greater interest rate risk. Incurring more risk, the portfolio has become slightly less conservative."
    },
    {
       "id":39565,
       "practice_test_id":4,
       "topic_id":10,
       "question":"An investor\u0027s portfolio is as follows: <img src='/question_assets/series7/34.png'></img> The investor proposes to reallocate as follows: <img src='/question_assets/series7/35.png'></img> Which of the following best characterizes what the investor\u0027s goal would be with the new allocation he proposes?",
       "choice_a":"To protect against regulatory risk while increasing exposure to interest rate risk.",
       "choice_b":"To protect against regulatory risk and lower exposure to interest rate risk.",
       "choice_c":"To protect against inflation while increasing exposure to interest rate risk.",
       "choice_d":"To protect against inflation and lower exposure to interest rate risk.",
       "correct_answer":"D",
       "explanation":"With the addition of the Treasury Inflation Protection Securities (TIPS) position, it is clear that the goal would be to protect against inflation risk. TIPS are issued with a fixed interest rate, but the principal amount is adjusted semiannually to align with any change in the Consumer Price Index (CPI), the standard by which inflation is measured. Additionally, interest rate risk has been lowered given the smaller allocations to long-term fixed securities, both government and corporate. Longer term fixed income security maturities have greater exposure to interest rate risk."
    },
    {
       "id":39566,
       "practice_test_id":5,
       "topic_id":10,
       "question":"An investor\u0027s portfolio is as follows: <img src='/question_assets/series7/36.png'></img> She has decided to amend her portfolio as follows: <img src='/question_assets/series7/37.png'></img> Which of the following best characterizes the changes?",
       "choice_a":"Systematic risk and opportunity cost are both increased.",
       "choice_b":"Systematic risk and opportunity cost are both reduced.",
       "choice_c":"Systematic risk is reduced, but opportunity cost is higher.",
       "choice_d":"Systematic risk is increased, but opportunity cost is lower.",
       "correct_answer":"C",
       "explanation":"Remember that systematic risk is the risk that changes in the overall market will have a negative impact on securities, equity and/or debt. With the addition of the MM fund and cash positions, funded by reductions in all of the other positions, systematic risk has been reduced. However, the ability to participate in the markets has also been lessened and this is the cost that has been paid to reduce the systematic risk; opportunity cost."
    },
    {
       "id":39571,
       "practice_test_id":6,
       "topic_id":10,
       "question":"Regarding a standing letter of authorization (LOA) utilized for the purpose of transferring funds or securities to another account, which of the following is true?",
       "choice_a":"Standing LOAs must be accepted by member firms as required by FINRA rule.",
       "choice_b":"Standing LOAs are permitted for both retail and institutional clients.",
       "choice_c":"Standing LOAs are permitted for institutional clients only.",
       "choice_d":"Standing LOAs are permitted for retail clients only.",
       "correct_answer":"B",
       "explanation":"While standing LOAs for the purpose of transferring funds or securities to another account are permitted for both retail and institutional clients, no member firm is required by rule to accept them. If a firm chooses to accept LOAs, rules do require specific supervisory procedures be in place and be continuously monitored for compliance."
    },
    {
       "id":39578,
       "practice_test_id":"",
       "topic_id":10,
       "question":"Spouses in their early 40s note to their registered representative that they are willing to accept some risk in order to hopefully keep pace with inflation. Of the following investment choices which would be the most suitable for them to attain their investment objective?",
       "choice_a":"A diversified equity growth and income portfolio.",
       "choice_b":"A Treasury bond portfolio.",
       "choice_c":"An exchange-traded note (ETN) portfolio.",
       "choice_d":"A digital asset portfolio.",
       "correct_answer":"A",
       "explanation":"Of the choices given, and considering the couple\u0027s willingness to accept some risk, stock would be the most likely to keep pace with inflation with the income oriented (dividend paying) securities used to hedge some of the risk. Notably safer, Treasury bonds would not likely have yields high enough to achieve the objective. Exchange-traded notes (ETNs) are a more complicated investment incurring credit risk, and digital assets are unregulated, volatile, and have no appreciable risk or investment history; therefore speculative."
    },
    {
       "id":39579,
       "practice_test_id":"",
       "topic_id":10,
       "question":"An investor has a well-diversified portfolio consisting of both equity and debt securities. This singular bit of information tells you that the portfolio is best protected from which of the following types of risk?",
       "choice_a":"Nonsystematic.",
       "choice_b":"Systematic.",
       "choice_c":"Market.",
       "choice_d":"Purchasing power.",
       "correct_answer":"A",
       "explanation":"Diversification reduces nonsystematic risk; risk associated with the decline of an individual security\u0027s value, equity or debt. Systematic risk, such as market or inflationary risk, affects all securities and therefore is not eliminated by diversifying one\u0027s portfolio. Remember that purchasing power risk, usually associated with fixed payments, accompanies inflation."
    },
    {
       "id":39581,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A new customer, in his mid-twenties wants to list capital appreciation as the primary investment objective on his new account form. At this time in his life, he sees no reason why assuming a moderate amount of risk wouldn\u0027t be suitable. He also notes an immediate concern about inflation and how it will impact his portfolio both short and long term. Given his objective and concerns, which of the following investments would be the most suitable recommendation?",
       "choice_a":"Common and preferred stock",
       "choice_b":"Long-term corporate bonds",
       "choice_c":"Long-term municipal bonds",
       "choice_d":"Crypto currency",
       "correct_answer":"A",
       "explanation":"Given the customer\u0027s age, his stated capital appreciation investment objective and willingness to accept moderate risk, equities both common and preferred would be the most suitable recommendation of those listed. The long-term debt choices, corporate or government, are not likely to meet the capital appreciation objective and volatile crypto currencies would not align with a moderate risk tolerance."
    },
    {
       "id":39584,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A client tells you that he is interested in zero coupon bonds. He tells you he knows how they work and that no interest will be received until they mature. His sudden interest in zeros is completely unexpected, and given that, what specific issue might your next best follow-up question address first to determine if zeros are suitable?",
       "choice_a":"Whether he intends to fund the purchase of these bonds with available cash or with funds gotten from liquidating current investments?",
       "choice_b":"Whether or not he is aware that they are highly sensitive to interest rate movements?",
       "choice_c":"Whether or not the client has a particular investment target and a date for that target to occur?",
       "choice_d":"Whether or not he realizes receiving no interest until they mature doesn\u0027t necessarily avoid taxes on the interest prior to maturity?",
       "correct_answer":"C",
       "explanation":"Inquiries to determine suitability would be first. Zero coupon bonds are generally considered most suitable when there is a specific target investment to be met and a specific time frame within which it will occur. Saving to fund an upcoming college education is a prime example. No doubt that once zeros have been determined to be suitable to meet the objective, a discussion about tax consequences, they\u0027re sensitivity to interest rate movements, and how best to fund the purchase would also need to be had."
    },
    {
       "id":39585,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A client laments that his portfolio, set up to align with his investment objective of maximizing income, has no convertible bonds in it. She says that if there were, she could consider converting some and possibly participate in the current strong bull market. How might you best begin to continue this discussion?",
       "choice_a":"Reminding the client that convertible bonds have lower coupons than non-convertible bonds and therefore are generally avoided if one\u0027s primary objective is to maximize income",
       "choice_b":"Reminding the client that convertible bonds, generally issued by corporations, are taxable at all levels and paying more in taxes does not lend itself to maximizing income.",
       "choice_c":"Reminding the client that convertible bonds are only deemed suitable when growth is listed as an investment objective.",
       "choice_d":"Reminding the client that convertible bonds are usually issued by companies with lower bond ratings and therefore not suitable for someone who wants to maximize income.",
       "correct_answer":"A",
       "explanation":"Because of the additional feature they offer the investor, convertible bonds tend to have lower coupons than non-convertible bonds. Reminding the client that the lower coupon generally would not align with an objective of maximizing income would be the best place to continue the discussion from. Note; convertible bonds can be suitable for meeting both income and growth objectives, are not necessarily associated with lower debt ratings and the tax consequences when issued by corporations are the same, whether the bonds are convertible or nonconvertible."
    },
    {
       "id":39586,
       "practice_test_id":6,
       "topic_id":10,
       "question":"A client with a balanced (equity vs debt) portfolio says that some research he\u0027s done clearly indicates that callable corporate bonds tend to pay a bit more in interest than noncallable bonds from the same issuer. He wonders why there are no callable bonds in his portfolio and thinks there should be. How might you best begin this discussion?",
       "choice_a":"Explaining that rules mandate your recommendation of a callable bond must be preceded by the client signing a risk waiver document.",
       "choice_b":"Explaining why callable bonds tend to pay more in interest and that they inherently have reinvestment risk attached to them.",
       "choice_c":"Explaining why callable bonds have no place in a balanced portfolio.",
       "choice_d":"Explaining why inevitably all callable bonds will be called and why that is not good.",
       "correct_answer":"B",
       "explanation":"Callable bonds do tend to pay more in interest than non-callable bonds because the added callable feature works to the advantage of the issuer who will call them if interest rates should decline. The added yield acts as an enticement to purchase them. In addition, because they will be called in a declining interest rate environment the investor is left to shoulder reinvestment risk; reinvesting the proceeds in a lower interest rate environment. This is the discussion that should be had first. Note; callable bonds can be suitable for balanced portfolios, are only likely to be called when interest rates fall, and no risk disclosure or waiver is required to recommend them."
    },
    {
       "id":39587,
       "practice_test_id":"",
       "topic_id":10,
       "question":"A long-standing client contacts you and says that he and his wife, both retired and in their late sixties, are barely getting by on their social security payments. He notes that they have friends who receive monthly payments from a variable annuity and he thinks they\u0027d like to know more and possibly purchase a VA themselves. They have a small savings account and IRAs neither has withdrawn from yet. Which of the following is the best course to take first in an ensuing conversation about VAs?",
       "choice_a":"A discussion about the suitability of VAs for seniors who are already retired should occur.",
       "choice_b":"A discussion regarding how much will be needed in monthly payments to make their retirement more comfortable should occur.",
       "choice_c":"A discussion about how much of their IRAs would be suitable to divest of in order to fund the VA should occur.",
       "choice_d":"A discussion about the differences between fixed and variable annuities should occur to determine if a VA is the best option.",
       "correct_answer":"A",
       "explanation":"Purchasing a VA is generally not considered suitable for seniors, particularly when no way to fund one with available cash is possible. Given what we know here, other options should be explored first. The most obvious might be to begin taking distributions from their IRAs to ease their financial situation but suggesting that those distributions be used to fund a VA would not be at all suitable."
    },
    {
       "id":6788,
       "practice_test_id":"",
       "topic_id":11,
       "question":"When an investor changes from the pay-in stage of the annuity to the payout stage of the contract, the investor is said to have:",
       "choice_a":"Annuitized the contract",
       "choice_b":"Annualized the contract",
       "choice_c":"Accumulated the contract",
       "choice_d":"None of the choices listed",
       "correct_answer":"A",
       "explanation":"Annuitizing a contract occurs when an investor changes from paying into an annuity and begins to receive payouts from this annuity."
    },
    {
       "id":6789,
       "practice_test_id":"",
       "topic_id":11,
       "question":"When you were single, you purchased a variable life insurance policy.  You have since gotten married and want to exchange it for a whole life policy to protect your family. How long from the policy\u0027s issuance do you have to make the conversion:",
       "choice_a":"18 months",
       "choice_b":"12 months",
       "choice_c":"24 months",
       "choice_d":"16 month",
       "correct_answer":"C",
       "explanation":"An individual has 24 months to switch a variable life policy to a whole life policy.  The insurance company may not require another physical."
    },
    {
       "id":6790,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which  of the following are features of a 401K plan? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> A 401K may be easily rolled over  </li><li>Employee\u0027s contributions are excluded from their gross income </li><li>Employees are 100% vested in all contributions immediately  </li><li>Employers may match a certain percentage of the employee\u0027s contributions</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and II",
       "choice_c":"I and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"A",
       "explanation":"Of the choices listed only II and IV are correct. A 401k may not be easily rolled over. Remember that a roll over allows the participant to take possession of the money. A plan participant is only vested immediately in their own contributions. They will become vested in their employer\u0027s contributions based on a vesting schedule."
    },
    {
       "id":6791,
       "practice_test_id":6,
       "topic_id":11,
       "question":"Which of the following are funded with after tax dollars? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>TDA </li><li>Roth IRA </li><li>TSA </li><li>Tax deferred Annuity</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and II",
       "choice_c":"II and IV",
       "choice_d":"III and IV",
       "correct_answer":"C",
       "explanation":"A Roth IRA and a tax deferred annuity are funded with after tax dollars."
    },
    {
       "id":6792,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following are funded with pretax dollars? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>  Keogh  </li><li> Variable annuity </li><li>Fixed annuity </li><li>TDA</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and II",
       "choice_c":"II and IV",
       "choice_d":"I and IV",
       "correct_answer":"D",
       "explanation":"Only the Keogh plan and the TDA are funded with pretax dollars.  The rest are funded with after tax dollars."
    },
    {
       "id":6793,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following are true regarding a variable annuity? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The unit values are calculated once per business day </li><li>Investors have voting rights </li><li>Unit value depends on performance </li><li>The maximum sales charge is 9% of the total payments</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"All of the answers are true except there is no maximum sales charge for a variable annuity. The sales charge must be reasonable based on the total payments made to the account."
    },
    {
       "id":6794,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following are true regarding non qualified plans? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The plan is a trust  </li><li>The cost base equals the deposits into plan </li><li>IRS approval is not needed </li><li>All money is taxed as ordinary income upon receipt</li></ol>",
       "choice_a":"III and IV",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"D",
       "explanation":"A non qualified plan is not a trust and IRS approval is not needed. Only the growth is taxed as ordinary income upon receipt."
    },
    {
       "id":6795,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following are true regarding the mortality risk with regard to a variable annuity? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is absorbed by the annuitant  </li><li>It is absorbed by the insurance company </li><li>A fee is deducted from the separate account </li><li>A fee is deducted from the general account</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"II and IV",
       "choice_d":"I and III",
       "correct_answer":"A",
       "explanation":"The mortality risk with an annuity is the risk that the annuitant lives to long. It is absorbed by the insurance company and a fee is deducted from the separate account to help underwrite that risk."
    },
    {
       "id":6796,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following is a non-allowable investment for an IRA?",
       "choice_a":"Stocks and bonds",
       "choice_b":"Rare coins and art",
       "choice_c":"Mutual funds and annuities",
       "choice_d":"U S minted coins",
       "correct_answer":"B",
       "explanation":"Rare coins and art are not allowed as investments for an IRA because the investment must be negotiable and allowed to grow in value tax deferred."
    },
    {
       "id":6797,
       "practice_test_id":1,
       "topic_id":11,
       "question":"Which of the following is not a type of annuity?",
       "choice_a":"Fixed annuity",
       "choice_b":"Variable annuity",
       "choice_c":"Contractual annuity",
       "choice_d":"Combination annuity",
       "correct_answer":"C",
       "explanation":"There is no such thing as a contractual annuity."
    },
    {
       "id":6798,
       "practice_test_id":2,
       "topic_id":11,
       "question":"Which of the following is not true about a single payment deferred annuity?",
       "choice_a":"The investor funds the contract completely with one payment",
       "choice_b":"The value of the separate account\u0027s portfolio will increase with additional investments by the investor",
       "choice_c":"The investor defers receiving payments from the contract until some point usually after retirement",
       "choice_d":"Money invested is used to purchase accumulation units",
       "correct_answer":"B",
       "explanation":"In a single payment deferred annuity, there are no additional investments as the contract is funded by one single payment; there may be distributions which are reinvested."
    },
    {
       "id":6799,
       "practice_test_id":3,
       "topic_id":11,
       "question":"Which of the following is not true about a single payment immediate annuity?",
       "choice_a":"The investor funds the contract completely with one payment",
       "choice_b":"The number of annuity units remains fixed and the value changes as the value of the securities fluctuates",
       "choice_c":"The investor defers receiving payments from the contract until some point usually after retirement",
       "choice_d":"Money invested is used to purchase annuity units",
       "correct_answer":"C",
       "explanation":"With a single payment immediate annuity the investor begins receiving payments from the contract immediately, usually within 60 days."
    },
    {
       "id":6800,
       "practice_test_id":4,
       "topic_id":11,
       "question":"Which of the following is not true about types of withdrawals from annuity contracts?",
       "choice_a":"Lump sum and random withdrawals are paid on a first in last out (FILO) basis",
       "choice_b":"Lump sum and random withdrawals may be taxed at an extra 10% if the annuitant is less than 59\u00BD years old",
       "choice_c":"Annuitized contracts pay out monthly payments, part of which is taxable as growth and part of which is not taxable as after tax money invested",
       "choice_d":"Annuitized contracts, if the investor is less than 59\u00BD years old, are not subject to the 10% tax penalty nor are withdrawals due to death or disability",
       "correct_answer":"A",
       "explanation":"Lump sum and random payments are always done on a LIFO, last in first out, basis; thus the growth is considered to be the last in portion and is taxed as ordinary income. Contracts annuitized prior to 59.5 are not subject to the 10 percent penalty tax. "
    },
    {
       "id":6801,
       "practice_test_id":5,
       "topic_id":11,
       "question":"Which of the following may vary? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>  The number of annuity units  </li><li> The number of accumulation units    </li><li>The price of accumulation units  </li><li>The price of annuity units</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"II, III, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"Only the price of an annuity unit may vary while the price and number of accumulation units may vary."
    },
    {
       "id":6802,
       "practice_test_id":6,
       "topic_id":11,
       "question":"Which of the following options would provide the highest monthly payout on an Immediate Annuity?",
       "choice_a":"Straight Life Annuity",
       "choice_b":"Life with 20 Year Period Certain",
       "choice_c":"Lump Sum",
       "choice_d":"Life with 10 Year Period Certain",
       "correct_answer":"A",
       "explanation":"A Straight Life Annuity always has the highest monthly pay out of the options with a life contingency. With the Straight Life Option, the monthly payments end when the annuitant dies, which lowers the risk to the company, and results in a higher monthly pay out to the annuitant. With the Period Certain Options, there could be a longer pay out to a beneficiary based on the time period selected. Because of the potentially longer time period than the life of the annuitant, there is a higher risk to the company. Because of this increased risk, the monthly payments will be lower. The Lump Sum Option is only a one time payment, not a monthly payment."
    },
    {
       "id":6803,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following plans is non funded?",
       "choice_a":"Keogh",
       "choice_b":"TSA",
       "choice_c":"TDA",
       "choice_d":"Deferred compensation plan",
       "correct_answer":"D",
       "explanation":"A deferred compensation plan is non-funded.  There is no money set aside for the participant in the plan."
    },
    {
       "id":6804,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following types of insurance policy provides the insured with a guaranteed death benefit equal to the face amount of the policy plus a guaranteed cash value which the policyholder may borrow against?",
       "choice_a":"Whole life",
       "choice_b":"Variable life",
       "choice_c":"Universal life",
       "choice_d":"Variable universal life",
       "correct_answer":"A",
       "explanation":"A whole life policy provides the insured with a guaranteed death benefit equal to the face amount of the policy plus a guaranteed cash value which the policyholder may borrow against."
    },
    {
       "id":6805,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which type of life insurance policy invests the money in the separate account and allows the policyholder to determine when the premiums are paid and how large those payments are?",
       "choice_a":"Whole life",
       "choice_b":"Variable life",
       "choice_c":"Universal life",
       "choice_d":"Variable universal life",
       "correct_answer":"D",
       "explanation":"A variable universal life insurance policy allows the policyholder to determine when the premiums are paid and how large those payments are."
    },
    {
       "id":6806,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which type of life insurance policy invests the money in the general account, has no scheduled premium payments and has a face amount which can be adjusted according to the policyholder\u0027s needs?",
       "choice_a":"Whole life",
       "choice_b":"Variable life",
       "choice_c":"Universal life",
       "choice_d":"Variable universal life",
       "correct_answer":"C",
       "explanation":"A universal life insurance policy has no scheduled premium payments and has a face amount which can be adjusted according to the policyholder\u0027s needs."
    },
    {
       "id":6807,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which type of life insurance policy is considered both an insurance policy and a security because the company offers part of the funds as a fixed death benefit and invests part in securities such as stock, bonds, and mutual funds?",
       "choice_a":"Whole life",
       "choice_b":"Variable life",
       "choice_c":"Universal life",
       "choice_d":"Variable universal life",
       "correct_answer":"B",
       "explanation":"A variable life insurance policy is considered both an insurance policy and a security because the company offers part of the funds as a fixed death benefit and invests part in securities such as stock, bonds, and mutual funds."
    },
    {
       "id":6808,
       "practice_test_id":"",
       "topic_id":11,
       "question":"You have been investing in a variable annuity that invests indirectly in the stock market.  The separate account would have to be registered  as:",
       "choice_a":"A UIT",
       "choice_b":"A closed end investment company",
       "choice_c":"An open end investment company",
       "choice_d":"An investment fund",
       "correct_answer":"A",
       "explanation":"If the separate account invests indirectly it buys mutual funds. The separate account would have to be registered as a UIT."
    },
    {
       "id":6809,
       "practice_test_id":"",
       "topic_id":11,
       "question":"You have been working for the local school system for 15 years and have been contributing to a payroll deduction plan for 9 years.  You have deposited $ 11,000 during the period and it has grown to $ 16,200.  What is your tax liability upon a lump sum withdrawal if you are in the 30% tax bracket when you retire:",
       "choice_a":"$4,840",
       "choice_b":"$0",
       "choice_c":"$3,300",
       "choice_d":"$1,560",
       "correct_answer":"D",
       "explanation":"The money has been deposited into a non-qualified plan and the $ 11,000 has therefore been placed into the plan with after tax dollars. Only the growth in the account is taxable or in this case $ 5,200 X 30% = $ 1,560."
    },
    {
       "id":6810,
       "practice_test_id":"",
       "topic_id":11,
       "question":"You have just joined your company\u0027s pension plan and are asking about the reports that will be furnished to you regarding its investment results.  You must get statements at least:",
       "choice_a":"Monthly",
       "choice_b":"Quarterly",
       "choice_c":"Semi-annually",
       "choice_d":"Annually",
       "correct_answer":"D",
       "explanation":"A participant in a corporate pension plan must get reports at least annually."
    },
    {
       "id":6811,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Your client has been paying $1,200 per year towards the premium for his variable life insurance policy.  All of the following come out from the gross premium received by the insurance company except:",
       "choice_a":"Sales load",
       "choice_b":"Administrative fee",
       "choice_c":"Premium tax",
       "choice_d":"Mortality fee",
       "correct_answer":"D",
       "explanation":"All if those listed come out of the gross premium except the mortality fee that is deducted from the separate account."
    },
    {
       "id":6812,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Your customer has retired early on a very large inheritance and wants to know about his options for withdrawing money from his IRA that he established 12 years ago. You should tell him:",
       "choice_a":"Since he does not need the money he could leave the money there to grow indefinitely",
       "choice_b":"He has to begin taking distributions at 59 \u00BD",
       "choice_c":"He must begin taking distributions at 65",
       "choice_d":"He must begin taking distributions at 72",
       "correct_answer":"D",
       "explanation":"Investors have to begin taking money out of an IRA at 72 years old."
    },
    {
       "id":6813,
       "practice_test_id":"",
       "topic_id":11,
       "question":"An engineer earning $25,000 a year is not covered under a pension plan by his employer. The engineer is also a self-employed antique dealer and has earned $18,000 from this source. The engineer would like to start a self-employed retirement plan. The maximum contribution he could make to the plan would be:",
       "choice_a":"$3,000.00",
       "choice_b":"$2,250.00",
       "choice_c":"$3,600.00",
       "choice_d":"$6,450.00",
       "correct_answer":"C",
       "explanation":"The individual may contribute 20% of their self-employed earnings to a Keogh plan. In this case $18,000 X 20% = $3,600."
    },
    {
       "id":6814,
       "practice_test_id":"",
       "topic_id":11,
       "question":"What percentage of employee contributions to a 403b plan are vested after one year?",
       "choice_a":"It depends on the plan but normally at least 50%",
       "choice_b":"All employee contributions vest after 1 year",
       "choice_c":"It is required by law that all contributions to 403b vest after 10 years",
       "choice_d":"All employee contributions vest immediately",
       "correct_answer":"D",
       "explanation":"All employee contributions to a 403b plan vest immediately as the employee placed the money into the plan. Vesting spells out how the employer contributions become the property of the employee."
    },
    {
       "id":6815,
       "practice_test_id":"",
       "topic_id":11,
       "question":"An advantage of variable annuities over mutual funds would be:",
       "choice_a":"The investor can move money within annuity without fees",
       "choice_b":"The investor receives tax advantages",
       "choice_c":"The investor achieves diversification",
       "choice_d":"The investor achieves a higher return with lower risk",
       "correct_answer":"B",
       "explanation":"An annuity allows the investor\u0027s money in the annuity to grow tax deferred. The growth is only taxed when the money is taken out. While the growth in mutual funds is subject to taxation."
    },
    {
       "id":6816,
       "practice_test_id":6,
       "topic_id":11,
       "question":"A retired person must think about which of the following when considering taxable income after retirement? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Face value of life insurance </li><li> Investment income in a retirement account </li><li> Corporate pension plan </li><li> Qualified dividends received on holdings</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"A person who is retired would have to consider all of the items listed except the face value of their life insurance policy when considering taxable income during retirement."
    },
    {
       "id":6817,
       "practice_test_id":"",
       "topic_id":11,
       "question":"If an investor is going to retire in one year, what is the time horizon on their retirement income fund?",
       "choice_a":"1 year",
       "choice_b":"The life expectancy of the recipient",
       "choice_c":"20 years",
       "choice_d":"5 years",
       "correct_answer":"A",
       "explanation":"An investor\u0027s time horizon is the amount of time they have until they need to liquidate or access the assets in an investment account. In this case the investor will need to begin to draw on the account in 1 year. Therefore their time horizon is 1 year."
    },
    {
       "id":24652,
       "practice_test_id":"",
       "topic_id":11,
       "question":"An investor had established a Roth IRA when he was 54 years old by depositing $5,000. During each of the next two years he made equal installments totaling $12,000. When he was 57 years old he made a single contribution of $6,500. No further contributions were made. Now at 60 he wants to take a lump sum distribution with the account valued at $30,125. Which of the following is correct? ",
       "choice_a":"The investor may withdraw all of the money tax free",
       "choice_b":"The investor may withdraw the deposits plus the growth on the assets that are more than 5 years old tax free",
       "choice_c":"The investor may withdraw the deposits tax free but will be subject to ordinary income taxes on the growth since not all of the money was there for more than 5 years",
       "choice_d":"In order to avoid paying income taxes the investor must take payments that are substantially similar over time",
       "correct_answer":"A",
       "explanation":"All deposits made to a Roth IRA are made with after tax dollars. As such the contributions to the plan create the investor\u0027s cost basis. Since the investor is over 59 \u00BD the investor may take all of the growth out of the account tax free. "
    },
    {
       "id":24664,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following is true relating to the taxation of annuities? ",
       "choice_a":"They are deferred until the annuity phase or until the investor closes out the contract",
       "choice_b":"They are fully taxable in the annuity phase of the contract",
       "choice_c":"They are fully taxable during the accumulation phase",
       "choice_d":"They are taxed annually after the annuity phase ends",
       "correct_answer":"A",
       "explanation":"An annuity is a non qualified account and as such the money is deposited with after tax dollars. The investor\u0027s deposits will be returned to them tax free. The taxation on the growth will be deferred until the investor annuitizes the contract or until the investor closes out the contract and takes a lump sum distribution. "
    },
    {
       "id":20929,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Your client is looking at various options for purchasing a variable annuity your firm has recommended to her. Which of the following would be considered abusive sales practices under FINRA guidelines? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Suggesting she take a home equity loan on the home she owns which is fully paid for </li><li>Suggesting she withdraw the money from a variable life insurance police she purchased 3 years ago </li><li>Suggesting she convert the funds from an another annuity with less features she established 2 years ago </li><li>Suggesting she convert the funds from a negotiable CD with 1 year remaining until maturity </li></ol>",
       "choice_a":"I only",
       "choice_b":"II and II",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"It is never appropriate to recommend that an investor use the equity in a home to invest. Recommending that the investor convert funds from another variable contract established in the last few years would most likely subject the investor to significant surrender charges and would not be suitable. Both of these practices have been identified as being abusive sales practices by FINRA. Since the CD is negotiable it can be sold in the market without subjecting the investor to surrender charges or penalties. Using the proceeds from the sale would not be abusive. "
    },
    {
       "id":20930,
       "practice_test_id":"",
       "topic_id":11,
       "question":"A lifetime income rider would be most suitable for an investor who is considering purchasing an annuity in which of the following circumstances? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor is already retired  </li><li>The investor anticipates a long retirement  </li><li>The investor has not yet retired  </li><li>The investor does not anticipate a long retirement </li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and III",
       "choice_c":"I and II",
       "choice_d":"II and IV",
       "correct_answer":"A",
       "explanation":"A lifetime income rider would be most suitable for an investor who is not yet retired and who anticipates a long retirement. "
    },
    {
       "id":19349,
       "practice_test_id":"",
       "topic_id":11,
       "question":"When evaluating pension plans ERISA would regulate all but which of the following plans?",
       "choice_a":"401K",
       "choice_b":"Public sector plan",
       "choice_c":"Private sector plan",
       "choice_d":"A small business plan administered by a qualified third party",
       "correct_answer":"B",
       "explanation":"ERISA regulates private sector pension plans. ERISA does not regulate plans administered for employees of the public sector."
    },
    {
       "id":19360,
       "practice_test_id":"",
       "topic_id":11,
       "question":"A new variable annuity product is being introduced by a large well respected company. The variable annuity product would be required to be registered with: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The SEC </li><li>The NYSE </li><li>The appropriate Insurance regulators </li><li>FINRA</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I, II, and III",
       "choice_d":"I,II,III, IV",
       "correct_answer":"A",
       "explanation":"A variable annuity is both a security and an insurance product. As such the annuity must be registered with the SEC and the appropriate insurance regulators"
    },
    {
       "id":19382,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Who would realize the greatest benefit as it relates to a defined benefit plan? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Employees who have fewer years until retirement </li><li>Employees with many years until retirement  </li><li>Employees who have high salaries  </li><li>Employees who have modest salaries</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I only",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"A",
       "explanation":"Employees with the highest salaries with the fewest years until retirement would realize the greatest benefit from participation in a defined benefit plan. A defined benefit plan provides a stated benefit such as a set percentage of the employee\u0027s income during retirement"
    },
    {
       "id":19393,
       "practice_test_id":"",
       "topic_id":11,
       "question":"An investor purchased a non qualified annuity by depositing a lump sum when he as 45 years old. He has enjoyed a high paying job for the last 15 years and has not annuitized the contract. At 60 years old he wants to buy a second home and withdraws $20,000 from the account to help with the down payment. What are the tax consequences of the withdrawal?",
       "choice_a":"Ordinary income taxes plus 10% penalty tax on the total amount",
       "choice_b":"Ordinary income taxes plus 10% penalty tax up to the cost base",
       "choice_c":"Ordinary income tax up to the cost base",
       "choice_d":"No tax if the withdrawal is done on a FIFO basis",
       "correct_answer":"C",
       "explanation":"The investor is over 59 \u00BD so there is no penalty tax. All random withdrawals from an annuity are done on a LIFO basis. The IRS considers all random withdrawals to come from the growth in the account and it is taxed as ordinary income. In this case if the $20,000 exceeded the growth in the account the portion that was the return of the cost base (deposit) would be returned tax free. "
    },
    {
       "id":20102,
       "practice_test_id":"",
       "topic_id":11,
       "question":"If an investor wants to purchase an annuity by making regular scheduled payments into the contract, he should invest in which of the following types of annuities?",
       "choice_a":"Single payment deferred annuity",
       "choice_b":"Multiple payment periodic annuity",
       "choice_c":"Regular payment immediate annuity",
       "choice_d":"Periodic payment deferred annuity",
       "correct_answer":"D",
       "explanation":"A periodic payment deferred annuity allows an investor to make regularly scheduled payments into a contract annuity which has a deferred pay out time."
    },
    {
       "id":20103,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Tax sheltered annuities and tax deferred accounts are established as retirement plans for all of the following except:",
       "choice_a":"Union members for an auto company",
       "choice_b":"Public schools and educational personnel",
       "choice_c":"Non-profit organizations",
       "choice_d":"Religious organizations",
       "correct_answer":"A",
       "explanation":"Tax sheltered annuities and tax deferred accounts are only established for non-profit organizations and public sector ( government) employees."
    },
    {
       "id":20104,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following is true about taxation of annuities?",
       "choice_a":"Contributions are made with after tax money",
       "choice_b":"The investment is allowed to grow tax deferred",
       "choice_c":"When the investor withdraws money from the contract, only the growth is taxed",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are true about the taxation of annuities."
    },
    {
       "id":20105,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Why do variable annuities contain more risk than fixed annuities?",
       "choice_a":"Because the number of accumulation units is fixed",
       "choice_b":"Because they invest in stocks, bonds, and mutual funds which contain inherent risk",
       "choice_c":"Because they are considered both a security and an insurance company product",
       "choice_d":"Because the money may be invested either directly or indirectly",
       "correct_answer":"B",
       "explanation":"Variable annuities contain more risk because the funds are invested in stocks, bonds, and mutual funds which may increase or decrease in value."
    },
    {
       "id":20106,
       "practice_test_id":"",
       "topic_id":11,
       "question":"All of the following are ways an investor may purchase a variable annuity except:",
       "choice_a":"Periodic payment deferred annuity",
       "choice_b":"Single payment deferred annuity",
       "choice_c":"Single payment immediate annuity",
       "choice_d":"Periodic payment immediate annuity",
       "correct_answer":"D",
       "explanation":"There is no such thing as a periodic payment immediate annuity."
    },
    {
       "id":20107,
       "practice_test_id":"",
       "topic_id":11,
       "question":"An investor has annuitized her variable annuity.  Which of the following are true?        <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Accumulation units have been exchanged for annuity units </li><li>Annuity units have been exchanged for accumulation units </li><li>The number of accumulation units is fixed </li><li>The number of annuity units is fixed</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"II and IV",
       "choice_d":"I and III",
       "correct_answer":"B",
       "explanation":"When an investor annuities a contract, they trade in their accumulation units for annuity units and the number of annuity units remains fixed."
    },
    {
       "id":20108,
       "practice_test_id":"",
       "topic_id":11,
       "question":"An investor has deposited $ 14,500 into a variable annuity over a three-year period. The money has grown to $17,800. The investor is 61 years old and must make a random withdrawal of $ 3,000. On what amount must he pay taxes?",
       "choice_a":"$0",
       "choice_b":"$3,000",
       "choice_c":"$700",
       "choice_d":"$2,300",
       "correct_answer":"B",
       "explanation":"The money taken from a variable annuity during a random withdrawal will be done on a LIFO basis, which means the growth will come out first and will be taxed. The investor will pay taxes on the entire $3,000."
    },
    {
       "id":20109,
       "practice_test_id":"",
       "topic_id":11,
       "question":"An investor has just begun the payout phase of their variable annuity and is wondering about the tax consequences of their payments.  You should tell them:",
       "choice_a":"Your payments will be tax free",
       "choice_b":"You will have to pay capital gains on the money",
       "choice_c":"You will have to pay ordinary income taxes on the entire amount",
       "choice_d":"You will only be taxed on the growth portion of the payment",
       "correct_answer":"D",
       "explanation":"The investor will only be taxed on the distribution of growth and it will be taxed as ordinary income. The investor\u0027s cost base will be returned tax free."
    },
    {
       "id":20110,
       "practice_test_id":"",
       "topic_id":11,
       "question":"An investor in a variable annuity may change their payout option:",
       "choice_a":"Under no circumstances",
       "choice_b":"If their financial needs change significantly",
       "choice_c":"To convert to a lump sum withdrawal",
       "choice_d":"Upon the death of a spouse for joint with last survivor",
       "correct_answer":"A",
       "explanation":"An investor may never change their payout option once it has been set."
    },
    {
       "id":20111,
       "practice_test_id":"",
       "topic_id":11,
       "question":"A 55 year old investor who withdraws money from a variable annuity to meet a family emergency will pay:",
       "choice_a":"Ordinary income taxes only",
       "choice_b":"Capital gains taxes only",
       "choice_c":"Ordinary income taxes plus a 10% penalty",
       "choice_d":"No taxes because the money deposited into a variable annuity are after tax dollars",
       "correct_answer":"C",
       "explanation":"The investor will have to pay the ordinary income taxes on the money as well as a 10% penalty because he is under 59 \u00BD."
    },
    {
       "id":20112,
       "practice_test_id":2,
       "topic_id":11,
       "question":"A client who is 65 years old has invested $ 10,000 in a Roth IRA. It has now grown to $ 14,000. He plans to retire and take a lump sum distribution. He will pay taxes on:",
       "choice_a":"$14,000",
       "choice_b":"$4,000",
       "choice_c":"$10,000",
       "choice_d":"$0",
       "correct_answer":"D",
       "explanation":"The money has been deposited in a Roth IRA after taxes. It is allowed to grow tax deferred. If you are over 59 \u00BD and the money has been there for at least 5 years, then it may all be returned without paying taxes on the growth."
    },
    {
       "id":20113,
       "practice_test_id":3,
       "topic_id":11,
       "question":"A simplified Employee Pension IRA is:",
       "choice_a":"Frequently used by small companies and individuals to plan for retirement",
       "choice_b":"Attractive to small employers because it allows them to establish a retirement plan for their employees quickly and inexpensively",
       "choice_c":"A plan which requires all eligible employees to participate as well as the employer, both of whom are contributing to the fund",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are true about a SEP IRA."
    },
    {
       "id":20114,
       "practice_test_id":4,
       "topic_id":11,
       "question":"A client who is a lawyer making $ 230,000 per year makes the maximum contribution to his Keogh plan.  He has a full time paralegal that earns $ 65,000 per year and wants to know what he must do for his employee\u0027s retirement.  You should tell him:",
       "choice_a":"Since you are self-employed, you can decide what to pay your own people",
       "choice_b":"You must contribute the same amount of money to the employee\u0027s Keogh as you did to yours",
       "choice_c":"You must make a contribution to the employee\u0027s Keogh at the same percentage rate as your own",
       "choice_d":"The employee is not self-employed and may not have a Keogh plan",
       "correct_answer":"C",
       "explanation":"A self-employed individual who has a full time employee must make a contribution for that employee at the same rate as his or her own contribution."
    },
    {
       "id":20115,
       "practice_test_id":5,
       "topic_id":11,
       "question":"A Keogh plan (HR-10) is which of the following?",
       "choice_a":"A qualified retirement plan",
       "choice_b":"Usually set up by individuals, sole proprietors, or unincorporated businesses",
       "choice_c":"May be funded only with earned income during a period when the business showed a gross profit",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"A Keogh plan allows individuals, sole proprietors, and unincorporated small businesses to establish a retirement plan for themselves and their employees."
    },
    {
       "id":20116,
       "practice_test_id":6,
       "topic_id":11,
       "question":"A Keogh plan is available for all of the following except:",
       "choice_a":"An independent coffee shop owner",
       "choice_b":"A lawyer",
       "choice_c":"A janitor at a local college",
       "choice_d":"A nurse at a local doctor\u0027s office",
       "correct_answer":"C",
       "explanation":"The janitor at a local college is not self-employed nor do they work for someone who is self-employed."
    },
    {
       "id":20117,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following is a qualified account? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>SEP IRA </li><li>Traditional IRA </li><li>Educational IRA </li><li>Roth IRA</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"A",
       "explanation":"Only the SEP and the Traditional IRAs are funded with pretax dollars."
    },
    {
       "id":20118,
       "practice_test_id":"",
       "topic_id":11,
       "question":"A qualified retirement plan differs from a non-qualified retirement plan in all of the following ways except:",
       "choice_a":"Contributions for the qualified plan are pre-tax, while contributions for the non-qualified plan are after tax",
       "choice_b":"Participation must be allowed for everyone in the qualified plan while the corporation may choose who participates in the non-qualified plan",
       "choice_c":"IRS approval is required for both plans",
       "choice_d":"Withdrawals from a qualified plan are 100% taxed as ordinary income while growth in excess of the cost base is taxed as ordinary income in a non-qualified plan",
       "correct_answer":"C",
       "explanation":"IRS approval is required for participation in a qualified plan, but IRS approval is not required for a non-qualified plan."
    },
    {
       "id":20120,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following investments exposes the investor to the most purchasing power risk?",
       "choice_a":"Growth fund",
       "choice_b":"Income fund",
       "choice_c":"Money market fund",
       "choice_d":"Fixed annuity",
       "correct_answer":"D",
       "explanation":"A fixed annuity will not provide any real protection from inflation and will subject the investor to the most purchasing power risk."
    },
    {
       "id":20123,
       "practice_test_id":"",
       "topic_id":11,
       "question":"A 45-year-old investor has rolled over $ 10,000 from an IRA to buy a car.  How long does he have to deposit the money in another qualified plan?",
       "choice_a":"45 days",
       "choice_b":"60 days",
       "choice_c":"30 days",
       "choice_d":"90 days",
       "correct_answer":"B",
       "explanation":"An investor may roll over their IRA once per year and has 60 days to get the money into a qualified plan."
    },
    {
       "id":20124,
       "practice_test_id":"",
       "topic_id":11,
       "question":"A customer has an unexpected expense to meet and would like to take a loan from his variable life insurance policy. Which of the following is not true?",
       "choice_a":"At least 75% of their cash value must be made available to them in the form of a loan",
       "choice_b":"Loans must be made available after 3 years",
       "choice_c":"Interest must be charged to the loan",
       "choice_d":"Interest must be charged on the loan and the rate must be equal to the prime rate at the time the loan is made",
       "correct_answer":"D",
       "explanation":"All of the answers in the question are true except there is no requirement that the interest rate be equal to the prime rate."
    },
    {
       "id":20126,
       "practice_test_id":"",
       "topic_id":11,
       "question":"A fixed annuity guarantees all of the following except:",
       "choice_a":"Income for life",
       "choice_b":"Protection from inflation",
       "choice_c":"Rate of return",
       "choice_d":"Protection from investment risk",
       "correct_answer":"B",
       "explanation":"A fixed annuity provides all of those listed except protection from inflation. If inflation rises, the holder of a fixed annuity may end up worse off due to the loss of value of the dollar."
    },
    {
       "id":20127,
       "practice_test_id":"",
       "topic_id":11,
       "question":"A principal in a school has deposited $ 15,000 in a tax deferred annuity through a payroll deduction plan.  The account has grown in value to $22,000.  The principal plans to retire and take a lump sum distribution.  On what amount does he pay taxes?",
       "choice_a":"$22,000",
       "choice_b":"$15,000",
       "choice_c":"$7,000",
       "choice_d":"$0",
       "correct_answer":"C",
       "explanation":"This is a non qualified plan meaning the money is deposited after taxes so the retiree will only pay taxes on the growth. The cost base will be returned to them tax free as they have already paid taxes on that amount."
    },
    {
       "id":20128,
       "practice_test_id":"",
       "topic_id":11,
       "question":"A Single investor has invested $ 8,000 in his IRA for the current year.  Which of the following is true?",
       "choice_a":"The investor may add an additional $ 1,000",
       "choice_b":"The investor is subject to a 6% penalty on the overage per year for as long as it remains in the IRA",
       "choice_c":"The investor is subject to a 10% penalty on the overage",
       "choice_d":"The investor is subject to a 6% penalty on the entire amount",
       "correct_answer":"B",
       "explanation":"The investor is subject to a 6% penalty on the excess amount for each year it remains in the plan."
    },
    {
       "id":20290,
       "practice_test_id":6,
       "topic_id":11,
       "question":"Your customer has twin boys who are about to enter kindergarten. He realizes the need to begin saving for their college education and is trying to decide between a 529 plan and an educational IRA. You tell him: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> The amount you can contribute to the 529 plan exceeds what you can contribute to the educational IRA </li><li>Both the 529 plan and the IRA allow you to make pre-tax contributions </li><li>Only the IRA allows withdrawals for educational expenses to be taken tax free </li><li>A benefit to the 529 is that if one of the boys chooses not to go to college the money in the plan can be used entirely for his brother\u0027s education</li></ol>",
       "choice_a":"I, II",
       "choice_b":"II, III",
       "choice_c":"I, IV",
       "choice_d":"II, IV",
       "correct_answer":"C",
       "explanation":"When deciding between an education IRA and a 529 plan it is important to note that the contribution limitations for an educational IRA are much lower than for a 529 plan. Additionally, contributions are made with after tax dollars, and withdrawals for education are usually tax free in both the IRA and the 529 plan. And only in the 529 can the money be transferred, without tax or penalty, to another \u0022reasonably related\u0022 person to be used for that individual\u0027s education."
    },
    {
       "id":20296,
       "practice_test_id":"",
       "topic_id":11,
       "question":"A variable annuity is:",
       "choice_a":"A retirement vehicle",
       "choice_b":"A mutual fund-like product",
       "choice_c":"An insurance product",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"A variable annuity is a retirement vehicle offered by insurance companies whereby the investor\u0027s contributions in mutual fund shares / seperate account grows tax deferred until retirement."
    },
    {
       "id":20299,
       "practice_test_id":"",
       "topic_id":11,
       "question":"All of the following are true with regards to a variable annuity\u0027s separate account except:",
       "choice_a":"If the separate account is a direct investment account it is classified as an open end investment company",
       "choice_b":"If the variable annuity\u0027s separate account is an indirect investment account it is classified as a UIT",
       "choice_c":"The separate account may only be used to invest in mutual fund shares",
       "choice_d":"The separate account may not be commingled with the general account of the insurance company",
       "correct_answer":"C",
       "explanation":"A variable annuity\u0027s separate account is named as such because the assets in the account must be kept separate from the insurance company\u0027s general account. If the separate account invests in mutual fund shares the account is an indirect investment account and is classified as a UIT under the Investment Company Act of 1940. If the separate account invests in individual stocks and bonds it is a direct investment account and is classified as an open end investment company."
    },
    {
       "id":20300,
       "practice_test_id":"",
       "topic_id":11,
       "question":"All of the following purchase options can be used by investors investing in variable annuities except:",
       "choice_a":"Periodic payment immediate annuity",
       "choice_b":"Single premium immediate annuity",
       "choice_c":"Periodic payment deferred annuity",
       "choice_d":"Single premium deferred annuity",
       "correct_answer":"A",
       "explanation":"Investors may invest in variable annuities by making a single contribution and either: begin taking immediate payments or defer payments until a later date. If an investor chooses to make multiple payments into the annuity they must choose to defer payments. The insurance company prohibits the investor from receiving payments while they are still investing in the separate account."
    },
    {
       "id":20301,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following risks would an investor in a fixed annuity be subject to? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Inflation risk  </li><li>Purchasing power risk  </li><li>Investment risk  </li><li>Systematic risk</li></ol>",
       "choice_a":"I, II",
       "choice_b":"II, IV",
       "choice_c":"I, II, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"A",
       "explanation":"Investors in fixed annuities are guaranteed a fixed rate of return on their investment. They are at risk that the fixed return will not outpace the rate of inflation (inflation risk) and that their money won\u0027t buy as much in the future as it does today (purchasing power risk). There is no investment risk to the investor, that risk is borne by the insurance company, as is the systematic risk."
    },
    {
       "id":20302,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following is/are true of a variable annuity\u0027s pay-in and pay-out phase? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> The value of accumulation units can vary  </li><li>The number of accumulation units can vary  </li><li>The value of the annuity units can vary  </li><li>The number of annuity units can vary</li></ol>",
       "choice_a":"I, II, IV",
       "choice_b":"I, III, IV",
       "choice_c":"I, II, III",
       "choice_d":"II, III, IV",
       "correct_answer":"C",
       "explanation":"In the pay-in phase of a variable annuity the investors purchases annuity units which can fluctuate in value as the separate account goes up and down. The investor can also make multiple purchases, which can affect the number of accumulation units he owns. During the pay-out phase the annuity units are now fixed in number because the investor is no longer buying additional units, however the value of the units is still subject to fluctuation."
    },
    {
       "id":20303,
       "practice_test_id":"",
       "topic_id":11,
       "question":"When an investor annuitizes a variable annuity contract the amount of the monthly payment is based on all of the following except:",
       "choice_a":"The customer\u0027s age",
       "choice_b":"The customer\u0027s gender",
       "choice_c":"The investment management fee",
       "choice_d":"The performance of the separate account in relation to the AIR",
       "correct_answer":"C",
       "explanation":"When determining the size of the monthly check for an annuitant the insurance company factors in the annuitant\u0027s age, sex and payout option as well as the value of the account and its performance in relation to the AIR."
    },
    {
       "id":20304,
       "practice_test_id":"",
       "topic_id":11,
       "question":"When determining the amount of an annuitant\u0027s monthly check which of the following is/are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> If the separate account outperforms the AIR this month\u0027s check will be larger than last month\u0027s check  </li><li>If the separate account performance equals the AIR this month\u0027s check will be larger than last month\u0027s check  </li><li>If the separate account underperforms the AIR this month\u0027s check will be less than last month\u0027s check </li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"I, III",
       "choice_d":"I, II, III",
       "correct_answer":"C",
       "explanation":"The assumed interest rate (AIR) is a benchmark that helps determine the size of a monthly annuity check. If the separate account outperforms the AIR this month\u0027s check will be larger than last month\u0027s. If the separate account performance equals the AIR this month\u0027s check will be equal to last month\u0027s check. If the separate account under performs the AIR this month\u0027s check will be smaller than last month\u0027s check."
    },
    {
       "id":20306,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following risks are borne by the insurance company when a customer purchases a variable annuity? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Investment risk  </li><li>Operating expense risk  </li><li>Mortality risk  </li><li>Inflation risk</li></ol>",
       "choice_a":"I, II",
       "choice_b":"II, III",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"The insurance company assumes the operating expense risk i.e. if the costs to operate the annuity are high than the insurance company anticipated they are responsible for covering those costs, not the investor; and the mortality risk insofar as the insurance company has promised to pay the annuitant for as long as he or she lives. If the annuitant outlives the insurance company\u0027s estimated life expectancy the insurance company is contractually obligated to continue paying the annuitant until the date of death."
    },
    {
       "id":20307,
       "practice_test_id":"",
       "topic_id":11,
       "question":"Which of the following is a risk to investors in variable annuities?",
       "choice_a":"Investment risk",
       "choice_b":"Inflation risk",
       "choice_c":"Purchasing power risk",
       "choice_d":"Mortality risk",
       "correct_answer":"A",
       "explanation":"An investor in a variable annuity bears all of the investment risk. In other words there is no guarantee that the customer\u0027s annuity will rise in value. However, because of the variable nature of the investment, the inflation and purchasing power risk are mitigated. Mortality risk is a risk the insurance company, not the investor assumes."
    },
    {
       "id":20308,
       "practice_test_id":"",
       "topic_id":11,
       "question":"All of the following are risks to an investor in variable annuities except:",
       "choice_a":"Capital risk",
       "choice_b":"Liquidity risk",
       "choice_c":"Legislative risk",
       "choice_d":"Reinvestment risk",
       "correct_answer":"D",
       "explanation":"Reinvestment risk is a risk associated with callable securities and mortgage back securities. When a bond or preferred share is called away, or a mortgage is refinanced, an investor will have all or a portion of his investment returned to him earlier that he anticipated; and he may not be able to receive the same high rate of return when trying to reinvest that money."
    },
    {
       "id":37020,
       "practice_test_id":"",
       "topic_id":11,
       "question":"An Investor who is looking to begin to save for retirement is concerned that they will not have enough assets to generate significant income during their retirement years. The investor explains to the representative that these will be the first contributions they are making to any retirement accounts. Which of the following is the least suitable for this client?",
       "choice_a":"A traditional IRA",
       "choice_b":"A Roth IRA",
       "choice_c":"Participating in his / her employer\u0027s 401K program",
       "choice_d":"A variable annuity",
       "correct_answer":"D",
       "explanation":"The variable annuity would be least suitable for this investor as it is clear that they have not contributed any money to retirement accounts. A variable annuity would only be appropriate if the investor was looking to supplement or augment other retirement assets."
    },
    {
       "id":37022,
       "practice_test_id":"",
       "topic_id":11,
       "question":"An investor owns an equity-indexed annuity contract with a minimum guaranteed rate of 3%. The contract has been designed so that the account holder will receive 80% of the performance of the S \u0026 P 500 Index up to a maximum of 12%. The S \u0026 P 500 was up 3.8% in the previous period. During that same time frame the CPI increased by 1%. Given this scenario, the investor would expect the value of their account to:",
       "choice_a":"increase by 3%",
       "choice_b":"increase by 3.8%",
       "choice_c":"increase by 3.04%",
       "choice_d":"increase by 2.8%",
       "correct_answer":"C",
       "explanation":"The investor would expect the value of their account to increase by 3.04%. The S \u0026 P 500 was up 3.8% and the investor is entitled to receive 80% of the Increase in the index. 3.8% X 80% equals 3.04%"
    },
    {
       "id":6915,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Which of the following gave the Federal Reserve Board the authority to regulate the extension of credit for securities purchases?",
       "choice_a":"Securities Lending Act of 1935",
       "choice_b":"Maloney Act of 1938",
       "choice_c":"Securities Exchange Act of 1934",
       "choice_d":"Securities Act of 1933",
       "correct_answer":"C",
       "explanation":"Regulation T of the Securities Exchange Act of 1934 gave the Federal Reserve board the authority to regulate the extension of credit for securities purchases."
    },
    {
       "id":6916,
       "practice_test_id":6,
       "topic_id":13,
       "question":"Which of the following handles trade practice complaints for FINRA?",
       "choice_a":"Rules of Conduct",
       "choice_b":"Department of Enforcement",
       "choice_c":"Uniform Practice Code",
       "choice_d":"The Board of Governors",
       "correct_answer":"B",
       "explanation":"The Department of Enforcement handles trade practice complaints for each district of FINRA."
    },
    {
       "id":6917,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Which of the following would not be considered retail communication?",
       "choice_a":"A market letter",
       "choice_b":"A research report",
       "choice_c":"A film about retirement accounts",
       "choice_d":"A market report sent to 75 banks",
       "correct_answer":"D",
       "explanation":"A market report sent to banks would be institutional communication and not retail communication Institutional communication is not required to be pre approved by a principal but must be maintained for three years by the firm."
    },
    {
       "id":6918,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Which of the following is misleading? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Multiple hedge clauses  </li><li>Implied regulatory endorsement </li><li>Promises of free services </li><li>Using outside research</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"A",
       "explanation":"Multiple hedge clauses and implied regulatory endorsement are violations and misleading. Free services must be free to everyone with no payment required."
    },
    {
       "id":6919,
       "practice_test_id":1,
       "topic_id":13,
       "question":"Which of the following is or are associated persons of a member firm: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Registered representative </li><li>Trader </li><li>Director </li><li>Manager</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"II and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of those listed would be considered associated people and would be required to register."
    },
    {
       "id":6920,
       "practice_test_id":2,
       "topic_id":13,
       "question":"You are looking to increase your book of business and are planning to step up your marketing effort. Which of the following would not be considered retail communication?",
       "choice_a":"A free writing prospectus created by a broker dealer",
       "choice_b":"Prospecting script",
       "choice_c":"Invitation to a seminar",
       "choice_d":"A letter to a customer requesting a meeting to discuss her portfolio",
       "correct_answer":"D",
       "explanation":"The letter to a particular customer asking to meet with them would not be considered retail communication. The letter would be considered correspondence. A free writing prospectus created by a broker-dealer must be filed with FINRA as part of retail communication"
    },
    {
       "id":6921,
       "practice_test_id":3,
       "topic_id":13,
       "question":"You are the owner of a restaurant and you would like to have a guitarist play in the lounge on Saturday evenings.  You have known your representative for 15 years and know her to be a great jazz guitarist.  You think she would like to play and ask her if she was available to do so.  She would have to get permission from which of the following before accepting your offer?",
       "choice_a":"FINRA",
       "choice_b":"NYSE",
       "choice_c":"Her Firm",
       "choice_d":"No one since it is not securities related and is on her on time",
       "correct_answer":"C",
       "explanation":"The representative would have to get permission from her employer before working outside the office in any capacity."
    },
    {
       "id":6922,
       "practice_test_id":4,
       "topic_id":13,
       "question":"You have an account with a brokerage firm that has filed for bankruptcy. There is $ 370,000 in market value in the account along with $ 75,000 in cash. Your spouse also has an account with $ 300,000 in market value and $ 90,000 in cash, what will SIPC cover?",
       "choice_a":"A total of $ 500,000 for both accounts",
       "choice_b":"Everything is covered in this situation",
       "choice_c":"The cash only",
       "choice_d":"The securities only",
       "correct_answer":"B",
       "explanation":"Everything is covered. SIPC covers $ 500,000 per separate customer of which up to $ 250,000 may be cash, so both accounts are fully covered"
    },
    {
       "id":6923,
       "practice_test_id":5,
       "topic_id":13,
       "question":"You have just been handed a business card by a representative, and \u0022FINRA\u0022 is in bold letters in the center of the card with the firm\u0027s name and the representative\u0027s name in the lower corner of the card along with the firm\u0027s phone and fax number. Which of the following is true?",
       "choice_a":"The card is acceptable as it has all of the required information on it",
       "choice_b":"The card is a violation of the rules of fair practice because it implies that FINRA has approved or endorsed the firm",
       "choice_c":"The card is a violation because it does not have SIPC on the card",
       "choice_d":"FINRA takes no position regarding business cards",
       "correct_answer":"B",
       "explanation":"The card is implying that FINRA has somehow approved or endorsed the firm and is a violation. The FINRA logo may be used on a card but only to detail that the firm is a FINRA member."
    },
    {
       "id":6924,
       "practice_test_id":6,
       "topic_id":13,
       "question":"Your brokerage firm has placed an ad in the local newspaper advertising its new line of services being offered to investors.  The firm must maintain the ad for how long?",
       "choice_a":"3 years",
       "choice_b":"2 years",
       "choice_c":"18 months",
       "choice_d":"12 months",
       "correct_answer":"A",
       "explanation":"Brokerage firms must maintain their advertising as part of retail communication for at least 3 years as required under FINRA Rule 2210 ."
    },
    {
       "id":6925,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Your firm has just started a sales contest for the office. The representative who has the highest gross commission for the current quarter will win an all expense paid trip for two to Hawaii. Under FINRA rules this is:",
       "choice_a":"Not permitted as it is valued over the $ 100 limit",
       "choice_b":"Not permitted as it would be seen as an enticement for the representative and encourages churning.",
       "choice_c":"Not permitted without approval of FINRA",
       "choice_d":"Permitted as it is an internal sales contest",
       "correct_answer":"D",
       "explanation":"This would be permitted, as it is an internal sales contest.  You may influence your own employees, just not the employees of other firms."
    },
    {
       "id":6926,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Your firm has the following people working for it.  Which one is required to be registered in order to perform their job?",
       "choice_a":"Part time sales assistant who occasionally takes verbal orders from customers",
       "choice_b":"A corporate officer whose sole function is to act as liaison between the board of directors and management",
       "choice_c":"Your firm\u0027s receptionist who takes messages from customers inquiring about their accounts",
       "choice_d":"A back office margin clerk who assists the head of the margin department",
       "correct_answer":"A",
       "explanation":"The part time sales assistant who takes orders from customers must be registered because she is taking orders."
    },
    {
       "id":6927,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A technique that may be used by terrorists to conceal the nature of funds is known as:",
       "choice_a":"Concealment",
       "choice_b":"Layering",
       "choice_c":"Duping",
       "choice_d":"Exchanging",
       "correct_answer":"B",
       "explanation":"A terrorist organization may use the layering of accounts or transactions to conceal the true nature of assets."
    },
    {
       "id":6928,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A broker dealer who is a respondent fails to provide FINRA with the information requested under the code of procedure within 25 days. FINRA will:",
       "choice_a":"Immediately take action against the broker dealer for failing to respond.",
       "choice_b":"Immediately enter a default judgment against the broker dealer",
       "choice_c":"Immediately send another request for the information giving the broker dealer another 14 days to respond",
       "choice_d":"Immediately notify the NAC of the broker dealer\u0027s failure to respond and take action against the firm\u0027s principal",
       "correct_answer":"C",
       "explanation":"A broker dealer who fails to respond to FINRA with the information requested under the code of procedure within 25 days will be sent a second notice and be given an additional 14 days to respond. If the broker dealer fails to respond in 14 days a default judgment will be entered against them at that time."
    },
    {
       "id":6929,
       "practice_test_id":6,
       "topic_id":13,
       "question":"Prior written permission of the person\u0027s employer is needed to open which of the following accounts: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Margin for an employee of an MSRB member . </li><li>Margin account for an employee of a publicly traded company.  </li><li>Margin account for an employee of an NYSE member.  </li><li>Cash account for an employee of another NYSE member.</li></ol>",
       "choice_a":"I, II, and IV.",
       "choice_b":"I, III, and IV.",
       "choice_c":"III, and IV.",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"Only the employee of an NYSE member needs prior permission to open an account with another member. "
    },
    {
       "id":6930,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A customer wishes to establish a tax loss and sells 100 shares of XYZ Corporation. The loss would not be allowed if the customer within 30 days:",
       "choice_a":"Bought an XYZ Corporation put.",
       "choice_b":"Sold an XYZ Corporation put.",
       "choice_c":"Bought an XYZ Corporation call.",
       "choice_d":"Sold an XYZ Corporation call.",
       "correct_answer":"C",
       "explanation":"The wash sale rule would not allow the investor to purchase a call or any other security which gives the holder the right to purchase the same security."
    },
    {
       "id":6931,
       "practice_test_id":"",
       "topic_id":13,
       "question":"SIPC trustees are responsible for:",
       "choice_a":"Orderly liquidation of a failed firm.",
       "choice_b":"Distribution of customer securities.",
       "choice_c":"Notifying customers of a firm in SIPC liquidation.",
       "choice_d":"All of the choices listed.",
       "correct_answer":"D",
       "explanation":"The SIPC trustee is responsible for all of the choices listed. Once appointed the trustee will proceed with the orderly distribution of customer assets."
    },
    {
       "id":6932,
       "practice_test_id":"",
       "topic_id":13,
       "question":"The Trust Indenture Act of 1939 covers: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A purchase of $5,000,000 worth of Treasury bonds. </li><li>A private placement of $3,000,000 of corporate notes.  </li><li>A $20,000,000 sale of corporate bonds sold interstate.  </li><li>A sale by a brokerage firm throughout the country of $25,000,000 worth of corporate debentures.</li></ol>",
       "choice_a":"I only.",
       "choice_b":"I and III.",
       "choice_c":"III and IV.",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"The Trust Indenture Act covers the issuance of corporate debt in excess of $5,000,000 with a maturity of longer than one year."
    },
    {
       "id":6933,
       "practice_test_id":2,
       "topic_id":13,
       "question":"If SIPC does not cover a customer\u0027s account in a brokerage firm that has gone bankrupt, the investor would be a:",
       "choice_a":"General creditor.",
       "choice_b":"Secured creditor.",
       "choice_c":"Preferred creditor.",
       "choice_d":"Guaranteed creditor.",
       "correct_answer":"A",
       "explanation":"If the assets in the customer\u0027s account exceed the protection provided by SIPC the investor will be a general creditor for the overage."
    },
    {
       "id":6934,
       "practice_test_id":3,
       "topic_id":13,
       "question":"Under MSRB rules, which of the following gifts would be a violation?",
       "choice_a":"$50 in tickets to a ball game.",
       "choice_b":"$100 business dinner.",
       "choice_c":"$150 Christmas gift.",
       "choice_d":"$175 economic seminar.",
       "correct_answer":"C",
       "explanation":"A gift of material value over $100 would be a violation."
    },
    {
       "id":6935,
       "practice_test_id":4,
       "topic_id":13,
       "question":"With respect to reviewing a registered rep\u0027s emails at the firm, a supervisor:",
       "choice_a":"may not delegate this responsibility",
       "choice_b":"may delegate only to Series 24 licensed principal",
       "choice_c":"is ultimately responsible for the review",
       "choice_d":"is required to perform this review every 30 days",
       "correct_answer":"C",
       "explanation":"Firm\u0027s are required to have procedures in place for reviewing rep\u0027s emails, though not necessarily every 30 days.  The review may be done by a supervisor or it may be delegated to another person with the proper knowledge, experience and training.  It is not required for the reviewer to be a Series 24 principal."
    },
    {
       "id":6936,
       "practice_test_id":5,
       "topic_id":13,
       "question":"Which of the following electronic communications require supervision by a principal?",
       "choice_a":"blogs",
       "choice_b":"group emails",
       "choice_c":"bulletin boards",
       "choice_d":"all of the choices listed",
       "correct_answer":"D",
       "explanation":"The principal is required to supervise all electronic communications including blogs, group emails and bulletin boards."
    },
    {
       "id":6937,
       "practice_test_id":6,
       "topic_id":13,
       "question":"If a broker dealer\u0027s website requires a person to type in a password to gain access to the site, this is considered:",
       "choice_a":"customized communications with the public",
       "choice_b":"retail communication",
       "choice_c":"advertising",
       "choice_d":"prohibited, as FINRA Conduct Rules require that all broker dealer websites be public websites, and therefore cannot be password protected sites.",
       "correct_answer":"B",
       "explanation":"When a website is password protected a firm has the ability to display targeted information to the visitor. If any visitors with access to the website are retail investors, the website is retail communication under FINRA Rule 2210."
    },
    {
       "id":6938,
       "practice_test_id":"",
       "topic_id":13,
       "question":"How long is a firm required to keep copies of group emails?",
       "choice_a":"the firm is not required to keep copies of group emails",
       "choice_b":"5 years, readily accessible for 2 years",
       "choice_c":"3 years, readily accessible for 2 years",
       "choice_d":"10 years, readily accessible for 3 years",
       "correct_answer":"C",
       "explanation":"Group emails are considered retail communication and copies need to be kept for 3 years, with the most recent 2 years readily accessible."
    },
    {
       "id":6939,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Joe is a registered rep at XYZ broker dealer.  According to FINRA rules if Joe sends an email to 15 prospective clients, which of the following is true?",
       "choice_a":"the emails are considered to be group emails",
       "choice_b":"the emails are classified as retail communication",
       "choice_c":"the emails are classified as correspondence",
       "choice_d":"the emails must be pre-approved by the compliance officer",
       "correct_answer":"C",
       "explanation":"If the same email is sent to fewer than 25 prospects the email is still considered correspondence.  Just like with form letters, once the email is sent to 25 or more prospects it becomes a \u0022group email\u0022 and is considered retail communication .  There is no FINRA requirement that the compliance officer pre approve correspondence."
    },
    {
       "id":6940,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Electronic advertising must:",
       "choice_a":"be approved by the principal prior to use",
       "choice_b":"be filed with FINRA",
       "choice_c":"both of the choices listed",
       "choice_d":"neither of the choices listed",
       "correct_answer":"C",
       "explanation":"All retail communication must be approved by a principal of the firm prior to first use. All retail communication must be filed with FINRA 10 days after its first use."
    },
    {
       "id":6941,
       "practice_test_id":"",
       "topic_id":13,
       "question":"When a registered rep sends an instant message to a client all of the following are true except:",
       "choice_a":"the instant message is considered correspondence",
       "choice_b":"the information contained in the instant message is subject to the rules of fair practice",
       "choice_c":"the instant message must be supervised by the firm",
       "choice_d":"the instant message may omit material facts",
       "correct_answer":"D",
       "explanation":"An instant message is an example of electronic correspondence.  As with written correspondence, it may not contain any false or misleading information, or omit any material facts."
    },
    {
       "id":6942,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Which of the following is not retail communication?",
       "choice_a":"An email to 35 existing clients",
       "choice_b":"A broker dealer\u0027s website",
       "choice_c":"Password protected areas of a broker dealer\u0027s website",
       "choice_d":"An instant message to 20 customers regarding breaking news on a stock",
       "correct_answer":"D",
       "explanation":"An IM to 20 customers regarding breaking news on a stock would be correspondence and not retail communication. If the IM was sent to more than 25 customers in a 30 day period it would become part of retail communication and subject approval and retention requirements."
    },
    {
       "id":6943,
       "practice_test_id":"",
       "topic_id":13,
       "question":"All of the following are retail communication except:",
       "choice_a":"a research report",
       "choice_b":"a marketing letter",
       "choice_c":"group email",
       "choice_d":"a blog only accessible to institutional clients",
       "correct_answer":"D",
       "explanation":"Retail communication includes marketing letters, circulars, and emails to 25 or more prospective clients. An Internet blog only accessible to institutional clients would be institutional communication."
    },
    {
       "id":6944,
       "practice_test_id":"",
       "topic_id":13,
       "question":"If a registered rep enters an Internet chat room which of the following is true?",
       "choice_a":"the rep may make exaggerated statements if he is not sending a research report to the customer",
       "choice_b":"the rep may make misleading statements to entice a prospective customer",
       "choice_c":"the rep may not reference past performance to indicate potential future results",
       "choice_d":"the rep may make unwarranted statements to entice a customer",
       "correct_answer":"C",
       "explanation":"A chat room is considered a retail communication by the rep and must adhere to FINRA\u0027s rules regarding fair practice.  Therefore, no unwarranted or exaggerated claims or misleading statements are allowed.  And as always, past performance is no indication of future performance."
    },
    {
       "id":6945,
       "practice_test_id":6,
       "topic_id":13,
       "question":"According to FINRA rules correspondence includes all of the following except:",
       "choice_a":"a chat room",
       "choice_b":"a letter to an individual client",
       "choice_c":"20 emails to existing clients",
       "choice_d":"7 instant messages to prospective clients",
       "correct_answer":"A",
       "explanation":"A posting in a chat room is a public appearance and not correspondence. Sending less than 25 emails to existing or prospective clients is considered correspondence. Additionally, when sending emails or IMs the number must remain under 25 to be classified as correspondence. 25 or more IMs or emails in a 30 day period become retail communication."
    },
    {
       "id":6946,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Which of the following must be maintained by the broker dealer for 3 years?",
       "choice_a":"a business related email sent by the rep to his customer from his personal email address",
       "choice_b":"a business related email sent by the rep to his customer from his firm\u0027s email address",
       "choice_c":"a business related instant message sent by the rep to his customer from his personal email address",
       "choice_d":"all of the choices listed",
       "correct_answer":"D",
       "explanation":"Whether the representative is communicating from home or office the firm is required to maintain copies of his business related electronic communications for 3 years."
    },
    {
       "id":6947,
       "practice_test_id":"",
       "topic_id":13,
       "question":"With regard to a broker dealer\u0027s website, all of the following are true except:",
       "choice_a":"public websites are considered retail communication",
       "choice_b":"research reports must be approved by the principal before being posted on the website",
       "choice_c":"password protected websites are considered retail communication",
       "choice_d":"FINRA logos are prohibited on a broker dealer\u0027s website",
       "correct_answer":"D",
       "explanation":"The FINRA logo may be used on broker dealer websites. However, if the logo is used it must have a hyperlink in close proximity to the logo, and the logo may not imply endorsement or approval by FINRA."
    },
    {
       "id":6948,
       "practice_test_id":"",
       "topic_id":13,
       "question":"All of the following require prior principal approval except:",
       "choice_a":"research reports being posted on the company\u0027s website",
       "choice_b":"an instant message sent to 20 conservative customers",
       "choice_c":"an email being sent to 35 prospects in a 30 day period",
       "choice_d":"an Internet blog posted by a registered rep offering market advice",
       "correct_answer":"B",
       "explanation":"Prior principal approval is required for retail communication. If the blog established by the rep posts investment information the rep would require principal approval to start the blog and the blog must be monitored by the firm. Instant messages and emails to less than 25 people in a 30 day period are considered to be correspondence."
    },
    {
       "id":6949,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Which of the following need to be taken into consideration when a broker dealer maintains a website?",
       "choice_a":"the information contained must be current",
       "choice_b":"the firm\u0027s name must be prominently displayed",
       "choice_c":"risk disclosures must be displayed appropriately",
       "choice_d":"all of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices are important when a broker dealer maintains a website."
    },
    {
       "id":6950,
       "practice_test_id":"",
       "topic_id":13,
       "question":"All of the following are true except:",
       "choice_a":"electronic communications referring to the reliability of a firm\u0027s electronic trading systems may not be exaggerated",
       "choice_b":"a broker dealers must update the information on its website at least annually",
       "choice_c":"risk disclosures must be displayed on the broker dealer\u0027s website",
       "choice_d":"the broker dealer is not required to mention it\u0027s FINRA membership on its website",
       "correct_answer":"B",
       "explanation":"There is no exact requirement for how often a broker dealer must update it\u0027s website.  However, the information contained must be \u0022current\u0022 so as not to mislead the public.  Reference to FINRA membership on a member\u0027s website is not obligatory.  If the firm chooses to mention it\u0027s FINRA membership it must furnish a hyperlink to FINRA\u0027s homepage."
    },
    {
       "id":6951,
       "practice_test_id":"",
       "topic_id":13,
       "question":"With regard to correspondence which of the following is true?",
       "choice_a":"an email to 50 potential customers is correspondence",
       "choice_b":"each email to individual customers must be approved by the principal",
       "choice_c":"the principal may randomly select certain emails for review",
       "choice_d":"the principal need not review correspondence, only only retail communication",
       "correct_answer":"C",
       "explanation":"A principal is required to review correspondence, and approve retail communication (a group email to 25 or more people is retail communication ).  However, due to the volume of correspondence the firm\u0027s supervisory procedures may allow them to review correspondence randomly."
    },
    {
       "id":6952,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Which of the following is/are true if a registered rep enters a chat room?",
       "choice_a":"it is considered retail communication",
       "choice_b":"it is subject to supervision by the firm",
       "choice_c":"both of the choices listed",
       "choice_d":"neither of the choices listed",
       "correct_answer":"C",
       "explanation":"When a registered rep enters a chat room it is retail communication and is subject to appropriate firm supervision. Entering a chat room does not require firm approval."
    },
    {
       "id":6953,
       "practice_test_id":"",
       "topic_id":13,
       "question":"According to SRO rules, under which of the following circumstances may an individual make a supervisory review of her own electronic communications?",
       "choice_a":"If the member is a sole proprietor with no other way of conducting a review",
       "choice_b":"If the member has fewer than 100 electronic communications per 60 day period",
       "choice_c":"If the member has fewer than 10 reps",
       "choice_d":"If a review is done on a monthly basis",
       "correct_answer":"A",
       "explanation":"Members may not make a supervisory review of their own individual electronic communications unless, because of their size or corporate structure, there is no other way to conduct the review.  A member who is a sole proprietor with no other employees fits this scenario."
    },
    {
       "id":6954,
       "practice_test_id":6,
       "topic_id":13,
       "question":"Under FINRA rules all of the following are institutional communication except:",
       "choice_a":"an email to hedge funds regarding retail investor sentiment",
       "choice_b":"an email sent to 25 or more broker dealers  in a 30 day period",
       "choice_c":"a broker dealer\u0027s password protected website only accessible to other dealers",
       "choice_d":"a registered rep\u0027s Internet blog regarding institutional investors",
       "correct_answer":"D",
       "explanation":"A registered representative\u0027s internet blog would be very accessible to retail investors over the internet. Any public communication that may be seen by retail investors must be considered to be retail communication."
    },
    {
       "id":6955,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Which of the following is considered to be false relating to institutional communications, according to FINRA Rule 2210?",
       "choice_a":"it need not be filed with FINRA",
       "choice_b":"it must be approved promptly after first use",
       "choice_c":"broker dealers must train employees to handle institutional communication properly",
       "choice_d":"It must be kept by the firm for three years",
       "correct_answer":"B",
       "explanation":"All broker dealers must train their employees on the proper use of institutional communications. So long as the firm has trained their employees on the use of institutional communications, the communication does not need to be approved by a principal. All institutional communications must be kept by the firm for three years."
    },
    {
       "id":6956,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A registered rep sends an email to a prospect with the intent of gaining her as a client.  Which of the following is true?",
       "choice_a":"the email is correspondence and requires prior approval by the principal",
       "choice_b":"the email is correspondence and does not require prior approval by the principal",
       "choice_c":"the email is retail communication and requires prior approval by the principal",
       "choice_d":"the email is retail communication and must be approved by the principal within 10 days",
       "correct_answer":"B",
       "explanation":"An email that is sent to fewer than 25 prospective customers in a 30 day period is correspondence and does not require prior principal approval.  However, the firm is required to review a rep\u0027s correspondence."
    },
    {
       "id":6957,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Which of the following is/are true when  a rep sends electronic communications to the public?",
       "choice_a":"the rep has the same responsibilities as she would if she were speaking face to face with the client",
       "choice_b":"the rep must abide by firm policies regarding e-communications",
       "choice_c":"the same electronic communications sent to 10 existing customers is correspondence",
       "choice_d":"all of the choices listed",
       "correct_answer":"D",
       "explanation":"Member Conduct Rules are the same for all communications with the public.  In addition to SRO rules, the individual firm\u0027s have policies in place regarding e-communications that the rep is required to adhere to. If the same email is sent to 25 or more retail investors the email is considered to be retail communication."
    },
    {
       "id":6958,
       "practice_test_id":"",
       "topic_id":13,
       "question":"When a registered rep sends an instant message to a client, that instant message is:",
       "choice_a":"advertising",
       "choice_b":"Exempt from FINRA rules",
       "choice_c":"correspondence",
       "choice_d":"none of the choices listed",
       "correct_answer":"C",
       "explanation":"An IM to an individual client is correspondence. A rep may send the same instant message to up to 25 people in a 30 day period before the IM becomes retail communication and subject to approval."
    },
    {
       "id":6959,
       "practice_test_id":2,
       "topic_id":13,
       "question":"Regarding electronic communications between a firm\u0027s research department and non-research departments all of the following are true except:",
       "choice_a":"pre approval of FINRA is required",
       "choice_b":"pre-approval by the principal is required for certain public communications",
       "choice_c":"copies of the electronic communications are sent to the firm\u0027s legal department",
       "choice_d":"copies of the electronic communications are sent to the firm\u0027s compliance department",
       "correct_answer":"A",
       "explanation":"Both the NYSE and FINRA rules require that electronic communications between the research and non-research departments be copied to the firm\u0027s legal and compliance departments.  Additionally, the principal is required to pre-approve all retail communication (eg: a research report).  FINRA does not approve any communications."
    },
    {
       "id":6960,
       "practice_test_id":3,
       "topic_id":13,
       "question":"XYZ brokerage firm is a full service investment bank occupying the top four floors of the office building where the corporate headquarters is located. Sales and trading are located on floors 14 and 15. Research and investment banking are located on the 16th and 17th floors. Two sales traders and two research analysts are riding the elevator up to their respective offices. The two research analysts are speaking about BGT Company in advance of a research report they are going to issue on BGT recommending its purchase. The analysts are discussing the fact that BGT has been in secret negotiations with a potentially big customer and this is expected to significantly boost revenues for BGT. One of the sales people upon hearing this information goes out and buys $20,000 worth of BGT based on that conversation. BGT announces that the company got the customer and the shares the salesperson bought subsequently fall by 10%. Which of the following is / are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>By trading in advance of the issuance of a research report the agent committed a violation known as front running  </li><li>By trading in advance of a research report the agent committed a violation known as trading ahead  </li><li>By trading based on non public material information the agent has violated the Insider Trading Act </li><li>Since the agent did not profit from the transaction the agent did not violate the Insider Trading Act</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"D",
       "explanation":"That sales trader has committed two violations in this situation. By purchasing the stock in advance of the research report the sales trader committed a violation known as trading ahead. By purchasing the stock due to the fact that BGT was in secret talks with a big customer the sales trader violated The Insider Trading Act. The fact that the stock declined on the news does not change the fact that the violations were committed. The analysts would not be allowed to issue a research report until the news of the new customer was made public."
    },
    {
       "id":6961,
       "practice_test_id":4,
       "topic_id":13,
       "question":"A 10 Q must be filled with the commission under SEC Rule 13a - 13:",
       "choice_a":"For each and every quarter of operation by the subject company",
       "choice_b":"For each of the first three calendar quarters",
       "choice_c":"For each and every quarter of operation along with an annual 10 K at the end of the subject company\u0027s fiscal year",
       "choice_d":"For each of the subject company\u0027s first three fiscal quarters",
       "correct_answer":"D",
       "explanation":"Publicly traded companies must file quarterly reports with the SEC for each of the first three fiscal quarters. A 10 Q for the company\u0027s year end is not required as full year results are reported to the commission containing the results for the fourth quarter on form 10 K."
    },
    {
       "id":6962,
       "practice_test_id":5,
       "topic_id":13,
       "question":"How many times per year must an SEC reporting company file reports with the SEC?",
       "choice_a":"once per month",
       "choice_b":"Once per quarter",
       "choice_c":"Once per year",
       "choice_d":"Once every 6 months",
       "correct_answer":"B",
       "explanation":"Publicly traded companies must file quarterly reports with the SEC for each of the first three fiscal quarters. A 10 Q for the company\u0027s year end is not required as full year results are reported to the commission containing the results for the fourth quarter on form 10K. The company will file form 10Q three times and form 10K once."
    },
    {
       "id":6963,
       "practice_test_id":6,
       "topic_id":13,
       "question":"Which organization sets the rules for margin requirements?",
       "choice_a":"SEC",
       "choice_b":"FINRA",
       "choice_c":"Federal Reserve Board",
       "choice_d":"NYSE",
       "correct_answer":"C",
       "explanation":"The Federal Reserve Board sets the rules regarding lending for securities purchases. This was granted to the FRB under The Securities Exchange Act of 1934."
    },
    {
       "id":6964,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Which of the following cannot appear on the firm\u0027s website?",
       "choice_a":"The State Administrator approves our practices",
       "choice_b":"Goals of the institution",
       "choice_c":"Amount of money they control",
       "choice_d":"Quotes from customers",
       "correct_answer":"A",
       "explanation":"A firm may never state that any regulator approves or endorses the firm or its agents. All of the other choices may be placed on the firm\u0027s website."
    },
    {
       "id":24702,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A wholesaler picks up an FA at her office and takes her to a very exclusive country club for a round of golf and lunch. The wholesaler is a member of the club and the club is not open to the public. Which of the following is true? ",
       "choice_a":"This would be allowed as it is entertainment",
       "choice_b":"This would not be allowed as the club is not open to the public",
       "choice_c":"This would not be allowed as the round of golf and lunch would likely exceed the $100 gift limit",
       "choice_d":"This would be allowed if the principal of the FA\u0027s firm approved it",
       "correct_answer":"A",
       "explanation":"This indeed would be allowed as entertainment. The wholesaler is attending the golf outing and lunch. The key is that it cannot be too frequent and the party attends with the FA. "
    },
    {
       "id":24641,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A customer sells a stock he has owned at a loss and two weeks later purchases a security that is substantially the same. Which of the following is true?",
       "choice_a":"The customer may claim the loss if the stock was held for more than 1 year",
       "choice_b":"The customer may claim the loss if the stock was held for less than 1 year",
       "choice_c":"The original cost base passes to the new purchase",
       "choice_d":"The loss may only be used to offset a gain in the current year",
       "correct_answer":"C",
       "explanation":"Under the wash sale rule if a person sells a security at a loss and within 30 days purchases a security which is substantially the same, the loss will be disallowed and the investor\u0027s original cost base will be passed along to the new purchase."
    },
    {
       "id":24642,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Which of the following choices are governed by Rule 144? ",
       "choice_a":"Control stock and restricted stock",
       "choice_b":"secondary offerings and unregistered offerings",
       "choice_c":"Control stock and insider trading",
       "choice_d":"Regulation D offerings and Regulation S offerings",
       "correct_answer":"A",
       "explanation":"Rule 144 regulates the sale of restricted securities, such as those acquired through a private placement or other no public means and control stock owned by officers directors and large controlling stockholders."
    },
    {
       "id":24685,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A registered representative who received notice to complete the regulatory continuing education requirement more than 120 days ago but who has not yet completed the required continuing education training may act in which of the following capacities?",
       "choice_a":"As a registered representative so long as the required training is completed within 15 days",
       "choice_b":"As a registered representative who will be subject to daily supervision by a principal until the required training is completed",
       "choice_c":"In administrative capacity posting trades to customer accounts",
       "choice_d":"As a speaker at a seminar for potential clients so long as there is a principal in attendance and all scripts have been approved in advance",
       "correct_answer":"C",
       "explanation":"A registered representative who fails to complete the regulator CE training within the 120 window must cease all activities of a registered representative. The rep may only act in an administrative capacity until the required CE courses have been completed. Of the choices listed only posting trades to accounts would be allowed as all others are activities of a registered representative."
    },
    {
       "id":24686,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A registered representative received notice to complete the regulatory continuing education requirement more than 120 days ago but has not yet completed the required continuing . Which of the following is true? ",
       "choice_a":"The representative must cease acting as an agent immediately",
       "choice_b":"The representative has 15 days to complete the required training",
       "choice_c":"The representative must file for a 30 day extension to continue acting as an agent and must complete the training the 30 day time frame",
       "choice_d":"The representative will have their registration terminated",
       "correct_answer":"A",
       "explanation":"A registered representative who fails to complete the regulatory CE training within the 120 day window must immediately cease all activities of a registered representative until the training is completed."
    },
    {
       "id":20914,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A FINRA member firm is seeking to expand its sales force and hire new representatives for a new branch office. Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The advertisement is considered to be retail communication  </li><li>The advertisement must be approved by a principal prior to use </li><li>The advertisement is considered to be institutional communication  </li><li>The advertisement must be filed with FINRA</li></ol>",
       "choice_a":"III only",
       "choice_b":"II and III",
       "choice_c":"I, II and IV",
       "choice_d":"II, III and IV",
       "correct_answer":"C",
       "explanation":"Even though the ad is directed at registered representatives the ad is considered to be part of retail communication. As part of retail communication it must be approved by a principal prior to first use and must be filed with FINRA."
    },
    {
       "id":20922,
       "practice_test_id":"",
       "topic_id":13,
       "question":"When reviewing content to be disseminated by the broker dealer or by a registered representative concerning business activities, which of the following determine the classification for the communication?",
       "choice_a":"The content and the number and type of recipients",
       "choice_b":"How the content was delivered",
       "choice_c":"If the content is required to be filed with FINRA",
       "choice_d":"If the content requires principal approval",
       "correct_answer":"A",
       "explanation":"When reviewing content to be disseminated by the broker dealer or by a registered representative concerning business activities the content and the number and type of recipients will be the determining factor in classifying the communication. There is no difference between electronic or written forms of distribution."
    },
    {
       "id":20923,
       "practice_test_id":"",
       "topic_id":13,
       "question":"As it relates to money laundering which of the following is the first step in the process?",
       "choice_a":"Execution",
       "choice_b":"Placement",
       "choice_c":"Layering",
       "choice_d":"Integration",
       "correct_answer":"B",
       "explanation":"The first step in the money laundering process is the placement of the funds into an account. This is when the process begins. Once the funds are placed in the account Transactions will take place to try to hide the true origin of the funds. This is known as layering. "
    },
    {
       "id":20926,
       "practice_test_id":"",
       "topic_id":13,
       "question":"An operations clerk working in the back office of a brokerage firm notices a pattern of activity coming from within the firm that seems to violate industry regulations. The clerk has reported the matter to his supervisor several times and the activity still continues. The clerk should do which of the following?",
       "choice_a":"Report the matter to SIPC",
       "choice_b":"Report the matter to the SEC",
       "choice_c":"Report the matter to the FINRA tip line",
       "choice_d":"Report the matter to the NYSE",
       "correct_answer":"C",
       "explanation":"In this case the matter should be reported to FINRA\u0027s tip line in Washington DC. The tip line is operated to allow industry participants to report suspected violations."
    },
    {
       "id":20936,
       "practice_test_id":6,
       "topic_id":13,
       "question":"As it is related to retail communication regarding investment companies containing performance ranking data, which of the following is true? ",
       "choice_a":"The communication is subject to a 10 day pre filing requirement",
       "choice_b":"The communication must be filed 10 days after its first use",
       "choice_c":"The performance ranking data must be submitted to FINRA\u0027s statistical analysis department",
       "choice_d":"The use of performance data is not allowed in retail communication",
       "correct_answer":"A",
       "explanation":"Retail communication regarding investment companies containing performance ranking data must be filed with FINRA 10 days prior to first use. If the communication does not contain performance ranking data it must be filed 10 days after first use. "
    },
    {
       "id":19335,
       "practice_test_id":"",
       "topic_id":13,
       "question":"An accredited investor who received securities through a non public offering wound not be required to file form 144 if: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> The number of shares is less than 10,000 </li><li>The value of the shares is less than $100,000 </li><li>The number of shares is less than 5,000 </li><li>The value of the shares is less than $50,000</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"III and IV",
       "choice_d":"II only",
       "correct_answer":"C",
       "explanation":"A sale of 5,000 shares or less with a value of $50,000 or less is exempt from the filing requirements of Rule 144. If the number of shares exceed 5,000 or the value was greater than $50,000 form 144 would have to be filed at the time the order is entered. "
    },
    {
       "id":19339,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A well established agent who lives in New Jersey and commutes to his office in New York City is working out of his vacation home in Florida during the winter. How long can the agent work out of his vacation home without working in a branch office?",
       "choice_a":"30 days",
       "choice_b":"45 days",
       "choice_c":"60 days",
       "choice_d":"90 days",
       "correct_answer":"A",
       "explanation":"The agent may work out of his vacation home for 30 days without being required to report to a branch office. "
    },
    {
       "id":19356,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A registered representative invites current and prospective clients to a seminar at an exclusive restaurant in the area. The RR plans to discuss his background, the history of his employing member firm and a mutual fund he is recommending to clients . Which of the following is / are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> If the cost of each individual attendee exceeds $100 attending would violate FINRA standards and could be seen as a rebate to current customers </li><li>If the RR mentions the fund\u0027s performance he must state the time frame for which the performance information is quoted </li><li>The RR\u0027s attendance at the restaurant is considered retail communication </li><li>If more than 25 people attend a principal of the firm must be there to supervise</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"I, II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"When a registered rep holds a seminar the seminar is considered to be retail communication. If the RR mentions a fund\u0027s performance the RR must state the time frame during which the performance occurred. There is no requirement that a principal attend the event and a seminar at a nice restaurant would not be considered a rebate. "
    },
    {
       "id":19362,
       "practice_test_id":"",
       "topic_id":13,
       "question":"An investment executive decides it is time for a career change after 12 years with his firm and opens up a restaurant. After five years he sells his restaurant and returns to his old firm. He will receive notice of his regulator CE requirement based on:",
       "choice_a":"His initial date of registration",
       "choice_b":"His date of reassociation",
       "choice_c":"His date of resignation",
       "choice_d":"The date he signs his new U 4",
       "correct_answer":"B",
       "explanation":" The agent left the business for more than 24 months and will therefore have his regulatory continuing education requirement based on his date of re association with the new firm."
    },
    {
       "id":19363,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Congress passed the Sarbanes -- Oxley legislation to place further requirements on:",
       "choice_a":"The board of directors of public companies",
       "choice_b":"High frequency traders",
       "choice_c":"ECN operators",
       "choice_d":"ETFs",
       "correct_answer":"A",
       "explanation":"Congress passes the Sarbanes -- Oxley legislation to place further requirements on the board of public companies to help ensure that the financial statements released by the company meet higher standards of disclosure and are certified."
    },
    {
       "id":19366,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A college graduate joins a FINRA member firm and completes his licensing exam. Shortly thereafter he is called home to deal with family issues and is forced to leave the firm. 15 months later he joins a new firm. He will receive notice of his regulatory CE requirement based on:",
       "choice_a":"His initial date of registration",
       "choice_b":"His date of reassociation",
       "choice_c":"His date of resignation",
       "choice_d":"The date he signs his new U 4",
       "correct_answer":"A",
       "explanation":" The agent left the business for less than 24 months and will therefore have his regulatory continuing education requirement based on his initial date of registration with the original firm. "
    },
    {
       "id":19389,
       "practice_test_id":"",
       "topic_id":13,
       "question":"An investor who is in their early 70s account has lost a significant amount of value as the securities his agent recommended have fallen in value. The customer has filed an arbitration claim against the agent after mediation had failed to reach an agreement. After the arbitration hearing the panel rules that the client is entitled to less than what the client claimed were the actual losses due to unsuitable investments. Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> The first appeal will go to the National Adjudicatory Council </li><li>The decision is binding on FINRA registered agents but not on members of the public </li><li>The decision is final and may not be appealed </li><li>The award must be paid in 30 days</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II",
       "choice_c":"II only",
       "choice_d":"III and IV",
       "correct_answer":"D",
       "explanation":"All awards under arbitration are final, binding and there is no appeal . The decision is binding on all parties and all awards must be paid in 30 days."
    },
    {
       "id":20119,
       "practice_test_id":"",
       "topic_id":13,
       "question":"An employee participating in a SEP IRA will be vested:",
       "choice_a":"After 2 years",
       "choice_b":"Gradually between 3-7 years",
       "choice_c":"After 5 years",
       "choice_d":"Immediately",
       "correct_answer":"D",
       "explanation":"Investors in SEP IRAs are vested immediately"
    },
    {
       "id":20211,
       "practice_test_id":"",
       "topic_id":13,
       "question":"According to FINRA Rule 2210 communication includes all of the following: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Communication sent to retail customers  </li><li>Communication sent to institutional customers  </li><li>Written or electronic communication distributed to 25 or fewer retail customers in a 30 calendar day period  </li><li>Written or electronic internal memos</li></ol>",
       "choice_a":"I  and  II",
       "choice_b":"III  and  IV",
       "choice_c":"I, II  and  III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"According to Rule 2210 Communication is defined as all written or electronic communication sent to retail and institutional customers; including correspondence which means any communication made to 25 or fewer retail customers in a 30 day period, but does not include a member\u0027s internal memos."
    },
    {
       "id":20212,
       "practice_test_id":"",
       "topic_id":13,
       "question":"All of the following are true regarding FINRA Rule 2210 except:",
       "choice_a":"Governments are treated as institutional investors",
       "choice_b":"High net worth individual investors are treated as institutional investors",
       "choice_c":"Registered persons of a FINRA member are treated as institutional investors",
       "choice_d":"Some employee benefit plans are treated as institutional investors",
       "correct_answer":"B",
       "explanation":"High net worth individual customers are treated as retail, not institutional investors; whereas governments, persons registered with a FINRA member and those employee benefit plans which meet IRS requirements and have at least 100 participants are treated as institutional investors."
    },
    {
       "id":20213,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A broker dealer that is a FINRA member wishes to send out an electronic newsletter to 30 retail customers in a 30 day period. Which of the following statements is true?",
       "choice_a":"The communication must be approved by FINRA prior to first use",
       "choice_b":"The communication must be approved by FINRA within 10 days of first use",
       "choice_c":"The communication must be approved by a registered principal prior to first use",
       "choice_d":"The communication must be approved by a registered principal within 10 days of first use",
       "correct_answer":"C",
       "explanation":"All retail communication, whether written or electronic, must be approved by a registered principal prior to first use. FINRA requires the member to file the communication, but does not approve it."
    },
    {
       "id":20214,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A FINRA member firm is exempt from filing retail communications with the Department in which of the following situations?",
       "choice_a":"if another FINRA member has already filed the communication and received confirmation that it meets all acceptable FINRA standards",
       "choice_b":"if a registered principal has approved the communication and placed a copy in the firm\u0027s internal file",
       "choice_c":"the communication is being sent to 25 or more customers in a 30 day period",
       "choice_d":"There are no exemptions. FINRA members must always file retail communications with the Department",
       "correct_answer":"A",
       "explanation":"Even if the registered principal has approved the communication the member must still file all written or electronic communications with FINRA, unless another member has already filed the same communication and received a response letter stating the communication meets the acceptable FINRA standards."
    },
    {
       "id":20215,
       "practice_test_id":"",
       "topic_id":13,
       "question":"When a member files retail communications with FINRA what is required to be kept in an internal file at the firm? <P>I. A copy of the communication with the date it was first used  </liI><ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The name of the principal who approved the communication  </li><li>The date the principal approved the communication  </li><li>The date FINRA approved the communication</li></ol>",
       "choice_a":"I, II",
       "choice_b":"I, II, III",
       "choice_c":"III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"The communication kept on file at the firm must include the name of the principal who approved the communication and the date as well as the date of first use. And though the member is required to file with FINRA, it does not approve retail communications."
    },
    {
       "id":20216,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A broker dealer who has been in business 6 months must do which of the following?",
       "choice_a":"Pre-file all information regarding the firm\u0027s public website within 10 days of first use",
       "choice_b":"Pre-file all television and radio ads within 10 days of first use",
       "choice_c":"Both A and B",
       "choice_d":"Neither A nor B",
       "correct_answer":"C",
       "explanation":"During its first year of business a broker dealer is required to pre- file all retail communications with FINRA 10 days prior to first use."
    },
    {
       "id":20217,
       "practice_test_id":"",
       "topic_id":13,
       "question":"According to FINRA Rule 2210, if an established broker dealer communicates with retail customers electronically, which of the following are required to be pre-filed 10 days prior to first use?",
       "choice_a":"Retail communications regarding direct participation programs",
       "choice_b":"Retail communication regarding preferred stock",
       "choice_c":"Retail communication concerning municipal bonds",
       "choice_d":"Retail communication regarding GNMAs",
       "correct_answer":"A",
       "explanation":"Established broker dealers are normally required to post file their retail communication with FINRA. One notable exception is if the communication relates to direct participation programs."
    },
    {
       "id":20218,
       "practice_test_id":"",
       "topic_id":13,
       "question":"As it related to FINRA Rule 2210 which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Established firms are generally required to pre-file all retail communication 10 days prior to first use </li><li>First year firms are generally required to pre-file all retail communication 10 days prior to first use  </li><li>Established firms are generally required to post file all retail communication within 10 days of first use  </li><li>First year firms are generally required to post file all retail communication within 10 days of first use</li></ol>",
       "choice_a":"I  and  II",
       "choice_b":"II  and  III",
       "choice_c":"III  and  IV",
       "choice_d":"I  and  IV",
       "correct_answer":"B",
       "explanation":"FINRA\u0027s rule on retail communication states that while established broker dealers generally post file all retail communication within 10 days of first use, first year broker dealers must pre-file 10 days prior to first use."
    },
    {
       "id":20219,
       "practice_test_id":6,
       "topic_id":13,
       "question":"Which of the following are true regarding FINRA Rule 2210? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> At FINRA\u0027s discretion, members may be subject to a spot check of their written and electronic communication  </li><li>A company\u0027s prospectus is exempt from FINRA filing  </li><li>If an established member deviates from acceptable standards FINRA can require that firm to pre-file future retail communications  </li><li>Copies of all retail communications must be kept by the broker dealer for 3 years</li></ol>",
       "choice_a":"I  and  III",
       "choice_b":"II  and  IV",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"All of the above statements are true with respect to Rule 2210."
    },
    {
       "id":20220,
       "practice_test_id":"",
       "topic_id":13,
       "question":"All of the following are prohibited in a member\u0027s written communication with the public except:",
       "choice_a":"\u0022FINRA Endorsed\u0022",
       "choice_b":"\u0022FINRA Guaranteed",
       "choice_c":"\u0022FINRA Approved\u0022",
       "choice_d":"\u0022FINRA Reviewed\u0022",
       "correct_answer":"D",
       "explanation":"The securities regulators do not endorse, guarantee or approve members, securities or sales practices. Therefore a member cannot state that in any communication they have with the customers. A firm may, however, use the phrase \u0022FINRA Reviewed\u0022 in its customer communications."
    },
    {
       "id":20221,
       "practice_test_id":"",
       "topic_id":13,
       "question":"If a FINRA member wishes to include a recommendation in its customer communication, which of the following are true?",
       "choice_a":"The firm must have a reasonable basis for making the recommendation",
       "choice_b":"The firm must disclose if they are a market maker in the security they are recommending",
       "choice_c":"The firm must disclose if they have been a manager or co-manager in any of the issuers public securities offerings in the prior 12 months",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The firm must have a reasonable basis for making the recommendation and must also disclose any information that could be construed as a possible conflict of interest."
    },
    {
       "id":20222,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Which of the folloing must be pre-fileed with FINRA: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> A bond advertisement for a highly volatile issue of bonds </li><li>An advertisement for an issue of preferred stock posted in a chatroom </li><li>A mutual fund advertisement created by the investment company </li><li>An advertisement placed in a national newspaper announcing a broker dealer\u0027s opening of a new branch office</li></ol>",
       "choice_a":"I  and  II",
       "choice_b":"I  and  III",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"An advertisement for a highly volatile securities future or bond issue, as well as investment company ads created by the investment company, must be pre-filed with FINRA 10 days prior to first use. Communications that are posted in a chat room and those that do not make any financial recommendations are not required to be either pre or post-filed with FINRA."
    },
    {
       "id":20223,
       "practice_test_id":"",
       "topic_id":13,
       "question":"According to FINRA Rule 2210, copies of all institutional communications must be kept by the broker dealer for a minimum of how long?",
       "choice_a":"1 year",
       "choice_b":"2 years",
       "choice_c":"3 years",
       "choice_d":"5 years",
       "correct_answer":"C",
       "explanation":"Copies of all institutional communications must be retained by the broker dealer for 3 years."
    },
    {
       "id":20224,
       "practice_test_id":"",
       "topic_id":13,
       "question":"According to FINRA Rule 2210, copies of all retail communication must be kept by the broker dealer for a minimum of how long?",
       "choice_a":"1 year",
       "choice_b":"2 years",
       "choice_c":"3 years",
       "choice_d":"5 years",
       "correct_answer":"C",
       "explanation":"Copies of all retail communications must be retained by the broker dealer for 3 years."
    },
    {
       "id":20225,
       "practice_test_id":"",
       "topic_id":13,
       "question":"All of the following are considered institutional investors under FINRA Rule 2210 except:",
       "choice_a":"An investment advisor with $30 million in total assets",
       "choice_b":"An individual with $40 million in total assets",
       "choice_c":"A government entity",
       "choice_d":"An insurance company with $75 million in total assets",
       "correct_answer":"B",
       "explanation":"Investment advisors, government entities, insurance companies, banks and S \u0026 Ls and employee benefit plans with at least 100 participants are automatically considered institutional investors under the Rule. However, an individual person must have at least $50 million in total assets to qualify as such."
    },
    {
       "id":20226,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Joe Smith, a registered representative of DCH, Inc. a registered broker dealer, will be making a public appearance next week. In his speech he will be making a recommendation of TRF common stock. What information must Joe disclose?",
       "choice_a":"If there is any conflict of interest in making the public appearance",
       "choice_b":"Whether Joe has a long or short position in the stock",
       "choice_c":"Whether Joe owns rights or warrants on the stock",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Any time an associated person makes a public appearance he must disclose if there is a potential conflict of interest. This includes disclosing if the person has any financial interest in the security he is recommending."
    },
    {
       "id":20227,
       "practice_test_id":"",
       "topic_id":13,
       "question":"When making a public appearance, members must file which of the following with FINRA? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Any power point slides that will be used in the presentation  </li><li>All handouts that will be distributed to the participants  </li><li>The script that the presenter will be using</li></ol>",
       "choice_a":"III only",
       "choice_b":"I  and  II",
       "choice_c":"II  and  III",
       "choice_d":"I, II, III",
       "correct_answer":"D",
       "explanation":"According to FINRA Rule 2210, when a member is making a public appearance any script, slides or handouts are treated as retail communication and must be filed with FINRA."
    },
    {
       "id":20228,
       "practice_test_id":"",
       "topic_id":13,
       "question":"When an established broker dealer wishes to place a recruitment ad in a local newspaper all of the following are true except:",
       "choice_a":"The ad does not have to state the name of the firm",
       "choice_b":"The ad does not need principal approval",
       "choice_c":"The ad cannot contain exaggerated claims",
       "choice_d":"The ad is considered retail communication",
       "correct_answer":"B",
       "explanation":"A recruitment ad is treated as retail communication by FINRA. Therefore, it must be approved by a licensed principal. And although member\u0027s may place a blind recruitment ad (without the firm\u0027s name on it), the ad cannot make any exaggerated claims about opportunities in the securities business."
    },
    {
       "id":20229,
       "practice_test_id":"",
       "topic_id":13,
       "question":"XYZ broker dealer, a first year broker dealer, has decided to create a website for the firm. When adding content to the site which of the following is/are true:",
       "choice_a":"electronic communication must follow the same filing rules as written communication",
       "choice_b":"Content must be pre-filed with FINRA 10 days prior to first use",
       "choice_c":"neither a nor b",
       "choice_d":"both a and b",
       "correct_answer":"D",
       "explanation":"Electronic communication is treated in exactly the same manner as written communication. Therefore, the content on the website must be approved by the principal and the firm is required to file the information with FINRA."
    },
    {
       "id":20230,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Advertisements for municipal bonds must be approved by which of the following entities?",
       "choice_a":"FINRA",
       "choice_b":"The MSRB",
       "choice_c":"The firm\u0027s licensed principal",
       "choice_d":"No approval is necessary for municipal bond advertisements",
       "correct_answer":"C",
       "explanation":"All communication with the public must be approved by a licensed principal. FINRA and the MSRB do not approve advertising, though members are subject to the regulator\u0027s filing requirements."
    },
    {
       "id":20258,
       "practice_test_id":"",
       "topic_id":13,
       "question":"All of the following are prohibited practices except:",
       "choice_a":"Front running",
       "choice_b":"Hypothecating",
       "choice_c":"Commingling",
       "choice_d":"Unauthorized trading",
       "correct_answer":"B",
       "explanation":"Hypothecation occurs when a customer has agreed to allow the broker dealer to pledge his securities to the bank as collateral for a margin loan. In order for hypothecation to be permitted a customer must sign a hypothecation agreement. Front running, commingling, and unauthorized trading are all examples of prohibited practices."
    },
    {
       "id":20259,
       "practice_test_id":"",
       "topic_id":13,
       "question":"According to regulation S-P which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Customers must receive an initial privacy notice from the broker dealer no later than at account opening </li><li>Customers must receive annual privacy notices from the broker dealer </li><li>Customers may elect to receive the annual privacy notice electronically </li><li>Regulation S-P was designed to safeguard the financial information of the customers</li></ol>",
       "choice_a":"IV only",
       "choice_b":"I, II",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"Regulation S-P was derived from the Gramm-Leach-Bliley Act to ensure that broker dealers had procedures in place to protect customer\u0027s sensitive financial information."
    },
    {
       "id":20261,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Which of the following statements are true regarding the Act of 1933? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> It regulates the new issues </li><li>It regulates the primary market </li><li>It regulates trades between issuers and the public <liIII><liIV>It regulates investor to investor trades</li></ol>",
       "choice_a":"I, II",
       "choice_b":"III, IV",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"The Act of 1933 regulates the primary market, also known as the new issue market, where issuers sell securities to the public for the first time. Once the securities are in the public hands, they are traded between investors, and those trades are regulated by the Act of 1934."
    },
    {
       "id":20942,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A customer is seeking to execute an order with your broker dealer. Utilizing FINRA\u0027s 5 percent policy what will be the basis for the mark down?",
       "choice_a":"The highest offer",
       "choice_b":"The highest bid",
       "choice_c":"The lowest offer",
       "choice_d":"The lowest bid",
       "correct_answer":"B",
       "explanation":"The key to this question is \u0022mark down\u0022. A mark down is only charged when the customer is the seller of a security. As such the marked down will be calculated based on the highest (best) bid."
    },
    {
       "id":21285,
       "practice_test_id":"",
       "topic_id":13,
       "question":"As it relates to the firm element continuing education plan requirement which of the following is correct?",
       "choice_a":"It is based on the agent\u0027s initial registration date",
       "choice_b":"It is based on the date the agent submitted the most recent U4",
       "choice_c":"It is based on a needs analysis",
       "choice_d":"It must be performed every 2 years",
       "correct_answer":"C",
       "explanation":"The firm element portion of the continuing education plan is based on a needs analysis conducted by the firm. The firm must conduct its firm element training every year."
    },
    {
       "id":21286,
       "practice_test_id":"",
       "topic_id":13,
       "question":"An agent who has been registered continuously for fifteen years leaves the industry for 18 months to pursue other interests. After 18 months the agent becomes re-associated with another member firm. Which of the following is true?",
       "choice_a":"The agent\u0027s regulatory continuing education requirement is based on the date of re-association",
       "choice_b":"The agent\u0027s regulatory continuing education requirement is based on the date on their last U5",
       "choice_c":"The agent\u0027s regulatory continuing education requirement is based on the date of initial association",
       "choice_d":"The agent\u0027s regulatory continuing education requirement is based on the date of original association less the time spent out of the industry",
       "correct_answer":"C",
       "explanation":"An agent who leaves the industry for less than 24 months will have their regulatory continuing education requirement based on the date of initial association."
    },
    {
       "id":21287,
       "practice_test_id":1,
       "topic_id":13,
       "question":"Which of the following people would not be subject to heightened supervisory requirements?",
       "choice_a":"An agent who transacts business in complex structured products",
       "choice_b":"A producing manager whose production is greater than 10 percent of the locations production",
       "choice_c":"An agent who has been sanctioned",
       "choice_d":"A manager who has ignored red flags and violations",
       "correct_answer":"B",
       "explanation":"A producing manager whose production is greater than 20 percent of the location\u0027s production would be subject to heightened supervision by the member."
    },
    {
       "id":21288,
       "practice_test_id":2,
       "topic_id":13,
       "question":"A member has received a written notice from a representative of a customer claiming that the member firm has acted in bad faith by recommending investments that were too risky and which caused the customer to suffer large losses. Which of the following Actions is not required of the member who received the notice? ",
       "choice_a":"The firm must electronically file the complaint within 15 calendar days of the end of the quarter",
       "choice_b":"The principal must review the complaint and respond within 10 days",
       "choice_c":"The complaint is subject to retention for 4 years",
       "choice_d":"The complaint must be maintained in a supervising OSJ",
       "correct_answer":"B",
       "explanation":"All of the choices listed are required of a member firm who receives a complaint except there is no time frame in which the firm must respond to the complaint. The principal must review all complaints"
    },
    {
       "id":21289,
       "practice_test_id":3,
       "topic_id":13,
       "question":"A member firm with multiple offices each differing in size, location and function must do which of the following?",
       "choice_a":"Designate an office with custody of customer assets as a corporate headquarters",
       "choice_b":"Designate in writing to FINRA which offices are OSJs",
       "choice_c":"Assign a duly qualified principal to oversee each branch",
       "choice_d":"Require satellite offices to use the address of the satellite and its OSJ on all communications",
       "correct_answer":"B",
       "explanation":"A member firm must designate in writing to FINRA which offices are OSJs. A satellite office may not use its address on communications. It may only use the address of its branch or OSJ. A branch office may be managed by a resident agent and an office with custody of customer assets must be designated as an OSJ."
    },
    {
       "id":21290,
       "practice_test_id":4,
       "topic_id":13,
       "question":"An agent who lives in Connecticut and works in New York maintains a vacation home in Florida. During the Winter the agent spends a considerable amount of time in the vacation home in Florida. The agent must be assigned to a branch if the agent works out of the vacation home:",
       "choice_a":"for more than 45 days",
       "choice_b":"for more than 30 days",
       "choice_c":"for more than 60 days",
       "choice_d":"for more than 90 days",
       "correct_answer":"B",
       "explanation":"The agent must be assigned to a branch if the agent works out of the vacation home for more than 30 days"
    },
    {
       "id":21291,
       "practice_test_id":5,
       "topic_id":13,
       "question":"As it relates to the member firm\u0027s annual compliance review, which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The member must inspect each office directly  </li><li>The member must assign a principal to test the firm\u0027s supervisory controls  </li><li>Reports detailing the status of supervisory systems must be filed with senior management  </li><li>Supervisory controls must be in place to provide daily supervision of producing managers</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"All of the choices listed are correct except members are not required to inspect every office. By inspecting the OSJs the member is inspecting all of the branch offices under the supervision of the branch."
    },
    {
       "id":21292,
       "practice_test_id":6,
       "topic_id":13,
       "question":"A firm that receives currency from a client in excess of $10,000 must fill out and submit a currency transaction report (CTR) form 4789:",
       "choice_a":"on the day the currency is received",
       "choice_b":"within 10 days of receipt",
       "choice_c":"within 15 days of receipt",
       "choice_d":"within 48 hours",
       "correct_answer":"C",
       "explanation":"A firm that receives currency from a client in excess of $10,000 must  fill out and submit a currency transaction report (CTR) form 4789 within 15 days of receipt."
    },
    {
       "id":21293,
       "practice_test_id":"",
       "topic_id":13,
       "question":"As it relates to a member\u0027s AML program which of the following are true?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It must be approved by senior management </li><li>A SARs must be filed for any suspicious activity exceeding $10,000 </li><li>All SARs must be kept for 3 years, 2 years readily accessible  </li><li>AML programs must ensure customers do not appear on the OFAC list </li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"A",
       "explanation":"All AML programs must be approved by members of senior management. AML programs must ensure that customers do not appear on the OFAC list of known or suspected terrorists. SARs must be filed for suspicious activity involving amounts of $5,000 or more and all SARs must be kept for 5 years. "
    },
    {
       "id":21294,
       "practice_test_id":"",
       "topic_id":13,
       "question":"A designated principal at a member firm has just received a new email list of known and suspected persons and entities from FinCen. Upon review of the list the principal notices that one of the businesses on the list has an account with his firm. Which of the following is true?",
       "choice_a":"The principal must take steps to freeze the account",
       "choice_b":"The principal must notify FinCen within 14 days",
       "choice_c":"The principal must take steps to investigate the account and the agent who introduced the account to the firm",
       "choice_d":"The principal must notify senior management",
       "correct_answer":"B",
       "explanation":"If the designated principal finds a match on the FinCen list, the principal must notify FinCen within 14 calendar days. "
    },
    {
       "id":21471,
       "practice_test_id":"",
       "topic_id":13,
       "question":"Which of the following are covered under the Sarbanes Oxley Act of 2002? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>SEC reporting  </li><li>Regulation of conflicts of interest  </li><li>Auditor requirements  </li><li>Internal controls </li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"The Sarbanes Oxley Act of 2002 governs the independence of auditors, the internal controls used by the firm to ensure accuracy of reports and conflicts of interest for publicly traded corporations. "
    },
    {
       "id":21472,
       "practice_test_id":"",
       "topic_id":13,
       "question":"The Hart Scott Rodino Act is most concerned with:",
       "choice_a":"Financial oversight of public corporations",
       "choice_b":"Disclosure of material information",
       "choice_c":"Antitrust laws",
       "choice_d":"Transactions with persons affiliated with issuers",
       "correct_answer":"C",
       "explanation":"The Hart Scott Rodino Act is most concerned with antitrust laws and requires parties in a merger to file papers with the FTC for review. The terms must be filed 30 days prior to the effective date for cash and stock dealers and 15 days prior for all cash deals. "
    },
    {
       "id":7002,
       "practice_test_id":"",
       "topic_id":12,
       "question":"Who must disclose the amount involved in the  commission?",
       "choice_a":"Broker",
       "choice_b":"Dealer",
       "choice_c":"Neither",
       "choice_d":"Both",
       "correct_answer":"A",
       "explanation":"A broker must disclose the amount of commission involved in any transaction."
    },
    {
       "id":7003,
       "practice_test_id":"",
       "topic_id":12,
       "question":"Who participates in the trade as a principal?",
       "choice_a":"Broker",
       "choice_b":"Dealer",
       "choice_c":"Neither",
       "choice_d":"Both",
       "correct_answer":"B",
       "explanation":"A dealer will participate in a trade as a principal. If the customer is buying the stock the dealer will sell the stock to the customer. Alternatively, if the customer is selling the stock the dealer will buy the stock from the customer."
    },
    {
       "id":7004,
       "practice_test_id":6,
       "topic_id":12,
       "question":"Your brokerage firm acts as a market maker for several high volume stocks that are quoted on the NASDAQ.  What is the firm\u0027s consideration for being a market maker:",
       "choice_a":"Commission",
       "choice_b":"Fees",
       "choice_c":"Spread",
       "choice_d":"5%",
       "correct_answer":"C",
       "explanation":"Firms that act as market makers in NASDAQ securities are trying to make the spread that is the difference between the bid and the ask."
    },
    {
       "id":7005,
       "practice_test_id":"",
       "topic_id":12,
       "question":"Your brokerage firm regularly trades stock in the third market. Which of the following best describes what they do?",
       "choice_a":"They regularly trade stocks with institutions",
       "choice_b":"They regularly act as an underwriter",
       "choice_c":"They regularly trade listed stocks over the NASDAQ system",
       "choice_d":"They regularly participate in private securities transactions",
       "correct_answer":"C",
       "explanation":"A third market transaction is a transaction in an exchange listed security executed over the NASDAQ workstation"
    },
    {
       "id":7006,
       "practice_test_id":"",
       "topic_id":12,
       "question":"Your customer is the manager of a large pension fund and tells you that he regularly trades stock in the fourth market.  He regularly trades stock with:",
       "choice_a":"Market makers",
       "choice_b":"Other institutions",
       "choice_c":"Broker dealers",
       "choice_d":"Issuers",
       "correct_answer":"B",
       "explanation":"Fourth market transactions are transactions which take place between two large institutions without the use of a broker dealer."
    },
    {
       "id":7007,
       "practice_test_id":1,
       "topic_id":12,
       "question":"In which market would one institution trading directly with another institution take place?",
       "choice_a":"Primary market",
       "choice_b":"Secondary market.",
       "choice_c":"Third market",
       "choice_d":"Fourth Market",
       "correct_answer":"D",
       "explanation":"An institution will trade directly with another institution in the fourth market."
    },
    {
       "id":7008,
       "practice_test_id":2,
       "topic_id":12,
       "question":"Which of the following securities are traded over-the-counter? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>U.S. Government bonds, municipal bonds, corporate bonds. </li><li>Mutual funds, Treasury bonds, tax-exempts. </li><li>Corporate bonds, common stocks and bank holding companies. </li><li>Insurance holding companies, bank holding companies and foreign securities.</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I, II, and III",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed trade in the over the counter market."
    },
    {
       "id":7009,
       "practice_test_id":3,
       "topic_id":12,
       "question":"Which of the following services can a dealer provide? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Makes a market in a given security. </li><li>Provides a firm bid to buy a given security at a price. </li><li>Provides a firm offer to sell a given security at a price. </li><li>Acts as principal on one side of a transaction.</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"IV only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"A firm acting as a dealer may do all of the answers listed."
    },
    {
       "id":7010,
       "practice_test_id":4,
       "topic_id":12,
       "question":"Which of the following is true when a work-out quote is accepted?",
       "choice_a":"The dealer must execute the order immediately at a price",
       "choice_b":"The dealer may have time to sell the security within a price range",
       "choice_c":"The dealer will place the order with a specialist on the New York Stock Exchange.",
       "choice_d":"The dealer will tell the investors to work-out the details of the sale.",
       "correct_answer":"B",
       "explanation":"When a dealer gives a work out quote they are giving a range in which they may be willing to trade the security."
    },
    {
       "id":7011,
       "practice_test_id":5,
       "topic_id":12,
       "question":"What is an order called which stipulates the price to be met, regardless of the number of shares?",
       "choice_a":"Not Held order",
       "choice_b":"All or none order",
       "choice_c":"Fill or kill order",
       "choice_d":"Immediate or cancel order",
       "correct_answer":"D",
       "explanation":"An Immediate or cancel order will buy or sell whatever can be bought or sold immediately at the stipulated price and the rest of the order will be canceled."
    },
    {
       "id":7012,
       "practice_test_id":6,
       "topic_id":12,
       "question":"In what market does the sale of listed securities in the OTC market (\u0027off the board\u0027) happen?",
       "choice_a":"Primary market",
       "choice_b":"Secondary market",
       "choice_c":"Third market",
       "choice_d":"Fourth market",
       "correct_answer":"C",
       "explanation":"A trade in a listed security executed over the counter takes place in the third market."
    },
    {
       "id":7013,
       "practice_test_id":"",
       "topic_id":12,
       "question":"Which level in the NASDAQ System allows market-makers the ability to change quotes?",
       "choice_a":"Level I",
       "choice_b":"Level II",
       "choice_c":"Level III",
       "choice_d":"Level IV",
       "correct_answer":"C",
       "explanation":"Level III NASDAQ subscription service allows market makers to enter quotes."
    },
    {
       "id":7014,
       "practice_test_id":"",
       "topic_id":12,
       "question":"Which of the following accurately defines a broker/dealer\u0027s functions?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A broker acts for others in an agency relationship. </li><li>A dealer buys/sells for their own account. </li><li>Brokers sell directly from inventory. </li><li>Brokers deal solely in primary distributions.</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"I and III",
       "choice_d":"II and IV",
       "correct_answer":"A",
       "explanation":"When a firm is acting as a broker it is acting as the customer\u0027s agent. When acting as a dealer the firm is acting as a principal."
    },
    {
       "id":7016,
       "practice_test_id":"",
       "topic_id":12,
       "question":"Which of the following is true of a market-maker?",
       "choice_a":"They function as a principal",
       "choice_b":"Quoted prices are for odd lots only",
       "choice_c":"They will buy only in a rising market",
       "choice_d":"They need not accept round lot orders",
       "correct_answer":"A",
       "explanation":"Market makers are always acting as a principal. Quotes are for round lot orders."
    },
    {
       "id":7018,
       "practice_test_id":"",
       "topic_id":12,
       "question":"Which of the following statements is true concerning FINRA\u0027s \u00275% markup\u0027 policy?",
       "choice_a":"Allows no deviation from a markup of precisely 5%.",
       "choice_b":"Is general policy only and does not apply to all transactions",
       "choice_c":"Places a limit on dealer loans",
       "choice_d":"Tends to reduce markups on very low priced stock",
       "correct_answer":"B",
       "explanation":"The 5% policy is a guideline not a rule and it does not apply to all transactions."
    },
    {
       "id":7019,
       "practice_test_id":6,
       "topic_id":12,
       "question":"Which of the following is an order to buy that allows the floor broker to exercise judgment as to the price?",
       "choice_a":"Market order",
       "choice_b":"Not held order",
       "choice_c":"Fill or kill",
       "choice_d":"AON",
       "correct_answer":"B",
       "explanation":"A not held order allows the floor broker to determine the best time and price to execute and order."
    },
    {
       "id":7020,
       "practice_test_id":"",
       "topic_id":12,
       "question":"What is the name of a special order that must be executed for the entire amount of shares or not at all without regard to time?",
       "choice_a":"FOK",
       "choice_b":"IOC",
       "choice_c":"AON",
       "choice_d":"DNR",
       "correct_answer":"C",
       "explanation":"An all or none order requires that all the shares be bought or sold. It may be entered as a day order or GTC."
    },
    {
       "id":7021,
       "practice_test_id":"",
       "topic_id":12,
       "question":"Which of the following statements is true concerning NASDAQ quotes?",
       "choice_a":"They relate the price and volume of each transaction",
       "choice_b":"They include markup/commission",
       "choice_c":"They are the highest bid and lowest offer by any dealer",
       "choice_d":"They are prepared separately for each FINRA district",
       "correct_answer":"C",
       "explanation":"NASDAQ quotes contain the highest bid and lowest offer displayed by any dealer and do not include markups or commissions."
    },
    {
       "id":7022,
       "practice_test_id":"",
       "topic_id":12,
       "question":"A stock with a current market value of $35 splits 5-for-4. What price would the stock be adjusted to immediately following the split?",
       "choice_a":"$43.75",
       "choice_b":"$26.25",
       "choice_c":"$28.00",
       "choice_d":"There is no adjustment",
       "correct_answer":"C",
       "explanation":"To determine the price of the stock multiply the stock price by the reciprocal of the fraction. In this case 35 X 4/5 = 28"
    },
    {
       "id":7023,
       "practice_test_id":"",
       "topic_id":12,
       "question":"All of the following would be traded in the secondary market, except:",
       "choice_a":"Listed common stocks.",
       "choice_b":"Unlisted bonds.",
       "choice_c":"Bonds that are trading flat.",
       "choice_d":"New issues.",
       "correct_answer":"D",
       "explanation":"New Issues are not traded in the secondary market. All new issue transactions take place in the primary market."
    },
    {
       "id":7024,
       "practice_test_id":"",
       "topic_id":12,
       "question":"The PINK OTC market shows:",
       "choice_a":"Bond prices and market makers",
       "choice_b":"Retail stock prices and firm quotes",
       "choice_c":"Bid and asked quotes for stocks and broker/dealers making a market in stocks",
       "choice_d":"All new issue prices",
       "correct_answer":"C",
       "explanation":"The Pink OTC market shows bid and ask prices for securities and the names of the broker dealers quoting the securities. The Pink OTC market shows firm quotes and has real time reporting."
    },
    {
       "id":7025,
       "practice_test_id":"",
       "topic_id":12,
       "question":"The over-the-counter market is:",
       "choice_a":"Where customers buy and sell publicly with each other.",
       "choice_b":"An auction market.",
       "choice_c":"The fourth market.",
       "choice_d":"Negotiated between broker/dealers.",
       "correct_answer":"D",
       "explanation":"The over the counter market is a negotiated market."
    },
    {
       "id":7026,
       "practice_test_id":"",
       "topic_id":12,
       "question":"When the underlying common stock sells ex-dividend, a GTC buy-limit order will:",
       "choice_a":"Remain unchanged.",
       "choice_b":"Be reduced.",
       "choice_c":"Be increased.",
       "choice_d":"None of the choices listed.",
       "correct_answer":"B",
       "explanation":"Buy limit orders entered GTC are entered below the market price and will be reduced by the amount of the dividend."
    },
    {
       "id":7027,
       "practice_test_id":"",
       "topic_id":12,
       "question":"Assume an order was placed prior to the opening-\u0027Sell Short 500 X  67.20 STOP LIMIT GTC.\u0027 At what price was the stop activated? (Assume trades occurred as follows): Open 67.22 ...67.19.... 67.20",
       "choice_a":"67.19.",
       "choice_b":"67.20.",
       "choice_c":"67.22.",
       "choice_d":"The stop was not activated.",
       "correct_answer":"A",
       "explanation":"The price that activated the order was 67.19. In order for a stop to be activated the stock has to trade at or through the stop price."
    },
    {
       "id":7029,
       "practice_test_id":6,
       "topic_id":12,
       "question":"A broker enters a day order for a customer. Later in the day the customer changes the order to a good-until-cancelled (GTC) order, leaving the price and the quantity the same. The order:",
       "choice_a":"Loses its position.",
       "choice_b":"Does not lose its position.",
       "choice_c":"Is automatically cancelled.",
       "choice_d":"None of the choices listed.",
       "correct_answer":"A",
       "explanation":"Any change to the terms of an order causes it to lose its place on the DMM\u0027s book."
    },
    {
       "id":7031,
       "practice_test_id":"",
       "topic_id":12,
       "question":"A stock listed on the NYSE stopped trading because of an influx of orders. Trading of the stock in other markets will appear on the Network A (consolidated tape):",
       "choice_a":"As it occurs, even though it stopped trading on the NYSE.",
       "choice_b":"Will not be shown during the time it stopped trading on the NYSE.",
       "choice_c":"The trades are held back and printed after trading starts on the NYSE again.",
       "choice_d":"Trades in other markets will not resume until trading starts on the NYSE again.",
       "correct_answer":"D",
       "explanation":"If a stock is halted on the NYSE it will be halted in all markets"
    },
    {
       "id":7033,
       "practice_test_id":"",
       "topic_id":12,
       "question":"A customer enters a sell-limit order at 85 GTC. The last sale in the stock was 82. A 60¢ dividend is declared. On the ex-dividend date how much will the DMM reduce the order on his book?",
       "choice_a":"60 cents",
       "choice_b":"62.5 cents",
       "choice_c":"Nothing only if marked do not reduce",
       "choice_d":"Nothing.",
       "correct_answer":"D",
       "explanation":"Orders placed above the market are not reduced for dividends. Only orders placed below the market are reduced for dividends."
    },
    {
       "id":7034,
       "practice_test_id":"",
       "topic_id":12,
       "question":"A woman who is short 1,000 shares of XYZ at 105 is going on vacation. She enters orders to buy either 1,000 shares of XYZ at 101 GTC (to cover her short sale should the stock decline to 101), or 1,000 at 109 buy-stop GTC (to cover her short sale if the stock should go up to 109). She tells the R.R. she wants to close out her short position of 1,000 XYZ by either buying the stock at a lower price than she sold it (at 101), or at a higher price if it should advance (at 109). The stock declines to 101, but only 700 shares are bought at 101. The GTC orders would now be changed to:",
       "choice_a":"Buy 300 XYZ at 101 or 300 XYZ at 109 buy-stop GTC.",
       "choice_b":"Buy 300 XYZ at 101 or 1,000 XYZ at 109 buy-stop GTC.",
       "choice_c":"Buy 300 XYZ at 101 or 700 XYZ at 109 buy-stop GTC.",
       "choice_d":"Buy 700 XYZ at 100 or 300 XYZ at 109 buy-stop GTC.",
       "correct_answer":"A",
       "explanation":"Both orders would have to be reduced by the amount of stock that was purchased at 101, in this case 700 shares."
    },
    {
       "id":7035,
       "practice_test_id":"",
       "topic_id":12,
       "question":"The seller would pay a commission in all of the following, except:",
       "choice_a":"A tender offer.",
       "choice_b":"An exchange distribution.",
       "choice_c":"A secondary distribution.",
       "choice_d":"A specialist\u0027s block purchase.",
       "correct_answer":"A",
       "explanation":"A seller would not pay a commission during a tender offer."
    },
    {
       "id":7036,
       "practice_test_id":"",
       "topic_id":12,
       "question":"A customer is short 100 ABC at 120. The market is moving up sharply and the customer decides to cover his short position. The customer instructs his R.R. to cover the short position at the market on the close. The order:",
       "choice_a":"Will be executed on the closing price of the day.",
       "choice_b":"Will be executed at or as near to the closing price as possible.",
       "choice_c":"Will be executed at the closing bid price.",
       "choice_d":"Will be executed at the closing price offer.",
       "correct_answer":"B",
       "explanation":"A market on close order will be executed at the close or as a close to the closing price as possible"
    },
    {
       "id":7037,
       "practice_test_id":"",
       "topic_id":12,
       "question":"An open buy order entered above the current market price of a security would be a:",
       "choice_a":"All or none order.",
       "choice_b":"Stop order.",
       "choice_c":"Limit order.",
       "choice_d":"Not held order.",
       "correct_answer":"B",
       "explanation":"Only a buy stop order would be entered above the market."
    },
    {
       "id":7038,
       "practice_test_id":"",
       "topic_id":12,
       "question":"When a specialist or DMM is \u0027stopping stock:\u0027 <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>He guarantees the purchase or sale of a specific number of shares at a given price.  </li><li>He may stop stock for the customers of NYSE members.  </li><li>He must obtain permission from a Floor Governor.  </li><li>He guarantees a specific price while the broker tries to do better.</li></ol>",
       "choice_a":"I and II.",
       "choice_b":"III and IV.",
       "choice_c":"I, II and IV.",
       "choice_d":"II, III and IV.",
       "correct_answer":"C",
       "explanation":"All of the choices listed are correct except permission of a floor governor is not required. A specialist or DMM may only stop stock for a public customer."
    },
    {
       "id":7039,
       "practice_test_id":"",
       "topic_id":12,
       "question":"All of the following are valid reasons for an investor to swap securities except to:",
       "choice_a":"Establish a loss to offset capital gains or income.",
       "choice_b":"Improve marketability of holdings.",
       "choice_c":"Incur additional commission costs for income tax purposes.",
       "choice_d":"Gain an increased amount of current income, an increased yield to maturity, or both.",
       "correct_answer":"C",
       "explanation":"An investor would not swap securities to incur additional transaction costs for tax purposes"
    },
    {
       "id":7040,
       "practice_test_id":2,
       "topic_id":12,
       "question":"Assume the customer purchased 100 ABC in a cash transaction on Monday, July 1. When would the trade settle?",
       "choice_a":"Tuesday, July 2.",
       "choice_b":"Monday, July 1.",
       "choice_c":"Tuesday, July 9.",
       "choice_d":"Friday, July 5 .",
       "correct_answer":"B",
       "explanation":"Cash trades settle the same day. Both the buyer and seller must agree to the settlement terms, prior to the execution. "
    },
    {
       "id":7041,
       "practice_test_id":3,
       "topic_id":12,
       "question":"When an investor is bearish on the market he can profit by:",
       "choice_a":"Buying common stocks",
       "choice_b":"Buying preferred stocks",
       "choice_c":"Selling short common stocks",
       "choice_d":"Selling long common stocks",
       "correct_answer":"C",
       "explanation":"Short selling is a strategy used by investors who are bearish on the market. The objective of this strategy is to sell borrowed shares at a high price and buy them back some time in the future at a lower price."
    },
    {
       "id":7043,
       "practice_test_id":4,
       "topic_id":12,
       "question":"A market maker who is unable to resolve a trade issue with another market maker must:",
       "choice_a":"Report to NASDAQ Market Operations within 15 minutes",
       "choice_b":"Report to NASDAQ Market Operations within 5 minutes",
       "choice_c":"Report to NASDAQ Market Operations within 30 minutes",
       "choice_d":"Report to NASDAQ Market Operations  within 45 minutes",
       "correct_answer":"C",
       "explanation":"Reports must be filed with NASDAQ Market Operations within 30 minutes."
    },
    {
       "id":7044,
       "practice_test_id":5,
       "topic_id":12,
       "question":"Which of the following assist in the execution of third market trades between OTC / CQS dealers?",
       "choice_a":"SDBK",
       "choice_b":"TRACE",
       "choice_c":"NMCES",
       "choice_d":"AutoEX",
       "correct_answer":"C",
       "explanation":"The NASDAQ market center execution system links CQS market makers together to trade securities in the third market."
    },
    {
       "id":7045,
       "practice_test_id":6,
       "topic_id":12,
       "question":"ACT does not:",
       "choice_a":"Report",
       "choice_b":"Quote",
       "choice_c":"Match",
       "choice_d":"Clear",
       "correct_answer":"B",
       "explanation":"ACT does not provide quotes. ACT matches, clears and reports trades that have been executed between two dealers in the NASDAQ market."
    },
    {
       "id":7046,
       "practice_test_id":"",
       "topic_id":12,
       "question":"Which of the following would be considered firm? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A priced quoted for a non NASDAQ security received from a dealer over the phone </li><li>A two sided quote for a non NASDAQ DPP </li><li>A two sided bond quote </li><li>A two sided priced quote from a dealer listed in the pink otc</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I, III and IV",
       "choice_c":"II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"The priced quote received over the phone and a two sided bond quote would be firm. The Pink OTC market also shows real time firm quotes. Quotes for DPPs are not firm."
    },
    {
       "id":7047,
       "practice_test_id":"",
       "topic_id":12,
       "question":"An investor enters an order to buy 1000 ABC MOC. Which of the following is false?",
       "choice_a":"The order will be executed as close to the closing price as possible",
       "choice_b":"The order will be canceled if trading on the exchange is halted",
       "choice_c":"The order will be canceled if trading in ABC is halted",
       "choice_d":"It may be executed at any price within the last 4 minutes of the trading day since it is a market order",
       "correct_answer":"D",
       "explanation":"All of the answers are correct with regard to a market on close order. It must be executed on the closing price or as close to the closing trade as possible. 4 minutes is too far away from the close to be reasonable."
    },
    {
       "id":7049,
       "practice_test_id":"",
       "topic_id":12,
       "question":"You buy stock in XYZ. You are sure that it will either go up or down a lot and you want to hedge your downside risk while keeping the opportunity to buy more if XYZ goes up.  What combination of orders would you most likely place?",
       "choice_a":"Buy stop, sell limit",
       "choice_b":"Buy limit, sell stop",
       "choice_c":"Buy stop, sell stop",
       "choice_d":"Buy limit, sell limit",
       "correct_answer":"C",
       "explanation":"In the case described you would want to protect your downside risk by entering a sell stop below the market. If XYZ did well you would be able to add to your position by entering a buy stop above the market."
    },
    {
       "id":7050,
       "practice_test_id":"",
       "topic_id":12,
       "question":"You sell a stock short. What type of order are you most likely to enter to hedge your risk?",
       "choice_a":"Buy stop",
       "choice_b":"Sell stop",
       "choice_c":"Buy limit",
       "choice_d":"Sell limit",
       "correct_answer":"A",
       "explanation":"If you sell stock short your risk is to the upside and to exit the trade you must buy the stock back. The best order would be to enter a buy stop above the market."
    },
    {
       "id":7051,
       "practice_test_id":6,
       "topic_id":12,
       "question":"An investor sells short a stock. Selling short means:",
       "choice_a":"Selling something you don\u0027t own",
       "choice_b":"Selling when you think price will stay stagnant",
       "choice_c":"Selling to an investment company",
       "choice_d":"Selling stock after exercising an option",
       "correct_answer":"A",
       "explanation":"An investor who sells a stock short is selling a stock that they do not own. The investor borrows the securities to effect delivery and must buy back the stock to return the shares they borrowed when they exit the trade."
    },
    {
       "id":24700,
       "practice_test_id":"",
       "topic_id":12,
       "question":"A trader on a high volume NASDAQ trading desk received an order to sell 500 shares of INTC from a retail customer. Prior to presentation to the market, the trader receives a customer order to buy 500 shares of INTC at the market. The trader may:",
       "choice_a":"cross the orders on a riskless simultaneous basis",
       "choice_b":"not cross the orders as the order to sell was received first and should be routed promptly to the market for execution",
       "choice_c":"cross the orders and charge each customer a markup or markdown",
       "choice_d":"cross the orders and charge each customer a commission",
       "correct_answer":"D",
       "explanation":"The trader may cross the orders and will do so by acting as an agent and charge each customer a commission. The cross must take place at price that does not favor one customer over the other."
    },
    {
       "id":24635,
       "practice_test_id":"",
       "topic_id":12,
       "question":"A stock is quoted as follows:<img src='/question_assets/series7/1.png'></img> The investor enters an order to buy 5,000 shares of the above stock in the third market and his broker executes the order and charges a 25 cent markup. What is reported to the consolidated tape ?",
       "choice_a":"5,000 shares at 84",
       "choice_b":"5,000 shares at 84.13",
       "choice_c":"5,000 shares at 84.38",
       "choice_d":"5,000 shares at 84.25",
       "correct_answer":"B",
       "explanation":"All transactions reported to the tape are wholesale prices, without commissions or markups. Therefore, the trade will be reported to the tape as 5,000 shares at 84.13"
    },
    {
       "id":20954,
       "practice_test_id":"",
       "topic_id":12,
       "question":"If you are interested in knowing the level of fear in the market, you would most likely look at which of the following?",
       "choice_a":"The put / call ratio",
       "choice_b":"Option open interest",
       "choice_c":"Short interest in the S \u0026 P 500",
       "choice_d":"The VIX",
       "correct_answer":"D",
       "explanation":"The VIX or volatility index is a measure of fear in the overall market and measures the expected volatility in the overall market. The VIX will increase and investors become more fearful about a big move in the overall market."
    }
  ]